webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var platform_browser_dynamic_1 = __webpack_require__(1);
	var forms_1 = __webpack_require__(337);
	// Our main component
	var app_component_1 = __webpack_require__(375);
	// Our main routes
	var app_routes_1 = __webpack_require__(702);
	var common_1 = __webpack_require__(205);
	var http_1 = __webpack_require__(376);
	var core_1 = __webpack_require__(11);
	var common_2 = __webpack_require__(205);
	if (true) {
	    // Production
	    core_1.enableProdMode();
	}
	platform_browser_dynamic_1.bootstrap(app_component_1.AppComponent, [
	    [http_1.HTTP_PROVIDERS],
	    app_routes_1.APP_ROUTER_PROVIDERS,
	    forms_1.disableDeprecatedForms(),
	    forms_1.provideForms(),
	    core_1.provide(common_1.LocationStrategy, { useClass: common_1.PathLocationStrategy }),
	    { provide: common_2.APP_BASE_HREF, useValue: '/taf2024/' }
	])
	    .catch(function (err) { return console.error(err); });


/***/ },

/***/ 375:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var http_1 = __webpack_require__(376);
	__webpack_require__(398);
	var router_1 = __webpack_require__(655);
	var app_config_values_1 = __webpack_require__(676);
	var airport_service_1 = __webpack_require__(677);
	var taf_book_service_1 = __webpack_require__(681);
	var taf_book_b1_service_1 = __webpack_require__(682);
	var taf_book_b2_service_1 = __webpack_require__(683);
	var taf_book_b3_service_1 = __webpack_require__(684);
	var taf_book_b4_service_1 = __webpack_require__(685);
	var taf_book_b5_service_1 = __webpack_require__(686);
	var taf_book_s1_service_1 = __webpack_require__(687);
	var taf_book_s2_service_1 = __webpack_require__(688);
	var taf_book_s3_service_1 = __webpack_require__(689);
	var taf_book_graph_s1_service_1 = __webpack_require__(690);
	var query_report_service_1 = __webpack_require__(691);
	var scenario_service_1 = __webpack_require__(692);
	var commondata_service_1 = __webpack_require__(693);
	var auth_service_1 = __webpack_require__(679);
	var system_control_service_1 = __webpack_require__(694);
	var user_info_service_1 = __webpack_require__(695);
	var auth_guard_service_1 = __webpack_require__(696);
	var http_helper_1 = __webpack_require__(678);
	var airport_interfaces_1 = __webpack_require__(697);
	var query_report_1 = __webpack_require__(698);
	var router_2 = __webpack_require__(655);
	var user_session_1 = __webpack_require__(699);
	var AppComponent = (function () {
	    // private IMGFOOTRIGHT= require('/app/images/foot_app_right.gif');
	    function AppComponent(route, router, authService, _User) {
	        this.route = route;
	        this.router = router;
	        this.authService = authService;
	        this._User = _User;
	        this.pageTitle = 'TAF Legacy NET 472';
	    }
	    AppComponent.prototype.ngOnInit = function () {
	        this.isAdmin = this.authService.isInRole("System Developer");
	        this.isLoggedIn = this.authService.isLoggedIn();
	        this.isReadOnly = this.authService.isReadOnly();
	    };
	    AppComponent.prototype.onSubmit = function () {
	        this.router.navigate(['/airports', { locId: this.locId }]);
	        this.locId = '';
	    };
	    AppComponent.prototype.logout = function () {
	        this.authService.logOut();
	        this.router.navigate(['/login']);
	        window.location.reload();
	    };
	    AppComponent = __decorate([
	        core_1.Component({
	            selector: 'pm-app',
	            template: "\n    <div class=\"container-fluid\" style=\"min-height:0px !important;\" id=\"customApp\">\n            <div class='row' style=\" background:url('app/images/head_app_patt.gif');\" id=\"taf-header\" \n            *ngIf=\"!router.url.includes('operations-graph-display')\">\n                <div class=\"col-sm-2\" style=\"padding-left: 0;padding-right: 0;\">\n                    <a href=\"http://www.faa.gov/\" class=\"bodyTextLink\" title=\"FAA.gov Homepage\">\n                            <img src=\"app/images/head_app_logo.gif\" alt=\"Federal Aviation Administration Seal\" border=\"0\" height=\"86\">\n                        </a>\n                </div>\n                <div class=\"col-sm-6\" style=\"padding-left:0; padding-right:0;padding-bottom:0;\">\n                        <div class='row' style=\"background-size:100% auto; text-align:center;padding-bottom:0;\" >\n                            <label style=\"font-family: arial,verdana,helvetica; font-size: 18px; font-weight: bold; color: #900;\" >\n                                APO Terminal Area Forecast 2024\n                            </label>\n                        </div>\n                        <div class='row' style=\"padding-top:0;\" *ngIf=\"isLoggedIn\">\n                            <!--<nav class='nav navbar navbar-default navbar-brand' *ngIf=\"isLoggedIn\" >\n                                    <ul *ngIf=\"isLoggedIn\" class='nav navbar-nav'>-->\n                                    <div style=\"background:url('app/images/head_app_patt.gif');padding-left:165px;\"  *ngIf=\"isLoggedIn\">\n                                        <a [routerLink]=\"['/welcome']\"  class=\"btn btn-danger  btn-sm active custom-button-header\">Home</a>\n                                        <a [routerLink]=\"['/airports']\" class=\"btn  btn-danger btn-sm active custom-button-header\">Facility View</a>\n                                        <a [routerLink]=\"['/scenario-activities']\" class=\"btn btn-danger  btn-sm active custom-button-header\" *ngIf=\"!isReadOnly\">Scenario Activities</a>\n                                        <a [routerLink]=\"['/query-reports']\" class=\"btn  btn-danger  btn-sm active custom-button-header\">Query Reports</a>\n                                    </div>\n                                       <!-- <li><a [routerLink]=\"['/account']\" class=\"btn btn-danger  btn-sm active custom-button-header\"> Manage Account</a></li>\n                                        <li *ngIf=\"isAdmin\"><a [routerLink]=\"['/system-management']\" class=\"btn btn-danger  btn-sm active custom-button-header\">System Management</a></li>\n                                        <li *ngIf=\"isAdmin\"><a [routerLink]=\"['/admin']\" class=\"btn btn-danger  btn-sm active custom-button-header\">Admin</a></li>-->\n                            <!--        </ul>\n                            </nav>-->\n                        </div>\n                </div>\n                <div class=\"col-sm-3\" style=\"background:url('app/images/head_app_patt.gif');padding-left:0; padding-right:10px; text-align:right;height:86px;\">\n                        <a href=\"http://www.faa.gov/data_research/aviation/\" class=\"btn btn-link btn-sm \">\n                            <font style=\"font-family: verdana,arial,helvetica; font-size: 11px; font-weight: bold; color: #0065ff;\">Aviation Data and Statistics Home</font>\n                        </a>\n                         <button type=\"button\" class=\"btn btn-link btn-xs\" (click)=\"logout()\" *ngIf=\"isLoggedIn\">\n                            <span class=\"glyphicon glyphicon-log-out\"></span> \n                            <font style=\"font-family: verdana,arial,helvetica; font-size: 11px; font-weight: bold; color: #0065ff;padding-top:0; padding-bottom:0;\">Log out</font>\n                        </button>\n                        <form class=\"navbar-form no-print\" (ngSubmit)=\"onSubmit();\" *ngIf=\"isLoggedIn\">\n                            <div style=\"font-size: 12px; margin:2px; font-weight: bold;\">\n                                Go to LOCID:<input type=\"text\" class=\"form-control\" placeholder=\"Loc Id\" [(ngModel)]=\"locId\" name=\"locId\" maxlength=\"4\" size=\"4\" >\n                                <button type=\"submit\" class=\"tn btn-default btn-xs active \">Go...</button>\n                            </div>\n                        </form>\n                </div>\n                <div class=\"col-sm-1\"  style=\"padding-left: 0;padding-right: 0;\">\n                    <img src=\"app/images/head_app_right.gif\" alt=\"\" border=\"0\" height=\"86px\" width=\"100%\">\n                </div>\n            </div>\n\n        <div class='container' style=\"margin-left:20px\">\n            <router-outlet></router-outlet>\n        </div>\n        <div class='row' style=\"background-color:#c0e4fe;height:'29'\" id=\"taf-footer\"\n        *ngIf=\"!router.url.includes('operations-graph-display')\">\n            <div class=\"col-sm-4\" style=\"padding-left: 0;padding-right: 0;\">\n                <img src=\"app/images/foot_app_left.gif\" alt=\"\" border=\"0\" height=\"29\" width=\"100%\">\n            </div>\n            <div class=\"col-sm-4\" style=\"padding-left: 0;padding-right: 0;\">\n                <img src=\"app/images/foot_app_patt.gif\" alt=\"\" border=\"0\" height=\"29\" width=\"100%\">\n            </div>\n            <div class=\"col-sm-4\" style=\"padding-left: 0;padding-right: 0;\">\n                <img src=\"app/images/foot_app_right.gif\" alt=\"\" border=\"0\" height=\"29\" width=\"100%\">\n            </div>\n        </div>\n</div>",
	            styles: [__webpack_require__(700), __webpack_require__(701)],
	            directives: [router_1.ROUTER_DIRECTIVES],
	            providers: [app_config_values_1.AppConfigValues,
	                airport_service_1.AirportService,
	                query_report_service_1.QueryReportService,
	                taf_book_service_1.TAFBookService,
	                taf_book_s1_service_1.TAFBookS1Service,
	                taf_book_s2_service_1.TAFBookS2Service,
	                taf_book_graph_s1_service_1.TAFBookGraphS1Service,
	                taf_book_s3_service_1.TAFBookS3Service,
	                taf_book_b1_service_1.TAFBookB1Service,
	                taf_book_b2_service_1.TAFBookB2Service,
	                taf_book_b3_service_1.TAFBookB3Service,
	                taf_book_b4_service_1.TAFBookB4Service,
	                taf_book_b5_service_1.TAFBookB5Service,
	                scenario_service_1.ScenarioService,
	                scenario_service_1.CreateScenarioRequest,
	                commondata_service_1.CommonDataService,
	                http_1.HTTP_PROVIDERS,
	                auth_service_1.AuthService,
	                http_helper_1.HttpHelper,
	                auth_guard_service_1.AuthGuard,
	                user_info_service_1.UserInfoService,
	                user_session_1.UserSession,
	                system_control_service_1.SystemControlService,
	                airport_interfaces_1.OperationsListRequest,
	                query_report_1.QueryReportListRequest]
	        }), 
	        __metadata('design:paramtypes', [router_2.ActivatedRoute, router_2.Router, auth_service_1.AuthService, user_session_1.UserSession])
	    ], AppComponent);
	    return AppComponent;
	}());
	exports.AppComponent = AppComponent;


/***/ },

/***/ 676:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var AppConfigValues = (function () {
	    function AppConfigValues() {
	    }
	    //public apiHostUrl: string = 'http://localhost:55706/'; // local development settings
	    //public apiHostUrl: string = ''; // production settings
	    AppConfigValues.prototype.getApiHostUrl = function () {
	        //console.log("process.env.ENV" + process.env.ENV);
	        if (true) {
	            return '/taf2024/'; // production settings
	        }
	        else {
	            return 'http://localhost:55706/'; // local development settings
	        }
	    };
	    AppConfigValues = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], AppConfigValues);
	    return AppConfigValues;
	}());
	exports.AppConfigValues = AppConfigValues;


/***/ },

/***/ 677:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	__webpack_require__(524);
	__webpack_require__(494);
	var http_helper_1 = __webpack_require__(678);
	var AirportService = (function () {
	    function AirportService(httpHelper) {
	        this.httpHelper = httpHelper;
	        //need to have this somewhere besides hardcoded in here
	        //private _baseAirportUrl = `http://localhost:55706/api/airport`;
	        this._baseAirportUrl = "api/airport";
	    }
	    AirportService.prototype.getAirport = function (locId, scenarioId) {
	        this.locId = locId;
	        this.scenarioId = scenarioId;
	        //console.log("scenarioId: " + scenarioId);
	        return this.httpHelper.get(this._baseAirportUrl + "/" + scenarioId + "/" + locId);
	    };
	    AirportService.prototype.getAirportLocIds = function (scenarioId) {
	        return this.httpHelper.get(this._baseAirportUrl + "/locidlist/" + scenarioId);
	    };
	    AirportService.prototype.getAirportLocIdsByCriteria = function (request) {
	        var url = (this._baseAirportUrl + "/facilities/search?") +
	            ("baseScenarioId=" + request.baseScenarioId) +
	            ("&locId=" + request.locId) +
	            ("&region=" + request.region) +
	            ("&state=" + request.state) +
	            ("&hubSize=" + request.hubSize) +
	            ("&level=" + request.level) +
	            ("&type=" + request.type) +
	            ("&allFaaTowers=" + request.allFaaTowers) +
	            ("&allFaaAndContractTowers=" + request.allFaaContractTowers) +
	            ("&oep35=" + request.oep35) +
	            ("&centerId=" + request.centerId) +
	            ("&relieverFacility=" + request.relieverFacility) +
	            ("&relieverLocId=" + request.relieverLocId) +
	            ("&approachControlId=" + request.approachControlId) +
	            ("&searchOption=" + request.searchOption) +
	            ("&selectVariable=" + request.selectVariable) +
	            ("&growthStartYear=" + request.growthStartYear) +
	            ("&growthEndYear=" + request.growthEndYear) +
	            ("&growthOperator=" + request.growthOperator) +
	            ("&growthPercentage=" + request.growthPercentage) +
	            ("&growthExcludeChanges=" + request.growthExcludeChanges) +
	            ("&varValueYear=" + request.varValueYear) +
	            ("&varValueOperator=" + request.varValueOperator) +
	            ("&varValue=" + request.varValue);
	        return this.httpHelper.get(url);
	    };
	    AirportService.prototype.getAirportCenterIds = function (baseScenarioId) {
	        return this.httpHelper.get(this._baseAirportUrl + "/centerids/" + baseScenarioId);
	    };
	    AirportService.prototype.getRelieverLocIds = function (scenarioId) {
	        return this.httpHelper.get(this._baseAirportUrl + "/relieverids/" + scenarioId);
	    };
	    AirportService.prototype.getApproachControlIds = function (scenarioId) {
	        return this.httpHelper.get(this._baseAirportUrl + "/approachcontrolids/" + scenarioId);
	    };
	    AirportService.prototype.getScenarioNotes = function (locId, scenarioId) {
	        return this.httpHelper.get(this._baseAirportUrl + "/scenarionotes/" + scenarioId + "/" + locId);
	    };
	    AirportService.prototype.getFacilityList = function (scenarioId) {
	        return this.httpHelper.get(this._baseAirportUrl + "/facilitylist/" + scenarioId);
	    };
	    AirportService.prototype.updateScenarioNotes = function (locId, scenarioId, note) {
	        var params = {
	            locId: locId,
	            scenarioId: scenarioId,
	            note: note
	        };
	        return this.httpHelper.put(this._baseAirportUrl + "/scenarionotes", JSON.stringify(params));
	    };
	    AirportService.prototype.updateAirport = function (airport) {
	        return this.httpHelper.put("" + this._baseAirportUrl, airport);
	    };
	    AirportService.prototype.getAirportFromScenario = function (scenarioId) {
	        return this.httpHelper.get(this._baseAirportUrl + "/scenario-airport/" + scenarioId);
	    };
	    AirportService.prototype.getNextAndPreviousAirports = function (locId, scenarioId) {
	        return this.httpHelper.get(this._baseAirportUrl + "/next-previous/" + scenarioId + "/" + locId);
	    };
	    AirportService.prototype.getOperations = function () {
	        return this.httpHelper.get(this._baseAirportUrl + "/operations");
	    };
	    AirportService.prototype.getOperationsColumns = function (request) {
	        var url = (this._baseAirportUrl + "/operations-columns?") +
	            ("tableName=" + request.tableName) +
	            ("&locId=" + request.locId) +
	            ("&scenarioId=" + request.scenarioId) +
	            ("&isAdmin=" + request.isAdmin);
	        return this.httpHelper.get(url);
	    };
	    AirportService.prototype.getOperationsList = function (request) {
	        var url = (this._baseAirportUrl + "/operations-list?") +
	            ("tableName=" + request.tableName) +
	            ("&locId=" + request.locId) +
	            ("&scenarioId=" + request.scenarioId) +
	            ("&isAdmin=" + request.isAdmin);
	        return this.httpHelper.get(url);
	    };
	    AirportService.prototype.updateOperations = function (request) {
	        return this.httpHelper.put(this._baseAirportUrl + "/operations-update", request);
	    };
	    AirportService.prototype.saveOperationsYear = function (request) {
	        return this.httpHelper.post(this._baseAirportUrl + "/operations-year", request);
	    };
	    AirportService.prototype.getGraphMinYear = function (request) {
	        var url = (this._baseAirportUrl + "/operations-graph/min-year?") +
	            ("tableName=" + request.tableName) +
	            ("&locId=" + request.locId) +
	            ("&scenarioId=" + request.scenarioId);
	        return this.httpHelper.get(url);
	    };
	    AirportService.prototype.getGraphData = function (request) {
	        return this.httpHelper.post(this._baseAirportUrl + "/operations-graph", request);
	    };
	    AirportService.prototype.hasGraphData = function (request) {
	        var url = (this._baseAirportUrl + "/operations-graph/has-data?") +
	            ("tableName=" + request.tableName) +
	            ("&locId=" + request.locId) +
	            ("&scenarioId=" + request.scenarioId);
	        return this.httpHelper.get(url);
	    };
	    AirportService.prototype.getReforcastData = function (request) {
	        var url = (this._baseAirportUrl + "/operations-reforecast?") +
	            ("tableName=" + request.tableName) +
	            ("&fieldName=" + request.fieldName) +
	            ("&minYear=" + request.minYear) +
	            ("&locId=" + request.locId) +
	            ("&scenarioId=" + request.scenarioId);
	        return this.httpHelper.get(url);
	    };
	    AirportService.prototype.reforecastSupplyData = function (request) {
	        return this.httpHelper.post(this._baseAirportUrl + "/operations-reforecast/supply-data", request);
	    };
	    AirportService.prototype.reforecastOperation = function (request) {
	        return this.httpHelper.post(this._baseAirportUrl + "/operations-reforecast/operation", request);
	    };
	    AirportService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], AirportService);
	    return AirportService;
	}());
	exports.AirportService = AirportService;


/***/ },

/***/ 678:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var http_1 = __webpack_require__(376);
	var Rx_1 = __webpack_require__(398);
	var app_config_values_1 = __webpack_require__(676);
	var auth_service_1 = __webpack_require__(679);
	var HttpHelper = (function () {
	    function HttpHelper(http, config, authService) {
	        this.http = http;
	        this.config = config;
	        this.authService = authService;
	        this.urlPrefix = config.getApiHostUrl();
	    }
	    HttpHelper.prototype.get = function (url) {
	        var headers = new http_1.Headers();
	        if (this.authService.isLoggedIn()) {
	            headers.append('Authorization', "Bearer " + this.authService.getAccessToken());
	        }
	        return this.http.get(this.urlPrefix + url, { headers: headers })
	            .map(this.extractData)
	            .do(function (data) { return console.log(data); })
	            .catch(this.handleError);
	    };
	    HttpHelper.prototype.post = function (url, body, options) {
	        var headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        if (this.authService.isLoggedIn()) {
	            headers.append('Authorization', "Bearer " + this.authService.getAccessToken());
	        }
	        var postOptions = options || { headers: headers };
	        return this.http.post(this.urlPrefix + url, body, postOptions)
	            .map(this.extractData)
	            .do(function (data) { return console.log(" data " + data); })
	            .catch(this.handleError);
	    };
	    HttpHelper.prototype.put = function (url, body, options) {
	        var headers = new http_1.Headers({ 'Content-Type': 'application/json' });
	        if (this.authService.isLoggedIn()) {
	            headers.append('Authorization', "Bearer " + this.authService.getAccessToken());
	        }
	        var postOptions = options || { headers: headers };
	        return this.http.put(this.urlPrefix + url, body, postOptions)
	            .map(this.extractData)
	            .do(function (data) { return console.log(data); })
	            .catch(this.handleError);
	    };
	    HttpHelper.prototype.delete = function (url, options) {
	        //not sure if I actually need the headers and options here 
	        //let headers = new Headers({'Content-Type': 'application/json'});
	        //let postOptions = options || {headers : headers }
	        //return this.http.delete(this.urlPrefix + url, postOptions)
	        var headers = new http_1.Headers();
	        if (this.authService.isLoggedIn()) {
	            headers.append('Authorization', "Bearer " + this.authService.getAccessToken());
	        }
	        return this.http.delete(this.urlPrefix + url, { headers: headers })
	            .map(this.extractData)
	            .do(function (data) { return console.log(data); })
	            .catch(this.handleError);
	    };
	    HttpHelper.prototype.extractData = function (res) {
	        var body;
	        // check if empty, before call json
	        if (res.text()) {
	            body = res.json();
	        }
	        return body || {};
	    };
	    HttpHelper.prototype.handleError = function (error) {
	        var errMsg = (error.message) ? error.message :
	            error.status ? error.status + " - " + error.statusText : 'Server error';
	        console.error(errMsg);
	        return Rx_1.Observable.throw(errMsg);
	    };
	    HttpHelper = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_1.Http, app_config_values_1.AppConfigValues, auth_service_1.AuthService])
	    ], HttpHelper);
	    return HttpHelper;
	}());
	exports.HttpHelper = HttpHelper;


/***/ },

/***/ 679:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	// user.service.ts
	var core_1 = __webpack_require__(11);
	var http_1 = __webpack_require__(376);
	//import { HttpHelper } from '../shared/http-helper';
	var Rx_1 = __webpack_require__(398);
	var app_config_values_1 = __webpack_require__(676);
	var _ = __webpack_require__(680);
	var AuthService = (function () {
	    function AuthService(http) {
	        this.http = http;
	        this.serviceUrlPrefix = new app_config_values_1.AppConfigValues().getApiHostUrl();
	    }
	    AuthService.prototype.oidclogin = function () {
	        var linkurl = new app_config_values_1.AppConfigValues().getApiHostUrl();
	        window.location.href = linkurl + 'auth/api/account/oidclogin';
	        //window.location.href='http://localhost:55706/auth/api/account/oidclogin';
	        //return this.http.get('http://localhost:55706/auth/api/account/oidclogin');
	    };
	    AuthService.prototype.getToken = function () {
	        if (this.token) {
	            return this.token;
	        }
	        else {
	            return JSON.parse(sessionStorage.getItem("token"));
	        }
	    };
	    AuthService.prototype.isLoggedIn = function () {
	        return this.getToken() !== null && new Date() < new Date(this.getToken()['.expires']);
	    };
	    AuthService.prototype.getAccessToken = function () {
	        return this.getToken().access_token;
	    };
	    AuthService.prototype.setToken = function (token) {
	        this.token = token;
	        if (token) {
	            //think I can do either
	            //this seems to be setting the to string of token not the actual json will have to look at that
	            //http://vaughnroyko.com/saving-and-loading-objects-or-arrays-in-localstorage
	            sessionStorage.setItem("token", JSON.stringify(token));
	        }
	        else {
	            sessionStorage.removeItem("token");
	        }
	    };
	    AuthService.prototype.getLoggedInUser = function () {
	        if (this.getToken()) {
	            return this.getToken().userName;
	        }
	    };
	    AuthService.prototype.getFullName = function () {
	        if (this.getToken()) {
	            return this.getToken().fullname;
	        }
	    };
	    AuthService.prototype.getRoles = function () {
	        if (this.getToken())
	            return this.getToken().roles;
	    };
	    AuthService.prototype.isInRole = function (role) {
	        console.log(this.getToken());
	        return this.getToken() != null && _.includes(this.getToken().roles.split(','), role);
	    };
	    AuthService.prototype.isAdmin = function () {
	        return this.getToken() != null && (_.includes(this.getToken().roles.split(','), "System Developer") ||
	            _.includes(this.getToken().roles.split(','), "FAA Admin"));
	    };
	    AuthService.prototype.isRegionalManager = function () {
	        return this.getToken() != null && (_.includes(this.getToken().roles.split(','), "Regional Manager"));
	    };
	    AuthService.prototype.isReadOnly = function () {
	        return this.getToken() != null && (_.includes(this.getToken().roles.split(','), "Read Only"));
	    };
	    AuthService.prototype.logOut = function () {
	        this.token = null;
	        sessionStorage.clear();
	    };
	    AuthService.prototype.getUserId = function () {
	        if (this.getToken())
	            return this.getToken().id;
	    };
	    AuthService.prototype.login = function (oidcCode) {
	        var _this = this;
	        var headers = new http_1.Headers();
	        headers.append('Content-Type', 'application/x-www-form-urlencoded');
	        //will need to call our helper method here 
	        return this.http.post(this.serviceUrlPrefix + "token", 'grant_type=myaccess&oidcCode=' + encodeURIComponent(oidcCode), { headers: headers })
	            .map(this.extractData)
	            .do(function (data) { return console.log("data" + data); })
	            .catch(this.handleError)
	            .map(function (data) {
	            _this.setToken(data);
	            return data;
	        });
	    };
	    AuthService.prototype.handleError = function (error) {
	        var body = error.json();
	        return Rx_1.Observable.throw(body || { error_description: "Server Error" });
	    };
	    AuthService.prototype.extractData = function (res) {
	        var body = res.json();
	        return body || {};
	    };
	    AuthService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_1.Http])
	    ], AuthService);
	    return AuthService;
	}());
	exports.AuthService = AuthService;


/***/ },

/***/ 681:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var TAFBookService = (function () {
	    function TAFBookService(httpHelper) {
	        this.httpHelper = httpHelper;
	        this._tafBookurl = "api/tafbook";
	    }
	    TAFBookService.prototype.generateTafBook = function (request) {
	        return this.httpHelper.post(this._tafBookurl + "/tafbookGenerate", request);
	    };
	    TAFBookService.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    TAFBookService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], TAFBookService);
	    return TAFBookService;
	}());
	exports.TAFBookService = TAFBookService;


/***/ },

/***/ 682:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	__webpack_require__(552);
	var TAFBookB1Service = (function () {
	    function TAFBookB1Service(httpHelper) {
	        this.httpHelper = httpHelper;
	        //need to have this somewhere besides hardcoded in here
	        //private _tafBookB1Url = ` http://localhost:55706/api/systemmanagement/TAFBookB1`;
	        this._tafBookB1Url = "api/systemmanagement/TAFBookB1";
	    }
	    TAFBookB1Service.prototype.getTAFBookB1 = function () {
	        return this.httpHelper.get("" + this._tafBookB1Url);
	        //.map((response: Response) => <ITAFBookB1> response.json())
	        //.do(data => console.log('ITafBookB1: ' +  JSON.stringify(data)))
	        //.catch(this.handleError);
	    };
	    TAFBookB1Service.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json() || 'Server error');
	    };
	    TAFBookB1Service = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], TAFBookB1Service);
	    return TAFBookB1Service;
	}());
	exports.TAFBookB1Service = TAFBookB1Service;


/***/ },

/***/ 683:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var TAFBookB2Service = (function () {
	    function TAFBookB2Service(httpHelper) {
	        this.httpHelper = httpHelper;
	        //need to have this somewhere besides hardcoded in here
	        //private _tafBookB2Url = ` http://localhost:55706/api/systemmanagement/TAFBookB2`;
	        this._tafBookB2Url = "api/systemmanagement/TAFBookB2";
	    }
	    TAFBookB2Service.prototype.getTAFBookB2 = function () {
	        return this.httpHelper.get("" + this._tafBookB2Url);
	        //.map((response: Response) => <ITAFBookB2> response.json())
	        //.do(data => console.log('ITafBookB2: ' +  JSON.stringify(data)))
	        //.catch(this.handleError);
	    };
	    TAFBookB2Service.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    TAFBookB2Service = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], TAFBookB2Service);
	    return TAFBookB2Service;
	}());
	exports.TAFBookB2Service = TAFBookB2Service;


/***/ },

/***/ 684:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var TAFBookB3Service = (function () {
	    function TAFBookB3Service(httpHelper) {
	        this.httpHelper = httpHelper;
	        //need to have this somewhere besides hardcoded in here
	        //private _tafBookB3Url = ` http://localhost:55706/api/systemmanagement/TAFBookB3`;
	        this._tafBookB3Url = "api/systemmanagement/TAFBookB3";
	    }
	    TAFBookB3Service.prototype.getTAFBookB3 = function () {
	        return this.httpHelper.get("" + this._tafBookB3Url);
	        //.map((response: Response) => <ITAFBookB3> response.json())
	        //.do(data => console.log('ITafBookB3: ' +  JSON.stringify(data)))
	        //.catch(this.handleError);
	    };
	    TAFBookB3Service.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    TAFBookB3Service = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], TAFBookB3Service);
	    return TAFBookB3Service;
	}());
	exports.TAFBookB3Service = TAFBookB3Service;


/***/ },

/***/ 685:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var TAFBookB4Service = (function () {
	    function TAFBookB4Service(httpHelper) {
	        this.httpHelper = httpHelper;
	        //need to have this somewhere besides hardcoded in here
	        //private _tafBookB4Url = ` http://localhost:55706/api/systemmanagement/TAFBookB4`;
	        this._tafBookB4Url = "api/systemmanagement/TAFBookB4";
	    }
	    TAFBookB4Service.prototype.getTAFBookB4 = function () {
	        return this.httpHelper.get("" + this._tafBookB4Url);
	        //.map((response: Response) => <ITAFBookB4> response.json())
	        //.do(httpHelper => console.log('ITafBookB4: ' +  JSON.stringify(data)))
	        //.catch(this.handleError);
	    };
	    TAFBookB4Service.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    TAFBookB4Service = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], TAFBookB4Service);
	    return TAFBookB4Service;
	}());
	exports.TAFBookB4Service = TAFBookB4Service;


/***/ },

/***/ 686:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var TAFBookB5Service = (function () {
	    function TAFBookB5Service(httpHelper) {
	        this.httpHelper = httpHelper;
	        //need to have this somewhere besides hardcoded in here
	        //private _tafBookB5Url = ` http://localhost:55706/api/systemmanagement/TAFBookB5`;
	        this._tafBookB5Url = "api/systemmanagement/TAFBookB5";
	    }
	    TAFBookB5Service.prototype.getTAFBookB5 = function () {
	        return this.httpHelper.get("" + this._tafBookB5Url);
	        //.map((response: Response) => <ITAFBookB5> response.json())
	        //.do(httpHelper => console.log('ITafBookB5: ' +  JSON.stringify(data)))
	        //.catch(this.handleError);
	    };
	    TAFBookB5Service.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    TAFBookB5Service = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], TAFBookB5Service);
	    return TAFBookB5Service;
	}());
	exports.TAFBookB5Service = TAFBookB5Service;


/***/ },

/***/ 687:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var TAFBookS1Service = (function () {
	    function TAFBookS1Service(httpHelper) {
	        this.httpHelper = httpHelper;
	        //need to have this somewhere besides hardcoded in here
	        //private _tafBookS1Url = ` http://localhost:55706/api/systemmanagement/TAFBookS1`;
	        this._tafBookS1Url = "api/systemmanagement/TAFBookS1";
	    }
	    TAFBookS1Service.prototype.getTAFBookS1 = function () {
	        return this.httpHelper.get("" + this._tafBookS1Url);
	        //.map((response: Response) => <ITAFBookS1> response.json())
	        //.do(data => console.log('ITafBookS1: ' +  JSON.stringify(data)))
	        //.catch(this.handleError);
	    };
	    TAFBookS1Service.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    TAFBookS1Service = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], TAFBookS1Service);
	    return TAFBookS1Service;
	}());
	exports.TAFBookS1Service = TAFBookS1Service;


/***/ },

/***/ 688:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var TAFBookS2Service = (function () {
	    function TAFBookS2Service(httpHelper) {
	        this.httpHelper = httpHelper;
	        //need to have this somewhere besides hardcoded in here
	        //private _tafBookS2Url = ` http://localhost:55706/api/systemmanagement/TAFBookS2`;
	        this._tafBookS2Url = "api/systemmanagement/TAFBookS2";
	    }
	    TAFBookS2Service.prototype.getTAFBookS2 = function () {
	        return this.httpHelper.get("" + this._tafBookS2Url);
	        //.map((response: Response) => <ITAFBookS2> response.json())
	        //.do(data => console.log('ITafBookS2: ' +  JSON.stringify(data)))
	        //.catch(this.handleError);
	    };
	    TAFBookS2Service.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    TAFBookS2Service = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], TAFBookS2Service);
	    return TAFBookS2Service;
	}());
	exports.TAFBookS2Service = TAFBookS2Service;


/***/ },

/***/ 689:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var TAFBookS3Service = (function () {
	    function TAFBookS3Service(httpHelper) {
	        this.httpHelper = httpHelper;
	        //need to have this somewhere besides hardcoded in here
	        //private _tafBookS3Url = ` http://localhost:55706/api/systemmanagement/TAFBookS3`;
	        this._tafBookS3Url = "api/systemmanagement/TAFBookS3";
	    }
	    TAFBookS3Service.prototype.getTAFBookS3 = function () {
	        return this.httpHelper.get("" + this._tafBookS3Url);
	        //.map((response: Response) => <ITAFBookS3> response.json())
	        //.do(data => console.log('ITafBookS3: ' +  JSON.stringify(data)))
	        //.catch(this.handleError);
	    };
	    TAFBookS3Service.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    TAFBookS3Service = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], TAFBookS3Service);
	    return TAFBookS3Service;
	}());
	exports.TAFBookS3Service = TAFBookS3Service;


/***/ },

/***/ 690:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var TAFBookGraphS1Service = (function () {
	    function TAFBookGraphS1Service(httpHelper) {
	        this.httpHelper = httpHelper;
	        //private _tafBookGraphS1Url = ` http://localhost:55706/api/systemmanagement/TAFBookGraphS1`;
	        this._tafBookGraphS1Url = "api/systemmanagement/TAFBookGraphS1";
	    }
	    TAFBookGraphS1Service.prototype.getTAFGraphS1BookSplit = function () {
	        return this.httpHelper.get("" + this._tafBookGraphS1Url);
	        //return Observable.forkJoin(
	        //  this.httpHelper.get(`${this._tafBookGraphS1Url}`));
	        //.map((response: Response) => _.map(JSON.parse(JSON.stringify(response.json())),'locid')),
	        //.do(httpHelper => console.log("trying to pull locid only in Service: " + data)),
	        // this.httpHelper.get(`${this._tafBookGraphS1Url}`)
	        //.map((response: Response) => _.map(JSON.parse(JSON.stringify(response.json())),'rateFyLfc')));
	        //.do(httpHelper => console.log("trying to pull rates only in Service: " + data)));
	    };
	    TAFBookGraphS1Service.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    TAFBookGraphS1Service = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], TAFBookGraphS1Service);
	    return TAFBookGraphS1Service;
	}());
	exports.TAFBookGraphS1Service = TAFBookGraphS1Service;


/***/ },

/***/ 691:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var QueryReportService = (function () {
	    function QueryReportService(httpHelper) {
	        this.httpHelper = httpHelper;
	        this._queryreporturl = "api/queryreport";
	    }
	    QueryReportService.prototype.getFacilityListReport = function (request) {
	        return this.httpHelper.post(this._queryreporturl + "/queryReportsGenerate", request);
	    };
	    QueryReportService.prototype.saveLocids = function (requestLocid) {
	        return this.httpHelper.post(this._queryreporturl + "/saveLocidList", requestLocid);
	    };
	    QueryReportService.prototype.generateGraphs = function (request) {
	        return this.httpHelper.post(this._queryreporturl + "/queryReportGraphs", request);
	    };
	    QueryReportService.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    QueryReportService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], QueryReportService);
	    return QueryReportService;
	}());
	exports.QueryReportService = QueryReportService;


/***/ },

/***/ 692:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var ScenarioService = (function () {
	    function ScenarioService(_httpHelper) {
	        this._httpHelper = _httpHelper;
	        this._baseScenarioUrl = 'api/scenario';
	    }
	    ScenarioService.prototype.getScenario = function (scenarioId) {
	        return this._httpHelper.get(this._baseScenarioUrl + "/" + scenarioId);
	    };
	    ScenarioService.prototype.getScenarios = function (userId) {
	        return this._httpHelper.get(this._baseScenarioUrl + "/list/" + userId);
	    };
	    ScenarioService.prototype.getMergeListScenarios = function (type, userId) {
	        return this._httpHelper.get(this._baseScenarioUrl + "/mergelist/" + type + "/" + userId);
	    };
	    ScenarioService.prototype.getDeleteListScenarios = function (userId) {
	        return this._httpHelper.get(this._baseScenarioUrl + "/deletelist/" + userId);
	    };
	    ScenarioService.prototype.createScenario = function (request) {
	        return this._httpHelper.post(this._baseScenarioUrl + "/create", request);
	    };
	    ScenarioService.prototype.deleteScenarios = function (ids) {
	        return this._httpHelper.post(this._baseScenarioUrl + "/delete", ids);
	    };
	    ScenarioService.prototype.updateCommitScenario = function (request) {
	        return this._httpHelper.post(this._baseScenarioUrl + "/updatecommit", request);
	    };
	    ScenarioService.prototype.modifyScenarioFacilities = function (request) {
	        return this._httpHelper.post(this._baseScenarioUrl + "/modifyscenariofacilities", request);
	    };
	    ScenarioService.prototype.executeReforecast = function (request) {
	        return this._httpHelper.post(this._baseScenarioUrl + "/forecast", request);
	    };
	    ScenarioService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], ScenarioService);
	    return ScenarioService;
	}());
	exports.ScenarioService = ScenarioService;
	var CreateScenarioRequest = (function () {
	    function CreateScenarioRequest() {
	    }
	    CreateScenarioRequest.prototype.updateSessionState = function () {
	        sessionStorage.setItem('create-scenario-request', JSON.stringify(this));
	    };
	    CreateScenarioRequest.prototype.getSession = function () {
	        if (sessionStorage.getItem('create-scenario-request') === null)
	            return null;
	        var storedRq = JSON.parse(sessionStorage.getItem('create-scenario-request'));
	        this.baseScenarioId = storedRq.baseScenarioId;
	        this.facilities = storedRq.facilities;
	        this.public = storedRq.public;
	        this.scenarioName = storedRq.scenarioName;
	        this.source = storedRq.source;
	        this.userId = storedRq.userId;
	        return (this);
	    };
	    CreateScenarioRequest.prototype.destroySession = function () {
	        sessionStorage.removeItem('create-scenario-request');
	    };
	    CreateScenarioRequest.prototype.hasValidSession = function () {
	        return sessionStorage.getItem('create-scenario-request') !== null;
	    };
	    return CreateScenarioRequest;
	}());
	exports.CreateScenarioRequest = CreateScenarioRequest;
	var CreateScenarioResponse = (function () {
	    function CreateScenarioResponse() {
	    }
	    return CreateScenarioResponse;
	}());
	exports.CreateScenarioResponse = CreateScenarioResponse;
	var UpdateCommitScenarioRequest = (function () {
	    function UpdateCommitScenarioRequest() {
	    }
	    return UpdateCommitScenarioRequest;
	}());
	exports.UpdateCommitScenarioRequest = UpdateCommitScenarioRequest;
	var UpdateCommitScenarioResponse = (function () {
	    function UpdateCommitScenarioResponse() {
	    }
	    return UpdateCommitScenarioResponse;
	}());
	exports.UpdateCommitScenarioResponse = UpdateCommitScenarioResponse;
	var ModifyScenarioFacilitiesRequest = (function () {
	    function ModifyScenarioFacilitiesRequest() {
	    }
	    return ModifyScenarioFacilitiesRequest;
	}());
	exports.ModifyScenarioFacilitiesRequest = ModifyScenarioFacilitiesRequest;
	var ModifyScenarioFacilitiesResponse = (function () {
	    function ModifyScenarioFacilitiesResponse() {
	    }
	    return ModifyScenarioFacilitiesResponse;
	}());
	exports.ModifyScenarioFacilitiesResponse = ModifyScenarioFacilitiesResponse;
	var ScenarioForecastRequest = (function () {
	    function ScenarioForecastRequest() {
	    }
	    ScenarioForecastRequest.prototype.setNameInSession = function (name) {
	        sessionStorage.setItem('reforecast-scenario-name', name);
	    };
	    ScenarioForecastRequest.prototype.getNameInSession = function () {
	        return sessionStorage.getItem('reforecast-scenario-name');
	    };
	    ScenarioForecastRequest.prototype.destroySessionValues = function () {
	        sessionStorage.removeItem('reforecast-scenario-name');
	    };
	    return ScenarioForecastRequest;
	}());
	exports.ScenarioForecastRequest = ScenarioForecastRequest;
	var ScenarioForecastResponse = (function () {
	    function ScenarioForecastResponse() {
	    }
	    return ScenarioForecastResponse;
	}());
	exports.ScenarioForecastResponse = ScenarioForecastResponse;


/***/ },

/***/ 693:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var http_helper_1 = __webpack_require__(678);
	var CommonDataService = (function () {
	    function CommonDataService(_httpHelper) {
	        this._httpHelper = _httpHelper;
	        this._serviceUrlPrefix = '/api/data';
	    }
	    CommonDataService.prototype.getData = function (source) {
	        return this._httpHelper.get(this._serviceUrlPrefix + "/" + source);
	    };
	    CommonDataService.prototype.getSystemControlData = function () {
	        return this._httpHelper.get(this._serviceUrlPrefix + "/systemcontrol");
	    };
	    CommonDataService.prototype.getVariableInfo = function () {
	        return this._httpHelper.get(this._serviceUrlPrefix + "/variableinfo");
	    };
	    CommonDataService.prototype.getEnplanementYears = function () {
	        return this._httpHelper.get(this._serviceUrlPrefix + "/enplanementyears");
	    };
	    CommonDataService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], CommonDataService);
	    return CommonDataService;
	}());
	exports.CommonDataService = CommonDataService;
	var KeyValuePair = (function () {
	    function KeyValuePair() {
	    }
	    return KeyValuePair;
	}());
	exports.KeyValuePair = KeyValuePair;
	var SystemControl = (function () {
	    function SystemControl() {
	    }
	    return SystemControl;
	}());
	exports.SystemControl = SystemControl;
	var VariableInfo = (function () {
	    function VariableInfo() {
	    }
	    return VariableInfo;
	}());
	exports.VariableInfo = VariableInfo;


/***/ },

/***/ 694:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var SystemControlService = (function () {
	    function SystemControlService(httpHelper) {
	        this.httpHelper = httpHelper;
	        this._systemControlUrl = "api/data";
	    }
	    SystemControlService.prototype.getSystemControl = function () {
	        return this.httpHelper.get(this._systemControlUrl + "/systemcontrol");
	    };
	    SystemControlService.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    SystemControlService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], SystemControlService);
	    return SystemControlService;
	}());
	exports.SystemControlService = SystemControlService;


/***/ },

/***/ 695:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	// user.service.ts
	var core_1 = __webpack_require__(11);
	var http_helper_1 = __webpack_require__(678);
	var UserInfoService = (function () {
	    function UserInfoService(httpHelper) {
	        this.httpHelper = httpHelper;
	    }
	    UserInfoService.prototype.isScenarioOwner = function (userId, scenarioId) {
	        return this.httpHelper.get("api/user-info/scenario-owner/" + userId + "/" + scenarioId);
	    };
	    UserInfoService.prototype.getRegCode = function (userId) {
	        return this.httpHelper.get("api/user-info/reg-code/" + userId);
	    };
	    UserInfoService.prototype.getRegionalYear = function (userId) {
	        return this.httpHelper.get("api/user-info/regional-years/" + userId);
	    };
	    UserInfoService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], UserInfoService);
	    return UserInfoService;
	}());
	exports.UserInfoService = UserInfoService;


/***/ },

/***/ 696:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var auth_service_1 = __webpack_require__(679);
	var _ = __webpack_require__(680);
	var AuthGuard = (function () {
	    function AuthGuard(authService, router) {
	        this.authService = authService;
	        this.router = router;
	        this.systemDeveloperOnlyRoutes = ['/admin', '/user-admin'];
	    }
	    AuthGuard.prototype.canActivate = function (route, state) {
	        if (this.authService.isLoggedIn()) {
	            if (_.includes(this.systemDeveloperOnlyRoutes, state.url) && !this.authService.isInRole("System Developer")) {
	                this.router.navigate(['/welcome']);
	                return false;
	            }
	            return true;
	        }
	        else {
	            // Store the attempted URL for redirecting
	            this.authService.redirectUrl = state.url;
	            // Navigate to the login page
	            this.router.navigate(['/login', { requestedUrl: state.url }]);
	            return false;
	        }
	    };
	    AuthGuard = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [auth_service_1.AuthService, router_1.Router])
	    ], AuthGuard);
	    return AuthGuard;
	}());
	exports.AuthGuard = AuthGuard;


/***/ },

/***/ 697:
/***/ function(module, exports) {

	/* Defines the airport entity */
	"use strict";
	var OperationsListRequest = (function () {
	    function OperationsListRequest() {
	    }
	    return OperationsListRequest;
	}());
	exports.OperationsListRequest = OperationsListRequest;
	var ReforecastRequest = (function () {
	    function ReforecastRequest() {
	    }
	    return ReforecastRequest;
	}());
	exports.ReforecastRequest = ReforecastRequest;


/***/ },

/***/ 698:
/***/ function(module, exports) {

	"use strict";
	var QueryReportListRequest = (function () {
	    function QueryReportListRequest() {
	    }
	    return QueryReportListRequest;
	}());
	exports.QueryReportListRequest = QueryReportListRequest;
	var IQueryReportRequest = (function () {
	    function IQueryReportRequest(startYear, scenario, reportId, facOption, locidList) {
	        this.startYear = startYear;
	        this.scenario = scenario;
	        this.reportId = reportId;
	        this.facOption = facOption;
	        this.locidList = locidList;
	    }
	    return IQueryReportRequest;
	}());
	exports.IQueryReportRequest = IQueryReportRequest;
	var IQueryReportListComponent = (function () {
	    function IQueryReportListComponent(id, name) {
	        this.id = id;
	        this.name = name;
	    }
	    return IQueryReportListComponent;
	}());
	exports.IQueryReportListComponent = IQueryReportListComponent;
	var IQueryReportsFacilityRequest = (function () {
	    function IQueryReportsFacilityRequest(locid, scenario) {
	        this.locid = locid;
	        this.scenarioId = scenario;
	    }
	    return IQueryReportsFacilityRequest;
	}());
	exports.IQueryReportsFacilityRequest = IQueryReportsFacilityRequest;


/***/ },

/***/ 699:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var auth_service_1 = __webpack_require__(679);
	//import { plainToClass } from "class-transformer"; 
	var UserSession = (function () {
	    function UserSession(_authService) {
	        this._authService = _authService;
	        this.userId = _authService.getUserId();
	        this.fullName = _authService.getFullName();
	        this.roles = _authService.getRoles();
	        this.isAdmin = _authService.isAdmin();
	        this.isRegionalManager = _authService.isRegionalManager();
	        this.isReadOnly = _authService.isReadOnly();
	        this.scenarioId = 1; // default to National
	    }
	    UserSession.prototype.updateSessionState = function () {
	        if (sessionStorage.getItem('user-session') !== null)
	            sessionStorage.removeItem('user-session');
	        sessionStorage.setItem('user-session', JSON.stringify(sessionStorage["token"]));
	    };
	    UserSession.prototype.getSession = function () {
	        if (sessionStorage.getItem('user-session') === null)
	            return null;
	        //let uSession:UserSession = JSON.parse(sessionStorage.getItem('user-session')) as UserSession;
	        var jsonObject = JSON.parse(sessionStorage["token"]);
	        var uSession = jsonObject;
	        uSession.scenarioId = this.scenarioId;
	        uSession.isAdmin = this._authService.isAdmin();
	        uSession.isRegionalManager = this._authService.isRegionalManager();
	        uSession.isReadOnly = this._authService.isReadOnly();
	        //console.log("uSession.scenarioId" + uSession.scenarioId);
	        return uSession;
	    };
	    UserSession.prototype.getUserId = function () {
	        var userId = this._authService.getUserId();
	        return userId;
	    };
	    UserSession.prototype.getScenarioId = function () {
	        return this.scenarioId;
	    };
	    UserSession.prototype.hasValidSession = function () {
	        return sessionStorage.getItem('user-session') !== null;
	    };
	    UserSession = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [auth_service_1.AuthService])
	    ], UserSession);
	    return UserSession;
	}());
	exports.UserSession = UserSession;


/***/ },

/***/ 700:
/***/ function(module, exports) {

	module.exports = "\r\n .custom {\r\n    width: 250px !important;\r\n    background-color:#ff9;\r\n    color: #000;\r\n}\r\n.custom-airport-button{\r\n    font-weight:normal;\r\n}\r\n/*.ui-button,  .ui-button.ui-state-default {\r\n    width: 150px !important;\r\n    background-color:#ff9;\r\n    color: #000;\r\n}*/\r\n.custom-button-header {\r\n    background-color:#ff9;\r\n    color: #000;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n    border-radius: 8px;\r\n    width: 150px !important;\r\n}\r\n.customh2{\r\n    font-size: 18px;\r\n    padding-bottom: 2px;\r\n    margin: 20px 0px 10px;\r\n    color: #900;\r\n    border-bottom: #999 1px solid;\r\n    text-align: left;\r\n}\r\n.customh3{\r\n    padding-right: 0px;\r\n    padding-left: 0px;\r\n    padding-bottom: 0px;\r\n    padding-top: 0px;\r\n    margin: 13px 0px 5px;\r\n    font: bold 94%/115% Arial, Verdana, Helvetica, sans-serif;\r\n    color: #3d3d3d;\r\n    font-size: 12px;\r\n}\r\n.custom-checkbox-label{\r\n    padding-right: 0px;\r\n    padding-left: 0px;\r\n    padding-bottom: 0px;\r\n    padding-top: 0px;\r\n    margin: 13px 0px 5px;\r\n    font: bold 94%/115% Arial, Verdana, Helvetica, sans-serif;\r\n    color: #3d3d3d;\r\n    font-size: 12px;\r\n}\r\n.custom-radio-label{\r\n    padding-right: 0px;\r\n    padding-left: 0px;\r\n    padding-bottom: 0px;\r\n    padding-top: 0px;\r\n    font: bold 94%/115% Arial, Verdana, Helvetica, sans-serif;\r\n    color: #3d3d3d;\r\n    font-size: 10px;\r\n}\r\n.selectionOptions {\r\n\tmargin-left: 20px;\r\n\tpadding: 10px;\r\n\tbackground-color: #fff5ce;\r\n}\r\n.customtd{\r\n    font-size: 12px;\r\n    text-align: left; \r\n}\r\n.customtd-reforecast{\r\n    font-size: 11px;\r\n    text-align: right; \r\n    white-space:nowrap;\r\n}\r\n.customtd-reforecast-year{\r\n    font-size: 11px;\r\n    text-align: left; \r\n    white-space:nowrap\r\n}\r\n.customtd-reforecast-numeric{\r\n    font-size: 11px;\r\n    text-align: right; \r\n    white-space:nowrap;\r\n    box-sizing: border-box;\r\n    -moz-box-sizing: border-box;\r\n    width:75px;\r\n    padding:0px;\r\n}\r\n.customth-reforecast{\r\n    font-weight: bold;\r\n    font-size: 13px;\r\n    background-color: #ddd;\r\n    color: #1e1e1e;\r\n    text-align: center;\r\n}\r\n\r\n.table > thead > tr > th,\r\n.table > tbody > tr > th,\r\n.table > tfoot > tr > th,\r\n.table > thead > tr > td,\r\n.table > tbody > tr > td,\r\n.table > tfoot > tr > td {\r\n  padding-bottom: 2px !important;\r\n  padding-top: 2px !important;\r\n  padding-left: 2px;\r\n  padding-right:8px!important;;\r\n  line-height: 1.42857143;\r\n  vertical-align: top;\r\n  border-top: 1px solid #ddd;\r\n}\r\n\r\n.divider {\r\n    border-bottom: 1px;\r\n    border-bottom-color: black;\r\n    border-bottom-style: solid;\r\n}\r\n.current-scenario{\r\n    text-align: center;\r\n    vertical-align: top;\r\n}\r\n.menu-section {\r\n    font-weight: bold;\r\n    width: 200px;\r\n}\r\n.menu-section .menu-items {\r\n    margin-left: 22px;\r\n    display: none;\r\n}\r\n.menu-section .menu-items-visible {\r\n    margin-left: 22px;\r\n    display: block;\r\n}\r\n.divider-space {\r\n    margin-bottom: 20px;\r\n}\r\n.checkbox-group {\r\n    clear: both;\r\n    height: 25px;\r\n    margin-bottom: 5px;\r\n}\r\n.checkbox-group .checkbox {\r\n    float: left;\r\n    height: 20px;\r\n    margin: 5px 30px 0 0 ;\r\n    width: 225px;\r\n}\r\n.search {\r\n    border: 1px solid #e5e5e5;\r\n    border-radius: 5px;\r\n    margin: 10px 0 20px 0;\r\n    padding: 0 10px 10px 10px;\r\n}\r\n.search h3 {\r\n    text-align: center;\r\n}\r\n.locids {\r\n    border: 1px solid #e5e5e5;\r\n    border-radius: 5px;\r\n    margin: 10px 0 0 5px;\r\n    height: 400px;\r\n    background-color: #f6f6f6;\r\n    overflow: scroll;\r\n    align-items: right;\r\n}\r\n.locids .header {\r\n    text-align: center;\r\n}\r\n.locids ul {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n.locids ul li a {\r\n    float: right;\r\n    cursor: pointer;\r\n}\r\n.checkbox-group {\r\n    clear: both;\r\n    height: 25px;\r\n    margin-bottom: 5px;\r\n}\r\n.checkbox-group .checkbox {\r\n    margin-top: 5px;\r\n}\r\n.hidden {\r\n    display: none;\r\n}\r\n.more-search-options-panel {\r\n    margin-top: -20px;\r\n}\r\n.more-search-options-panel .glyphicon {\r\n    cursor: pointer;\r\n}\r\n.more-search-options {\r\n    display: block;\r\n}\r\n.totals {\r\n    margin-left: 5px;\r\n}\r\n.search-option-container {\r\n    border: 1px solid #d5d5d5;\r\n    border-radius: 5px;\r\n    clear: both;\r\n    padding: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n.search-option-container .radio {\r\n    margin-left: 20px;\r\n}\r\n/*************************************************************************************************/\r\n/* title */\r\nnav .navbar .navbar-default .navbar-brand {\r\n  float: left;\r\n  font-size: 18px;\r\n  line-height: 20px;\r\n}\r\n.navbar-default .navbar-nav > li > a {\r\n  color: #777;\r\n  padding-top: 0px;\r\n  padding-bottom: 0px;\r\n}\r\n.navbar-default .navbar-brand {\r\n    background-color: #c0e4fe;\r\n    color: #777;\r\n    font: bold 50%/75% Arial, Verdana, Helvetica, sans-serif;\r\n    font-size:5px;\r\n    padding-left:50%;\r\n    padding:0px 0px;\r\n}\r\n\r\n.navbar-default .navbar-brand:hover,\r\n.navbar-default .navbar-brand:focus {\r\n    color: #5E5E5E;\r\n}\r\n/* link */\r\n.nav .navbar-nav > li > a {\r\n    color: #777;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n}\r\n.navbar-default .navbar-nav > li > a:hover,\r\n.navbar-default .navbar-nav > li > a:focus {\r\n    color: #333;\r\n    font-size:5px;\r\n    padding-left:50%;\r\n}\r\n.navbar-default .navbar-nav > .active > a, \r\n.navbar-default .navbar-nav > .active > a:hover, \r\n.navbar-default .navbar-nav > .active > a:focus {\r\n    color: #555;\r\n    background-color: #E7E7E7;\r\n\r\n}\r\n.navbar-default .navbar-nav > .open > a, \r\n.navbar-default .navbar-nav > .open > a:hover, \r\n.navbar-default .navbar-nav > .open > a:focus {\r\n    color: #555;\r\n    background-color: #D5D5D5;\r\n}\r\n/* caret */\r\n.navbar-default .navbar-nav > .dropdown > a .caret {\r\n    border-top-color: #777;\r\n    border-bottom-color: #777;\r\n}\r\n.navbar-default .navbar-nav > .dropdown > a:hover .caret,\r\n.navbar-default .navbar-nav > .dropdown > a:focus .caret {\r\n    border-top-color: #333;\r\n    border-bottom-color: #333;\r\n}\r\n.navbar-default .navbar-nav > .open > a .caret, \r\n.navbar-default .navbar-nav > .open > a:hover .caret, \r\n.navbar-default .navbar-nav > .open > a:focus .caret {\r\n    border-top-color: #555;\r\n    border-bottom-color: #555;\r\n}\r\n/* mobile version */\r\n.navbar-default .navbar-toggle {\r\n    border-color: #DDD;\r\n}\r\n.navbar-default .navbar-toggle:hover,\r\n.navbar-default .navbar-toggle:focus {\r\n    background-color: #DDD;\r\n}\r\n.navbar-default .navbar-toggle .icon-bar {\r\n    background-color: #CCC;\r\n}\r\n@media (max-width: 600px) {\r\n    .navbar-default .navbar-nav .open .dropdown-menu > li > a {\r\n        color: #777;\r\n\r\n    }\r\n    .navbar-default .navbar-nav .open .dropdown-menu > li > a:hover,\r\n    .navbar-default .navbar-nav .open .dropdown-menu > li > a:focus {\r\n        color: #333;\r\n    }\r\n}\r\n/*********************************** Facility View Notes/Previous/Next buttons ***************************************/\r\n:host .ui-button, .ui-button span button.ui-button.ui-state-default span .ui-button.ui-state-default span {\r\n\tfont-weight: normal; \r\n}\r\n\r\n:host ui-tabview .ui-tabview-nav > li.ui-state-default.ui-state-hover {\r\n    background-color:#ff9;\r\n    color: #000;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n    border-radius: 8px;\r\n    width: 150px ;\r\n    height:45px;\r\n}\r\n:host .ui-tabview .ui-tabview-nav {\r\n    margin-top: 20px;\r\n    margin-left: 150px;\r\n    width: 1090px;\r\n    height: 35px;\r\n}\r\n:host .fa-external-link-square {\r\n    font-weight:normal;\r\n}\r\n:host ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only{\r\n    font-weight:normal;\r\n}\r\n:host span.ui-button-text.ui-c{\r\n    font-weight:normal;\r\n}\r\n:host .ui-button-text-icon-left .ui-button-text {\r\n    font-weight:normal;\r\n}\r\n:host .ui-button, button.ui-button.ui-state-default, .ui-button.ui-state-default{\r\n    background-color:#ff9;\r\n    color: #000;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n    border-radius: 8px;\r\n    width: 150px ;\r\n    font-weight: normal;\r\n}\r\n:host .ui-tabview.ui-tabview-top>.ui-tabview-nav li{\r\n    background-color:#ff9;\r\n    color: #000;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n    border-radius: 8px;\r\n    width: 150px ;\r\n    font-weight: normal;\r\n}\r\n:host ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only{\r\n    background-color: #900;\r\n    color: white;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n    border-radius: 8px;\r\n    width: 150px ;\r\n}\r\n:host .btn-danger:active:hover, .btn-danger.active:hover, .open > .dropdown-toggle.btn-danger:hover, .btn-danger:active:focus, .btn-danger.active:focus, .open > .dropdown-toggle.btn-danger:focus, .btn-danger:active.focus, .btn-danger.active.focus, .open > .dropdown-toggle.btn-danger.focus{\r\n    background-color: #900;\r\n    color: white;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n    border-radius: 8px;\r\n    width: 150px ;\r\n}\r\n:host .ui-tabview .ui-tabview-nav > li.ui-state-default.ui-state-hover{\r\n    background-color: #900;\r\n    color:white;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n    border-radius: 8px;\r\n    width: 150px ;\r\n}\r\n/*:host button.ui-button.ui-state-hover, .ui-button.ui-state-hover, button.ui-button.ui-state-focus, .ui-button.ui-state-focus{\r\n    background-color: #900;\r\n    color: #000;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n    border-radius: 8px;\r\n    width: 150px !important;\r\n    font-weight: normal;\r\n}*/\r\n/*********************************** Data table buttons ***************************************/\r\n:host .ui-datatable .ui-sortable-column-icon {\r\n    display: none;\r\n}\r\n\r\n\r\n:host .ui-datatable th.ui-state-hover{\r\n    background-color: #c9302c;\r\n    color:white;\r\n}\r\n\r\n:host .ui-datatable .ui-sortable-column {\r\n    background-color: #ff9\r\n}\r\n/*************************************************************************************************/\r\n\r\n\r\n/****************************************Operations list page************************************/\r\n:host .ui-datatable .ui-sortable-column-icon {\r\n    display: none;\r\n}\r\n\r\n\r\n:host .ui-datatable th.ui-state-hover{\r\n    background-color: #c9302c;\r\n}\r\n\r\n:host .ui-datatable .ui-sortable-column {\r\n    background-color: #ff9\r\n}\r\n:host .myTableAyear {\r\n   width: 5%;\r\n}\r\n\r\n:host .myTableForecast{\r\n   width: 2.5%;\r\n}\r\n:host .myTableColsLightGrey{\r\n   text-align:right;\r\n   background-color:lightgrey;\r\n}\r\n:host .myTableCols{\r\n   text-align:right;\r\n   background-color: transparent;\r\n}\r\n/*************************************************************************************/\r\n\r\n/*********************************** Airports ***************************************/\r\n.current-scenario{\r\n    text-align: center;\r\n}\r\n.divider {\r\n    clear: both;\r\n}\r\n.divider-space {\r\n    margin-bottom: 20px;\r\n}\r\n.merge-column {\r\n    float: left;\r\n    margin-right: 100px;\r\n}\r\n.section-title {\r\n    font-weight: bold;\r\n}\r\n.btn-right {\r\n    float: right;\r\n    margin-left: 15px;\r\n}\r\n\r\n\r\n/*************************************************************************************************/\r\n.body\r\n{\r\n    font-size: 12px;\r\n    color: #3d3d3d;\r\n    font-family: Arial, Verdana, Helvetica, sans-serif;\r\n    border-width:1px;\r\n    border-color:black;\r\n    background-color:#c0e4fe;\r\n    border-style: solid;\r\n}\r\n.select.input-sm {\r\n    -webkit-appearance: menulist;\r\n    box-sizing: border-box;\r\n    align-items: center;\r\n    white-space: pre;\r\n    -webkit-rtl-ordering: logical;\r\n    color: black;\r\n    background-color: white;\r\n    cursor: default;\r\n    border-width: 1px;\r\n    border-style: solid;\r\n    border-color: initial;\r\n    border-image: initial;\r\n}\r\n/*:host .table-bordered > thead > tr > th, .table-bordered > tbody > tr > th, .table-bordered > tfoot > tr > th, .table-bordered > thead > tr > td, .table-bordered > tbody > tr > td, .table-bordered > tfoot > tr > td{\r\n    display: table-cell;\r\n    vertical-align: inherit;\r\n    height:20px!important;;\r\n    margin:0px !important;\r\n    table-layout:fixed;  \r\n}*/\r\n\r\n\r\n\r\n\r\n\r\n\r\n"

/***/ },

/***/ 701:
/***/ function(module, exports) {

	module.exports = ""

/***/ },

/***/ 702:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var router_1 = __webpack_require__(655);
	var welcome_component_1 = __webpack_require__(703);
	var airport_routes_1 = __webpack_require__(705);
	var system_management_routes_1 = __webpack_require__(792);
	var scenario_activities_routes_1 = __webpack_require__(865);
	var query_report_routes_1 = __webpack_require__(891);
	var auth_routes_1 = __webpack_require__(898);
	var admin_routes_1 = __webpack_require__(910);
	var account_routes_1 = __webpack_require__(916);
	var auth_guard_service_1 = __webpack_require__(696);
	var auth_service_1 = __webpack_require__(679);
	//import { Http } from '@angular/http';
	exports.routes = [
	    { path: '', redirectTo: '/welcome', pathMatch: 'full' },
	    { path: 'welcome', component: welcome_component_1.WelcomeComponent, canActivate: [auth_guard_service_1.AuthGuard] }
	].concat(airport_routes_1.AirportRoutes, system_management_routes_1.SystemManagementRoutes, scenario_activities_routes_1.ScenarioActivitiesRoutes, query_report_routes_1.QueryReportRoutes, auth_routes_1.AuthRoutes, admin_routes_1.AdminRoutes, account_routes_1.AccountRoutes);
	exports.APP_ROUTER_PROVIDERS = [
	    router_1.provideRouter(exports.routes), auth_guard_service_1.AuthGuard, auth_service_1.AuthService //, Http
	];


/***/ },

/***/ 703:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var scenario_service_1 = __webpack_require__(692);
	var user_session_1 = __webpack_require__(699);
	var auth_service_1 = __webpack_require__(679);
	var user_info_service_1 = __webpack_require__(695);
	var WelcomeComponent = (function () {
	    function WelcomeComponent(_scenarioService, User, _userInfoService, authService) {
	        this._scenarioService = _scenarioService;
	        this.User = User;
	        this._userInfoService = _userInfoService;
	        this.authService = authService;
	        this.pageTitle = 'Welcome, ' + this.User.getSession()['fullname'];
	        this.isScenarioOwner = false;
	        this.isReadOnly = false;
	    }
	    WelcomeComponent.prototype.ngOnInit = function () {
	        //console.log("Welcome ngInit");
	        var _this = this;
	        this.isAdmin = this.authService.isInRole("System Developer");
	        this.isReadOnly = this.authService.isReadOnly();
	        this.User.updateSessionState();
	        var tempUserId = this.User.getSession()['id'];
	        var tempScenario = this.User.getSession().scenarioId;
	        this._scenarioService.getScenarios(tempUserId)
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            if (_this.User.hasValidSession())
	                _this.setScenarioHeader(_this.User.scenarioId);
	            else {
	                _this.setScenarioHeader(_this.User.scenarioId);
	                _this.User.updateSessionState();
	            }
	        });
	        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
	        //this probably needs to be somewhere more central
	        this._userInfoService.isScenarioOwner(tempUserId, tempScenario).subscribe(function (success) { return _this.isScenarioOwner = success.isOwner; }, function (error) { return _this.errorMessage = error; });
	    };
	    WelcomeComponent.prototype.onScenarioChange = function (event) {
	        var selectedScenarioId = +event.target.value;
	        this.User.scenarioId = selectedScenarioId;
	        this.setScenarioHeader(selectedScenarioId);
	        this.User.updateSessionState();
	    };
	    WelcomeComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	        this.scenarioHeaderDiv.innerHTML = "<strong>Current Scenario: " + this.currentScenario.scenarioName + " (" + this.currentScenario.id + ")</strong>";
	    };
	    __decorate([
	        core_1.ViewChild('scenarioHeader'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], WelcomeComponent.prototype, "scenarioHeader", void 0);
	    WelcomeComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/home/welcome.component.html',
	            template: __webpack_require__(704),
	            styles: [__webpack_require__(700)]
	        }), 
	        __metadata('design:paramtypes', [scenario_service_1.ScenarioService, user_session_1.UserSession, user_info_service_1.UserInfoService, auth_service_1.AuthService])
	    ], WelcomeComponent);
	    return WelcomeComponent;
	}());
	exports.WelcomeComponent = WelcomeComponent;


/***/ },

/***/ 704:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\" #scenarioHeader></div>\r\n<div class=\"panel panel-primary\">\r\n    <div class=\"panel-heading\">\r\n        {{pageTitle}}\r\n    </div>\r\n    <div class=\"panel-body\"  >\r\n         <div class=\"customh3\">Scenario:\r\n            <select (change)=\"onScenarioChange($event)\" style=\"width:250px;\">\r\n                <option *ngFor=\"let scenario of allScenarios\" [value]=\"scenario.id\"  [selected]=\"scenario.id === currentScenario.id\">\r\n                    {{scenario.scenarioName}} ({{scenario.id}})\r\n                </option>\r\n            </select>\r\n        </div>\r\n        <div class=\"container-fluid\">\r\n            <h2><b>Your Options</b></h2>\r\n            <div class=\"row\" style=\"padding-left:0; padding-right:0;\">\r\n                 <div class=\"col-sm-3\" style=\"padding-left:0; padding-right:0;\">\r\n                    <a [routerLink]=\"['/airports']\" data-toggle=\"tooltip\"  title=\"Facility View\" class=\"btn btn-danger  btn-md active custom\">Facility View</a>\r\n                 </div>\r\n                 <div class=\"col-sm-6\" style=\"padding-left:0; padding-right:0;text-align:left\" >\r\n                   <div class=\"customh3\"> View/Update Facilities in this Scenario</div>\r\n                </div>\r\n            </div>\r\n           <div *ngIf=\"!isReadOnly\" class=\"row\" style=\"padding-left:0; padding-right:0;padding-top:10px;\" >\r\n                 <div class=\"col-sm-3\" style=\"padding-left:0; padding-right:0;\">\r\n                    <a [routerLink]=\"['/scenario-activities']\" data-toggle=\"tooltip\"  title=\"Scenario Activities\" class=\"btn btn-danger  btn-md active custom\">Scenario Activities</a>\r\n                 </div>\r\n                 <div class=\"col-sm-6\" style=\"padding-left:0; padding-right:0;text-align:left\" >\r\n                   <div class=\"customh3\">Create/Delete, Change Facilities in a Scenario</div>\r\n                </div>\r\n            </div>\r\n           <div class=\"row\" style=\"padding-left:0; padding-right:0;padding-top:10px;\">\r\n                 <div class=\"col-sm-3\" style=\"padding-left:0; padding-right:0;\">\r\n                    <a [routerLink]=\"['/query-reports']\" data-toggle=\"tooltip\"  title=\"Query Reports\" class=\"btn btn-danger  btn-md active custom\">Query Reports</a>\r\n                 </div>\r\n                 <div class=\"col-sm-6\" style=\"padding-left:0; padding-right:0;text-align:left\" >\r\n                   <div class=\"customh3\">Create a variety of data and growth rate reports</div>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\" style=\"padding-left:0; padding-right:0;padding-top:10px;\" *ngIf=\"isAdmin\">\r\n                 <div class=\"col-sm-3\" style=\"padding-left:0; padding-right:0;\">\r\n                    <a [routerLink]=\"['/system-management']\" data-toggle=\"tooltip\"  title=\"System Management\" class=\"btn btn-danger  btn-md active custom\">System Management</a>\r\n                 </div>\r\n                 <div class=\"col-sm-6\" style=\"padding-left:0; padding-right:0;text-align:left\" >\r\n                   <div class=\"customh3\">Some Options Available for System Management</div>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\" style=\"padding-left:0; padding-right:0;padding-top:10px;\" *ngIf=\"isAdmin\">\r\n                 <div class=\"col-sm-3\" style=\"padding-left:0; padding-right:0;\">\r\n                    <a [routerLink]=\"['/admin']\" data-toggle=\"tooltip\"  title=\"Admin\" class=\"btn btn-danger  btn-md active custom\">Admin</a>\r\n                 </div>\r\n                 <div class=\"col-sm-6\" style=\"padding-left:0; padding-right:0;text-align:left\" >\r\n                   <div class=\"customh3\">Some Options Available for System Admin</div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ },

/***/ 705:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var airport_component_1 = __webpack_require__(706);
	var auth_guard_service_1 = __webpack_require__(696);
	var airport_edit_component_1 = __webpack_require__(773);
	var operations_list_component_1 = __webpack_require__(776);
	var operations_add_data_point_component_1 = __webpack_require__(780);
	var operations_graph_component_1 = __webpack_require__(782);
	var operations_graph_display_component_1 = __webpack_require__(786);
	var operations_reforecast_container_component_1 = __webpack_require__(788);
	exports.AirportRoutes = [
	    { path: 'airports', component: airport_component_1.AirportComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'airports/:locId', component: airport_component_1.AirportComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'airports-edit/:locId', component: airport_edit_component_1.AirportEditComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'operations-list/:tableName', component: operations_list_component_1.OperationsListComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'operations-add-year', component: operations_add_data_point_component_1.OperationsAddDataPointComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'operations-graph/:tableName', component: operations_graph_component_1.OperationsGraphComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'operations-graph-display/:tableName', component: operations_graph_display_component_1.OperationsGraphDisplayComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'operations-reforcast/:tableName', component: operations_reforecast_container_component_1.OperationsReforecastContainerComponent, canActivate: [auth_guard_service_1.AuthGuard] }
	];


/***/ },

/***/ 706:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var airport_service_1 = __webpack_require__(677);
	var query_report_service_1 = __webpack_require__(691);
	var query_report_1 = __webpack_require__(698);
	var scenario_service_1 = __webpack_require__(692);
	var user_session_1 = __webpack_require__(699);
	var user_info_service_1 = __webpack_require__(695);
	var degrees_from_seconds_pipe_1 = __webpack_require__(707);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var _ = __webpack_require__(680);
	var AirportComponent = (function () {
	    function AirportComponent(route, router, _airportService, _scenarioService, User, _userInfoService, _queryReport) {
	        this.route = route;
	        this.router = router;
	        this._airportService = _airportService;
	        this._scenarioService = _scenarioService;
	        this.User = User;
	        this._userInfoService = _userInfoService;
	        this._queryReport = _queryReport;
	        this.pageTitle = 'Facility View ';
	        this.displayNotes = false;
	        this.isScenarioOwner = false;
	        this.canEdit = false;
	        this.displayFacilityList = false;
	        this.displaySpinner = false;
	        this.msgs = [];
	        this.msgsAll = [];
	        this.displayGraphData = false;
	        this.showAll = "true";
	    }
	    AirportComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.sub = this.route.params.subscribe(function (params) {
	            var id = params['locId'];
	            if (!_.isEmpty(id)) {
	                _this.getAirport(id);
	            }
	            else {
	                //console.log("Empty param");
	                _this.getAirportFromScenario();
	            }
	        });
	        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
	        this._scenarioService.getScenarios(this.User.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.setScenarioHeader(_this.User.getSession().scenarioId);
	        });
	        //this probably needs to be somewhere more central
	        this.User.updateSessionState();
	        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(function (success) { return _this.isScenarioOwner = success.isOwner; }, function (error) { return _this.errorMessage = error; });
	        this.getOperations();
	        // this.request = new IQueryReportRequest(0,1,6,10,['ATL']);
	    };
	    AirportComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    AirportComponent.prototype.getOperations = function () {
	        var _this = this;
	        this._airportService.getOperations()
	            .subscribe(function (operations) { return _this.operations = operations; }, function (error) { return _this.errorMessage = error; });
	    };
	    AirportComponent.prototype.getAirportFromScenario = function () {
	        var _this = this;
	        //console.log("this.User.getSession().scenarioId " + this.User.getSession().scenarioId);
	        this._airportService.getAirportFromScenario(this.User.getSession().scenarioId)
	            .subscribe(function (success) { return _this.getAirport(success); }, function (error) { return _this.errorMessage = error; });
	    };
	    AirportComponent.prototype.getAirport = function (locId) {
	        var _this = this;
	        this._airportService.getAirport(locId, this.User.getSession().scenarioId)
	            .subscribe(function (airport) { return _this.airport = airport; }, function (error) { return _this.errorMessage = error; }, function () {
	            if (_this.airport.locId == undefined) {
	                _this.msgsAll = [];
	                _this.msgsAll.push({ severity: 'error', summary: 'Error Message', detail: 'If you were requesting a LOCID, it may not be part of your current scenario, or the LOCID is not found.' });
	                _this.showAll = "false";
	            }
	            else {
	                _this.msgsAll = [];
	                _this.showAll = "true";
	                _this.setCanEdit();
	                _this.setNextAndPrevious(locId);
	            }
	        });
	    };
	    AirportComponent.prototype.setNextAndPrevious = function (locId) {
	        var _this = this;
	        this._airportService.getNextAndPreviousAirports(locId, this.User.getSession().scenarioId)
	            .subscribe(function (success) {
	            _this.nextFacility = success.nextAirport;
	            _this.previousFacility = success.previousAirport;
	        });
	    };
	    AirportComponent.prototype.setCanEdit = function () {
	        var _this = this;
	        this._userInfoService.getRegCode(this.User.getSession()['id'])
	            .subscribe(function (success) {
	            if (_this.User.getSession().isAdmin || (_this.User.getSession().isRegionalManager && success === _this.airport.region)) {
	                _this.canEdit = true;
	            }
	        });
	    };
	    AirportComponent.prototype.onScenarioChange = function (event) {
	        var _this = this;
	        var selectedScenarioId = +event.target.value;
	        this.User.scenarioId = selectedScenarioId;
	        this.User.updateSessionState();
	        this.setScenarioHeader(selectedScenarioId);
	        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(function (success) { return _this.isScenarioOwner = success.isOwner; }, function (error) { return _this.errorMessage = error; });
	        this.getAirportFromScenario();
	    };
	    AirportComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	        this.scenarioHeaderDiv.innerHTML = "<strong>Current Scenario: " + this.currentScenario.scenarioName + " (" + this.currentScenario.id + ")</strong>";
	    };
	    AirportComponent.prototype.showNotes = function () {
	        var _this = this;
	        if (this.isScenarioOwner || this.User.getSession().isAdmin) {
	            this.notesTitle = "Edit Scenario Notes";
	        }
	        else {
	            this.notesTitle = "View Scenario Notes";
	        }
	        this._airportService.getScenarioNotes(this.airport.locId, this.User.getSession().scenarioId)
	            .subscribe(function (success) {
	            if (!_.isEmpty(success)) {
	                _this.scenarioNote = success;
	            }
	            _this.displayNotes = true;
	        }, function (error) { return _this.errorMessage = "An error occured while attempting to retrieve notes."; });
	    };
	    AirportComponent.prototype.showDataReport = function () {
	        var _this = this;
	        this.request = new query_report_1.IQueryReportRequest(1, 0, 6, 10, [this.airport.locId]);
	        this.request.scenario = this.currentScenario.id;
	        //year is fy_year -3 and will get calculated on webAPI side of the house; don't want to do that here also.
	        this.request.startYear = 0;
	        //these two values are hardcoded to reflect data from query reports: facility levelr eport data summary (6) for a certain facility (10)
	        this.request.reportId = 6;
	        this.request.facOption = 10;
	        this.request.locidList = [this.airport.locId];
	        if (this.isScenarioOwner || this.User.getSession().isAdmin || this.User.isReadOnly) {
	            this.graphDataTitle = "Data Report";
	            this.displaySpinner = true;
	            this._queryReport.getFacilityListReport(this.request)
	                .subscribe(function (response) {
	                _this.displaySpinner = false;
	                _this.facReportListResponse = response;
	                if (_this.facReportListResponse[0].responseStatus === 'ERROR') {
	                    _this.msgs = [];
	                    _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'An error has occurred executing your request'
	                            + _this.facReportListResponse[0].responseMessage });
	                }
	                else if (_this.facReportListResponse[0].responseMessage === 'No Data') {
	                    _this.msgs = [];
	                    _this.msgs.push({ severity: 'error', summary: 'Info Message', detail: 'No Data returned.'
	                            + _this.facReportListResponse[0].responseMessage });
	                    _this.facReportListResponse[0].pdfFileUrl = "";
	                    _this.facReportListResponse[0].htmlFileUrl = "";
	                }
	                else {
	                    _this.msgs = [];
	                    _this.msgs.push({ severity: 'info', summary: 'Info Message', detail: 'PDF & HTML file generated; please click links below' });
	                    _this.cols = [
	                        { field: "htmlFileUrl", header: 'Html' },
	                        { field: "pdfFileUrl", header: 'Pdf' },
	                    ];
	                    _this.displayGraphData = true;
	                }
	                //console.log ("Airport Data report response facility report " + this.facReportListResponse[0].htmlFileUrl + "  " 
	                //                + this.facReportListResponse[0].pdfFileUrl +" " + this.facReportListResponse[0].responseMessage +" "
	                //                + this.facReportListResponse[0].responseStatus +" " + this.facReportListResponse[0].responseDisplay)
	            }, function (error) { return _this.errorMessage = error; });
	        }
	    };
	    AirportComponent.prototype.showGrowthRateReport = function () {
	        var _this = this;
	        this.facListTitle = "Growth Rate Report";
	        this.request = new query_report_1.IQueryReportRequest(1, 0, 7, 10, [this.airport.locId]);
	        this.request.scenario = this.currentScenario.id;
	        //year is fy_year -3 and will get calculated on webAPI side of the house; don't want to do that here also.
	        this.request.startYear = 0;
	        //these two values are hardcoded to reflect data from query reports: facility levelr eport data summary (6) for a certain facility (10)
	        this.request.reportId = 7;
	        this.request.facOption = 10;
	        this.request.locidList = [this.airport.locId];
	        if (this.isScenarioOwner || this.User.getSession().isAdmin || this.User.isReadOnly) {
	            this.graphDataTitle = "Growth Rate Report";
	            this.displaySpinner = true;
	            this._queryReport.getFacilityListReport(this.request)
	                .subscribe(function (response) {
	                _this.displaySpinner = false;
	                _this.facReportListResponse = response;
	                if (_this.facReportListResponse[0].responseStatus === 'ERROR') {
	                    _this.msgs = [];
	                    _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'An error has occurred executing your request'
	                            + _this.facReportListResponse[0].responseMessage });
	                }
	                else if (_this.facReportListResponse[0].responseMessage === 'No Data') {
	                    _this.msgs = [];
	                    _this.msgs.push({ severity: 'error', summary: 'Info Message', detail: 'No Data returned.'
	                            + _this.facReportListResponse[0].responseMessage });
	                    _this.facReportListResponse[0].pdfFileUrl = "";
	                    _this.facReportListResponse[0].htmlFileUrl = "";
	                }
	                else {
	                    _this.msgs = [];
	                    _this.msgs.push({ severity: 'info', summary: 'Info Message', detail: 'PDF & HTML file generated; please click links below' });
	                    _this.cols = [
	                        { field: "htmlFileUrl", header: 'Html' },
	                        { field: "pdfFileUrl", header: 'Pdf' },
	                    ];
	                    _this.displayGraphData = true;
	                }
	                //console.log ("Airport Data report response facility report " + this.facReportListResponse[0].htmlFileUrl + "  " 
	                //                + this.facReportListResponse[0].pdfFileUrl +" " + this.facReportListResponse[0].responseMessage +" "
	                //                + this.facReportListResponse[0].responseStatus +" " + this.facReportListResponse[0].responseDisplay)
	            }, function (error) { return _this.errorMessage = error; });
	        }
	    };
	    AirportComponent.prototype.showOpsPerBA = function () {
	        var _this = this;
	        this.facListTitle = "Operations Per Based Aircraft Ratio";
	        this.request = new query_report_1.IQueryReportRequest(1, 0, 7, 10, [this.airport.locId]);
	        this.request.scenario = this.currentScenario.id;
	        //year is fy_year -3 and will get calculated on webAPI side of the house; don't want to do that here also.
	        this.request.startYear = 0;
	        //these two values are hardcoded to reflect data from query reports: facility levelr eport data summary (6) for a certain facility (10)
	        this.request.reportId = 12;
	        this.request.facOption = 0;
	        this.request.locidList = [this.airport.locId];
	        if (this.isScenarioOwner || this.User.getSession().isAdmin || this.User.isReadOnly) {
	            this.graphDataTitle = "Operations Per Based Aircraft Ratio";
	            this.displaySpinner = true;
	            this._queryReport.getFacilityListReport(this.request)
	                .subscribe(function (response) {
	                _this.displaySpinner = false;
	                _this.facReportListResponse = response;
	                if (_this.facReportListResponse[0].responseStatus === 'ERROR') {
	                    _this.msgs = [];
	                    _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'An error has occurred executing your request'
	                            + _this.facReportListResponse[0].responseMessage });
	                }
	                else if (_this.facReportListResponse[0].responseMessage === 'No Data') {
	                    _this.msgs = [];
	                    _this.msgs.push({ severity: 'error', summary: 'Info Message', detail: 'No Data returned.'
	                            + _this.facReportListResponse[0].responseMessage });
	                    _this.facReportListResponse[0].pdfFileUrl = "";
	                    _this.facReportListResponse[0].htmlFileUrl = "";
	                }
	                else {
	                    _this.msgs = [];
	                    _this.msgs.push({ severity: 'info', summary: 'Info Message', detail: 'PDF & HTML file generated; please click links below' });
	                    _this.cols = [
	                        { field: "htmlFileUrl", header: 'Html' },
	                        { field: "pdfFileUrl", header: 'Pdf' },
	                    ];
	                    _this.displayGraphData = true;
	                }
	                //console.log ("Operations Per Based Aircraft Ratio response " + this.facReportListResponse[0].htmlFileUrl + "  " 
	                //                + this.facReportListResponse[0].pdfFileUrl +" " + this.facReportListResponse[0].responseMessage +" "
	                //                + this.facReportListResponse[0].responseStatus +" " + this.facReportListResponse[0].responseDisplay)
	            }, function (error) { return _this.errorMessage = error; });
	        }
	    };
	    AirportComponent.prototype.showFacList = function () {
	        var _this = this;
	        this.facListTitle = "Facility List";
	        this.request = new query_report_1.IQueryReportRequest(1, 0, 5, 10, [this.airport.locId]);
	        this.request.scenario = this.User.getSession().scenarioId;
	        //year is fy_year -3 and will get calculated on webAPI side of the house; don't want to do that here also.
	        this.request.startYear = 0;
	        //these two values are hardcoded to reflect data from query reports: facility levelr eport data summary (6) for a certain facility (10)
	        this.request.reportId = 11;
	        this.request.facOption = 0;
	        this.request.locidList = [this.airport.locId];
	        if (this.isScenarioOwner || this.User.getSession().isAdmin || this.User.isReadOnly) {
	            this.graphDataTitle = "Facility List";
	            this.displaySpinner = true;
	            this._queryReport.getFacilityListReport(this.request)
	                .subscribe(function (response) {
	                _this.displaySpinner = false;
	                _this.facReportListResponse = response;
	                if (_this.facReportListResponse[0].responseStatus === 'ERROR') {
	                    _this.msgs = [];
	                    _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'An error has occurred executing your request'
	                            + _this.facReportListResponse[0].responseMessage });
	                }
	                else if (_this.facReportListResponse[0].responseMessage === 'No Data') {
	                    _this.msgs = [];
	                    _this.msgs.push({ severity: 'error', summary: 'Info Message', detail: 'No Data returned.'
	                            + _this.facReportListResponse[0].responseMessage });
	                    _this.facReportListResponse[0].pdfFileUrl = "";
	                    _this.facReportListResponse[0].htmlFileUrl = "";
	                }
	                else {
	                    _this.msgs = [];
	                    _this.msgs.push({ severity: 'info', summary: 'Info Message', detail: 'PDF & HTML file generated; please click links below' });
	                    _this.cols = [
	                        { field: "htmlFileUrl", header: 'Html' },
	                        { field: "pdfFileUrl", header: 'Pdf' },
	                    ];
	                    _this.displayGraphData = true;
	                }
	                //console.log ("Airport Data report response facility report " + this.facReportListResponse[0].htmlFileUrl + "  " 
	                //                + this.facReportListResponse[0].pdfFileUrl +" " + this.facReportListResponse[0].responseMessage +" "
	                //                + this.facReportListResponse[0].responseStatus +" " + this.facReportListResponse[0].responseDisplay)
	            }, function (error) { return _this.errorMessage = error; });
	        }
	        /* if(this.isScenarioOwner || this.User.getSession().isAdmin){
	             this.facListTitle = "Facility List";
	             this.displaySpinner = true;
	             this._airportService.getFacilityList(this.User.getSession().scenarioId)
	             .subscribe(
	                     response => {
	                         this.facList = response;
	                         this.displayFacilityList = true;
	                         this.cols = [
	                             {field: "locId", header: 'Locid'},
	                             {field: "name", header: 'Airport Name'},
	                             {field: "region", header: 'Region'},
	                             {field: "city", header: 'City'},
	                             {field: "stateName", header: 'State'},
	                             {field: "facClassName", header: 'Facility Class'},
	                             {field: "facLevelName", header: 'Facility Level'},
	                             {field: "latitude", header: 'Latitude'},
	                             {field: "longitude", header: 'Longitude'},
	                             {field: "siteNumber", header: 'Site'},
	                         ]
	                         console.log('Airport Get Facility List Component: ' +  JSON.stringify(this.cols));
	                         this.displaySpinner =false;
	                     },
	                     error => this.errorMessage = "An error occured while attempting to retrieve notes."
	                 );
	         }*/
	    };
	    AirportComponent.prototype.saveNotes = function () {
	        var _this = this;
	        this._airportService.updateScenarioNotes(this.airport.locId, this.User.getSession().scenarioId, this.scenarioNote)
	            .subscribe(function (success) { }, function (error) {
	            _this.errorMessage = "An error occured while attempting to save your note.";
	            _this.displayNotes = false;
	        }, function () { return _this.displayNotes = false; });
	    };
	    AirportComponent.prototype.editAirport = function () {
	        this.router.navigate([("/airports-edit/" + this.airport.locId)]);
	    };
	    AirportComponent.prototype.nextFacilityAction = function () {
	        this.router.navigate([("/airports/" + this.nextFacility)]);
	    };
	    AirportComponent.prototype.previousFacilityAction = function () {
	        this.router.navigate([("/airports/" + this.previousFacility)]);
	    };
	    AirportComponent.prototype.performOp = function (op) {
	        var params = {
	            locId: this.airport.locId,
	            airportName: this.airport.name
	        };
	        this.router.navigate([("/operations-list/" + op.tableName), params]);
	    };
	    AirportComponent.prototype.openPDFFile = function (responsepdf) {
	        window.open(responsepdf, '_blank');
	    };
	    AirportComponent.prototype.openHTMLFile = function (responseHtml) {
	        window.open(responseHtml, '_blank');
	    };
	    __decorate([
	        core_1.ViewChild('scenarioHeader'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], AirportComponent.prototype, "scenarioHeader", void 0);
	    AirportComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/airports/airport.component.html',
	            template: __webpack_require__(772),
	            styles: [__webpack_require__(700), __webpack_require__(701)],
	            //styleUrls: ['app/products/product-list.component.css'],
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.Dialog, primeng_2.Button],
	            pipes: [degrees_from_seconds_pipe_1.DegreesFromSecondsPipe]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, airport_service_1.AirportService, scenario_service_1.ScenarioService, user_session_1.UserSession, user_info_service_1.UserInfoService, query_report_service_1.QueryReportService])
	    ], AirportComponent);
	    return AirportComponent;
	}());
	exports.AirportComponent = AirportComponent;


/***/ },

/***/ 707:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var DegreesFromSecondsPipe = (function () {
	    function DegreesFromSecondsPipe() {
	    }
	    DegreesFromSecondsPipe.prototype.transform = function (seconds) {
	        var secLen = seconds.length;
	        var calc = parseFloat(seconds);
	        calc = calc / 3600;
	        if (seconds.substr(secLen - 1, 1) == 'W' || seconds.substr(secLen - 1, 1) == 'S')
	            calc = calc * -1;
	        if (isNaN(calc)) {
	            calc = 0;
	        }
	        return calc.toString();
	    };
	    DegreesFromSecondsPipe = __decorate([
	        core_1.Pipe({ name: 'degreesFromSeconds' }), 
	        __metadata('design:paramtypes', [])
	    ], DegreesFromSecondsPipe);
	    return DegreesFromSecondsPipe;
	}());
	exports.DegreesFromSecondsPipe = DegreesFromSecondsPipe;


/***/ },

/***/ 772:
/***/ function(module, exports) {

	module.exports = "\r\n<div class=\"current-scenario\" #scenarioHeader></div>\r\n<div class='panel panel-primary' style='width:770px'>\r\n    <div class='panel-heading' *ngIf='airport'>\r\n        {{pageTitle + ': ' + airport.locId + ' - ' + airport.name}}\r\n    </div>\r\n\r\n    <!-- Filter the Products   -->\r\n    <p-messages [value]=\"msgsAll\" [closable]=\"false\"></p-messages>\r\n    <div class='panel-body' *ngIf=\"showAll==='true'\">\r\n        \r\n        <div class='has-error' *ngIf='errorMessage'>{{errorMessage}}</div>\r\n        <b>Scenario:</b>\r\n        <select (change)=\"onScenarioChange($event)\">\r\n            <option *ngFor=\"let scenario of allScenarios\" [value]=\"scenario.id\" [selected]=\"scenario.id === currentScenario.id\">\r\n                {{scenario.scenarioName}} ({{scenario.id}})\r\n            </option>\r\n        </select>\r\n        <br/>\r\n        <br/>\r\n        <p-dialog *ngIf=\"airport && currentScenario\" header=\"{{graphDataTitle}}\" \r\n                [(visible)]=\"displayGraphData\" modal=\"modal\" showEffect=\"fade\"  width=\"850\" height=\"350\" responsive=\"true\">\r\n            <p-messages [value]=\"msgs\" [closable]=\"false\"></p-messages>\r\n            <div class=\"container-fluid\">\r\n                <div class= \"row\" *ngFor=\"let resp of facReportListResponse\">\r\n                    <div class=\"col-md-6\">\r\n                            HTML file created for facility {{airport.locId}}: \r\n                            <button class=\"btn btn-link btn-right btn-sm\"  (click)=\"openHTMLFile(resp.htmlFileUrl)\">{{resp.responseDisplay}}</button>\r\n                    </div>\r\n                    <div class=\"col-md-6\">\r\n                            PDF file created for facility {{airport.locId}}: \r\n                            <button class=\"btn btn-link btn-right btn-sm\"  (click)=\"openPDFFile(resp.pdfFileUrl)\">{{resp.responseDisplay}}</button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </p-dialog>\r\n            <!--can jsut bind the header to a variable on the back in and set on approved status or not-->\r\n            <!--actually that variable will tell us if they are approved.-->\r\n        <p-dialog *ngIf=\"airport && currentScenario\" header=\"{{notesTitle}}\" [(visible)]=\"displayNotes\" modal=\"modal\" showEffect=\"fade\">\r\n            <div>\r\n                <h4 class=\"text-center\">Scenario: {{currentScenario.scenarioName}}</h4>\r\n                <h4 class=\"text-center\">LOCID: {{airport.locId}} - {{airport.name}}</h4>\r\n                <div class=\"form-group\">\r\n                    <textarea class=\"form-control\" rows=\"5\" id=\"notes\" [(ngModel)]=\"scenarioNote\"></textarea>\r\n                </div>\r\n            </div>\r\n            <div>\r\n                <div  class=\"col-sm-6\">\r\n                    <button *ngIf=\"User.isAdmin || isScenarioOwner\" type=\"text\" pButton (click)=\"saveNotes()\" label=\"Save\" style=\"width:100px!important\"></button>\r\n                </div>\r\n                <div  class=\"col-sm-6\">\r\n                    <button type=\"text\" pButton (click)=\"displayNotes=false\" label=\"Cancel\" style=\"width:100px!important\"></button>\r\n                </div>\r\n            </div>\r\n        </p-dialog>\r\n         <p-dialog *ngIf=\"airport && currentScenario\" header=\"{{facListTitle}}\" [(visible)]=\"displayFacilityList\" \r\n                    modal=\"modal\" showEffect=\"fade\" width=\"1000\" height=\"700\" resizable=\"true\">\r\n            <div>\r\n                <h4 class=\"text-left\">Title: APO TAF Facility List</h4>\r\n                <h4 class=\"text-left\">Scenario: {{currentScenario.scenarioName}} ({{currentScenario.id}})</h4>\r\n            </div>\r\n            <p-dataTable  #dt [value]=\"facList\"  scrollable=\"true\" scrollHeight=\"500px\" scrollWidth=\"100%\" [style]=\"{'margin-top':'30px'}\" >\r\n                <p-column *ngFor=\"let col of cols\" [field]=\"col.field\" [header]=\"col.header\"></p-column>\r\n            </p-dataTable>\r\n        </p-dialog>\r\n         <p-dialog  [(visible)]=\"displaySpinner\" [modal]=true   [closable]=false showEffect=\"fade\">\r\n                <div align=\"center\">\r\n                    <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n                    <div>Loading please wait ....</div>\r\n                    <div>Do Not click back or Refresh the page</div>\r\n                </div>\r\n        </p-dialog>\r\n        <div  class=\"body\">\r\n            <div class=\"row\"  style=\"padding-left:0; padding-right:0;margin-left: 3px;margin-top: 3px;\">\r\n                <button *ngIf=\"!User.isReadOnly\" type=\"text\" (click)=\"showNotes()\" pButton icon=\"fa-external-link-square\" label=\"Notes\"\r\n                        class=\"btn btn-danger  btn-md active \"></button>\r\n\r\n                <button *ngIf=\"canEdit || User.isAdmin || isScenarioOwner\" type=\"text\" (click)=\"editAirport()\" pButton icon=\"fa-edit\" label=\"Edit\"\r\n                        class=\"btn btn-danger  btn-md active \"></button>\r\n\r\n                <button *ngIf=\"previousFacility\" type=\"text\" (click)=\"previousFacilityAction()\" pButton icon=\"fa-arrow-circle-left\" label=\"Previous\"\r\n                        class=\"btn btn-danger  btn-md active \"></button>\r\n\r\n                <button *ngIf=\"nextFacility\" type=\"text\" (click)=\"nextFacilityAction()\" pButton icon=\"fa-arrow-circle-right\" label=\"Next\"\r\n                        class=\"btn btn-danger  btn-md active \"></button>\r\n            </div>\r\n            <br/>\r\n            <div class=\"row\"  style=\"padding-left:0; padding-right:0;margin-left: 3px;margin-top: 3px;\">\r\n               <button type=\"text\" (click)=\"showFacList()\" pButton icon=\"fa fa-list\" label=\" Facility List\"\r\n                        class=\"btn btn-danger  btn-md active \"></button>\r\n               <button type=\"text\" (click)=\"showDataReport()\" pButton icon=\"fa fa-list-alt \" label=\"Data Report\"\r\n                        class=\"btn btn-danger  btn-md active \"></button>\r\n\r\n               <button type=\"text\" (click)=\"showGrowthRateReport()\" pButton icon=\"fa fa-list-alt \" label=\"GR Report\"\r\n                        class=\"btn btn-danger  btn-md active \"></button>\r\n            </div>\r\n            <br/>\r\n            <div class=\"row no-print\"  style=\"padding-left:0; padding-right:0;margin-left: 3px;margin-top: 3px;\">\r\n                <button type=\"text\" (click)=\"showOpsPerBA()\" style= \" width: 250px \" pButton icon=\"fa fa-list\" label=\" Operations Per Based Aircraft Ratio\"\r\n                        class=\"btn btn-danger btn-md active \"></button>\r\n            </div>\r\n            <br/>\r\n            <div class=\"row\" style=\"padding-left:0; padding-right:0;margin-left: 3px;margin-top: 3px;\">\r\n                <button *ngFor=\"let op of operations\" type=\"text\" (click)=\"performOp(op)\" pButton label=\"{{op.displayName}}\" \r\n                     class=\"btn btn-danger  btn-md active \" style=\"font-weight:normal\"></button>\r\n            </div>\r\n            <br/>\r\n            <br/>\r\n            <div class=\"container\" style=\"white-space: nowrap\">\r\n                <div class='row' >\r\n                    <div class='col-sm-2' style=\"padding-right:0;text-align:left;width:7%;margin-left:5px\">LOCID:</div>\r\n                    <div class='col-sm-2' *ngIf='airport' style=\"padding-left:0;text-align:left;width:3%\"><b>{{airport.locId}}</b></div>\r\n                    <div class='col-sm-2' style=\"padding-left:0;text-align:left;width:5%;\">Region:</div>\r\n                    <div class='col-sm-2' *ngIf='airport' style=\"padding-left:0; padding-right:0;text-align:left;\"><b>{{airport.regName}}</b></div>\r\n                    <div class='col-sm-2' style=\"padding-left:0;text-align:left;width:5%\">Name:</div>\r\n                    <div class='col-sm-2' *ngIf='airport' style=\"padding-left:0;padding-right:0;text-align:left\"><b>{{airport.name}}</b></div>\r\n                </div>  \r\n                    <div class='row'>\r\n                        <div class='col-sm-2' style=\"padding-right:0;text-align:left;width:7%\">&nbsp;</div>\r\n                        <div class='col-sm-2' *ngIf='airport' style=\"padding-left:0;text-align:left;width:3%\">&nbsp;</div>\r\n                        <div class='col-sm-2 ' style=\"padding-left:0;text-align:left;width:5%\">City:</div>\r\n                        <div class='col-sm-2' *ngIf='airport' style=\"padding-left:0; padding-right:0;text-align:left;\"><b>{{airport.city}}</b></div>\r\n                        <div class='col-sm-2' style=\"padding-left:0;text-align:left;width:5%\">State:</div>\r\n                        <div class='col-sm-2' *ngIf='airport' style=\"padding-left:0;padding-right:0;text-align:left\"><b>{{airport.stateName}}</b></div>\r\n                    </div>\r\n                    <div class='row' style=\"margin-top:5px;margin-bottom:5px;margin-left:5px\">\r\n                        <div class='col-sm-2' >Facility Class:</div>\r\n                        <div class='col-sm-2' *ngIf='airport'><b>{{airport.facClassName}}</b></div>\r\n                        <div class='col-sm-2 checkbox disabled' *ngIf='airport'>\r\n                            <label>\r\n                                <input type=\"checkbox\" [ngModel]=\"airport.atctFacility\" disabled>ATCT Facility\r\n                            </label>\r\n                        </div>\r\n                    </div>\r\n                    <div class='row' style=\"margin-left:5px\">\r\n                        <div class='col-sm-2'>Facility Level:</div>\r\n                        <div class='col-sm-2' *ngIf='airport'><b>{{airport.facLevelName}}</b></div>\r\n                    </div>\r\n                    <div class=\"row\" style=\"margin-left:5px\">\r\n                            <div class=\"col-md-4\" \r\n                                 style=\"border-style:solid; width:350px;padding-left:0px; padding-right:0px;border-width:1px;padding-bottom:5px;padding-top:5px\">\r\n                                <div class='row' style=\" margin-left:0px;\">\r\n                                    <div class='col-sm-3' style=\"text-align:left;padding-left:0px;padding-right:0px;\">Hub Size:</div>\r\n                                    <div class='col-sm-3' *ngIf='airport' style=\"padding-left:0px;text-align:left;\"><b>{{airport.hubSizeName}}</b></div>\r\n                                    <div class='col-sm-3'  style=\"text-align:right;padding-right:0px;\">Hub Loc Id:</div>\r\n                                    <div class='col-sm-3' *ngIf='airport'  style=\"padding-left:0px; padding-right:0px;text-align:left;\"><b>{{airport.hubLocId}}</b></div>\r\n                                </div>\r\n                                <div class='row' style=\"margin-left:0px;\">\r\n                                    <div class='col-sm-3 checkbox disabled' *ngIf='airport' style=\"text-align:left;margin:0px;\">\r\n                                            <label><input type=\"checkbox\" [ngModel]=\"airport.reliever\" disabled>Reliever</label>\r\n                                    </div>\r\n                                    <div class='col-sm-3' style=\"padding-left:0px;padding-right:0px;text-align:left;\"><p></p></div>\r\n                                    <div class='col-sm-3' style=\"text-align:right;padding-right:0px;\" nowrap>Reliever Id:</div>\r\n                                    <div class='col-sm-3' *ngIf='airport'><b>{{airport.relieverId}}</b></div>\r\n                                </div>\r\n                                <div class='row' style=\" margin-left:0px;\">\r\n                                    <div class='col-sm-3' style=\"text-align:right;padding-left:0px;\" ><p></p></div>\r\n                                    <div class='col-sm-3' style=\"text-align:right;padding-right:0px;\"><p></p></div>\r\n                                    <div class='col-sm-3' style=\"text-align:right;padding-right:0px;padding-left:0px;\" no-wrap>Center Area Id:</div>\r\n                                    <div class='col-sm-3' *ngIf='airport' style=\"padding-left:0px;padding-right:0px;text-align:left;\"><b>{{airport.centerAreaId}}</b></div>\r\n                                </div>\r\n                                <div class='row' style=\"margin-left:0px;\">\r\n                                    <div class='col-sm-3' style=\"text-align:right;padding-left:0px;\" ><p></p></div>\r\n                                    <div class='col-sm-2' style=\"text-align:right;padding-right:0px;\"><p></p></div>\r\n                                    <div class='col-sm-4' style=\"text-align:right;padding-right:0px;padding-left:0px;\" no-wrap>Approach Control Id:</div>\r\n                                    <div class='col-sm-3' *ngIf='airport' style=\"padding-left:0px;padding-right:0px;text-align:left;\"><b>{{airport.approachControlId}}</b></div>\r\n                                </div>\r\n                                <div><p></p></div>\r\n                            </div>\r\n                            <div></div>\r\n                            <div  class=\" clearfix col-md-4\" \r\n                                  style=\" margin-left:5px;border-style:solid;width:350px;padding-left:5px;padding-bottom:2px;padding-right:0;padding-top:5px;border-width:1px;\">\r\n                                <div class='row' style=\" margin-left:0px;\">\r\n                                    <div class='col-sm-6'>Site Number:</div>\r\n                                    <div class='col-sm-3' *ngIf='airport'><b>{{airport.siteNumber}}</b></div>\r\n                                </div>\r\n                                <div class='row' style=\" margin-left:0px;\">\r\n                                    <div class='col-sm-6'>Nasp Number:</div>\r\n                                    <div class='col-sm-3' *ngIf='airport'><b>{{airport.naspNumber}}</b></div>\r\n                                </div>\r\n                                <div class='row' style=\" margin-left:0px;\">\r\n                                    <div class='col-sm-6'>Latitude:</div>\r\n                                    <div class='col-sm-3' *ngIf='airport'><b>{{airport.latitude | degreesFromSeconds}}</b></div>\r\n                                </div>\r\n                                <div class='row' style=\" margin-left:0px;\">\r\n                                    <div class='col-sm-6'>Longitude:</div>\r\n                                    <div class='col-sm-3' *ngIf='airport'><b>{{airport.longitude | degreesFromSeconds}}</b></div>\r\n                                </div>\r\n                                <div class='row' style=\" margin-left:0px;\">\r\n                                    <div class='col-sm-6'>Link to Google Maps:</div>\r\n                                    <div class='col-sm-3' *ngIf='airport'>\r\n                                        <a href =\"http://maps.google.com/maps?q= + {{airport.latitude | degreesFromSeconds}}+{{airport.longitude | degreesFromSeconds}}+({{airport.name}})+&hl=en\" target=\"_blank\" style=\"font-size:12px;text-decoration:underline;\">Map It!</a>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n                    </div>\r\n                    <p></p>\r\n                    <div class='row' style=\"border-style:solid; width:700px;padding-left:0; padding-right:0;border-width:1px;margin-bottom:5px;margin-left:5px;white-space: normal;\">\r\n                        <div class='col-md-2'><b>Comments/Notes:</b></div><br>\r\n                        <div class='col-md-10' *ngIf='airport' style=\"font-size:83%;\">{{airport.comments}}</div>\r\n                    </div>\r\n                    \r\n                    <div class='row' style=\"border-style:solid; width:700px;border-width:1px; margin-top:5px;margin-left:5px\">\r\n                        <div class=\"row\" style=\"margin-left:5px\">\r\n                            <div class='col-sm-4 checkbox disabled' *ngIf='airport'  style=\"padding-left:0px;\" >\r\n                                <label><input type=\"checkbox\" [ngModel]=\"airport.primaryRadar\" disabled>Primary Radar</label>\r\n                            </div>\r\n                            <div class='col-sm-4 checkbox disabled' *ngIf='airport'  style=\"text-align:left;padding-left:0px;margin-top:11px\" >\r\n                                <label><input type=\"checkbox\" [ngModel]=\"airport.noAddFacility\" disabled>No Add Facility</label>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row\" style=\"margin-left:5px;margin-bottom:5px\">\r\n                            <div class='col-sm-6'>OPS_FLAG</div>\r\n                            <div class='col-sm-6' *ngIf='airport'><b>{{airport.OpsFlagName}}</b></div>\r\n                        </div>\r\n                        <div class=\"row\" style=\"margin-left:5px\">\r\n                            <div class='col-sm-6' *ngIf='airport'>\r\n                                <div class=\"checkbox disabled\">\r\n                                    <label><input type=\"checkbox\" [ngModel]=\"airport.regionalInput\" disabled>Regional Input</label>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"row\" style=\"margin-left:5px\">\r\n                            <div class='col-md-3'>Regional Input Start Year:</div>\r\n                            <div class='col-md-3' *ngIf='airport'>{{airport.regionalInputStartYear}}</div>\r\n                            <div class='col-md-3'>Regional Input End Year:</div>\r\n                            <div class='col-md-3' *ngIf='airport'>{{airport.regionalInputEndYear}}</div>\r\n                        </div>\r\n                    </div>\r\n                    <div><p></p></div>\r\n                </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ },

/***/ 773:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var airport_service_1 = __webpack_require__(677);
	var scenario_service_1 = __webpack_require__(692);
	var user_session_1 = __webpack_require__(699);
	var user_info_service_1 = __webpack_require__(695);
	var commondata_service_1 = __webpack_require__(693);
	var AirportEditComponent = (function () {
	    function AirportEditComponent(route, router, _airportService, _scenarioService, _commonDataService, _userInfoService, User) {
	        this.route = route;
	        this.router = router;
	        this._airportService = _airportService;
	        this._scenarioService = _scenarioService;
	        this._commonDataService = _commonDataService;
	        this._userInfoService = _userInfoService;
	        this.User = User;
	        this.pageTitle = 'Facility Edit ';
	        this.displayNotes = false;
	    }
	    AirportEditComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        //TODO: need to see what the original page defaults to 
	        this.sub = this.route.params.subscribe(function (params) {
	            var id = params['locId'];
	            //will need to only do this if we get a value
	            _this.getAirport(id);
	        });
	        this._scenarioService.getScenarios(this.User.getSession()['id']) //this.User.getSession().userId
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.setScenarioHeader(_this.User.getSession().scenarioId);
	        });
	        this.getKeyValues('region');
	        this.getKeyValues('state');
	        this.getKeyValues('emdfcode');
	        this.getKeyValues('faclevel');
	        this.getKeyValues('hubsize');
	        this.getKeyValues('opsflags');
	        this._userInfoService.getRegionalYear(this.User.getSession()['id']) //this.User.getSession().userId
	            .subscribe(function (success) {
	            _this.regStartYear = success.startYear;
	            _this.regEndYear = success.endYear;
	        });
	    };
	    AirportEditComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    AirportEditComponent.prototype.getAirport = function (locId) {
	        var _this = this;
	        this._airportService.getAirport(locId, this.User.getSession().scenarioId)
	            .subscribe(function (airport) { return _this.airport = airport; }, function (error) { return _this.errorMessage = error; });
	    };
	    AirportEditComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	    };
	    AirportEditComponent.prototype.getKeyValues = function (id) {
	        var _this = this;
	        this._commonDataService.getData(id)
	            .subscribe(function (list) {
	            if (id == "region") {
	                _this.regions = list;
	            }
	            else if (id == "state") {
	                _this.states = list;
	            }
	            else if (id == "emdfcode") {
	                _this.facClasses = list;
	            }
	            else if (id == "faclevel") {
	                _this.facLevels = list;
	            }
	            else if (id == "hubsize") {
	                _this.sizes = list;
	            }
	            else if (id == "opsflags") {
	                _this.flags = list;
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    AirportEditComponent.prototype.updateAirport = function () {
	        var _this = this;
	        this.errorMessage = null;
	        if (+this.airport.regionalInputEndYear < +this.airport.regionalInputStartYear) {
	            this.errorMessage = "Regional input start year cannot be greater than regional input end year.";
	            return;
	        }
	        this._airportService.updateAirport(this.airport)
	            .subscribe(function (response) {
	            if (response.responseStatus == "success") {
	                _this.router.navigate(['/airports', { locId: _this.airport.locId }]);
	            }
	            else if (response.responseStatus == "error") {
	                _this.errorMessage = "An error occured while trying to update the facility.";
	                console.error(response.responseMessage);
	            }
	        }, function (error) {
	            _this.errorMessage = "An error occured while trying to update the facility.";
	            console.error(error);
	        });
	    };
	    AirportEditComponent.prototype.cancelEdit = function () {
	        this.router.navigate(['/airports', { locId: this.airport.locId }]);
	    };
	    AirportEditComponent.prototype.regionalInputChange = function (event) {
	        //TODO: need to set these to other default values
	        if (event.target.checked) {
	            this.airport.regionalInputStartYear = this.regStartYear;
	            this.airport.regionalInputEndYear = this.regEndYear;
	        }
	    };
	    AirportEditComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/airports/airport.component.html',
	            template: __webpack_require__(774),
	            styles: [__webpack_require__(775)],
	            //styleUrls: ['app/products/product-list.component.css'],
	            providers: [commondata_service_1.KeyValuePair],
	            directives: [router_1.ROUTER_DIRECTIVES]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, airport_service_1.AirportService, scenario_service_1.ScenarioService, commondata_service_1.CommonDataService, user_info_service_1.UserInfoService, user_session_1.UserSession])
	    ], AirportEditComponent);
	    return AirportEditComponent;
	}());
	exports.AirportEditComponent = AirportEditComponent;


/***/ },

/***/ 774:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\"><strong *ngIf=\"currentScenario\">Current Scenario: {{currentScenario.scenarioName}}</strong></div>\r\n<div class='panel panel-primary'>\r\n    <div class='panel-heading' *ngIf='airport'>\r\n        {{pageTitle + ': ' + airport.name }}\r\n    </div>\r\n\r\n    <!-- Filter the Products   -->\r\n    <div class='panel-body'>\r\n\r\n        <div *ngIf=\"errorMessage\" class='alert alert-danger' style=\"margin-top:10px\">{{errorMessage}}</div>\r\n        \r\n        <form *ngIf=\"airport\" #airportForm=\"ngForm\" class=\"form-vertical\" (ngSubmit)=\"updateAirport()\" novalidate>\r\n            <div class=\"form-group row\">\r\n                <label for=\"locID\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">LOCID:</label>\r\n                <div class=\"col-md-5\">\r\n                    <strong>{{airport.locId}}</strong>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"region\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Region:</label>\r\n                <div class=\"col-md-5\">\r\n                    <select id=\"region\" name=\"region\" required class=\"form-control input-sm\" [(ngModel)]=\"airport.region\" [disabled]=\"!User.isAdmin\">\r\n                        <option *ngFor=\"let region of regions\" [ngValue]=\"region.key\">{{region.value}}</option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"airportName\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Name:</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"airportName\" name=\"airportName\" required class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"airport.name\" #arportNameField=\"ngModel\"/>\r\n                    <div [hidden]=\"arportNameField.valid || arportNameField.pristine\" class=\"alert alert-danger\">\r\n                        Name is required\r\n                    </div>\r\n                </div>             \r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"city\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">City:</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"city\" name=\"city\" required class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"airport.city\" #cityField=\"ngModel\"/>\r\n                    <div [hidden]=\"cityField.valid || cityField.pristine\" class=\"alert alert-danger\">\r\n                        City is required\r\n                    </div>\r\n                </div>             \r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"state\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">State:</label>\r\n                <div class=\"col-md-5\">\r\n                    <select id=\"state\" name=\"state\" class=\"form-control input-sm\" [(ngModel)]=\"airport.state\">\r\n                        <option *ngFor=\"let state of states\" [ngValue]=\"state.key\">{{state.value}}</option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"facilityClass\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Facility Type:</label>\r\n                <div class=\"col-md-5\">\r\n                    <select id=\"facilityClass\" name=\"facilityClass\" class=\"form-control input-sm\" [(ngModel)]=\"airport.facilityClass\">\r\n                        <option *ngFor=\"let facClass of facClasses\" [ngValue]=\"facClass.key\">{{facClass.value}}</option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-group row\">\r\n                <label for=\"facClass\"  style=\"text-align:right\"  class=\"col-md-2 control-label\"></label>\r\n                <div class=\"col-md-5\">  \r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" name=\"atctFacility\" [(ngModel)]=\"airport.atctFacility\" [disabled]=\"!User.isAdmin\">ATCT Facility</label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-group row\">\r\n                <label for=\"facilityLevel\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Facility Level:</label>\r\n                <div class=\"col-md-5\">\r\n                    <select id=\"facilityLevel\" name=\"facilityLevel\" class=\"form-control input-sm\" [(ngModel)]=\"airport.facilityLevel\">\r\n                        <option *ngFor=\"let facLevel of facLevels\" [ngValue]=\"facLevel.key\">{{facLevel.value}}</option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-group row\">\r\n                <label for=\"hubSize\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Facility Level:</label>\r\n                <div class=\"col-md-5\">\r\n                    <select id=\"hubSize\" name=\"hubSize\" class=\"form-control input-sm\" [(ngModel)]=\"airport.hubSize\" [disabled]=\"!User.isAdmin\">\r\n                        <option *ngFor=\"let size of sizes\" [ngValue]=\"size.key\">{{size.value}}</option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n            \r\n            <div class=\"form-group row\">\r\n                <label for=\"hubLocId\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">HUB Loc ID:</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"hubLocId\" name=\"hubLocId\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"airport.hubLocId\"/>\r\n                </div>             \r\n            </div>\r\n\r\n            <div class=\"form-group row\">\r\n                <label for=\"reliever\"  style=\"text-align:right\"  class=\"col-md-2 control-label\"></label>\r\n                <div class=\"col-md-5\">  \r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" name=\"reliever\" [(ngModel)]=\"airport.reliever\" [disabled]=\"!User.isAdmin\">Reliever</label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-group row\">\r\n                <label for=\"relieverId\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Reliever ID:</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"relieverId\" name=\"relieverId\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"airport.relieverId\"/>\r\n                </div>             \r\n            </div>\r\n\r\n            <div class=\"form-group row\">\r\n                <label for=\"centerAreaId\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Center Area ID:</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"centerAreaId\" name=\"centerAreaId\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"airport.centerAreaId\"/>\r\n                </div>             \r\n            </div>\r\n\r\n            <div class=\"form-group row\">\r\n                <label for=\"approachControlId\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Approach Control ID:</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"approachControlId\" name=\"approachControlId\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"airport.approachControlId\"/>\r\n                </div>             \r\n            </div>\r\n\r\n            <div class=\"form-group row\">\r\n                <label for=\"siteNumber\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Site Number:</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"siteNumber\" name=\"siteNumber\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"airport.siteNumber\"/>\r\n                </div>             \r\n            </div>\r\n                \r\n            <div class=\"form-group row\">\r\n                <label for=\"naspNumber\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Nasp Number:</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"naspNumber\" name=\"naspNumber\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"airport.naspNumber\"/>\r\n                </div>             \r\n            </div>\r\n                \r\n            <div class=\"form-group row\">\r\n                <label for=\"latitude\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Latitude:</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"latitude\" name=\"latitude\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"airport.latitude\"/>\r\n                </div>             \r\n            </div>\r\n                \r\n            <div class=\"form-group row\">\r\n                <label for=\"longitude\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Longitude:</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"longitude\" name=\"longitude\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"airport.longitude\"/>\r\n                </div>             \r\n            </div>\r\n\r\n            <div class=\"form-group row\">\r\n                <label for=\"comments\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Comments:</label>\r\n                <div class=\"col-md-5\">\r\n                    <textarea id=\"comments\" name=\"comments\" class=\"form-control input-sm\" rows=\"2\" [(ngModel)]=\"airport.comments\"></textarea>\r\n                </div>             \r\n            </div>\r\n\r\n            <div class=\"form-group row\">\r\n                <label for=\"primaryRadar\"  style=\"text-align:right\"  class=\"col-md-2 control-label\"></label>\r\n                <div class=\"col-md-5\">  \r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" name=\"primaryRadar\" [(ngModel)]=\"airport.primaryRadar\" [disabled]=\"!User.isAdmin\">Primary Radar</label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-group row\">\r\n                <label for=\"noAddFacility\"  style=\"text-align:right\"  class=\"col-md-2 control-label\"></label>\r\n                <div class=\"col-md-5\">  \r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" name=\"noAddFacility\" [(ngModel)]=\"airport.noAddFacility\" [disabled]=\"!User.isAdmin\">No Add Facility</label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-group row\">\r\n                <label for=\"opsFlag\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Ops Flag:</label>\r\n                <div class=\"col-md-5\">\r\n                    <select id=\"opsFlag\" name=\"opsFlag\" class=\"form-control input-sm\" [(ngModel)]=\"airport.opsFlag\" [disabled]=\"!User.isAdmin\">\r\n                        <option *ngFor=\"let flag of flags\" [ngValue]=\"flag.key\">{{flag.value}}</option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-group row\">\r\n                <label for=\"regionalInput\"  style=\"text-align:right\"  class=\"col-md-2 control-label\"></label>\r\n                <div class=\"col-md-5\">  \r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" name=\"regionalInput\" [(ngModel)]=\"airport.regionalInput\" (change)=\"regionalInputChange($event)\" [disabled]=\"!User.isAdmin\">Regional Input</label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n                \r\n            <div class=\"form-group row\">\r\n                <label for=\"regionalInputStartYear\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Regional Input Start Year:</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"regionalInputStartYear\" name=\"regionalInputStartYear\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"airport.regionalInputStartYear\" [disabled]=\"!User.isAdmin\"/>\r\n                </div>             \r\n            </div>\r\n                \r\n            <div class=\"form-group row\">\r\n                <label for=\"regionalInputEndYear\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Regional Input End Year:</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"regionalInputEndYear\" minlength=\"4\" maxlength=\"4\" name=\"regionalInputEndYear\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"airport.regionalInputEndYear\" [disabled]=\"!User.isAdmin\"/>\r\n                </div>             \r\n            </div>\r\n\r\n            <div class=\"form-group row\">        \r\n                <div class=\"col-md-offset-3 col-md-10\">\r\n                    <button type=\"submit\" class=\"btn btn-success\" style=\"margin-right:10px\" [disabled]=\"!airportForm.form.valid\">Save</button>\r\n                    <button type=\"button\" class=\"btn btn-danger\" (click)=\"cancelEdit()\">Cancel</button>\r\n                </div>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>"

/***/ },

/***/ 775:
/***/ function(module, exports) {

	module.exports = ".current-scenario{\r\n    text-align: center;\r\n}\r\n.divider {\r\n    clear: both;\r\n}\r\n.divider-space {\r\n    margin-bottom: 20px;\r\n}\r\n.merge-column {\r\n    float: left;\r\n    margin-right: 100px;\r\n}\r\n.section-title {\r\n    font-weight: bold;\r\n}\r\n.btn-right {\r\n    float: right;\r\n    margin-left: 15px;\r\n}\r\n\r\n"

/***/ },

/***/ 776:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var airport_service_1 = __webpack_require__(677);
	var scenario_service_1 = __webpack_require__(692);
	var user_session_1 = __webpack_require__(699);
	var user_info_service_1 = __webpack_require__(695);
	var primeng_3 = __webpack_require__(708);
	var primeng_4 = __webpack_require__(708);
	var _ = __webpack_require__(680);
	var operation_grid_component_1 = __webpack_require__(777);
	var OperationsListComponent = (function () {
	    function OperationsListComponent(route, router, _airportService, _scenarioService, User, _userInfoService) {
	        this.route = route;
	        this.router = router;
	        this._airportService = _airportService;
	        this._scenarioService = _scenarioService;
	        this.User = User;
	        this._userInfoService = _userInfoService;
	        this.displayNotes = false;
	        this.isScenarioOwner = false;
	        this.canEdit = false;
	        this.displayAll = false;
	        this.msgs = [];
	    }
	    OperationsListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.tableName = params['tableName'];
	            _this.locId = params['locId'];
	            _this.airportName = params['airportName'];
	            _this.displayAll = params['displayAll'];
	            _this._airportService.getOperations()
	                .subscribe(function (operations) { return _this.allOperations = operations; }, function (error) { return _this.errorMessage = error; });
	        });
	        this._scenarioService.getScenarios(this.User.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.setScenarioHeader(_this.User.getSession().scenarioId);
	        });
	        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(function (success) {
	            _this.isScenarioOwner = success.isOwner;
	            if (_this.isScenarioOwner == false && _this.User.isAdmin == false) {
	                //console.log("this.isScenarioOwner == false " + (this.isScenarioOwner == false));
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'warn', summary: 'Warn Message', detail: 'We\'re sorry,  your access level does not permit you to view this page. Contact the TAF administrator to change your access privileges.' });
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    OperationsListComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    OperationsListComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	    };
	    OperationsListComponent.prototype.showNotes = function () {
	        var _this = this;
	        if (this.isScenarioOwner || this.User.getSession().isAdmin) {
	            this.notesTitle = "Edit Scenario Notes";
	        }
	        else {
	            this.notesTitle = "View Scenario Notes";
	        }
	        this._airportService.getScenarioNotes(this.locId, this.User.getSession().scenarioId)
	            .subscribe(function (success) {
	            if (!_.isEmpty(success)) {
	                _this.scenarioNote = success;
	            }
	            _this.displayNotes = true;
	        }, function (error) { return _this.errorMessage = "An error occured while attempting to retrieve notes."; });
	    };
	    OperationsListComponent.prototype.saveNotes = function () {
	        var _this = this;
	        this._airportService.updateScenarioNotes(this.locId, this.User.getSession().scenarioId, this.scenarioNote)
	            .subscribe(function (success) { }, function (error) {
	            _this.errorMessage = "An error occured while attempting to save your note.";
	            _this.displayNotes = false;
	        }, function () { return _this.displayNotes = false; });
	    };
	    OperationsListComponent.prototype.onTabChange = function (event) {
	        var params = {
	            locId: this.locId,
	            airportName: this.airportName
	        };
	        this.router.navigate([("/operations-list/" + this.allOperations[event.index].tableName), params]);
	    };
	    OperationsListComponent.prototype.back = function () {
	        this.router.navigate([("/airports/" + this.locId)]);
	    };
	    OperationsListComponent.prototype.graphData = function () {
	        var params = {
	            locId: this.locId,
	            airportName: this.airportName
	        };
	        this.router.navigate([("/operations-graph/" + this.tableName), params]);
	    };
	    OperationsListComponent.prototype.print = function () {
	        //console.log("printing");
	        document.getElementById("customButtons").style.visibility = "hidden";
	        //document.getElementById("customPanelBody").style.width = "1000px";
	        document.getElementById("taf-header").style.visibility = "hidden";
	        document.getElementById("taf-footer").style.visibility = "hidden";
	        window.print();
	        document.getElementById("customButtons").style.visibility = "visible";
	        //document.getElementById("customPanelBody").style.width = "1000px";
	        document.getElementById("taf-header").style.visibility = "visible";
	        document.getElementById("taf-footer").style.visibility = "visible";
	    };
	    OperationsListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(779),
	            //styles: [require('../airport.css')],
	            styles: [__webpack_require__(700)],
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_3.Button, primeng_1.TabView, primeng_2.TabPanel, operation_grid_component_1.OperationGridComponent, primeng_4.Dialog]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, airport_service_1.AirportService, scenario_service_1.ScenarioService, user_session_1.UserSession, user_info_service_1.UserInfoService])
	    ], OperationsListComponent);
	    return OperationsListComponent;
	}());
	exports.OperationsListComponent = OperationsListComponent;


/***/ },

/***/ 777:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var airport_interfaces_1 = __webpack_require__(697);
	var airport_service_1 = __webpack_require__(677);
	var scenario_service_1 = __webpack_require__(692);
	var user_info_service_1 = __webpack_require__(695);
	var user_session_1 = __webpack_require__(699);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var primeng_3 = __webpack_require__(708);
	var primeng_4 = __webpack_require__(708);
	var primeng_5 = __webpack_require__(708);
	var primeng_6 = __webpack_require__(708);
	var primeng_7 = __webpack_require__(708);
	var _ = __webpack_require__(680);
	var system_control_service_1 = __webpack_require__(694);
	var OperationGridComponent = (function () {
	    //might need the routes
	    function OperationGridComponent(route, router, _airportService, _scenarioService, _userInfoService, User, request, _systemControlService) {
	        this.route = route;
	        this.router = router;
	        this._airportService = _airportService;
	        this._scenarioService = _scenarioService;
	        this._userInfoService = _userInfoService;
	        this.User = User;
	        this.request = request;
	        this._systemControlService = _systemControlService;
	        this.displayDialog = false;
	        this.canEdit = false;
	        this.dialogHeader = "Detail";
	        //displayAll: boolean = false;
	        this.displayAllText = "View Previous Years";
	    }
	    OperationGridComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        if (this.selected) {
	            this.request.tableName = this.operation.tableName;
	            this.request.scenarioId = this.User.getSession().scenarioId;
	            this.request.locId = this.locId;
	            this.request.isAdmin = this.User.getSession().isAdmin ? 1 : 0;
	            this._airportService.getOperationsColumns(this.request)
	                .subscribe(function (columns) {
	                _this.columns = columns;
	                _this.editableColumns = _.filter(_this.columns, function (column) { return !column.calculated; });
	                _.find(columns, function (column) { column.fieldName === 'AAT' ? column.isAAT = 1 : column.isAAT = 0; });
	            }, function (error) { return _this.errorMessage = error; }, function () {
	            });
	            this.getResults();
	        }
	    };
	    //may not need this
	    OperationGridComponent.prototype.ngOnDestroy = function () { };
	    OperationGridComponent.prototype.getResults = function () {
	        var _this = this;
	        this._systemControlService.getSystemControl()
	            .subscribe(function (systemControlElem) { return _this.systemControlElem = systemControlElem; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this._airportService.getOperationsList(_this.request)
	                .subscribe(function (results) {
	                _this.results = results;
	                _this.results.map(function (result) {
	                    result.scenarioDisplay = result.SCENARIO == 0 ? "" : "*";
	                });
	                if (!_this.displayAll) {
	                    _this.results = _this.results.filter(function (results) { return results.AYEAR > (_this.systemControlElem.ffcYear - 4); });
	                }
	                _this.results.sort(function (n1, n2) {
	                    if (n1.AYEAR > n2.AYEAR) {
	                        return 1;
	                    }
	                    if (n1.AYEAR < n2.AYEAR) {
	                        return -1;
	                    }
	                    return 0;
	                });
	                _this.setDisplayAllText(_this.displayAll);
	            }, function (error) { return _this.errorMessage = error; });
	        });
	    };
	    OperationGridComponent.prototype.onRowSelect = function (event) {
	        //lets make this a view if they are not the scenario owner or admin
	        //need to get the scenario of the row
	        var _this = this;
	        if (this.User.getSession().isAdmin) {
	            this.dialogHeader = "Edit";
	            this.canEdit = true;
	            this.editRow = this.cloneRow(event.data);
	            this.displayDialog = true;
	        }
	        else {
	            this._userInfoService.isScenarioOwner(this.User.getSession()['id'], event.data.SCENARIO).subscribe(function (success) {
	                if (success.isOwner) {
	                    _this.dialogHeader = "Edit";
	                    _this.canEdit = true;
	                    _this.editRow = _this.cloneRow(event.data);
	                    _this.displayDialog = true;
	                }
	                else {
	                    _this.dialogHeader = "Detail";
	                    _this.canEdit = false;
	                    _this.editRow = _this.cloneRow(event.data);
	                    _this.displayDialog = true;
	                }
	            }, function (error) { return _this.errorMessage = error; });
	        }
	    };
	    OperationGridComponent.prototype.cloneRow = function (dataToClone) {
	        var editableColumnCounter = 0;
	        var cloneListCounter = 0;
	        var cloneList = [];
	        var _loop_1 = function(prop) {
	            var clone = { value: "", fieldName: "", displayName: "", readOnly: false, display: true };
	            if (_.find(this_1.editableColumns, function (column) { return column.fieldName === prop; })) {
	                clone.value = dataToClone[prop];
	                clone.fieldName = prop;
	                clone.displayName = this_1.editableColumns[editableColumnCounter].displayName;
	                clone.readOnly = false;
	                cloneList[cloneListCounter] = clone;
	                editableColumnCounter++;
	                cloneListCounter++;
	            }
	            else if (prop === "AYEAR") {
	                //really only want year in here
	                clone.value = dataToClone[prop];
	                clone.fieldName = prop;
	                clone.displayName = "Year";
	                clone.readOnly = true;
	                cloneList[cloneListCounter] = clone;
	                cloneListCounter++;
	            }
	            else if (prop === "SCENARIO") {
	                clone.value = dataToClone[prop];
	                clone.fieldName = prop;
	                clone.display = false;
	                clone.readOnly = true;
	                cloneList[cloneListCounter] = clone;
	                cloneListCounter++;
	            }
	        };
	        var this_1 = this;
	        for (var prop in dataToClone) {
	            _loop_1(prop);
	        }
	        return cloneList;
	    };
	    OperationGridComponent.prototype.addButtonClicked = function () {
	        var params = {
	            locId: this.locId,
	            tableName: this.operation.tableName,
	            airportName: this.airportName
	        };
	        this.router.navigate(["/operations-add-year", params]);
	    };
	    OperationGridComponent.prototype.columnClick = function (event) {
	        var params = {
	            locId: this.locId,
	            fieldName: event.field,
	            airportName: this.airportName
	        };
	        this.router.navigate([("/operations-reforcast/" + this.operation.tableName), params]);
	    };
	    OperationGridComponent.prototype.save = function () {
	        var _this = this;
	        var params = {
	            tableName: this.operation.tableName,
	            locId: this.locId,
	            editRow: this.editRow,
	        };
	        this._airportService.updateOperations(params)
	            .subscribe(function (response) {
	            if (response.responseStatus == "success") {
	                _this.getResults();
	                _this.displayDialog = false;
	            }
	            else if (response.responseStatus == "error") {
	                _this.displayDialog = false;
	                _this.errorMessage = "An error occured while trying to update the row.";
	                console.error(response.responseMessage);
	            }
	        }, function (error) {
	            _this.displayDialog = false;
	            _this.errorMessage = "An error occured while trying to update the facility.";
	            console.error(error);
	        });
	    };
	    OperationGridComponent.prototype.displayAllYears = function () {
	        this.displayAll = !this.displayAll;
	        this.setDisplayAllText(this.displayAll);
	        this.getResults();
	    };
	    OperationGridComponent.prototype.setDisplayAllText = function (flag) {
	        if (flag) {
	            this.displayAllText = "Hide Previous Years";
	        }
	        else {
	            this.displayAllText = "View Previous Years";
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], OperationGridComponent.prototype, "operation", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], OperationGridComponent.prototype, "selected", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], OperationGridComponent.prototype, "locId", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], OperationGridComponent.prototype, "airportName", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], OperationGridComponent.prototype, "displayAll", void 0);
	    OperationGridComponent = __decorate([
	        core_1.Component({
	            selector: 'operation-grid',
	            template: __webpack_require__(778),
	            styles: [__webpack_require__(700)],
	            //encapsulation: ViewEncapsulation.None,
	            directives: [primeng_1.Button, primeng_2.Column, primeng_3.TemplateLoader, primeng_4.TemplateWrapper, primeng_5.PrimeTemplate, primeng_6.ColumnBodyTemplateLoader, primeng_7.Footer]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, airport_service_1.AirportService, scenario_service_1.ScenarioService, user_info_service_1.UserInfoService, user_session_1.UserSession, airport_interfaces_1.OperationsListRequest, system_control_service_1.SystemControlService])
	    ], OperationGridComponent);
	    return OperationGridComponent;
	}());
	exports.OperationGridComponent = OperationGridComponent;


/***/ },

/***/ 778:
/***/ function(module, exports) {

	module.exports = "\r\n    <div class='alert alert-danger' *ngIf='errorMessage'>{{errorMessage}}</div>\r\n\r\n    \r\n     <div *ngIf=\"!selected || !results || !columns\" align=\"center\">\r\n        <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n        <div>Loading please wait ....</div>\r\n        <div>Do Not click back or Refresh the page</div>\r\n    </div>\r\n    \r\n\r\n    <p *ngIf=\"selected && results && columns\">\r\n        \r\n        <button type=\"button\" pButton style=\"float:right;width:200px;\" (click)=\"displayAllYears()\" label=\"{{displayAllText}}\" [disabled]=\"results.length <= 0\"></button>\r\n        <p-dataTable [value]=\"results\" selectionMode=\"single\" [(selection)]=\"selectedRow\" (onRowSelect)=\"onRowSelect($event)\"\r\n         [responsive]=\"true\" >\r\n            <header>\r\n                {{columns[0].tableDisplay}} \r\n            </header>\r\n\r\n            <p-column field=\"AYEAR\" header=\"Year\" styleClass=\"myTableAyear\"></p-column>\r\n\r\n            <p-column field=\"scenarioDisplay\" header=\"F\" styleClass=\"myTableForecast\"></p-column>\r\n            <p-column \r\n                *ngFor=\"let column of columns\"  \r\n                field=\"{{column.calculated === 1 ? column.graphName : column.fieldName}}\" \r\n                header=\"{{column.displayName}}\"\r\n                sortable=\"{{column.calculated === 0 ? 'custom' : ''}}\"\r\n                (sortFunction)=\"columnClick($event)\" \r\n                styleClass=\"{{column.isAAT}}==1? myTableColsLightGrey : myTableCols\">\r\n               <!-- contenteditable=\"true\">-->\r\n                        <template let-col let-result=\"rowData\" pTemplate type=\"body\">\r\n                            <span>\r\n                                {{result[col.field] | number}}</span>\r\n                        </template>\r\n            </p-column>\r\n\r\n            <!--\r\n                Think I can use this to make the headers navigate to the other page\r\n                just will need to tweak the css class ui-datatable-header to get rid of the arrows\r\n\r\n                need to make this just for the non calculated ones\r\n\r\n                sortable=\"custom\"\r\n                (sortFunction)=\"columnClick($event)\">\r\n            -->\r\n\r\n\r\n            <footer>\r\n                    &nbsp;\r\n            </footer>\r\n        </p-dataTable>\r\n        <button *ngIf=\"User.getSession().isAdmin\" type=\"button\" pButton icon=\"fa-plus\" style=\"float:left\" (click)=\"addButtonClicked()\" label=\"Add Year\"></button>\r\n\r\n        <p-dialog header=\"{{dialogHeader}}\" [(visible)]=\"displayDialog\" [responsive]=\"true\" showEffect=\"fade\" [modal]=\"true\">\r\n            <div class=\"ui-grid ui-grid-responsive ui-fluid\" *ngIf=\"editRow\">\r\n                <div *ngFor=\"let edit of editRow\" class=\"ui-grid-row\">\r\n                    <div class=\"ui-grid-col-4\"><label style=\"font-size:85%\">{{edit.displayName}}</label></div>\r\n\r\n                    <div *ngIf=\"(edit.readOnly || !canEdit) && edit.display\" class=\"ui-grid-col-8\">{{edit.value}}</div>\r\n\r\n\r\n                    <div *ngIf=\"!edit.readOnly && edit.display && canEdit\" class=\"ui-grid-col-8\"><input pInputText id=\"{{edit.fieldName}}\" [(ngModel)]=\"edit.value\"/></div>\r\n                </div>\r\n            </div>\r\n\r\n            <footer>\r\n                <div style=\"margin-left: 20px; margin-bottom: 10px;\">\r\n                    <button *ngIf=\"canEdit\" type=\"button\" pButton icon=\"fa-check\" style=\"width:100px!important\"  (click)=\"save()\" label=\"Save\"></button>\r\n                    <button  type=\"button\" pButton icon=\"fa-close\"  style=\"width:100px!important;\" (click)=\"displayDialog=false\" label=\"Cancel\"></button>\r\n                </div>\r\n            </footer>\r\n        </p-dialog>\r\n\r\n    </p>\r\n"

/***/ },

/***/ 779:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\"><strong *ngIf=\"currentScenario\">Current Scenario: {{currentScenario.scenarioName}}</strong></div>\r\n<div class='panel panel-primary'>\r\n    <div class='panel-heading'>\r\n        {{'Facility: ' + locId + ' - ' + airportName }}\r\n    </div>\r\n\r\n    <!-- Filter the Products   -->\r\n    <div class='panel-body' id=\"customPanelBody\">\r\n\r\n        <div class='alert alert-danger' *ngIf='errorMessage'>{{errorMessage}}</div>\r\n\r\n        <!--This will need to trigger off some different stuff, actually maybe not-->\r\n        <p-dialog *ngIf=\"currentScenario\" header=\"{{notesTitle}}\" [(visible)]=\"displayNotes\" modal=\"modal\" showEffect=\"fade\">\r\n            <div>\r\n                <h4 class=\"text-center\">Scenario: {{currentScenario.scenarioName}}</h4>\r\n                <h4 class=\"text-center\">LOCID: {{locId}} - {{airportName}}</h4>\r\n                <div class=\"form-group\">\r\n                    <textarea class=\"form-control\" rows=\"5\" id=\"notes\" [(ngModel)]=\"scenarioNote\"></textarea>\r\n                </div>\r\n            </div>\r\n            <div>\r\n                <div class=\"col-sm-6\">\r\n                    <button *ngIf=\"User.isAdmin || isScenarioOwner\" type=\"button\" pButton icon=\"fa-save\" (click)=\"saveNotes()\" label=\"Save\" style=\"width:100px!important\"></button>\r\n                </div>\r\n                <div class=\"col-sm-6\">\r\n                    <button type=\"button\" pButton icon=\"fa-close\" (click)=\"displayNotes=false\" label=\"Cancel\" style=\"width:100px!important\"></button>\r\n                </div>\r\n            </div>\r\n        </p-dialog>\r\n\r\n        <div class='row' id=\"customButtons\">\r\n            <button type=\"text\" (click)=\"back()\" pButton icon=\"fa-arrow-circle-left\" label=\"Facility View {{locId}}\"></button>\r\n\r\n            <button *ngIf=\"this.User.getSession().isReadOnly\" type=\"text\" (click)=\"showNotes()\" pButton icon=\"fa-external-link-square\"  style=\"font-weight:normal;\" label=\"Notes\"></button>\r\n\r\n            <button type=\"text\" (click)=\"graphData()\" pButton icon=\"fa-bar-chart\" label=\"Graph Data\"></button>\r\n\r\n            <button type=\"text\" (click)=\"print()\" pButton icon=\"fa-print\" label=\"Print\"></button>\r\n        </div>\r\n\r\n        <div class='row' >\r\n            <p-tabView (onChange)=\"onTabChange($event)\" > \r\n                <p-tabPanel *ngFor=\"let operation of allOperations\" header=\"{{operation.displayName}}\" [selected]=\"operation.tableName === tableName\">\r\n                    <operation-grid \r\n                        [operation]=\"operation\"\r\n                        [selected]=\"operation.tableName === tableName\"\r\n                        [locId]=\"locId\"\r\n                        [airportName]=\"airportName\"\r\n                        [displayAll]=\"displayAll\">\r\n                    </operation-grid>\r\n                </p-tabPanel>\r\n            </p-tabView>\r\n\r\n\r\n        </div>\r\n    </div>\r\n</div>"

/***/ },

/***/ 780:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var airport_service_1 = __webpack_require__(677);
	var scenario_service_1 = __webpack_require__(692);
	var user_session_1 = __webpack_require__(699);
	var user_info_service_1 = __webpack_require__(695);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var system_control_service_1 = __webpack_require__(694);
	var OperationsAddDataPointComponent = (function () {
	    function OperationsAddDataPointComponent(route, router, _airportService, _scenarioService, User, _userInfoService, _systemControlService) {
	        this.route = route;
	        this.router = router;
	        this._airportService = _airportService;
	        this._scenarioService = _scenarioService;
	        this.User = User;
	        this._userInfoService = _userInfoService;
	        this._systemControlService = _systemControlService;
	    }
	    OperationsAddDataPointComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.tableName = params['tableName'];
	            _this.locId = params['locId'];
	            _this.airportName = params['airportName'];
	        });
	        this._scenarioService.getScenarios(this.User.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.setScenarioHeader(_this.User.getSession().scenarioId);
	        });
	        this._systemControlService.getSystemControl()
	            .subscribe(function (systemControlElem) { return _this.systemControlElem = systemControlElem; }, function (error) { return _this.errorMessage = error; });
	    };
	    OperationsAddDataPointComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    OperationsAddDataPointComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	    };
	    OperationsAddDataPointComponent.prototype.submit = function () {
	        var _this = this;
	        this.errorMessage = null;
	        if (this.year >= this.systemControlElem.lfcYear) {
	            this.errorMessage = "The year can only be less than last forecast year";
	            return;
	        }
	        else {
	            var scenarioId = void 0;
	            if (this.year < this.systemControlElem.ffcYear) {
	                scenarioId = 0;
	            }
	            else {
	                scenarioId = this.User.getSession().scenarioId;
	            }
	            var params = {
	                tableName: this.tableName,
	                locId: this.locId,
	                scenario: scenarioId,
	                ayear: this.year
	            };
	            this._airportService.saveOperationsYear(params)
	                .subscribe(function (response) {
	                if (response.responseStatus == "success") {
	                    var displayAll = 0;
	                    if (_this.year < _this.systemControlElem.ffcYear - 4) {
	                        displayAll = 1;
	                    }
	                    var params_1 = {
	                        locId: _this.locId,
	                        airportName: _this.airportName,
	                        displayAll: displayAll
	                    };
	                    _this.router.navigate([("/operations-list/" + _this.tableName), params_1]);
	                }
	                else if (response.responseStatus == "duplicate") {
	                    _this.errorMessage = "This year already exist within this scenario.";
	                }
	                else if (response.responseStatus == "error") {
	                    _this.errorMessage = "An error occured while trying to update the facility.";
	                    console.error(response.responseMessage);
	                }
	            }, function (error) {
	                _this.errorMessage = "An error occured while trying to add the year.";
	                console.error(error);
	            });
	        }
	    };
	    OperationsAddDataPointComponent.prototype.cancel = function () {
	        var params = {
	            locId: this.locId,
	            airportName: this.airportName
	        };
	        this.router.navigate([("/operations-list/" + this.tableName), params]);
	    };
	    OperationsAddDataPointComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(781),
	            styles: [__webpack_require__(775)],
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.Button, primeng_2.Dialog]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, airport_service_1.AirportService, scenario_service_1.ScenarioService, user_session_1.UserSession, user_info_service_1.UserInfoService, system_control_service_1.SystemControlService])
	    ], OperationsAddDataPointComponent);
	    return OperationsAddDataPointComponent;
	}());
	exports.OperationsAddDataPointComponent = OperationsAddDataPointComponent;


/***/ },

/***/ 781:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\"><strong *ngIf=\"currentScenario\">Current Scenario: {{currentScenario.scenarioName}}</strong></div>\r\n<div class='panel panel-primary'>\r\n    <div class='panel-heading'>\r\n        TAF Add Year\r\n    </div>\r\n\r\n    <div class='panel-body'>\r\n\r\n        <div class='alert alert-danger' *ngIf='errorMessage'>{{errorMessage}}</div>\r\n\r\n        <p>\r\n            This feature allows you to add a new year to \r\n            for this LOCID and data set specified below. You must add a new year to \r\n            each data set individually.<br/> History years will be shared with all \r\n            scenarios.<br/><br/> \r\n            Forecast years must be within forecast years of {{systemControlElem?.ffcYear}} and {{systemControlElem?.lfcYear}} \r\n            and will be added to this scenario only. All the values will be set to \r\n            zero. <br/>You may edit the data points from the data set list page after \r\n            they are added.\r\n        </p>\r\n        <br/>\r\n        <br/>\r\n        <form #yearForm=\"ngForm\" class=\"form-vertical\" (ngSubmit)=\"submit()\">\r\n            <div class='form-group row'>\r\n                <div class='col-md-2 control-label' style=\"text-align:right\">Scenario:</div>\r\n                <div>{{currentScenario?.scenarioName}}</div>\r\n            </div>\r\n            <div class='form-group row'>\r\n                <div class='col-md-2 control-label' style=\"text-align:right\">Loc Id:</div>\r\n                <div>{{locId}}</div>\r\n            </div>\r\n            <div class='form-group row'>\r\n                <div class='col-md-2 control-label' style=\"text-align:right\">Data Set:</div>\r\n                <div>{{tableName}}</div>\r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"year\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Year:</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"year\" minlength=\"4\" maxlength=\"4\" required name=\"year\" class=\"form-control input-sm\" type=\"text\" [(ngModel)]=\"year\"/>\r\n                </div>             \r\n            </div>\r\n            <div class=\"form-group row\">        \r\n                <div class=\"col-md-offset-3 col-md-10\">\r\n                    <button type=\"submit\" class=\"btn btn-success\" style=\"margin-right:10px\" [disabled]=\"!yearForm.form.valid\">Submit</button>\r\n                    <button type=\"button\" class=\"btn btn-danger\" (click)=\"cancel()\">Cancel</button>\r\n                </div>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>"

/***/ },

/***/ 782:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var airport_service_1 = __webpack_require__(677);
	var scenario_service_1 = __webpack_require__(692);
	var user_session_1 = __webpack_require__(699);
	var user_info_service_1 = __webpack_require__(695);
	var primeng_3 = __webpack_require__(708);
	var operations_graph_selections_component_1 = __webpack_require__(783);
	var OperationsGraphComponent = (function () {
	    function OperationsGraphComponent(route, router, _airportService, _scenarioService, User, _userInfoService) {
	        this.route = route;
	        this.router = router;
	        this._airportService = _airportService;
	        this._scenarioService = _scenarioService;
	        this.User = User;
	        this._userInfoService = _userInfoService;
	        this.isScenarioOwner = false;
	    }
	    OperationsGraphComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.tableName = params['tableName'];
	            _this.locId = params['locId'];
	            _this.airportName = params['airportName'];
	            _this._airportService.getOperations()
	                .subscribe(function (operations) { return _this.allOperations = operations; }, function (error) { return _this.errorMessage = error; });
	        });
	        this._scenarioService.getScenarios(this.User.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.setScenarioHeader(_this.User.getSession().scenarioId);
	        });
	        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(function (success) { return _this.isScenarioOwner = success.isOwner; }, function (error) { return _this.errorMessage = error; });
	    };
	    OperationsGraphComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    OperationsGraphComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	    };
	    OperationsGraphComponent.prototype.onTabChange = function (event) {
	        var params = {
	            locId: this.locId,
	            airportName: this.airportName
	        };
	        this.router.navigate([("/operations-graph/" + this.allOperations[event.index].tableName), params]);
	    };
	    OperationsGraphComponent.prototype.backFacilityView = function () {
	        this.router.navigate([("/airports/" + this.locId)]);
	    };
	    OperationsGraphComponent.prototype.backDataSheet = function () {
	        var params = {
	            locId: this.locId,
	            airportName: this.airportName
	        };
	        this.router.navigate([("/operations-list/" + this.tableName), params]);
	    };
	    OperationsGraphComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(785),
	            styles: [__webpack_require__(700), __webpack_require__(701)],
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_3.Button, primeng_1.TabView, primeng_2.TabPanel, operations_graph_selections_component_1.OperationsGraphSelectionsComponent]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, airport_service_1.AirportService, scenario_service_1.ScenarioService, user_session_1.UserSession, user_info_service_1.UserInfoService])
	    ], OperationsGraphComponent);
	    return OperationsGraphComponent;
	}());
	exports.OperationsGraphComponent = OperationsGraphComponent;


/***/ },

/***/ 783:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var airport_interfaces_1 = __webpack_require__(697);
	var airport_service_1 = __webpack_require__(677);
	var scenario_service_1 = __webpack_require__(692);
	var user_info_service_1 = __webpack_require__(695);
	var user_session_1 = __webpack_require__(699);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var system_control_service_1 = __webpack_require__(694);
	var OperationsGraphSelectionsComponent = (function () {
	    function OperationsGraphSelectionsComponent(route, router, _airportService, _scenarioService, _userInfoService, User, request, _systemControlService) {
	        this.route = route;
	        this.router = router;
	        this._airportService = _airportService;
	        this._scenarioService = _scenarioService;
	        this._userInfoService = _userInfoService;
	        this.User = User;
	        this.request = request;
	        this._systemControlService = _systemControlService;
	        this.startYears = [];
	        this.endYears = [];
	        this.graphType = "bar";
	        this.yearsToPreview = 4;
	        this.dataCheckDone = false;
	    }
	    OperationsGraphSelectionsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        if (this.selected) {
	            var params = {
	                tableName: this.operation.tableName,
	                locId: this.locId,
	                scenarioId: this.User.getSession().scenarioId
	            };
	            this._airportService.hasGraphData(params)
	                .subscribe(function (response) {
	                if (response.hasData) {
	                    _this.hasData = true;
	                    _this.dataCheckDone = true;
	                    _this.getColumns();
	                    _this.getSystemControlValues();
	                }
	                else {
	                    _this.hasData = false;
	                    _this.dataCheckDone = true;
	                }
	            }, function (error) {
	                _this.errorMessage = "Server Error";
	                console.error(error);
	            });
	        }
	    };
	    OperationsGraphSelectionsComponent.prototype.getColumns = function () {
	        var _this = this;
	        this.request.tableName = this.operation.tableName;
	        this.request.scenarioId = this.User.getSession().scenarioId;
	        this.request.locId = this.locId;
	        this.request.isAdmin = this.User.getSession().isAdmin ? 1 : 0;
	        this._airportService.getOperationsColumns(this.request)
	            .subscribe(function (columns) { return _this.columns = columns; }, function (error) { return _this.errorMessage = error; });
	    };
	    OperationsGraphSelectionsComponent.prototype.getSystemControlValues = function () {
	        var _this = this;
	        this._systemControlService.getSystemControl()
	            .subscribe(function (systemControlElem) {
	            _this.systemControlElem = systemControlElem;
	            _this.populateYears();
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    OperationsGraphSelectionsComponent.prototype.populateYears = function () {
	        var _this = this;
	        this._userInfoService.getRegionalYear(this.User.getSession()['id'])
	            .subscribe(function (success) {
	            _this.populateStartYears(success.startYear);
	            _this.populateEndYears(success.endYear);
	        });
	    };
	    OperationsGraphSelectionsComponent.prototype.populateStartYears = function (startYear) {
	        var _this = this;
	        var params = {
	            tableName: this.operation.tableName,
	            locId: this.locId,
	            scenarioId: this.User.getSession().scenarioId
	        };
	        var minYear;
	        this._airportService.getGraphMinYear(params)
	            .subscribe(function (min) {
	            minYear = min;
	            var index = 0;
	            for (var year = minYear; year <= _this.systemControlElem.lfcYear; year++) {
	                _this.startYears[index] = year;
	                index++;
	            }
	            //need to set selected one
	            if (startYear) {
	                _this.selectedStartYear = startYear;
	            }
	            else {
	                _this.selectedStartYear = _this.systemControlElem.ffcYear - _this.yearsToPreview;
	            }
	        });
	    };
	    OperationsGraphSelectionsComponent.prototype.populateEndYears = function (endYear) {
	        var index = 0;
	        for (var year = this.systemControlElem.ffcYear - this.yearsToPreview; year <= this.systemControlElem.lfcYear; year++) {
	            this.endYears[index] = year;
	            index++;
	        }
	        //console.log("this.systemControlElem.ffcYear" + this.systemControlElem.ffcYear +" " + this.systemControlElem.lfcYear)
	        //need to set selected one
	        if (endYear) {
	            this.selectedEndYear = endYear;
	        }
	        else {
	            this.selectedEndYear = this.systemControlElem.ffcYear - this.yearsToPreview;
	        }
	    };
	    OperationsGraphSelectionsComponent.prototype.ngOnDestroy = function () { };
	    OperationsGraphSelectionsComponent.prototype.generateGraph = function () {
	        this.errorMessage = null;
	        var selectedColumns = this.columns.filter(function (column) {
	            return column.graphR == 1;
	        });
	        if (selectedColumns.length === 0) {
	            this.errorMessage = "At least one data column must be selected.";
	            return;
	        }
	        if (this.selectedEndYear <= this.selectedStartYear) {
	            this.errorMessage = "Selected end year must be greater than the selected start year.";
	            return;
	        }
	        sessionStorage.setItem('operations-graph-columns', JSON.stringify(selectedColumns));
	        var params = {
	            displayName: this.operation.displayName,
	            locId: this.locId,
	            airportName: this.airportName,
	            graphType: this.graphType,
	            startYear: this.selectedStartYear,
	            endYear: this.selectedEndYear,
	            quickGraph: "false"
	        };
	        this.router.navigate([("/operations-graph-display/" + this.operation.tableName), params]);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], OperationsGraphSelectionsComponent.prototype, "operation", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], OperationsGraphSelectionsComponent.prototype, "selected", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], OperationsGraphSelectionsComponent.prototype, "locId", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], OperationsGraphSelectionsComponent.prototype, "airportName", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], OperationsGraphSelectionsComponent.prototype, "displayAll", void 0);
	    OperationsGraphSelectionsComponent = __decorate([
	        core_1.Component({
	            selector: 'operations-graph-selections',
	            template: __webpack_require__(784),
	            styles: [__webpack_require__(700)],
	            directives: [primeng_1.Button, primeng_2.Checkbox]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, airport_service_1.AirportService, scenario_service_1.ScenarioService, user_info_service_1.UserInfoService, user_session_1.UserSession, airport_interfaces_1.OperationsListRequest, system_control_service_1.SystemControlService])
	    ], OperationsGraphSelectionsComponent);
	    return OperationsGraphSelectionsComponent;
	}());
	exports.OperationsGraphSelectionsComponent = OperationsGraphSelectionsComponent;


/***/ },

/***/ 784:
/***/ function(module, exports) {

	module.exports = "    <div class=\"divider\"></div>\r\n    <div class='alert alert-danger' *ngIf='errorMessage'>{{errorMessage}}</div>\r\n\r\n    \r\n     <div *ngIf=\"!columns && !dataCheckDone\" align=\"center\">\r\n        <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n        <div>Loading please wait ....</div>\r\n        <div>Do Not click back or Refresh the page</div>\r\n    </div>\r\n\r\n    <div *ngIf=\"!hasData && dataCheckDone\">\r\n        No records found\r\n    </div>\r\n    <div class=\"container\" style=\"margin:0px!important;padding-left: 0px;\">\r\n        <div *ngIf=\"hasData && dataCheckDone\" >\r\n            <div class=\"row col-md-12 customtd\" > \r\n                <div class=\"checkbox\" *ngFor=\"let column of columns\" >\r\n                    <label><input type=\"checkbox\" name=\"graphColumns\" [(ngModel)]=\"column.graphR\">{{column.displayName}}</label>\r\n                </div>\r\n            </div>\r\n            <br/>\r\n            <div class=\"row col-sm-12 customtd\" > \r\n                <b>Please enter the years used to define graph data:</b><br/><br/>\r\n            </div>\r\n            <div class=\"row col-sm-8 \"> \r\n                <div class= \"col-sm-2 customtd\" style=\"margin-right:5px;padding:0px;height:30px;\">\r\n                    Starting Year:\r\n                </div>\r\n                <div class= \"col-sm-2 customtd\"  style=\"margin-right:5px;padding-left: 0px;\">\r\n                    <select id=\"startYear\" name=\"startYear\" class=\"form-control input-sm\" [(ngModel)]=\"selectedStartYear\">\r\n                        <option *ngFor=\"let year of startYears\" [ngValue]=\"year\">{{year}}</option>\r\n                    </select>\r\n                </div>\r\n                <div class=\"col-sm-2 customtd\" style=\"margin-right:5px;padding:0px;height:30px\">\r\n                    Ending Year:     \r\n                </div>\r\n                <div class= \"col-sm-2 customtd\"  style=\"margin-right:5px;padding-left: 0px;\">\r\n                    <select id=\"endYear\" name=\"endYear\" class=\"form-control input-sm\" [(ngModel)]=\"selectedEndYear\">\r\n                        <option *ngFor=\"let year of endYears\" [ngValue]=\"year\">{{year}}</option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n            <div class=\"row col-sm-12\">\r\n                <div for=\"graphType\" class=\"col-sm-2 customtd\"><b>Graph Types:</b></div>\r\n                <div class=\"btn-group\" >\r\n                    <div class=\"radio\" >\r\n                        <input type=\"radio\" [(ngModel)]=\"graphType\"  name=\"graphTypeGroup\" value=\"bar\">Bar<br>\r\n                        <input type=\"radio\" [(ngModel)]=\"graphType\"  name=\"graphTypeGroup\" value=\"line\">Line\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"row\">        \r\n            <div class=\"col-sm-10\">\r\n                <button type=\"text\" pButton class=\"btn btn-success\" style=\"margin-right:10px\" (click)=\"generateGraph()\" label=\"Generate Graph\"></button>\r\n                <!--<button type=\"button\" class=\"btn btn-success\" style=\"margin-right:10px\" (click)=\"generateGraph()\">Save Graph Options</button>-->\r\n                <button type=\"text\" pButton class=\"btn btn-danger\" (click)=\"cancel()\" label=\"Cancel\"></button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n"

/***/ },

/***/ 785:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\"><strong *ngIf=\"currentScenario\">Current Scenario: {{currentScenario.scenarioName}}</strong></div>\r\n<div class='panel panel-primary'>\r\n    <div class='panel-heading'>\r\n        {{'Facility: ' + locId + ' - ' + airportName }}\r\n    </div>\r\n\r\n    <!-- Filter the Products   -->\r\n    <div class='panel-body'>\r\n\r\n        <div class='alert alert-danger' *ngIf='errorMessage'>{{errorMessage}}</div>\r\n\r\n        <div class='row'>\r\n            <button type=\"text\" (click)=\"backFacilityView()\" pButton icon=\"fa-arrow-circle-left\" label=\"Facility View {{locId}}\"></button>\r\n\r\n            <button type=\"text\" (click)=\"backDataSheet()\" pButton icon=\"fa-arrow-circle-left\" label=\"Data Sheet\"></button>\r\n        </div>\r\n\r\n        <div class='row'>\r\n            <p-tabView (onChange)=\"onTabChange($event)\">\r\n                <p-tabPanel *ngFor=\"let operation of allOperations\" header=\"{{operation.displayName}}\" [selected]=\"operation.tableName === tableName\">\r\n                    <operations-graph-selections \r\n                        [operation]=\"operation\"\r\n                        [selected]=\"operation.tableName === tableName\"\r\n                        [locId]=\"locId\"\r\n                        [airportName]=\"airportName\">\r\n                    </operations-graph-selections>\r\n                </p-tabPanel>\r\n            </p-tabView>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ },

/***/ 786:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var airport_service_1 = __webpack_require__(677);
	var scenario_service_1 = __webpack_require__(692);
	var user_session_1 = __webpack_require__(699);
	var user_info_service_1 = __webpack_require__(695);
	var primeng_1 = __webpack_require__(708);
	var _ = __webpack_require__(680);
	var OperationsGraphDisplayComponent = (function () {
	    function OperationsGraphDisplayComponent(route, router, _airportService, _scenarioService, User, _userInfoService) {
	        this.route = route;
	        this.router = router;
	        this._airportService = _airportService;
	        this._scenarioService = _scenarioService;
	        this.User = User;
	        this._userInfoService = _userInfoService;
	        this.graphType = "bar";
	    }
	    OperationsGraphDisplayComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.tableName = params['tableName'];
	            _this.displayName = params['displayName'];
	            _this.locId = params['locId'];
	            _this.airportName = params['airportName'];
	            _this.graphType = params['graphType'];
	            _this.startYear = params['startYear'];
	            _this.endYear = params['endYear'];
	            _this.quickGraph = params['quickGraph'];
	            _this.columns = JSON.parse(sessionStorage.getItem('operations-graph-columns'));
	            _this.getGraphData();
	        });
	        this._scenarioService.getScenarios(this.User.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.setScenarioHeader(_this.User.getSession().scenarioId);
	        });
	    };
	    OperationsGraphDisplayComponent.prototype.getGraphData = function () {
	        var _this = this;
	        var params = {
	            tableName: this.tableName,
	            locId: this.locId,
	            scenarioId: this.User.getSession().scenarioId,
	            startYear: this.startYear,
	            endYear: this.endYear,
	            columns: this.columns
	        };
	        this._airportService.getGraphData(params)
	            .subscribe(function (result) {
	            _this.result = result;
	            _this.createGraphDataSet();
	        });
	    };
	    OperationsGraphDisplayComponent.prototype.createGraphDataSet = function () {
	        var labels = _.map(this.result, 'AYEAR');
	        var datasets = [];
	        for (var index in this.columns) {
	            var dataset = {
	                label: this.columns[index].graphName,
	                data: _.map(this.result, this.columns[index].graphName),
	                fill: false,
	                backgroundColor: this.getRandomColor(),
	                borderColor: this.getRandomColor()
	            };
	            datasets[index] = dataset;
	        }
	        this.data = {
	            labels: labels,
	            datasets: datasets
	        };
	        this.graphOptions = {
	            scales: {
	                yAxes: [{
	                        ticks: {
	                            beginAtZero: true
	                        }
	                    }]
	            }
	        };
	    };
	    OperationsGraphDisplayComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    OperationsGraphDisplayComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	    };
	    OperationsGraphDisplayComponent.prototype.backFacilityView = function () {
	        this.router.navigate([("/airports/" + this.locId)]);
	    };
	    OperationsGraphDisplayComponent.prototype.backDataSheet = function () {
	        var params = {
	            locId: this.locId,
	            airportName: this.airportName
	        };
	        this.router.navigate([("/operations-list/" + this.tableName), params]);
	    };
	    OperationsGraphDisplayComponent.prototype.backSelections = function () {
	        var params = {
	            locId: this.locId,
	            airportName: this.airportName
	        };
	        this.router.navigate([("/operations-graph/" + this.tableName), params]);
	    };
	    OperationsGraphDisplayComponent.prototype.getRandomColor = function () {
	        var letters = '0123456789ABCDEF';
	        var color = '#';
	        for (var i = 0; i < 6; i++) {
	            color += letters[Math.floor(Math.random() * 16)];
	        }
	        return color;
	    };
	    OperationsGraphDisplayComponent.prototype.backReforecast = function () {
	        var params = {
	            locId: this.locId,
	            fieldName: this.columns[0].fieldName,
	            airportName: this.airportName
	        };
	        this.router.navigate([("/operations-reforcast/" + this.tableName), params]);
	    };
	    OperationsGraphDisplayComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(787),
	            styles: [__webpack_require__(700)],
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.UIChart]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, airport_service_1.AirportService, scenario_service_1.ScenarioService, user_session_1.UserSession, user_info_service_1.UserInfoService])
	    ], OperationsGraphDisplayComponent);
	    return OperationsGraphDisplayComponent;
	}());
	exports.OperationsGraphDisplayComponent = OperationsGraphDisplayComponent;


/***/ },

/***/ 787:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\"><strong *ngIf=\"currentScenario\">Current Scenario: {{currentScenario.scenarioName}}</strong></div>\r\n<div >\r\n    <div>\r\n        {{'Facility: ' + locId + ' - ' + airportName }}\r\n    </div>\r\n\r\n    <!-- Filter the Products   -->\r\n    <div >\r\n\r\n        <div class='alert alert-danger' *ngIf='errorMessage'>{{errorMessage}}</div>\r\n\r\n <!--       <div class='row'>\r\n            <button *ngIf=\"quickGraph === 'false'\" type=\"text\" (click)=\"backFacilityView()\" pButton icon=\"fa-arrow-circle-left\" label=\"Facility View {{locId}}\"></button>\r\n            <button *ngIf=\"quickGraph === 'false'\" type=\"text\" (click)=\"backDataSheet()\" pButton icon=\"fa-arrow-circle-left\" label=\"Data Sheet\"></button>\r\n            <button *ngIf=\"quickGraph === 'false'\" type=\"text\" (click)=\"backSelections()\" pButton icon=\"fa-arrow-circle-left\" label=\"Graph Selections\"></button>\r\n            <button *ngIf=\"quickGraph === 'true'\" type=\"text\" (click)=\"backReforecast()\" pButton icon=\"fa-arrow-circle-left\" label=\"Reforecast Tools\"></button>\r\n        </div>\r\n-->\r\n        <div style=\"font-family:Arial; font-size:25px;text-align:center;\">\r\n            {{displayName}}\r\n        </div>\r\n\r\n        <div class='row'>\r\n            <p-chart *ngIf=\"data && graphType === 'line'\" type=\"line\" [data]=\"data\" [options]=\"graphOptions\"  width=\"700\" height=\"400\"></p-chart>\r\n            <p-chart *ngIf=\"data && graphType === 'bar'\" type=\"bar\" [data]=\"data\" [options]=\"graphOptions\" width=\"700\" height=\"400\"></p-chart>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ },

/***/ 788:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var airport_interfaces_1 = __webpack_require__(697);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var airport_service_1 = __webpack_require__(677);
	var scenario_service_1 = __webpack_require__(692);
	var user_session_1 = __webpack_require__(699);
	var user_info_service_1 = __webpack_require__(695);
	var primeng_3 = __webpack_require__(708);
	var operations_reforecast_component_1 = __webpack_require__(789);
	var OperationsReforecastContainerComponent = (function () {
	    function OperationsReforecastContainerComponent(route, router, _airportService, _scenarioService, User, _userInfoService) {
	        this.route = route;
	        this.router = router;
	        this._airportService = _airportService;
	        this._scenarioService = _scenarioService;
	        this.User = User;
	        this._userInfoService = _userInfoService;
	        this.isScenarioOwner = false;
	    }
	    OperationsReforecastContainerComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.tableName = params['tableName'];
	            _this.locId = params['locId'];
	            _this.airportName = params['airportName'];
	            _this.fieldName = params['fieldName'];
	            _this._airportService.getOperations()
	                .subscribe(function (operations) { return _this.allOperations = operations; }, function (error) { return _this.errorMessage = error; });
	        });
	        this._scenarioService.getScenarios(this.User.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.setScenarioHeader(_this.User.getSession().scenarioId);
	        });
	        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(function (success) { return _this.isScenarioOwner = success.isOwner; }, function (error) { return _this.errorMessage = error; });
	    };
	    OperationsReforecastContainerComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    OperationsReforecastContainerComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	    };
	    OperationsReforecastContainerComponent.prototype.onTabChange = function (event) {
	        var _this = this;
	        var request = new airport_interfaces_1.OperationsListRequest();
	        request.tableName = this.allOperations[event.index].tableName;
	        request.scenarioId = this.User.getSession().scenarioId;
	        request.locId = this.locId;
	        request.isAdmin = this.User.getSession().isAdmin ? 1 : 0;
	        this._airportService.getOperationsColumns(request)
	            .subscribe(function (columns) {
	            var column = columns.filter(function (column) { return column.calculated == 0; })[0];
	            var params = {
	                locId: _this.locId,
	                airportName: _this.airportName,
	                fieldName: column.fieldName
	            };
	            _this.router.navigate([("/operations-reforcast/" + _this.allOperations[event.index].tableName), params]);
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    OperationsReforecastContainerComponent.prototype.backFacilityView = function () {
	        this.router.navigate([("/airports/" + this.locId)]);
	    };
	    OperationsReforecastContainerComponent.prototype.backDataSheet = function () {
	        var params = {
	            locId: this.locId,
	            airportName: this.airportName
	        };
	        this.router.navigate([("/operations-list/" + this.tableName), params]);
	    };
	    OperationsReforecastContainerComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(791),
	            styles: [__webpack_require__(700)],
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_3.Button, primeng_1.TabView, primeng_2.TabPanel, operations_reforecast_component_1.OperationsReforecastComponent]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, airport_service_1.AirportService, scenario_service_1.ScenarioService, user_session_1.UserSession, user_info_service_1.UserInfoService])
	    ], OperationsReforecastContainerComponent);
	    return OperationsReforecastContainerComponent;
	}());
	exports.OperationsReforecastContainerComponent = OperationsReforecastContainerComponent;


/***/ },

/***/ 789:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var airport_interfaces_1 = __webpack_require__(697);
	var airport_service_1 = __webpack_require__(677);
	var scenario_service_1 = __webpack_require__(692);
	var user_info_service_1 = __webpack_require__(695);
	var user_session_1 = __webpack_require__(699);
	var primeng_1 = __webpack_require__(708);
	var _ = __webpack_require__(680);
	var system_control_service_1 = __webpack_require__(694);
	var common_1 = __webpack_require__(205);
	var OperationsReforecastComponent = (function () {
	    function OperationsReforecastComponent(route, router, _airportService, _scenarioService, _userInfoService, User, request, _systemControlService) {
	        this.route = route;
	        this.router = router;
	        this._airportService = _airportService;
	        this._scenarioService = _scenarioService;
	        this._userInfoService = _userInfoService;
	        this.User = User;
	        this.request = request;
	        this._systemControlService = _systemControlService;
	        this.startYears = [];
	        this.endYears = [];
	        //not sure if this will be needed
	        this.yearsToPreview = 4;
	        this.isScenarioOwner = false;
	        this.dataDisabled = true;
	        this.growthDisabled = true;
	        this.highlightYears = false;
	        this.displaySpinner = false;
	        this.msgs = [];
	        this.ownScenarios = "true";
	    }
	    OperationsReforecastComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.fieldName = params['fieldName'];
	        });
	        if (this.selected) {
	            //will need to get columns in here for dropdown, only non calculated
	            this.getColumns();
	            this.getSystemControlValues();
	        }
	        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(function (success) {
	            _this.isScenarioOwner = success.isOwner;
	            if (_this.isScenarioOwner == false && _this.User.isAdmin == false) {
	                _this.ownScenarios = "false";
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'warn', summary: 'Warn Message', detail: 'We\'re sorry,  your access level does not permit you to view this page. Contact the TAF administrator to change your access privileges.' });
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    OperationsReforecastComponent.prototype.getYears = function () {
	        var _this = this;
	        this.displaySpinner = true;
	        var fieldNameSelected = event.target.value;
	        var params = new airport_interfaces_1.ReforecastRequest;
	        if (this.fieldName != fieldNameSelected && fieldNameSelected != undefined) {
	            this.fieldName = fieldNameSelected;
	        }
	        params.fieldName = this.fieldName;
	        params.locId = this.locId;
	        params.tableName = this.operation.tableName;
	        params.scenarioId = this.User.getSession().scenarioId;
	        params.minYear = this.systemControlElem.ffcYear - this.yearsToPreview;
	        this._airportService.getReforcastData(params)
	            .subscribe(function (success) {
	            if (success.length > 0) {
	                _this.reforecastData = success;
	                _this.setLastYearsValues(_this.reforecastData);
	                _this.reforecastData.map(function (data) {
	                    data.originalValue = data.value;
	                });
	                _this.reforecastData.map(function (data) {
	                    data.growth = _this.calcGrowthRate(data.value, data.lastYearsValue, 1);
	                });
	                _this.reforecastData.map(function (data) {
	                    data.originalGrowth = data.growth;
	                });
	                _this.averageRate = _this.calcGrowthRate(
	                //this.reforecastData[this.reforecastData.length-1].lastYearsValue,
	                _this.reforecastData.find(function (data) { return data.aYear === _this.systemControlElem.lfcYear; }).value, _this.reforecastData.find(function (data) { return data.aYear === _this.systemControlElem.fyYear; }).value, _this.systemControlElem.lfcYear - _this.systemControlElem.fyYear);
	            }
	            _this.displaySpinner = false;
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    OperationsReforecastComponent.prototype.setLastYearsValues = function (dataIn) {
	        for (var index in dataIn) {
	            if (+index === 0) {
	                dataIn[index].lastYearsValue = dataIn[index].value;
	            }
	            else {
	                dataIn[index].lastYearsValue = dataIn[+index - 1].value;
	            }
	        }
	    };
	    OperationsReforecastComponent.prototype.calcGrowthRate = function (last_value, first_value, num_years) {
	        var ret_val = 0;
	        if (last_value > 0 && first_value > 0 && num_years > 0) {
	            ret_val = (Math.exp((Math.log(last_value) - Math.log(first_value)) / num_years) - 1) * 100;
	        }
	        if (first_value == 0 && last_value > 0) {
	            ret_val = 999.99;
	        }
	        if (first_value > 0 && last_value == 0) {
	            ret_val = -999.99;
	        }
	        if (ret_val > 999.99) {
	            ret_val = 999.99;
	        }
	        if (ret_val < -999.99) {
	            ret_val = -999.99;
	        }
	        return (ret_val);
	    };
	    OperationsReforecastComponent.prototype.resetDataValues = function () {
	        this.reforecastData.map(function (data) {
	            data.value = data.originalValue;
	        });
	    };
	    OperationsReforecastComponent.prototype.resetGrowthValues = function () {
	        this.reforecastData.map(function (data) {
	            data.growth = data.originalGrowth;
	        });
	    };
	    OperationsReforecastComponent.prototype.getColumns = function () {
	        var _this = this;
	        this.request.tableName = this.operation.tableName;
	        this.request.scenarioId = this.User.getSession().scenarioId;
	        this.request.locId = this.locId;
	        this.request.isAdmin = this.User.getSession().isAdmin ? 1 : 0;
	        this._airportService.getOperationsColumns(this.request)
	            .subscribe(function (columns) {
	            _this.columns = columns.filter(function (column) { return column.calculated == 0; });
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    OperationsReforecastComponent.prototype.getSystemControlValues = function () {
	        var _this = this;
	        this._systemControlService.getSystemControl()
	            .subscribe(function (systemControlElem) {
	            _this.systemControlElem = systemControlElem;
	            _this.populateYears();
	            _this.getYears();
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    OperationsReforecastComponent.prototype.populateYears = function () {
	        this.populateStartYears();
	        this.populateEndYears();
	    };
	    OperationsReforecastComponent.prototype.populateStartYears = function () {
	        var index = 0;
	        for (var year = this.systemControlElem.ffcYear; year <= this.systemControlElem.lfcYear; year++) {
	            this.startYears[index] = year;
	            index++;
	        }
	        this.selectedStartYear = this.systemControlElem.ffcYear;
	    };
	    OperationsReforecastComponent.prototype.populateEndYears = function () {
	        var index = 0;
	        for (var year = this.systemControlElem.ffcYear - this.yearsToPreview; year <= this.systemControlElem.lfcYear; year++) {
	            this.endYears[index] = year;
	            index++;
	        }
	        this.selectedEndYear = this.systemControlElem.lfcYear;
	    };
	    OperationsReforecastComponent.prototype.ngOnDestroy = function () { };
	    OperationsReforecastComponent.prototype.radioSelected = function (event) {
	        if (!this.growthDisabled) {
	            this.resetGrowthValues();
	            this.growthDisabled = true;
	        }
	        if (!this.dataDisabled) {
	            this.resetDataValues();
	            this.dataDisabled = true;
	        }
	        this.dataDisabled = !(event.target.value === 'supplydata');
	        this.growthDisabled = !(event.target.value === 'supplygrowth');
	        this.highlightYears = !(event.target.value === 'supplygrowth' || event.target.value === 'supplydata');
	    };
	    OperationsReforecastComponent.prototype.formatGrowth = function (event, dataRow, format) {
	        if (event.target.value === "") {
	            event.target.value = 0;
	        }
	        dataRow.growth = +(new common_1.DecimalPipe().transform(event.target.value, format));
	    };
	    OperationsReforecastComponent.prototype.formatData = function (event, dataRow, format) {
	        if (event.target.value === "") {
	            event.target.value = 0;
	        }
	        dataRow.value = +(new common_1.DecimalPipe().transform(event.target.value, format));
	    };
	    OperationsReforecastComponent.prototype.calcDatasheet = function (dataRow, type) {
	        var lastYr = this.systemControlElem.lfcYear;
	        if (dataRow.value === dataRow.originalValue && dataRow.growth === dataRow.originalGrowth) {
	            return;
	        }
	        if (type === "data") {
	            //drop the decimal part here
	            dataRow.value = Math.floor(dataRow.value);
	            var previousRow = _.find(this.reforecastData, function (row) {
	                if (row.aYear == dataRow.aYear - 1) {
	                    return row;
	                }
	            });
	            dataRow.growth = this.calcGrowthRate(dataRow.value, previousRow.value, 1);
	            if (dataRow.aYear < lastYr) {
	                var nextRow = _.find(this.reforecastData, function (row) {
	                    if (row.aYear == dataRow.aYear + 1) {
	                        return row;
	                    }
	                });
	                nextRow.growth = this.calcGrowthRate(nextRow.value, dataRow.value, 1);
	            }
	        }
	        else if (type === "growth") {
	            var filteredRows_1 = _.filter(this.reforecastData, function (data) { return data.aYear >= dataRow.aYear; });
	            var first = true;
	            var _loop_1 = function(index) {
	                if (first) {
	                    var predRow = _.find(this_1.reforecastData, function (data) { return data.aYear == filteredRows_1[index].aYear - 1; });
	                    filteredRows_1[index].value = Math.floor(predRow.value +
	                        (predRow.value * filteredRows_1[index].growth) / 100);
	                    first = false;
	                }
	                else {
	                    filteredRows_1[index].value = Math.floor(filteredRows_1[+index - 1].value +
	                        (filteredRows_1[+index - 1].value * filteredRows_1[index].growth) / 100);
	                }
	                if (filteredRows_1[index].value < 0) {
	                    filteredRows_1[index].value = 0;
	                }
	            };
	            var this_1 = this;
	            for (var index in filteredRows_1) {
	                _loop_1(index);
	            }
	        }
	    };
	    OperationsReforecastComponent.prototype.reset = function () {
	        this.forecastOperation = null;
	        this.resetDataValues();
	        this.resetGrowthValues();
	        this.dataDisabled = true;
	        this.growthDisabled = true;
	        this.highlightYears = false;
	    };
	    OperationsReforecastComponent.prototype.cancel = function () {
	        var params = {
	            locId: this.locId,
	            airportName: this.airportName
	        };
	        this.router.navigate([("/operations-list/" + this.operation.tableName), params]);
	    };
	    OperationsReforecastComponent.prototype.isValid = function () {
	        if (!this.forecastOperation) {
	            this.errorMessage = "Please choose an operation to perform!";
	            return false;
	        }
	        if (!(this.forecastOperation.substr(0, 6) == "supply")) {
	            switch (this.forecastOperation) {
	                case "interpolate":
	                    {
	                        if (this.interpolationValue == null) {
	                            this.errorMessage = "No value set for INTERPOLATE.\nPlease set a value for the selected method!";
	                            return false;
	                        }
	                        Math.floor(this.interpolationValue);
	                        break;
	                    }
	                case "fillinyears":
	                    {
	                        if (this.fillInValue == null) {
	                            this.errorMessage = "No value set for FILLINYEARS.\nPlease set a value for the selected method!";
	                            return false;
	                        }
	                        Math.floor(this.fillInValue);
	                        break;
	                    }
	                case "growthrate": {
	                    if (this.growthRateValue == null) {
	                        this.errorMessage = "No value set for GROWTH RATE.\nPlease set a value for the selected method!";
	                        return false;
	                    }
	                    break;
	                }
	                case "growandsmooth":
	                    if (this.growAndSmoothValue == null) {
	                        this.errorMessage = "No value set for GROW AND SMOOTH.\nPlease set a value for the selected method!";
	                        return false;
	                    }
	                    break;
	                default:
	                    break;
	            }
	            if (this.selectedStartYear > this.selectedEndYear) {
	                this.errorMessage = "Start Year cannot be greater than End Year!";
	                return false;
	            }
	        }
	        return true;
	    };
	    OperationsReforecastComponent.prototype.save = function () {
	        var _this = this;
	        //console.log("save this.isValid()" + this.isValid());
	        this.errorMessage = null;
	        this.successMessage = null;
	        if (this.isValid()) {
	            this.displaySpinner = true;
	            if (this.forecastOperation === "supplydata" || this.forecastOperation === "supplygrowth") {
	                //so need to send the years and the data list
	                var params = {
	                    tableName: this.operation.tableName,
	                    locId: this.locId,
	                    fieldName: this.fieldName,
	                    ffcYear: this.selectedStartYear,
	                    lfcYear: this.selectedEndYear,
	                    values: this.reforecastData
	                };
	                this._airportService.reforecastSupplyData(params)
	                    .subscribe(function (response) {
	                    if (response.responseStatus == "success") {
	                        _this.msgs = [];
	                        _this.msgs.push({ severity: 'info', summary: 'Info Message', detail: 'Changes applied.' });
	                        _this.displaySpinner = false;
	                        _this.getYears();
	                    }
	                    else if (response.responseStatus == "error") {
	                        _this.msgs = [];
	                        _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'An error occured while trying to save changes.' });
	                        //this.errorMessage = "An error occured while trying to save changes.";
	                        console.error(response.responseMessage);
	                        _this.displaySpinner = false;
	                    }
	                }, function (error) {
	                    _this.msgs = [];
	                    _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'An error occured while trying to save changes.' });
	                    //this.errorMessage = "An error occured while trying to save changes.";
	                    console.error(error);
	                    _this.displaySpinner = false;
	                });
	            }
	            else if (this.forecastOperation === "interpolate") {
	                this.callOperationService(this.interpolationValue);
	            }
	            else if (this.forecastOperation === "fillinyears") {
	                this.callOperationService(this.fillInValue);
	            }
	            else if (this.forecastOperation === "growthrate") {
	                this.callOperationService(this.growthRateValue / 100);
	            }
	            else if (this.forecastOperation === "growandsmooth") {
	                this.callOperationService(this.growAndSmoothValue / 100);
	            }
	            else {
	                this.callOperationService();
	            }
	        }
	    };
	    OperationsReforecastComponent.prototype.callOperationService = function (value) {
	        var _this = this;
	        this.displaySpinner = true;
	        var params = {
	            type: this.forecastOperation,
	            startYear: this.selectedStartYear,
	            endYear: this.selectedEndYear,
	            value: value,
	            locId: this.locId,
	            fieldName: this.fieldName,
	            tableName: this.operation.tableName,
	            scenario: this.User.getSession().scenarioId
	        };
	        this._airportService.reforecastOperation(params)
	            .subscribe(function (response) {
	            if (response.responseStatus == "success") {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'info', summary: 'Info Message', detail: 'Changes applied.' });
	                _this.displaySpinner = false;
	                _this.getYears();
	            }
	            else if (response.responseStatus == "error") {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'An error occured while trying to save changes.' });
	                //this.errorMessage = "";
	                _this.displaySpinner = false;
	                console.error(response.responseMessage);
	            }
	        }, function (error) {
	            _this.errorMessage = "An error occured while trying to save changes.";
	            _this.msgs = [];
	            _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'An error occured while trying to save changes.' });
	            console.error(error);
	            _this.displaySpinner = false;
	        });
	    };
	    OperationsReforecastComponent.prototype.quickGraph = function () {
	        var confirmAnswer = confirm("Warning:\n Please save your changes by clicking Apply Options before viewing the graph, or all changes will be lost and previous values will be graphed. ");
	        if (confirmAnswer == true) {
	            //for some reason have to mask this
	            var field_1 = this.fieldName;
	            var selectedColumns = _.filter(this.columns, function (column) { return column.fieldName === field_1; });
	            sessionStorage.setItem('operations-graph-columns', JSON.stringify(selectedColumns));
	            var params = {
	                displayName: this.operation.displayName,
	                locId: this.locId,
	                airportName: this.airportName,
	                graphType: 'line',
	                startYear: this.selectedStartYear,
	                endYear: this.selectedEndYear,
	                quickGraph: "true"
	            };
	            this.router.navigate([("/operations-graph-display/" + this.operation.tableName), params]);
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object)
	    ], OperationsReforecastComponent.prototype, "operation", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], OperationsReforecastComponent.prototype, "selected", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], OperationsReforecastComponent.prototype, "locId", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], OperationsReforecastComponent.prototype, "airportName", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], OperationsReforecastComponent.prototype, "fieldName", void 0);
	    OperationsReforecastComponent = __decorate([
	        core_1.Component({
	            selector: 'operations-reforecast',
	            template: __webpack_require__(790),
	            styles: [__webpack_require__(700)],
	            directives: [primeng_1.Button]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, airport_service_1.AirportService, scenario_service_1.ScenarioService, user_info_service_1.UserInfoService, user_session_1.UserSession, airport_interfaces_1.OperationsListRequest, system_control_service_1.SystemControlService])
	    ], OperationsReforecastComponent);
	    return OperationsReforecastComponent;
	}());
	exports.OperationsReforecastComponent = OperationsReforecastComponent;


/***/ },

/***/ 790:
/***/ function(module, exports) {

	module.exports = "<div *ngIf=\"!isScenarioOwner\">\r\n    <p-messages [value]=\"msgs\" [closable]=\"false\"></p-messages>\r\n</div>\r\n<div *ngIf=\"ownScenarios ==='true'\">\r\n    <div class='panel-body' >\r\n        <p-messages [value]=\"msgs\" [closable]=\"false\"></p-messages>\r\n        <div class='alert alert-danger' *ngIf='errorMessage'>{{errorMessage}}</div>\r\n        <p-dialog  [(visible)]=\"displaySpinner\" [modal]=true   [closable]=false showEffect=\"fade\">\r\n            <div align=\"center\">\r\n                <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n                <div>Loading please wait ....</div>\r\n                <div>Do Not click back or Refresh the page</div>\r\n            </div>\r\n        </p-dialog>\r\n    </div>\r\n    <div><p>&nbsp;</p></div>\r\n    \r\n    <div class=\"container\">\r\n        <div class=\"row\">\r\n            <div class=\"col-sm-8\" >\r\n                <label>Locid: {{locId}} - {{airportName}} </label>\r\n                <label>Data:</label>\r\n                <select id=\"column\" name=\"column\"  (change)=\"getYears()\">\r\n                    <option *ngFor=\"let column of columns\" [value]=\"column.fieldName\" [selected]=\"column.fieldName === fieldName\">\r\n                        {{column.displayName}}\r\n                    </option>\r\n                </select>\r\n                 <button type=\"button\" class=\"btn btn-link\"  (click)=\"quickGraph()\" icon=\"fa-bar-chart\">Quick Graph</button>\r\n            </div>    \r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"divider\"></div>\r\n    <p></p>\r\n    <div class=\"containe-fluid\">\r\n        <div class=\"row\">\r\n            <div class=\"col-md-5\" style=\"margin:0px;width:auto;\">\r\n                <div style=\"margin-left:0px\"><b>TAF Forecast Tools:</b></div>\r\n                <div class=\"btn-group\" style=\"margin-left:20px;\">\r\n                    <div class=\"radio\" [style.backgroundColor]=\"forecastOperation == 'interpolate' ? '#c0e4fe':'#fff'\">\r\n                        <div class=\"customtd\">\r\n                            <input type=\"radio\" [(ngModel)]=\"forecastOperation\"  name=\"Operation\" value=\"interpolate\" (change)=\"radioSelected($event)\" >\r\n                            Interpolate from prior year to value of\r\n                            <!-- may just want to make this text ignoring maxlength 9, size 10-->\r\n                            <input type=\"number\" name=\"interpolateOperation\" [(ngModel)]=\"interpolationValue\"/>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"radio\" [style.backgroundColor]=\"forecastOperation == 'carryforward' ? '#c0e4fe':'#fff'\">\r\n                        <div class=\"customtd\">\r\n                            <input type=\"radio\" [(ngModel)]=\"forecastOperation\"  name=\"Operation\" value=\"carryforward\" (change)=\"radioSelected($event)\" >\r\n                            Carry forward prior year's value (based on starting year)\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"radio\" [style.backgroundColor]=\"forecastOperation == 'fillinyears' ? '#c0e4fe':'#fff'\">\r\n                        <div class=\"customtd\">\r\n                            <input type=\"radio\" [(ngModel)]=\"forecastOperation\"  name=\"Operation\" value=\"fillinyears\" (change)=\"radioSelected($event)\" >\r\n                            Fill in years with a value of\r\n                            <!-- may just want to make this text ignoring maxlength 9, size 10-->\r\n                            <input type=\"number\" name=\"fillinyearsOperation\" [(ngModel)]=\"fillInValue\"/>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"radio\" [style.backgroundColor]=\"forecastOperation == 'nationalrate' ? '#c0e4fe':'#fff'\">\r\n                       <div class=\"customtd\">\r\n                            <input type=\"radio\" [(ngModel)]=\"forecastOperation\"  name=\"Operation\" value=\"nationalrate\" (change)=\"radioSelected($event)\" >\r\n                            Use national annual growth rates\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"radio\" [style.backgroundColor]=\"forecastOperation == 'copynational' ? '#c0e4fe':'#fff'\">\r\n                        <div class=\"customtd\">\r\n                            <input type=\"radio\" [(ngModel)]=\"forecastOperation\"  name=\"Operation\" value=\"copynational\" (change)=\"radioSelected($event)\" >\r\n                            Copy from National Scenario\r\n                        </div>\r\n                    </div>\r\n                    <div *ngIf=\"operation.tableName === 'AirportOperations'\" class=\"radio\" [style.backgroundColor]=\"forecastOperation == 'forecastIFRBasedOnAOPS' ? '#c0e4fe':'#fff'\">\r\n                        <div class=\"customtd\">\r\n                            <input type=\"radio\" [(ngModel)]=\"forecastOperation\"  name=\"Operation\" value=\"forecastIFRBasedOnAOPS\" (change)=\"radioSelected($event)\" >\r\n                            Forecast IFR based on AOPS\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"radio\" [style.backgroundColor]=\"forecastOperation == 'growthrate' ? '#c0e4fe':'#fff'\">\r\n                        <div class=\"customtd\">\r\n                            <input type=\"radio\" [(ngModel)]=\"forecastOperation\"  name=\"Operation\" value=\"growthrate\" (change)=\"radioSelected($event)\" >\r\n                            Use growth rate of \r\n                            <!-- may just want to make this text ignoring maxlength 6, size 10-->\r\n                            <input type=\"number\" name=\"growthrateOperation\" [(ngModel)]=\"growthRateValue\"/>%\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"radio\" [style.backgroundColor]=\"forecastOperation == 'growandsmooth' ? '#c0e4fe':'#fff'\">\r\n                        <div class=\"customtd\">\r\n                            <input type=\"radio\" [(ngModel)]=\"forecastOperation\"  name=\"Operation\" value=\"growandsmooth\" (change)=\"radioSelected($event)\" >\r\n                            Grow and smooth using rate of \r\n                            <!-- may just want to make this text ignoring maxlength 6, size 10-->\r\n                            <input type=\"number\" name=\"growandsmoothOperation\" [(ngModel)]=\"growAndSmoothValue\"/>%\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"radio\" [style.backgroundColor]=\"forecastOperation == 'growexistingrate' ? '#c0e4fe':'#fff'\">\r\n                        <div class=\"customtd\">\r\n                            <input type=\"radio\" [(ngModel)]=\"forecastOperation\"  name=\"Operation\" value=\"growexistingrate\" (change)=\"radioSelected($event)\" >\r\n                            Grow and smooth using existing rate\r\n                        </div>\r\n                    </div>\r\n                    <!--<div class=\"radio\" [style.backgroundColor]=\"forecastOperation == 'yearregress' ? '#c0e4fe':'#fff'\">\r\n                        <div class=\"customtd\">\r\n                            <input type=\"radio\" [(ngModel)]=\"forecastOperation\"  name=\"Operation\" value=\"yearregress\" (change)=\"radioSelected($event)\" >\r\n                            Regression over time\r\n                        </div>\r\n                    </div>-->\r\n                    <div class=\"radio\" [style.backgroundColor]=\"forecastOperation == 'growstoredrates' ? '#c0e4fe':'#fff'\">\r\n                        <div class=\"customtd\">\r\n                            <input type=\"radio\" [(ngModel)]=\"forecastOperation\"  name=\"Operation\" value=\"growstoredrates\" (change)=\"radioSelected($event)\" >\r\n                            Grow using stored rates\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"col-md-7\"  >\r\n                <div *ngIf=\"!reforecastData\">\r\n                    <h1>No data available to display</h1>\r\n                </div>\r\n\r\n                <div *ngIf=\"reforecastData\" >\r\n                    <div class=\"row\" style=\"width:auto;\">\r\n                        <div class=\"col-sm-4\" style=\"width:auto;\">\r\n                            <table class=\"table table-bordered\" style=\"margin-left:10px!important;white-space:nowrap;width:100%;\">\r\n                                <tr class=\"customth-reforecast\">\r\n                                    <th >Year</th>\r\n                                    <th >Data</th>\r\n                                    <th >Growth Rate</th>\r\n                                </tr>\r\n                                <tr *ngFor=\"let data of reforecastData\">\r\n                                    <td align=\"center\" height=\"20\" *ngIf=\"data.aYear<2025\" style=\"padding=0px;\" class=\"customtd-reforecast-year\">\r\n                                        {{data.aYear}}\r\n                                    </td>\r\n                                    <td align=\"right\" [style.backgroundColor]=\"dataDisabled ? '#fff':'#c0e4fe'\" *ngIf=\"data.aYear<2025\"  style=\"padding=0px;\" >\r\n                                        <div *ngIf=\"data.scenario == 0\"  class=\" customtd-reforecast-numeric\">\r\n                                            {{data.value }}\r\n                                        </div>\r\n                                        <div *ngIf=\"data.scenario != 0\" >\r\n                                                <input \r\n                                                class=\"customtd-reforecast-numeric\"\r\n                                                placeholder=\".col-sm-6\"\r\n                                                type=\"number\"     \r\n                                                name=\"data + {{data.aYear}}\" \r\n                                                size=\"8\" \r\n                                                [(ngModel)]=\"data.value \"\r\n                                                maxlength=\"9\" \r\n                                                [disabled]=\"dataDisabled\"\r\n                                                (blur)=\"calcDatasheet(data, 'data')\"/>\r\n                                        </div>\r\n                                    </td>\r\n                                    <td align=\"right\" [style.backgroundColor]=\"growthDisabled ? '#fff':'#c0e4fe'\" *ngIf=\"data.aYear<2025\" >\r\n                                        <div *ngIf=\"data.scenario == 0\"  >\r\n                                            <div class=\"customtd-reforecast-numeric\">{{data.growth | number: '1.2-2'}}%</div>\r\n                                        </div>\r\n                                        <div *ngIf=\"data.scenario != 0\" class=\"customtd-reforecast-numeric\">\r\n                                                <input \r\n                                                type=\"number\"     \r\n                                                name=\"growth + {{data.aYear}}\" \r\n                                                size=\"8\"\r\n                                                class=\"customtd-reforecast-numeric\"\r\n                                                placeholder=\".col-sm-6\"\r\n                                                (change)=\"formatGrowth($event, data,'1.2-2')\" \r\n                                                [ngModel]=\"data.growth | number: '1.2-2'\"\r\n                                                maxlength=\"9\" \r\n                                                [disabled]=\"growthDisabled\"\r\n                                                (blur)=\"calcDatasheet(data, 'growth')\"\r\n                                                />%\r\n                                        </div>\r\n                                    </td>\r\n                                </tr>\r\n                            </table>\r\n                        </div>\r\n                        <div class=\"col-sm-6\" style=\"width:auto;\">\r\n                            <table class=\"table table-bordered\" style=\"margin-right:35px!important;white-space:nowrap;width:100%;\">\r\n                                <tr class=\"customth-reforecast\">\r\n                                    <th style=\"padding-left: 15px!important;\">Year</th>\r\n                                    <th style=\"padding-left: 15px!important;\">Data</th>\r\n                                    <th style=\"padding-left: 15px!important;\">Growth Rate</th>\r\n                                </tr>\r\n                                <tr *ngFor=\"let data of reforecastData\">\r\n                                    <td align=\"center\" height=\"20\" *ngIf=\"data.aYear>=2025\" style=\"padding-left:15px!important;\" \r\n                                        class=\"customtd-reforecast-year\">\r\n                                        {{data.aYear}}\r\n                                    </td>\r\n                                    <td align=\"right\" [style.backgroundColor]=\"dataDisabled ? '#fff':'#c0e4fe'\" *ngIf=\"data.aYear>=2025\">\r\n                                        <div *ngIf=\"data.scenario == 0\"  class=\" customtd-reforecast-numeric\">\r\n                                            {{data.value }}\r\n                                        </div>\r\n                                        <div *ngIf=\"data.scenario != 0\" >\r\n                                                <input \r\n                                                class=\"customtd-reforecast-numeric\"\r\n                                                style=\"padding:0px!important;\"\r\n                                                placeholder=\".col-sm-6\"\r\n                                                type=\"number\"     \r\n                                                name=\"data + {{data.aYear}}\" \r\n                                                size=\"8\" \r\n                                                [(ngModel)]=\"data.value\"\r\n                                                maxlength=\"9\" \r\n                                                [disabled]=\"dataDisabled\"\r\n                                                (blur)=\"calcDatasheet(data, 'data')\"/>\r\n                                        </div>\r\n                                    </td>\r\n                                    <td align=\"right\" [style.backgroundColor]=\"growthDisabled ? '#fff':'#c0e4fe'\" *ngIf=\"data.aYear>=2025\" >\r\n                                        <div *ngIf=\"data.scenario == 0\" >\r\n                                            <div class=\"customtd-reforecast-numeric\">{{data.growth | number: '1.2-2'}}%</div>\r\n                                        </div>\r\n                                        <div *ngIf=\"data.scenario != 0\" >\r\n                                            <div class=\"customtd-reforecast-numeric\">\r\n                                                <input \r\n                                                type=\"number\"     \r\n                                                name=\"growth + {{data.aYear}}\" \r\n                                                size=\"8\"\r\n                                                class=\"customtd-reforecast-numeric\"\r\n                                                placeholder=\".col-sm-6\"\r\n                                                (change)=\"formatGrowth($event, data,'1.2-2')\" \r\n                                                [ngModel]=\"data.growth | number: '1.2-2'\"\r\n                                                maxlength=\"9\" \r\n                                                [disabled]=\"growthDisabled\"\r\n                                                (blur)=\"calcDatasheet(data, 'growth')\"\r\n                                                />%\r\n                                            </div>\r\n                                        </div>\r\n                                    </td>\r\n                                </tr>\r\n                                <tr>\r\n                                    <td>\r\n                                        <div style=\"font-size:75%\">\r\n                                            Avg. rate of\r\n                                        </div>\r\n                                    </td>\r\n                                    <td align=\"right\">\r\n                                        <div class=\"customtd-reforecast-numeric\">\r\n                                           <input  type=\"number\" \r\n                                                   style=\"font-size:90%; width:75px;text-align: right; padding:0px;\"\r\n                                                   [ngModel]=\"averageRate| number: '1.2-2'\"\r\n                                                   [readonly]=\"true\"\r\n                                                   size=\"6\"\r\n                                                   maxlength=\"9\" \r\n                                                   placeholder=\".col-sm-2\"/>\r\n                                        </div>\r\n                                    </td>\r\n                                    <td>\r\n                                        <div style=\"font-size:75%;\">\r\n                                             from {{systemControlElem.fyYear}} to {{systemControlElem.lfcYear}}\r\n                                        </div>\r\n                                    </td>\r\n                                </tr>\r\n                            </table>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div><p></p></div>\r\n    <div class=\"container\">\r\n        <div class=\"row\" style=\"padding: 0px;\" >\r\n            <div class=\"col-sm-4 customtd\" [style.backgroundColor]=\"highlightYears ? '#c0e4fe':'#fff'\" style=\"width:auto;\"> \r\n                 Please enter the years to apply these changes:\r\n            </div>\r\n            <div class=\"col-sm-8\" [style.backgroundColor]=\"highlightYears ? '#c0e4fe':'#fff'\" >\r\n                <div class=\"row\" style=\"padding:0px;\" > \r\n                    <div class=\" col-sm-6 customtd\" style=\"align:center;margin-right:5px;padding:0px;width:auto!important\">Starting Year:\r\n                        <select id=\"startYear\" name=\"startYear\"  [(ngModel)]=\"selectedStartYear\">\r\n                            <option *ngFor=\"let year of startYears\" [ngValue]=\"year\">{{year}}</option>\r\n                        </select>\r\n                    </div>\r\n                    <div class=\" col-sm-6 customtd\" style=\"align:center;margin-left:10px;padding:0px;width:auto!important\"> to Ending Year:\r\n                        <select id=\"endYear\" name=\"endYear\"  [(ngModel)]=\"selectedEndYear\">\r\n                            <option *ngFor=\"let year of endYears\" [ngValue]=\"year\">{{year}}</option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"row\" style=\"padding:0px;margin-left:20px\" >\r\n            <div class=\"col-sm-4\">\r\n                <div class=\"btn-group\">\r\n                    <div class=\"radio\" [style.backgroundColor]=\"forecastOperation == 'supplygrowth' ? '#c0e4fe':'#fff'\">\r\n                        <div class=\"customtd\" style=\"width:auto; align:center;\">\r\n                            <input type=\"radio\" [(ngModel)]=\"forecastOperation\"  name=\"Operation\" value=\"supplygrowth\" (change)=\"radioSelected($event)\" >\r\n                            Supply individual growth rates for each year\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"radio\" [style.backgroundColor]=\"forecastOperation == 'supplydata' ? '#c0e4fe':'#fff'\">\r\n                        <div class=\"customtd\" style=\"width:auto; align:center;\">\r\n                            <input type=\"radio\" [(ngModel)]=\"forecastOperation\"  name=\"Operation\" value=\"supplydata\" (change)=\"radioSelected($event)\" >\r\n                            Supply individual data points for each year\r\n                        </div>\r\n                    </div>\r\n                </div>           \r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\" row\">        \r\n        <div class=\"col-md-offset-3 col-md-10\">\r\n            <button type=\"text\" pButton  class=\"btn btn-danger btn-md active \"  (click)=\"save()\" label=\"Apply Options\"></button>\r\n            <button type=\"text\"  pButton class=\"btn btn-danger btn-md active \" (click)=\"reset()\" label=\"Reset\"></button>\r\n            <button type=\"text\" pButton  class=\"btn btn-danger btn-md active \" (click)=\"cancel()\" label=\"Cancel\"></button>\r\n        </div>\r\n    </div>\r\n</div>\r\n    \r\n    "

/***/ },

/***/ 791:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\"><strong *ngIf=\"currentScenario\">Current Scenario: {{currentScenario.scenarioName}}</strong></div>\r\n<div class='panel panel-primary'>\r\n    <div class='panel-heading'>\r\n        {{'Facility: ' + locId + ' - ' + airportName }}\r\n    </div>\r\n\r\n    <!-- Filter the Products   -->\r\n    <div class='panel-body'>\r\n\r\n        <div class='alert alert-danger' *ngIf='errorMessage'>{{errorMessage}}</div>\r\n\r\n        <div class='row'>\r\n            <button type=\"text\" (click)=\"backFacilityView()\" pButton icon=\"fa-arrow-circle-left\" label=\"Facility View {{locId}}\"></button>\r\n            <button type=\"text\" (click)=\"backDataSheet()\" pButton icon=\"fa-arrow-circle-left\" label=\"Data Sheet\"></button>\r\n        </div>\r\n\r\n        <div class='row'>\r\n            <p-tabView (onChange)=\"onTabChange($event)\">\r\n                <p-tabPanel *ngFor=\"let operation of allOperations\" header=\"{{operation.displayName}}\" [selected]=\"operation.tableName === tableName\">\r\n                    <operations-reforecast \r\n                        [operation]=\"operation\"\r\n                        [selected]=\"operation.tableName === tableName\"\r\n                        [locId]=\"locId\"\r\n                        [airportName]=\"airportName\"\r\n                        [fieldName]=\"fieldName\">\r\n                    </operations-reforecast>\r\n                </p-tabPanel>\r\n            </p-tabView>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ },

/***/ 792:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var system_management_component_1 = __webpack_require__(793);
	var taf_book_component_1 = __webpack_require__(795);
	var staffing_standards_component_1 = __webpack_require__(798);
	var growth_rates_component_1 = __webpack_require__(800);
	var taf_book_routes_1 = __webpack_require__(804);
	var staffing_standards_routes_1 = __webpack_require__(823);
	var growth_rates_routes_1 = __webpack_require__(833);
	var towers_tracons_import_steps_routes_1 = __webpack_require__(840);
	var new_year_rollover_routes_1 = __webpack_require__(845);
	var new_year_rollover_component_1 = __webpack_require__(846);
	var tracon_model_routes_1 = __webpack_require__(856);
	var regional_review_component_1 = __webpack_require__(862);
	var auth_guard_service_1 = __webpack_require__(696);
	exports.SystemManagementRoutes = [
	    { path: 'system-management', component: system_management_component_1.SystemManagementComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'tafbooks', component: taf_book_component_1.TAFBookComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'staffing-standards', component: staffing_standards_component_1.StaffingStandardsComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'growth-rates', component: growth_rates_component_1.GrowthRatesComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'new-year-rollover', component: new_year_rollover_component_1.NewYearRolloverComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'regional-review', component: regional_review_component_1.RegionalReviewComponent, canActivate: [auth_guard_service_1.AuthGuard] }
	].concat(taf_book_routes_1.TAFBookRoutes, staffing_standards_routes_1.StaffingStandardsRoutes, growth_rates_routes_1.GrowthRatesRoutes, towers_tracons_import_steps_routes_1.TowersTraconsImportStepsRoutes, new_year_rollover_routes_1.NewYearRolloverRoutes, tracon_model_routes_1.TraconModelRoutes);


/***/ },

/***/ 793:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var user_session_1 = __webpack_require__(699);
	var user_info_service_1 = __webpack_require__(695);
	var scenario_service_1 = __webpack_require__(692);
	var SystemManagementComponent = (function () {
	    function SystemManagementComponent(route, router, _scenarioService, User, _userInfoService) {
	        this.route = route;
	        this.router = router;
	        this._scenarioService = _scenarioService;
	        this.User = User;
	        this._userInfoService = _userInfoService;
	        this.pageTitle = 'System Management';
	        this.isScenarioOwner = false;
	    }
	    SystemManagementComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
	        this._scenarioService.getScenarios(this.User.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.setScenarioHeader(_this.User.getSession().scenarioId);
	        });
	        //this probably needs to be somewhere more central
	        this.User.updateSessionState();
	        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(function (success) { return _this.isScenarioOwner = success.isOwner; }, function (error) { return _this.errorMessage = error; });
	    };
	    SystemManagementComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	        this.scenarioHeaderDiv.innerHTML = "<strong>Current Scenario: " + this.currentScenario.scenarioName + " (" + this.currentScenario.id + ")</strong>";
	    };
	    __decorate([
	        core_1.ViewChild('scenarioHeader'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], SystemManagementComponent.prototype, "scenarioHeader", void 0);
	    SystemManagementComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/system-management.component.html',
	            template: __webpack_require__(794),
	            styles: [__webpack_require__(700)],
	            directives: [router_1.ROUTER_DIRECTIVES],
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, scenario_service_1.ScenarioService, user_session_1.UserSession, user_info_service_1.UserInfoService])
	    ], SystemManagementComponent);
	    return SystemManagementComponent;
	}());
	exports.SystemManagementComponent = SystemManagementComponent;


/***/ },

/***/ 794:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\" #scenarioHeader></div>\r\n<div class='panel panel-primary'>\r\n    <div class='panel-heading'>\r\n        {{pageTitle}}\r\n    </div>\r\n\r\n    <div class='panel-body'>\r\n       <ul>\r\n        <li><a [routerLink]=\"['/staffing-standards']\">Staffing standards</a></li>\r\n        <li><a [routerLink]=\"['/tracon-model']\">Tracon Model</a></li>\r\n        <li><a [routerLink]=\"['/new-year-rollover']\">New Year Procedures/Reports</a></li>\r\n        <li><a [routerLink]=\"['/tafbooks']\">TAF Book</a></li>\r\n        <li><a [routerLink]=\"['/growth-rates']\">Administrative Options: Save National Forecast rates; Extend growth rates; Set Hub Sizes</a></li>\r\n        <li><a [routerLink]=\"['/towers-tracons-import-steps']\">End of the year procedures (October through December) Tower and TRACON import</a></li>\r\n        <li><a [routerLink]=\"['/regional-review']\">Regional Review</a></li>\r\n       </ul>\r\n    </div>\r\n</div>\r\n"

/***/ },

/***/ 795:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var taf_book_1 = __webpack_require__(796);
	var taf_book_service_1 = __webpack_require__(681);
	var TAFBookComponent = (function () {
	    function TAFBookComponent(route, router, _tafBookService) {
	        this.route = route;
	        this.router = router;
	        this._tafBookService = _tafBookService;
	        this.pageTitle = 'TAF BOOK';
	        this.msgs = [];
	        this.displaySpinner = false;
	    }
	    TAFBookComponent.prototype.ngOnInit = function () {
	        this.selectedOption = new taf_book_1.ITAFBookListComponent(1, 'TABLE S-1: Enplanements at Large Hub Airports');
	        this.options = [
	            new taf_book_1.ITAFBookListComponent(1, 'TABLE S-1: Enplanements at Large Hub Airports'),
	            new taf_book_1.ITAFBookListComponent(2, 'GRAPH S-1: Enplanements Growth Rates for the Core Airports'),
	            new taf_book_1.ITAFBookListComponent(3, 'TABLE S-2: Airport Operations at the Large Hub Airports '),
	            new taf_book_1.ITAFBookListComponent(4, 'GRAPH S-2: Airport Operations Growth Rates for the Core Airports'),
	            new taf_book_1.ITAFBookListComponent(5, 'TABLE S-3: Air Traffic Control Towers and Contract Towers by Region and State'),
	            new taf_book_1.ITAFBookListComponent(6, 'TABLE S-4: Ranking of Top 100 FAA Towers by Total Enplanements, FY 2016   '),
	            new taf_book_1.ITAFBookListComponent(7, 'TABLE S-5: Summary of Enplanements and Airport Operations at FAA Towers and Contract Towers '),
	            new taf_book_1.ITAFBookListComponent(8, 'TABLE S-6:Commercial Airport Operations Summary by Region '),
	            new taf_book_1.ITAFBookListComponent(9, 'TABLE S-7: Itinerant Airport Operations Summary by Region '),
	            new taf_book_1.ITAFBookListComponent(10, 'TABLE S-8:Total Airport Operations Summary by Region '),
	            new taf_book_1.ITAFBookListComponent(11, 'TABLE S-9:Tracon Operations Summary by Region '),
	            new taf_book_1.ITAFBookListComponent(12, 'TABLE S-10: Enplanements Summary by Region '),
	            new taf_book_1.ITAFBookListComponent(13, 'TABLE S-11: Based Aircraft Summary by Region '),
	            new taf_book_1.ITAFBookListComponent(14, 'TABLE B-1: List of Large Hub Towers'),
	            new taf_book_1.ITAFBookListComponent(15, 'TABLE B-2: List of Medium Hub Towers'),
	            new taf_book_1.ITAFBookListComponent(16, 'TABLE B-3: List of Small Hub Towers'),
	            new taf_book_1.ITAFBookListComponent(17, 'TABLE B-4: List of Non-Hub Towers'),
	            new taf_book_1.ITAFBookListComponent(18, 'TABLE B-5:  List of FAA Contract Towers')
	        ];
	        this.request = new taf_book_1.ITAFBookRequest(1);
	    };
	    TAFBookComponent.prototype.getValue = function (optionid) {
	        this.selectedOption = this.options.filter(function (item) { return item.id == optionid; })[0];
	        //console.log("get value" + this.selectedOption.id);
	    };
	    TAFBookComponent.prototype.generateReport = function () {
	        var _this = this;
	        this.msgs = [];
	        this.displaySpinner = true;
	        this.request.tafBookId = this.selectedOption.id;
	        this._tafBookService.generateTafBook(this.request)
	            .subscribe(function (response) {
	            _this.displaySpinner = false;
	            _this.facReportListResponse = response;
	            if (_this.facReportListResponse[0].responseStatus === 'ERROR') {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'An error has occurred executing your request'
	                        + _this.facReportListResponse[0].responseMessage });
	            }
	            else if (_this.facReportListResponse[0].responseMessage === 'No Data') {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Info Message', detail: 'No Data returned.'
	                        + _this.facReportListResponse[0].responseMessage });
	                _this.facReportListResponse[0].pdfFileUrl = "";
	                _this.facReportListResponse[0].htmlFileUrl = "";
	            }
	            else {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'info', summary: 'Info Message', detail: 'PDF & HTML file generated; please click links below' });
	                _this.cols = [
	                    { field: "htmlFileUrl", header: 'Html' },
	                    { field: "pdfFileUrl", header: 'Pdf' },
	                ];
	            }
	            //console.log ("response facility report " + this.facReportListResponse[0].htmlFileUrl + "  " 
	            //                + this.facReportListResponse[0].pdfFileUrl +" " + this.facReportListResponse[0].responseMessage +" "
	            //                + this.facReportListResponse[0].responseStatus +" " + this.facReportListResponse[0].responseDisplay)
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    TAFBookComponent.prototype.openPDFFile = function (responsepdf) {
	        window.open(responsepdf, '_blank');
	    };
	    TAFBookComponent.prototype.openHTMLFile = function (responseHtml) {
	        window.open(responseHtml, '_blank');
	    };
	    TAFBookComponent.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    TAFBookComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/tafbooks/taf-book.component.html',
	            template: __webpack_require__(797),
	            directives: [router_1.ROUTER_DIRECTIVES]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, taf_book_service_1.TAFBookService])
	    ], TAFBookComponent);
	    return TAFBookComponent;
	}());
	exports.TAFBookComponent = TAFBookComponent;


/***/ },

/***/ 796:
/***/ function(module, exports) {

	"use strict";
	var ITAFBookRequest = (function () {
	    function ITAFBookRequest(tafBookId) {
	        this.tafBookId = tafBookId;
	    }
	    return ITAFBookRequest;
	}());
	exports.ITAFBookRequest = ITAFBookRequest;
	var ITAFBookListComponent = (function () {
	    function ITAFBookListComponent(id, name) {
	        this.id = id;
	        this.name = name;
	    }
	    return ITAFBookListComponent;
	}());
	exports.ITAFBookListComponent = ITAFBookListComponent;


/***/ },

/***/ 797:
/***/ function(module, exports) {

	module.exports = "  <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n    <div>\r\n        <div class= \"row\" *ngFor=\"let resp of facReportListResponse\">\r\n                <div class=\"col-md-4\">\r\n                      HTML: <button class=\"btn btn-link btn-right btn-sm\"  (click)=\"openHTMLFile(resp.htmlFileUrl)\">{{resp.responseDisplay}}</button>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                      PDF:   <button class=\"btn btn-link btn-right btn-sm\"  (click)=\"openPDFFile(resp.pdfFileUrl)\">{{resp.responseDisplay}}</button>\r\n                </div>\r\n        </div>\r\n    </div>\r\n    <div class='panel-body'>\r\n       <div class=\"abc-radio-primary \" *ngFor=\"let option of options.slice(0,19)\">\r\n            <span></span>\r\n            <input type=\"radio\" class=\"styled\" id=\"option.id\" [checked]=\"option.id == selectedOption.id\" value=\"option.id\" (click)=\"getValue(option.id)\">\r\n            <label class=\"customtd\"> \r\n                {{option.name}}\r\n            </label>\r\n       </div>\r\n        <div class=\"row\">\r\n                <div class=\"col-sm-8\">\r\n                    <button type=\"text\" pButton  (click)=\"generateReport()\" label=\"Generate\"></button>\r\n                    <button type=\"text\" pButton  (click)=\"cancel()\" label=\"Cancel\"></button>\r\n                </div>\r\n       </div>\r\n    </div>\r\n    <p-dialog  [(visible)]=\"displaySpinner\" [modal]=true   [closable]=false showEffect=\"fade\">\r\n                <div align=\"center\">\r\n                    <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n                    <div>Loading please wait ....</div>\r\n                    <div>Do Not click back or Refresh the page</div>\r\n                </div>\r\n    </p-dialog>\r\n</div>\r\n"

/***/ },

/***/ 798:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var user_session_1 = __webpack_require__(699);
	var StaffingStandardsComponent = (function () {
	    function StaffingStandardsComponent(route, router, User) {
	        this.route = route;
	        this.router = router;
	        this.User = User;
	        this.pageTitle = 'Staffing Standards';
	    }
	    StaffingStandardsComponent.prototype.ngOnInit = function () {
	        this.scenario = this.User.getSession().scenarioId;
	    };
	    StaffingStandardsComponent.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    StaffingStandardsComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/staffing-standards/staffing-standards.component.html',
	            template: __webpack_require__(799),
	            directives: [router_1.ROUTER_DIRECTIVES],
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, user_session_1.UserSession])
	    ], StaffingStandardsComponent);
	    return StaffingStandardsComponent;
	}());
	exports.StaffingStandardsComponent = StaffingStandardsComponent;


/***/ },

/***/ 799:
/***/ function(module, exports) {

	module.exports = "  <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n\r\n    <div class='panel-body'>\r\n       <ul>\r\n         <li><a [routerLink]=\"['/staffing-standards-tracon']\">Staffing Standards tracon data export to excel (for scenario: {{scenario}})</a></li>\r\n         <li><a [routerLink]=\"['/staffing-standards-tower']\">Staffing Standards tower data export to excel (for scenario: {{scenario}})</a></li>\r\n         <li><a [routerLink]=\"['../towers-tracons-import']\">Staffing Standards FAA tower/TRACONS comparison report (for scenario: {{scenario}})</a></li>\r\n       </ul>\r\n    </div>\r\n</div>\r\n"

/***/ },

/***/ 800:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var growth_rates_save_service_1 = __webpack_require__(801);
	var set_hub_sizes_service_1 = __webpack_require__(802);
	var user_session_1 = __webpack_require__(699);
	var user_info_service_1 = __webpack_require__(695);
	var scenario_service_1 = __webpack_require__(692);
	var GrowthRatesComponent = (function () {
	    function GrowthRatesComponent(route, router, _scenarioService, User, _userInfoService) {
	        this.route = route;
	        this.router = router;
	        this._scenarioService = _scenarioService;
	        this.User = User;
	        this._userInfoService = _userInfoService;
	        this.pageTitle = 'Growth Rate';
	        this.isScenarioOwner = false;
	    }
	    GrowthRatesComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
	        this._scenarioService.getScenarios(this.User.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.setScenarioHeader(_this.User.getSession().scenarioId);
	        });
	        //this probably needs to be somewhere more central
	        this.User.updateSessionState();
	        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(function (success) { return _this.isScenarioOwner = success.isOwner; }, function (error) { return _this.errorMessage = error; });
	    };
	    GrowthRatesComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	        this.scenarioHeaderDiv.innerHTML = "<strong>Current Scenario: " + this.currentScenario.scenarioName + " (" + this.currentScenario.id + ")</strong>";
	    };
	    GrowthRatesComponent.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    __decorate([
	        core_1.ViewChild('scenarioHeader'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], GrowthRatesComponent.prototype, "scenarioHeader", void 0);
	    GrowthRatesComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/growth-rates/growth-rates.component.html',
	            template: __webpack_require__(803),
	            styles: [__webpack_require__(700)],
	            directives: [router_1.ROUTER_DIRECTIVES],
	            providers: [growth_rates_save_service_1.GrowthRatesSaveService, set_hub_sizes_service_1.SetHubSizesService]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, scenario_service_1.ScenarioService, user_session_1.UserSession, user_info_service_1.UserInfoService])
	    ], GrowthRatesComponent);
	    return GrowthRatesComponent;
	}());
	exports.GrowthRatesComponent = GrowthRatesComponent;


/***/ },

/***/ 801:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var GrowthRatesSaveService = (function () {
	    function GrowthRatesSaveService(httpHelper) {
	        this.httpHelper = httpHelper;
	        //need to have this somewhere besides hardcoded in here
	        //private _growthRatesSaveUrl = `http://localhost:55706/api/systemmanagement/GrowthRatesSave`;
	        this._growthRatesSaveUrl = "api/systemmanagement/GrowthRatesSave";
	    }
	    GrowthRatesSaveService.prototype.getSavedRatesResponse = function (scenId) {
	        return this.httpHelper.get(this._growthRatesSaveUrl + "/" + scenId);
	        // .map((response: Response) => <IGrowthRatesSave> response.json())
	        // .do(httpHelper => console.log('Growth rates save service: ' +  JSON.stringify(data)))
	        // .catch(this.handleError);
	    };
	    GrowthRatesSaveService.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    GrowthRatesSaveService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], GrowthRatesSaveService);
	    return GrowthRatesSaveService;
	}());
	exports.GrowthRatesSaveService = GrowthRatesSaveService;


/***/ },

/***/ 802:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var SetHubSizesService = (function () {
	    function SetHubSizesService(httpHelper) {
	        this.httpHelper = httpHelper;
	        //need to have this somewhere besides hardcoded in here
	        //private _setHubSizesSaveUrl = `http://localhost:55706/api/systemmanagement/SetHubSizes`;
	        this._setHubSizesSaveUrl = "api/systemmanagement/SetHubSizes";
	    }
	    SetHubSizesService.prototype.getSetHubSizesResponse = function () {
	        return this.httpHelper.get("" + this._setHubSizesSaveUrl);
	        // .map((response: Response) => <ISetHubSizes> response.json())
	        //  .do(data => console.log('Set Hub Sizes service: ' +  JSON.stringify(data)))
	        //  .catch(this.handleError);
	    };
	    SetHubSizesService.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    SetHubSizesService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], SetHubSizesService);
	    return SetHubSizesService;
	}());
	exports.SetHubSizesService = SetHubSizesService;


/***/ },

/***/ 803:
/***/ function(module, exports) {

	module.exports = "  <div class=\"current-scenario\" #scenarioHeader></div>\r\n  <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n\r\n    <div class='panel-body'>\r\n       <ul>\r\n         <li><a [routerLink]=\"['/growth-rates-save']\">Save Growth Rates for scenario {{User.getSession().scenarioId}} (This will overwrite any previously saved rates)</a></li>\r\n         <li><a [routerLink]=\"['/set-hub-sizes']\">Set Hub Sizes</a></li>\r\n       </ul>\r\n    </div>\r\n</div>\r\n\r\n"

/***/ },

/***/ 804:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var taf_book_component_1 = __webpack_require__(795);
	var taf_book_s1_component_1 = __webpack_require__(805);
	var taf_book_graph_s1_component_1 = __webpack_require__(807);
	var taf_book_s2_component_1 = __webpack_require__(809);
	var taf_book_s3_component_1 = __webpack_require__(811);
	var taf_book_b1_component_1 = __webpack_require__(813);
	var taf_book_b2_component_1 = __webpack_require__(815);
	var taf_book_b3_component_1 = __webpack_require__(817);
	var taf_book_b4_component_1 = __webpack_require__(819);
	var taf_book_b5_component_1 = __webpack_require__(821);
	var auth_guard_service_1 = __webpack_require__(696);
	exports.TAFBookRoutes = [
	    { path: 'taf-book', component: taf_book_component_1.TAFBookComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'taf-book-s1', component: taf_book_s1_component_1.TAFBookS1Component },
	    { path: 'taf-book-graph-s1', component: taf_book_graph_s1_component_1.TAFBookGraphS1Component },
	    { path: 'taf-book-s2', component: taf_book_s2_component_1.TAFBookS2Component },
	    { path: 'taf-book-s3', component: taf_book_s3_component_1.TAFBookS3Component },
	    { path: 'taf-book-b1', component: taf_book_b1_component_1.TAFBookB1Component },
	    { path: 'taf-book-b2', component: taf_book_b2_component_1.TAFBookB2Component },
	    { path: 'taf-book-b3', component: taf_book_b3_component_1.TAFBookB3Component },
	    { path: 'taf-book-b4', component: taf_book_b4_component_1.TAFBookB4Component },
	    { path: 'taf-book-b5', component: taf_book_b5_component_1.TAFBookB5Component },
	];


/***/ },

/***/ 805:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var taf_book_s1_service_1 = __webpack_require__(687);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var primeng_3 = __webpack_require__(708);
	var TAFBookS1Component = (function () {
	    function TAFBookS1Component(route, router, _tafBookS1Service) {
	        this.route = route;
	        this.router = router;
	        this._tafBookS1Service = _tafBookS1Service;
	        this.pageTitle = 'TAF BOOK S1';
	    }
	    TAFBookS1Component.prototype.ngOnInit = function () {
	        var _this = this;
	        this._tafBookS1Service.getTAFBookS1()
	            .subscribe(function (tafBookS1Arr) { return _this.tafBookS1Arr = tafBookS1Arr; }, function (error) { return _this.errorMessage = error; });
	    };
	    TAFBookS1Component.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    TAFBookS1Component = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/tafbooks/taf-book-s1/taf-book-s1.component.html',
	            template: __webpack_require__(806),
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.DataTable, primeng_2.Column, primeng_3.Header],
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, taf_book_s1_service_1.TAFBookS1Service])
	    ], TAFBookS1Component);
	    return TAFBookS1Component;
	}());
	exports.TAFBookS1Component = TAFBookS1Component;


/***/ },

/***/ 806:
/***/ function(module, exports) {

	module.exports = "  <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/\r\n        <a [routerLink]=\"['/tafbooks']\" style=\"color: white; text-decoration:underline\">TAF Book</a>/{{pageTitle}}\r\n    </div>\r\n\r\n    <div class=\"container\" style=\"width:100%\">\r\n       <table class=\"table borderless\">\r\n           <thead>\r\n               <tr><th colspan=\"11\" class=\"text-center\" style=\"border-bottom: none;\">Table S-1 Enplanements at Core Airports (in thousands)</th></tr>\r\n               <tr>                    \r\n                    <th class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th class='col-xs-1' style=\"border: none;\" class=\"text-center\" *ngFor=\"let  tafBookElem of tafBookS1Arr | slice:0:1\">{{tafBookElem.ffcYear-1}}</th>\r\n                    <th class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th class='col-xs-1' style=\"border: none;\" class=\"text-center\" >Rate**</th>\r\n                    <th class='col-xs-1' style=\"border: none;\" class=\"text-center\">Airport</th>\r\n                    <th class='col-xs-1' style=\"border: none;\">rating</th>\r\n                </tr>\r\n                <tr>\r\n                    <th class='col-xs-1' style=\"border-bottom: 2px solid black;border-top: none;\">Loc Id</th>\r\n                    <th class='col-xs-1' style=\"border-bottom: 2px solid black;border-top: none;\">Region</th>\r\n                    <th class='col-xs-1' class=\"text-nowrap\" style=\"border-bottom: 2px solid black;border-top: none;\">Airport Name</th>\r\n                    <th class='col-xs-1' class=\"text-center\" style=\"border-bottom: 2px solid black;border-top: none;\" *ngFor=\"let tafBookElem of tafBookS1Arr | slice:0:1\">{{tafBookElem.ffcYear-1}}</th>\r\n                    <th class='col-xs-1' class=\"text-center\" style=\"border-bottom: 2px solid black;border-top: none;\">Percent*</th>\r\n                    <th class='col-xs-1' class=\"text-center\" style=\"border-bottom: 2px solid black;border-top: none;\" *ngFor=\"let tafBookElem of tafBookS1Arr | slice:0:1\">{{tafBookElem.ffcYear}}</th>\r\n                    <th class='col-xs-1' class=\"text-center\" style=\"border-bottom: 2px solid black;border-top: none;\" *ngFor=\"let tafBookElem of tafBookS1Arr | slice:0:1\">{{tafBookElem.ffcYear+4}}</th>\r\n                    <th class='col-xs-1' class=\"text-center\" style=\"border-bottom: 2px solid black;border-top: none;\" *ngFor=\"let tafBookElem of tafBookS1Arr | slice:0:1\">{{tafBookElem.lfcYear}}</th>\r\n                    <th class='col-xs-1' class=\"text-nowrap\" style=\"border-bottom: 2px solid black;border-top: none;\" *ngFor=\"let tafBookElem of tafBookS1Arr | slice:0:1\">{{tafBookElem.ffcYear-1}}-2045</th>\r\n                    <th class='col-xs-1' class=\"text-center\" style=\"border-bottom: 2px solid black;border-top: none;\" *ngFor=\"let tafBookElem of tafBookS1Arr | slice:0:1\">{{tafBookElem.ffcYear-1}}</th>\r\n                    <th class='col-xs-1' class=\"text-center\" style=\"border-bottom: 2px solid black;border-top: none;\" *ngFor=\"let tafBookElem of tafBookS1Arr | slice:0:1\">{{tafBookElem.lfcYear}}</th>\r\n                </tr>\r\n           </thead>\r\n           <tbody>\r\n           <tr *ngFor=\"let tafBookElem of tafBookS1Arr\">\r\n               <td  class='col-xs-1' style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.locid}}</td>\r\n               <td  class='col-xs-1' style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.region}}</td>\r\n               <td  class='col-xs-1' class=\"text-nowrap\" style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.aport_name}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.totalEnplanementsFfcMinusOneTotEnpl}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.percentageFfcMinOneOverTotal}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\"> {{tafBookElem.totalEnplanementsFfcYearTotEnpl}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.totalEnplanementsFfcPlusFourTotEnpl}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.totalEnplanementsLfcTotEnpl}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.rateFyLfc}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.rankFFCMinusOneYear}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.rankLFCYear}}</td>\r\n           </tr>\r\n           <tr *ngFor=\"let  tafBookElem of tafBookS1Arr | slice:0:1\">\r\n               <td class='col-xs-1' class=\"text-left\"  colspan=\"3\" style=\"border-top: 2px solid black;\"><b>Totals:</b></td>\r\n               <td class='col-xs-1' class=\"text-right\" style=\"border-top: 2px solid black;\">{{tafBookElem.sumFfcMinusOneTotEnpl}}</td>\r\n               <td class='col-xs-1' class=\"text-right\" style=\"border-top: 2px solid black;\">{{tafBookElem.sumPercentageFfcMinOneOverTotal}}</td>\r\n               <td class='col-xs-1' class=\"text-right\" style=\"border-top: 2px solid black;\">{{tafBookElem.sumFfcYearTotEnpl}}</td>\r\n               <td class='col-xs-1' class=\"text-right\" style=\"border-top: 2px solid black;\">{{tafBookElem.sumFfcPlusFourTotEnpl}}</td>\r\n               <td class='col-xs-1' class=\"text-right\" style=\"border-top: 2px solid black;\">{{tafBookElem.sumsLfcTotEnpl}}</td>\r\n               <td class='col-xs-1' class=\"text-right\" style=\"border-top: 2px solid black;\">{{tafBookElem.sumRateFyLfc}}</td>\r\n               <td class='col-xs-1' colspan=\"2\" style=\"border-top: 2px solid black;\">&nbsp;</td>\r\n           </tr>\r\n           <tr>\r\n               <td colspan=\"11\" class=\"text-left\" style=\"border-top: none;\">*Percent of total US enplanements.</td>\r\n           </tr>\r\n           <tr>\r\n               <td colspan=\"11\" class=\"text-left\" style=\"border-top: none;\">**Annual compound growth rate.</td>\r\n           </tr>\r\n           </tbody>\r\n       </table>\r\n\r\n      <!--  <p-dataTable  #dt [value]=\"tafBookS1Arr\" [rows]=\"25\" [paginator]=\"true\" [pageLinks]=\"3\" [rowsPerPageOptions]=\"[5,10,20]\">\r\n             <header>\r\n                <div class=\"ui-helper-clearfix\">\r\n                    <button type=\"button\" pButton icon=\"fa-file-o\" iconPos=\"left\" label=\"CSV\" (click)=\"dt.exportCSV()\" style=\"float:left\">\r\n                         <i class=\"fa fa-file-text-o \" aria-hidden=\"true\"> Export To CSV</i>\r\n                    </button>\r\n                </div>\r\n            </header>\r\n            <p-column *ngFor=\"let col of cols\" [field]=\"col.field\" [header]=\"col.header\"></p-column>\r\n        </p-dataTable>-->\r\n    </div>\r\n</div>"

/***/ },

/***/ 807:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var taf_book_graph_s1_service_1 = __webpack_require__(690);
	var primeng_1 = __webpack_require__(708);
	var _ = __webpack_require__(680);
	/*steps to install lodash:
	npm install typings --global
	With older versions of typings things mess up and you'll get a bunch of "Duplicate identifier" issues. Also you don't need to use --ambient anymore as far as I could tell.
	
	So once typings is up to date, this should work (using the Angular 2 quickstart).
	
	Run:
	
	npm install lodash --save
	typings install lodash --save
	First, add this to systemjs.config.js:
	
	'lodash':                     'node_modules/lodash/lodash.js'
	 */
	var TAFBookGraphS1Component = (function () {
	    function TAFBookGraphS1Component(route, router, _tafBookGraphS1Service) {
	        this.route = route;
	        this.router = router;
	        this._tafBookGraphS1Service = _tafBookGraphS1Service;
	        this.pageTitle = 'TAF BOOK Graph S1';
	    }
	    TAFBookGraphS1Component.prototype.ngOnInit = function () {
	        var _this = this;
	        this._tafBookGraphS1Service.getTAFGraphS1BookSplit()
	            .subscribe(function (tafBookGraphS1Arr) { return _this.tafBookGraphS1Arr = tafBookGraphS1Arr; }, function (error) { return console.log("Error", error); }, function () {
	            _this.tafBookGraphS1ArrLocid = _.map(JSON.parse(JSON.stringify(_this.tafBookGraphS1Arr)), 'locid');
	            _this.tafBookGraphS1ArrRate = _.map(JSON.parse(JSON.stringify(_this.tafBookGraphS1Arr)), 'rateFyLfc');
	            //console.log("mapxAxis Component: " +this.tafBookGraphS1ArrLocid);// _.map(JSON.parse(JSON.stringify(this.tafBookGraphS1Arr)),'locid')
	            //console.log("mapyAxis Component: " +  _.map(JSON.parse(JSON.stringify(this.tafBookGraphS1Arr)),'rateFyLfc'));
	            _this.data = {
	                labels: _this.tafBookGraphS1ArrLocid,
	                datasets: [
	                    {
	                        label: 'Growth Rate',
	                        data: _this.tafBookGraphS1ArrRate
	                    }
	                ]
	            };
	            _this.options = {
	                legend: {
	                    display: false,
	                    position: 'bottom'
	                },
	                scales: {
	                    xAxes: [{
	                            scaleLabel: {
	                                display: true,
	                                labelString: 'Airport'
	                            }
	                        }],
	                    yAxes: [{
	                            scaleLabel: {
	                                display: true,
	                                labelString: 'Annual Growth Rate'
	                            }
	                        }]
	                }
	            };
	        });
	    };
	    TAFBookGraphS1Component.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    TAFBookGraphS1Component = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/tafbooks/taf-book-graph-s1/taf-book-graph-s1.component.html',
	            template: __webpack_require__(808),
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.UIChart]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, taf_book_graph_s1_service_1.TAFBookGraphS1Service])
	    ], TAFBookGraphS1Component);
	    return TAFBookGraphS1Component;
	}());
	exports.TAFBookGraphS1Component = TAFBookGraphS1Component;


/***/ },

/***/ 808:
/***/ function(module, exports) {

	module.exports = "<div class='panel panel-primary'>\r\n    <div class='panel-heading'>\r\n        <div class='panel-heading'>\r\n            <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/\r\n            <a [routerLink]=\"['/tafbooks']\" style=\"color: white; text-decoration:underline\">TAF Book</a>/{{pageTitle}}\r\n        </div>\r\n    </div>\r\n\r\n      <div class='panel-body'>\r\n        <div style=\"font-family:Arial; font-size:25px;text-align:center;\">Graph S-1. Enplanements Growth Rates for the Core  Airports - 2015 to 2045</div>\r\n        <p-chart *ngIf='data' type=\"bar\" [data]=\"data\"  [options]=\"options\"></p-chart>\r\n      </div>\r\n</div>"

/***/ },

/***/ 809:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var taf_book_s2_service_1 = __webpack_require__(688);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var primeng_3 = __webpack_require__(708);
	var TAFBookS2Component = (function () {
	    function TAFBookS2Component(route, router, _tafBooks2Service) {
	        this.route = route;
	        this.router = router;
	        this._tafBooks2Service = _tafBooks2Service;
	        this.pageTitle = 'TAF BOOK s2';
	    }
	    TAFBookS2Component.prototype.ngOnInit = function () {
	        var _this = this;
	        this._tafBooks2Service.getTAFBookS2()
	            .subscribe(function (tafBookS2Arr) { return _this.tafBookS2Arr = tafBookS2Arr; }, function (error) { return _this.errorMessage = error; });
	    };
	    TAFBookS2Component.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    TAFBookS2Component = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/tafbooks/taf-book-s2/taf-book-s2.component.html',
	            template: __webpack_require__(810),
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.DataTable, primeng_2.Column, primeng_3.Header],
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, taf_book_s2_service_1.TAFBookS2Service])
	    ], TAFBookS2Component);
	    return TAFBookS2Component;
	}());
	exports.TAFBookS2Component = TAFBookS2Component;


/***/ },

/***/ 810:
/***/ function(module, exports) {

	module.exports = "  <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/\r\n        <a [routerLink]=\"['/tafbooks']\" style=\"color: white; text-decoration:underline\">TAF Book</a>/{{pageTitle}}\r\n    </div>\r\n\r\n    <div class=\"container\" style=\"width:100%\">\r\n       <table class=\"table borderless\">\r\n           <thead>\r\n               <tr><th colspan=\"11\" class=\"text-center\" style=\"border-bottom: none;\">Table S-2 Airport Operations at Core Airports (in thousands)</th></tr>\r\n               <tr>                    \r\n                    <th class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th class='col-xs-1' style=\"border: none;\" class=\"text-center\" *ngFor=\"let  tafBookElem of tafBookS2Arr | slice:0:1\">{{tafBookElem.ffcYear-1}}</th>\r\n                    <th class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th class='col-xs-1' style=\"border: none;\" class=\"text-center\" >Rate**</th>\r\n                    <th class='col-xs-1' style=\"border: none;\" class=\"text-center\">Airport</th>\r\n                    <th class='col-xs-1' style=\"border: none;\">rating</th>\r\n                </tr>\r\n                <tr>\r\n                    <th class='col-xs-1' style=\"border-bottom: 2px solid black;border-top: none;\">Loc Id</th>\r\n                    <th class='col-xs-1' style=\"border-bottom: 2px solid black;border-top: none;\">Region</th>\r\n                    <th class='col-xs-1' class=\"text-nowrap\" style=\"border-bottom: 2px solid black;border-top: none;\">Airport Name</th>\r\n                    <th class='col-xs-1' class=\"text-center\" style=\"border-bottom: 2px solid black;border-top: none;\" *ngFor=\"let tafBookElem of tafBookS2Arr | slice:0:1\">{{tafBookElem.ffcYear-1}}</th>\r\n                    <th class='col-xs-1' class=\"text-center\" style=\"border-bottom: 2px solid black;border-top: none;\">Percent*</th>\r\n                    <th class='col-xs-1' class=\"text-center\" style=\"border-bottom: 2px solid black;border-top: none;\" *ngFor=\"let tafBookElem of tafBookS2Arr | slice:0:1\">{{tafBookElem.ffcYear}}</th>\r\n                    <th class='col-xs-1' class=\"text-center\" style=\"border-bottom: 2px solid black;border-top: none;\" *ngFor=\"let tafBookElem of tafBookS2Arr | slice:0:1\">{{tafBookElem.ffcYear+4}}</th>\r\n                    <th class='col-xs-1' class=\"text-center\" style=\"border-bottom: 2px solid black;border-top: none;\" *ngFor=\"let tafBookElem of tafBookS2Arr | slice:0:1\">{{tafBookElem.lfcYear}}</th>\r\n                    <th class='col-xs-1' class=\"text-nowrap\" style=\"border-bottom: 2px solid black;border-top: none;\" *ngFor=\"let tafBookElem of tafBookS2Arr | slice:0:1\">{{tafBookElem.ffcYear-1}}-2045</th>\r\n                    <th class='col-xs-1' class=\"text-center\" style=\"border-bottom: 2px solid black;border-top: none;\" *ngFor=\"let tafBookElem of tafBookS2Arr | slice:0:1\">{{tafBookElem.ffcYear-1}}</th>\r\n                    <th class='col-xs-1' class=\"text-center\" style=\"border-bottom: 2px solid black;border-top: none;\" *ngFor=\"let tafBookElem of tafBookS2Arr | slice:0:1\">{{tafBookElem.lfcYear}}</th>\r\n                </tr>\r\n           </thead>\r\n           <tbody>\r\n           <tr *ngFor=\"let tafBookElem of tafBookS2Arr\">\r\n               <td  class='col-xs-1' style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.locid}}</td>\r\n               <td  class='col-xs-1' style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.region}}</td>\r\n               <td  class='col-xs-1' class=\"text-nowrap\" style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.aport_name}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.totalOpsFfcMinusOneTotOps}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.percentageFfcMinOneOverTotal}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\"> {{tafBookElem.totalOpsFfcYearTotOps}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.totalOpsFfcPlusFourTotOps}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.totalOpsLfcTotOps}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.rateFyLfc}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.rankFFCMinusOneYear}}</td>\r\n               <td class='col-xs-1' class=\"text-right\"  style=\"border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.rankLFCYear}}</td>\r\n           </tr>\r\n           <tr *ngFor=\"let  tafBookElem of tafBookS2Arr | slice:0:1\">\r\n               <td class='col-xs-1' class=\"text-left\"  colspan=\"3\" style=\"border-top: 2px solid black;\"><b>Totals:</b></td>\r\n               <td class='col-xs-1' class=\"text-right\" style=\"border-top: 2px solid black;\">{{tafBookElem.sumFfcMinusOneTotOps}}</td>\r\n               <td class='col-xs-1' class=\"text-right\" style=\"border-top: 2px solid black;\">{{tafBookElem.sumPercentageFfcMinOneOverTotal}}</td>\r\n               <td class='col-xs-1' class=\"text-right\" style=\"border-top: 2px solid black;\">{{tafBookElem.sumFfcYearTotOps}}</td>\r\n               <td class='col-xs-1' class=\"text-right\" style=\"border-top: 2px solid black;\">{{tafBookElem.sumFfcPlusFourTotOps}}</td>\r\n               <td class='col-xs-1' class=\"text-right\" style=\"border-top: 2px solid black;\">{{tafBookElem.sumsLfcTotOps}}</td>\r\n               <td class='col-xs-1' class=\"text-right\" style=\"border-top: 2px solid black;\">{{tafBookElem.sumRateFyLfc}}</td>\r\n               <td class='col-xs-1' colspan=\"2\" style=\"border-top: 2px solid black;\">&nbsp;</td>\r\n           </tr>\r\n           <tr>\r\n               <td colspan=\"11\" class=\"text-left\" style=\"border-top: none;\">*Percent of total US operations.</td>\r\n           </tr>\r\n           <tr>\r\n               <td colspan=\"11\" class=\"text-left\" style=\"border-top: none;\">**Annual compound growth rate.</td>\r\n           </tr>\r\n           </tbody>\r\n       </table>\r\n\r\n      <!--  <p-dataTable  #dt [value]=\"tafBookS2Arr\" [rows]=\"25\" [paginator]=\"true\" [pageLinks]=\"3\" [rowsPerPageOptions]=\"[5,10,20]\">\r\n             <header>\r\n                <div class=\"ui-helper-clearfix\">\r\n                    <button type=\"button\" pButton icon=\"fa-file-o\" iconPos=\"left\" label=\"CSV\" (click)=\"dt.exportCSV()\" style=\"float:left\">\r\n                         <i class=\"fa fa-file-text-o \" aria-hidden=\"true\"> Export To CSV</i>\r\n                    </button>\r\n                </div>\r\n            </header>\r\n            <p-column *ngFor=\"let col of cols\" [field]=\"col.field\" [header]=\"col.header\"></p-column>\r\n        </p-dataTable>-->\r\n    </div>\r\n</div>"

/***/ },

/***/ 811:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var taf_book_s3_service_1 = __webpack_require__(689);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var primeng_3 = __webpack_require__(708);
	var TAFBookS3Component = (function () {
	    function TAFBookS3Component(route, router, _tafBooks3Service) {
	        this.route = route;
	        this.router = router;
	        this._tafBooks3Service = _tafBooks3Service;
	        this.pageTitle = 'TAF BOOK s3';
	    }
	    TAFBookS3Component.prototype.ngOnInit = function () {
	        var _this = this;
	        this._tafBooks3Service.getTAFBookS3()
	            .subscribe(function (tafBookS3Arr) { return _this.tafBookS3Arr = tafBookS3Arr; }, function (error) { return _this.errorMessage = error; });
	    };
	    TAFBookS3Component.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    TAFBookS3Component = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/tafbooks/taf-book-s3/taf-book-s3.component.html',
	            template: __webpack_require__(812),
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.DataTable, primeng_2.Column, primeng_3.Header],
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, taf_book_s3_service_1.TAFBookS3Service])
	    ], TAFBookS3Component);
	    return TAFBookS3Component;
	}());
	exports.TAFBookS3Component = TAFBookS3Component;


/***/ },

/***/ 812:
/***/ function(module, exports) {

	module.exports = " <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/\r\n        <a [routerLink]=\"['/tafbooks']\" style=\"color: white; text-decoration:underline\">TAF Book</a>/{{pageTitle}}\r\n    </div>\r\n\r\n    <div class=\"container\" style=\"width:100%\">\r\n       <table class=\"table borderless\">\r\n           <thead>\r\n                <tr><th colspan=\"10\" class=\"text-center\" style=\"border-bottom: none;\">Table S-3. Air Traffic Control Towers and Contract Towers</th></tr>\r\n                <tr>\r\n                    <th class=\"text-right\" style=\"border-bottom: none;border-top: none;\">&nbsp;</th>\r\n                    <th  style=\"border-bottom: none;border-top: none;\" ><b>FAA</b></th>\r\n                    <th  style=\"border-bottom: none;border-top: none;\"><b>Contract</b></th>\r\n                </tr>\r\n                <tr>\r\n                    <th style=\"border-bottom: 2px solid black;border-top: none;\"><b>Region/State</b></th>\r\n                    <th style=\"border-bottom: 2px solid black;border-top: none;\"><b>Towers</b></th>\r\n                    <th style=\"border-bottom: 2px solid black;border-top: none;\"><b>Towers</b></th>\r\n                </tr>\r\n           </thead>\r\n           <tbody *ngFor=\"let tafBookElem of tafBookS3Arr\">\r\n               <tr><td colspan='4' height='10'>&nbsp;</td></tr>\r\n               <tr>\r\n                   <td style=\"border-bottom: none;border-top: none;\"><b>{{tafBookElem.region}}/{{tafBookElem.stateName}}</b></td>\r\n                   <td style=\"border-bottom: none;border-top: none;\">{{tafBookElem.faaTowerCntsState}}</td>\r\n                   <td style=\"border-bottom: none;border-top: none;\">{{tafBookElem.contractTowersCntsState}}</td>\r\n                </tr>\r\n           </tbody>\r\n       </table>\r\n    </div>\r\n </div>"

/***/ },

/***/ 813:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var taf_book_b1_service_1 = __webpack_require__(682);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var primeng_3 = __webpack_require__(708);
	var TAFBookB1Component = (function () {
	    function TAFBookB1Component(route, router, _tafBookB1Service) {
	        this.route = route;
	        this.router = router;
	        this._tafBookB1Service = _tafBookB1Service;
	        this.pageTitle = 'TAF BOOK b1';
	    }
	    TAFBookB1Component.prototype.ngOnInit = function () {
	        var _this = this;
	        this._tafBookB1Service.getTAFBookB1()
	            .subscribe(function (tafBookB1Arr) { return _this.tafBookB1Arr = tafBookB1Arr; }, function (error) { return _this.errorMessage = error; });
	    };
	    TAFBookB1Component.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    TAFBookB1Component = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/tafbooks/taf-book-b1/taf-book-b1.component.html',
	            template: __webpack_require__(814),
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.DataTable, primeng_2.Column, primeng_3.Header],
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, taf_book_b1_service_1.TAFBookB1Service])
	    ], TAFBookB1Component);
	    return TAFBookB1Component;
	}());
	exports.TAFBookB1Component = TAFBookB1Component;


/***/ },

/***/ 814:
/***/ function(module, exports) {

	module.exports = " <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/\r\n        <a [routerLink]=\"['/tafbooks']\" style=\"color: white; text-decoration:underline\">TAF Book</a>/{{pageTitle}}\r\n    </div>\r\n\r\n    <div class=\"container\" style=\"width:100%\">\r\n       <table class=\"table borderless\">\r\n           <thead>\r\n                <tr><th colspan='4'  class='col-xs-1' style=\"border: none;\" class=\"text-center\">Table B-1 List of Large Hub Towers </th></tr>\r\n                <tr>\r\n                    <th colspan='1' class=\"text-center\" class='col-xs-1' style=\"border: none;\"><b>Location</b></th>\r\n                    <th colspan='1' id='Blank'  class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th colspan='1' id='Blank'  class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th colspan='1' id='Blank'  class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                </tr>\r\n                <tr>\r\n                    <th colspan='1' width='10%' class=\"text-center\" class='col-xs-1' style=\"border-bottom: 2px solid black;border-top: none;\"><b>Identifier</b></th>\r\n                    <th colspan='1' width='10%'  class='col-xs-1' style=\"border-bottom: 2px solid black;border-top: none;\"><b>Region</b></th>\r\n                    <th colspan='1' width='50%'  class='col-xs-1' style=\"border-bottom: 2px solid black;border-top: none;\"><b>Airport Name</b></th>\r\n                    <th colspan='1' width='30%'  class='col-xs-1' style=\"border-bottom: 2px solid black;border-top: none;\"><b>City, State</b></th>\r\n                </tr>\r\n           </thead>\r\n           <tbody >\r\n               <tr *ngFor=\"let tafBookElem of tafBookB1Arr\">\r\n                   <td class='col-xs-1' class=\"text-center\" style=\"border-bottom: none;border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.locid}}</td>\r\n                   <td class='col-xs-1' class=\"text-nowrap\" style=\"border-bottom: none;border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.region}}</td>\r\n                   <td class='col-xs-1' class=\"text-nowrap\" style=\"border-bottom: none;border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.aportName}}</td>\r\n                   <td class='col-xs-1' class=\"text-nowrap\" style=\"border-bottom: none;border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.city}},{{tafBookElem.state}}</td>\r\n               </tr>\r\n               <tr><td class='col-xs-1' colspan=\"4\" style=\"border-top: 2px solid black;\">&nbsp;</td></tr>\r\n           </tbody>\r\n            \r\n       </table>\r\n    </div>\r\n </div>"

/***/ },

/***/ 815:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var taf_book_b2_service_1 = __webpack_require__(683);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var primeng_3 = __webpack_require__(708);
	var TAFBookB2Component = (function () {
	    function TAFBookB2Component(route, router, _tafBookB2Service) {
	        this.route = route;
	        this.router = router;
	        this._tafBookB2Service = _tafBookB2Service;
	        this.pageTitle = 'TAF BOOK b2';
	    }
	    TAFBookB2Component.prototype.ngOnInit = function () {
	        var _this = this;
	        this._tafBookB2Service.getTAFBookB2()
	            .subscribe(function (tafBookB2Arr) { return _this.tafBookB2Arr = tafBookB2Arr; }, function (error) { return _this.errorMessage = error; });
	    };
	    TAFBookB2Component.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    TAFBookB2Component = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/tafbooks/taf-book-b2/taf-book-b2.component.html',
	            template: __webpack_require__(816),
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.DataTable, primeng_2.Column, primeng_3.Header],
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, taf_book_b2_service_1.TAFBookB2Service])
	    ], TAFBookB2Component);
	    return TAFBookB2Component;
	}());
	exports.TAFBookB2Component = TAFBookB2Component;


/***/ },

/***/ 816:
/***/ function(module, exports) {

	module.exports = " <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/\r\n        <a [routerLink]=\"['/tafbooks']\" style=\"color: white; text-decoration:underline\">TAF Book</a>/{{pageTitle}}\r\n    </div>\r\n\r\n    <div class=\"container\" style=\"width:100%\">\r\n       <table class=\"table borderless\">\r\n           <thead>\r\n                <tr><th colspan='4'  class='col-xs-1' style=\"border: none;\" class=\"text-center\">Table B-2 List of Medium Hub Towers </th></tr>\r\n                <tr>\r\n                    <th colspan='1' class=\"text-center\" class='col-xs-1' style=\"border: none;\"><b>Location</b></th>\r\n                    <th colspan='1' id='Blank'  class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th colspan='1' id='Blank'  class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th colspan='1' id='Blank'  class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                </tr>\r\n                <tr>\r\n                    <th colspan='1' width='10%' class=\"text-center\" class='col-xs-1' style=\"border-bottom: 2px solid black;border-top: none;\"><b>Identifier</b></th>\r\n                    <th colspan='1' width='10%'  class='col-xs-1' style=\"border-bottom: 2px solid black;border-top: none;\"><b>Region</b></th>\r\n                    <th colspan='1' width='50%'  class='col-xs-1' style=\"border-bottom: 2px solid black;border-top: none;\"><b>Airport Name</b></th>\r\n                    <th colspan='1' width='30%'  class='col-xs-1' style=\"border-bottom: 2px solid black;border-top: none;\"><b>City, State</b></th>\r\n                </tr>\r\n           </thead>\r\n           <tbody >\r\n               <tr *ngFor=\"let tafBookElem of tafBookB2Arr\">\r\n                   <td class='col-xs-1' class=\"text-center\" style=\"border-bottom: none;border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.locid}}</td>\r\n                   <td class='col-xs-1' class=\"text-nowrap\" style=\"border-bottom: none;border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.region}}</td>\r\n                   <td class='col-xs-1' class=\"text-nowrap\" style=\"border-bottom: none;border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.aportName}}</td>\r\n                   <td class='col-xs-1' class=\"text-nowrap\" style=\"border-bottom: none;border-top: none;font-size: 13px;font-family: Arial;\">{{tafBookElem.city}},{{tafBookElem.state}}</td>\r\n               </tr>\r\n               <tr><td class='col-xs-1' colspan=\"4\" style=\"border-top: 2px solid black;\">&nbsp;</td></tr>\r\n           </tbody>\r\n            \r\n       </table>\r\n    </div>\r\n </div>"

/***/ },

/***/ 817:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var taf_book_b3_service_1 = __webpack_require__(684);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var primeng_3 = __webpack_require__(708);
	var TAFBookB3Component = (function () {
	    function TAFBookB3Component(route, router, _tafBookB3Service) {
	        this.route = route;
	        this.router = router;
	        this._tafBookB3Service = _tafBookB3Service;
	        this.pageTitle = 'TAF BOOK b3';
	    }
	    TAFBookB3Component.prototype.ngOnInit = function () {
	        var _this = this;
	        this._tafBookB3Service.getTAFBookB3()
	            .subscribe(function (tafBookB3Arr) { return _this.tafBookB3Arr = tafBookB3Arr; }, function (error) { return _this.errorMessage = error; });
	    };
	    TAFBookB3Component.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    TAFBookB3Component = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/tafbooks/taf-book-b3/taf-book-b3.component.html',
	            template: __webpack_require__(818),
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.DataTable, primeng_2.Column, primeng_3.Header],
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, taf_book_b3_service_1.TAFBookB3Service])
	    ], TAFBookB3Component);
	    return TAFBookB3Component;
	}());
	exports.TAFBookB3Component = TAFBookB3Component;


/***/ },

/***/ 818:
/***/ function(module, exports) {

	module.exports = " <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/\r\n        <a [routerLink]=\"['/tafbooks']\" style=\"color: white; text-decoration:underline\">TAF Book</a>/{{pageTitle}}\r\n    </div>\r\n\r\n    <div class=\"container\" style=\"width:100%\">\r\n       <table class=\"table borderless\">\r\n           <thead>\r\n                <tr>\r\n                    <th colspan='4'  class='col-xs-3' style=\"border: none;\" class=\"text-center\">\r\n                        Table B-3 List of Small Hub Towers \r\n                    </th>\r\n                </tr>\r\n                <tr>\r\n                    <th colspan='1' class=\"text-center\" class='col-xs-1' style=\"border: none;\"><b>Location</b></th>\r\n                    <th colspan='1' id='Blank'  class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th colspan='1' id='Blank'  class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th colspan='1' id='Blank'  class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                </tr>\r\n                <tr>\r\n                    <th colspan='1' width='10%' class='text-center' class='col-xs-1' \r\n                            style=\"border-bottom: 2px solid black;border-top: none;\"><b>Identifier</b></th>\r\n                    <th colspan='1' width='30%'  class='col-xs-1' \r\n                            style=\"border-bottom: 2px solid black;border-top: none;\"><b>Region</b></th>\r\n                    <th colspan='1' width='50%'  class='col-xs-1' \r\n                            style=\"border-bottom: 2px solid black;border-top: none;\"><b>Airport Name</b></th>\r\n                    <th colspan='1' width='30%'  class='col-xs-1' \r\n                            style=\"border-bottom: 2px solid black;border-top: none;\"><b>City, State</b></th>\r\n                </tr>\r\n           </thead>\r\n           <tbody >\r\n               <tr *ngFor=\"let tafBookElem of tafBookB3Arr\">\r\n                   <td class='col-xs-1' class=\"text-center\" \r\n                        style=\"border-bottom: none;border-top: none;font-size: 14px;font-family: Arial;\">{{tafBookElem.locid}}</td>\r\n                   <td class='col-xs-1' class=\"text-nowrap\" \r\n                        style=\"border-bottom: none;border-top: none;font-size: 14px;font-family: Arial;\">{{tafBookElem.region}}</td>\r\n                   <td class='col-xs-1' class=\"text-nowrap\" \r\n                        style=\"border-bottom: none;border-top: none;font-size: 14px;font-family: Arial;\">{{tafBookElem.aportName}}</td>\r\n                   <td class='col-xs-1' class=\"text-nowrap\" \r\n                        style=\"border-bottom: none;border-top: none;font-size: 14px;font-family: Arial;\">{{tafBookElem.city}},{{tafBookElem.state}}</td>\r\n               </tr>\r\n               <tr><td class='col-xs-1' colspan=\"4\" style=\"border-top: 2px solid black;\">&nbsp;</td></tr>\r\n           </tbody>\r\n            \r\n       </table>\r\n    </div>\r\n </div>"

/***/ },

/***/ 819:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var taf_book_b4_service_1 = __webpack_require__(685);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var primeng_3 = __webpack_require__(708);
	var TAFBookB4Component = (function () {
	    function TAFBookB4Component(route, router, _tafBookB4Service) {
	        this.route = route;
	        this.router = router;
	        this._tafBookB4Service = _tafBookB4Service;
	        this.pageTitle = 'TAF BOOK b4';
	    }
	    TAFBookB4Component.prototype.ngOnInit = function () {
	        var _this = this;
	        this._tafBookB4Service.getTAFBookB4()
	            .subscribe(function (tafBookB4Arr) { return _this.tafBookB4Arr = tafBookB4Arr; }, function (error) { return _this.errorMessage = error; });
	    };
	    TAFBookB4Component.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    TAFBookB4Component = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/tafbooks/taf-book-b4/taf-book-b4.component.html',
	            template: __webpack_require__(820),
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.DataTable, primeng_2.Column, primeng_3.Header],
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, taf_book_b4_service_1.TAFBookB4Service])
	    ], TAFBookB4Component);
	    return TAFBookB4Component;
	}());
	exports.TAFBookB4Component = TAFBookB4Component;


/***/ },

/***/ 820:
/***/ function(module, exports) {

	module.exports = " <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/\r\n        <a [routerLink]=\"['/tafbooks']\" style=\"color: white; text-decoration:underline\">TAF Book</a>/{{pageTitle}}\r\n    </div>\r\n\r\n    <div class=\"container\" style=\"width:100%\">\r\n       <table class=\"table borderless\">\r\n           <thead>\r\n                <tr>\r\n                    <th colspan='4'  class='col-xs-3' style=\"border: none;\" class=\"text-center\">\r\n                        Table B-3 List of Small Hub Towers \r\n                    </th>\r\n                </tr>\r\n                <tr>\r\n                    <th colspan='1' class=\"text-center\" class='col-xs-1' style=\"border: none;\"><b>Location</b></th>\r\n                    <th colspan='1' id='Blank'  class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th colspan='1' id='Blank'  class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th colspan='1' id='Blank'  class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                </tr>\r\n                <tr>\r\n                    <th colspan='1' width='10%' class='text-center' class='col-xs-1' \r\n                            style=\"border-bottom: 2px solid black;border-top: none;\"><b>Identifier</b></th>\r\n                    <th colspan='1' width='30%'  class='col-xs-1' \r\n                            style=\"border-bottom: 2px solid black;border-top: none;\"><b>Region</b></th>\r\n                    <th colspan='1' width='50%'  class='col-xs-1' \r\n                            style=\"border-bottom: 2px solid black;border-top: none;\"><b>Airport Name</b></th>\r\n                    <th colspan='1' width='30%'  class='col-xs-1' \r\n                            style=\"border-bottom: 2px solid black;border-top: none;\"><b>City, State</b></th>\r\n                </tr>\r\n           </thead>\r\n           <tbody >\r\n               <tr *ngFor=\"let tafBookElem of tafBookB4Arr\">\r\n                   <td class='col-xs-1' class=\"text-center\" \r\n                        style=\"border-bottom: none;border-top: none;font-size: 14px;font-family: Arial;\">{{tafBookElem.locid}}</td>\r\n                   <td class='col-xs-1' class=\"text-nowrap\" \r\n                        style=\"border-bottom: none;border-top: none;font-size: 14px;font-family: Arial;\">{{tafBookElem.region}}</td>\r\n                   <td class='col-xs-1' class=\"text-nowrap\" \r\n                        style=\"border-bottom: none;border-top: none;font-size: 14px;font-family: Arial;\">{{tafBookElem.aportName}}</td>\r\n                   <td class='col-xs-1' class=\"text-nowrap\" \r\n                        style=\"border-bottom: none;border-top: none;font-size: 14px;font-family: Arial;\">{{tafBookElem.city}},{{tafBookElem.state}}</td>\r\n               </tr>\r\n               <tr><td class='col-xs-1' colspan=\"4\" style=\"border-top: 2px solid black;\">&nbsp;</td></tr>\r\n           </tbody>\r\n            \r\n       </table>\r\n    </div>\r\n </div>"

/***/ },

/***/ 821:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var taf_book_b5_service_1 = __webpack_require__(686);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var primeng_3 = __webpack_require__(708);
	var TAFBookB5Component = (function () {
	    function TAFBookB5Component(route, router, _tafBookB5Service) {
	        this.route = route;
	        this.router = router;
	        this._tafBookB5Service = _tafBookB5Service;
	        this.pageTitle = 'TAF BOOK b5';
	    }
	    TAFBookB5Component.prototype.ngOnInit = function () {
	        var _this = this;
	        this._tafBookB5Service.getTAFBookB5()
	            .subscribe(function (tafBookB5Arr) { return _this.tafBookB5Arr = tafBookB5Arr; }, function (error) { return _this.errorMessage = error; });
	    };
	    TAFBookB5Component.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    TAFBookB5Component = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/tafbooks/taf-book-b5/taf-book-b5.component.html',
	            template: __webpack_require__(822),
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.DataTable, primeng_2.Column, primeng_3.Header],
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, taf_book_b5_service_1.TAFBookB5Service])
	    ], TAFBookB5Component);
	    return TAFBookB5Component;
	}());
	exports.TAFBookB5Component = TAFBookB5Component;


/***/ },

/***/ 822:
/***/ function(module, exports) {

	module.exports = " <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/\r\n        <a [routerLink]=\"['/tafbooks']\" style=\"color: white; text-decoration:underline\">TAF Book</a>/{{pageTitle}}\r\n    </div>\r\n\r\n    <div class=\"container\" style=\"width:100%\">\r\n       <table class=\"table borderless\">\r\n           <thead>\r\n                <tr>\r\n                    <th colspan='4'  class='col-xs-3' style=\"border: none;\" class=\"text-center\">\r\n                        Table B-3 List of Small Hub Towers \r\n                    </th>\r\n                </tr>\r\n                <tr>\r\n                    <th colspan='1' class=\"text-center\" class='col-xs-1' style=\"border: none;\"><b>Location</b></th>\r\n                    <th colspan='1' id='Blank'  class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th colspan='1' id='Blank'  class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                    <th colspan='1' id='Blank'  class='col-xs-1' style=\"border: none;\">&nbsp;</th>\r\n                </tr>\r\n                <tr>\r\n                    <th colspan='1' width='10%' class='text-center' class='col-xs-1' \r\n                            style=\"border-bottom: 2px solid black;border-top: none;\"><b>Identifier</b></th>\r\n                    <th colspan='1' width='30%'  class='col-xs-1' \r\n                            style=\"border-bottom: 2px solid black;border-top: none;\"><b>Region</b></th>\r\n                    <th colspan='1' width='50%'  class='col-xs-1' \r\n                            style=\"border-bottom: 2px solid black;border-top: none;\"><b>Airport Name</b></th>\r\n                    <th colspan='1' width='30%'  class='col-xs-1' \r\n                            style=\"border-bottom: 2px solid black;border-top: none;\"><b>City, State</b></th>\r\n                </tr>\r\n           </thead>\r\n           <tbody >\r\n               <tr *ngFor=\"let tafBookElem of tafBookB5Arr\">\r\n                   <td class='col-xs-1' class=\"text-center\" \r\n                        style=\"border-bottom: none;border-top: none;font-size: 14px;font-family: Arial;\">{{tafBookElem.locid}}</td>\r\n                   <td class='col-xs-1' class=\"text-nowrap\" \r\n                        style=\"border-bottom: none;border-top: none;font-size: 14px;font-family: Arial;\">{{tafBookElem.region}}</td>\r\n                   <td class='col-xs-1' class=\"text-nowrap\" \r\n                        style=\"border-bottom: none;border-top: none;font-size: 14px;font-family: Arial;\">{{tafBookElem.aportName}}</td>\r\n                   <td class='col-xs-1' class=\"text-nowrap\" \r\n                        style=\"border-bottom: none;border-top: none;font-size: 14px;font-family: Arial;\">{{tafBookElem.city}},{{tafBookElem.state}}</td>\r\n               </tr>\r\n               <tr><td class='col-xs-1' colspan=\"4\" style=\"border-top: 2px solid black;\">&nbsp;</td></tr>\r\n           </tbody>\r\n            \r\n       </table>\r\n    </div>\r\n </div>"

/***/ },

/***/ 823:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var staffing_standards_tracon_component_1 = __webpack_require__(824);
	var staffing_standards_tower_component_1 = __webpack_require__(827);
	var towers_tracons_import_component_1 = __webpack_require__(830);
	exports.StaffingStandardsRoutes = [
	    //all staffingstandardsroutes routes here
	    { path: 'staffing-standards-tracon', component: staffing_standards_tracon_component_1.StaffingStandardsTraconComponent },
	    { path: 'staffing-standards-tower', component: staffing_standards_tower_component_1.StaffingStandardsTowerComponent },
	    { path: 'towers-tracons-import', component: towers_tracons_import_component_1.TowersTraconsImportComponent },
	];


/***/ },

/***/ 824:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var staffing_standards_tracon_service_1 = __webpack_require__(825);
	var user_session_1 = __webpack_require__(699);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var primeng_3 = __webpack_require__(708);
	var primeng_4 = __webpack_require__(708);
	var StaffingStandardsTraconComponent = (function () {
	    function StaffingStandardsTraconComponent(route, router, _staffingStandardsTraconService, User) {
	        this.route = route;
	        this.router = router;
	        this._staffingStandardsTraconService = _staffingStandardsTraconService;
	        this.User = User;
	        this.pageTitle = 'Staffing Standards Tracon';
	    }
	    StaffingStandardsTraconComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.scenario = this.User.getSession().scenarioId;
	        this._staffingStandardsTraconService.getSSTracon(this.scenario)
	            .subscribe(function (staffingStandardsTraconArr) { return _this.staffingStandardsTraconArr = staffingStandardsTraconArr; }, function (error) { return _this.errorMessage = error; });
	        this.cols = [
	            { field: "locid", header: 'Locid' },
	            { field: "year", header: 'Year' },
	            { field: "ac", header: 'Air Carrier' },
	            { field: "at", header: 'Air Taxi' },
	            { field: "ga", header: 'General Aviation' },
	            { field: "mil", header: 'Military' },
	            { field: "totOvers", header: 'Total Overflights' },
	            { field: "totOps", header: 'Total Operations' },
	        ];
	        // console.log('Staffing Standards Tracon Component: ' +  JSON.stringify(this.cols));
	    };
	    StaffingStandardsTraconComponent.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    StaffingStandardsTraconComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/staffing-standards/staffing-standards-tracon/staffing-standards-tracon.component.html',
	            template: __webpack_require__(826),
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.DataTable, primeng_2.Column, primeng_3.Header, primeng_4.Paginator],
	            providers: [staffing_standards_tracon_service_1.StaffingStandardsTraconService]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, staffing_standards_tracon_service_1.StaffingStandardsTraconService, user_session_1.UserSession])
	    ], StaffingStandardsTraconComponent);
	    return StaffingStandardsTraconComponent;
	}());
	exports.StaffingStandardsTraconComponent = StaffingStandardsTraconComponent;


/***/ },

/***/ 825:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var StaffingStandardsTraconService = (function () {
	    function StaffingStandardsTraconService(httpHelper) {
	        this.httpHelper = httpHelper;
	        //need to have this somewhere besides hardcoded in here
	        //private _staffingStandardsTraconUrl = `http://localhost:55706/api/systemmanagement/SSTracon`;
	        this._staffingStandardsTraconUrl = "api/systemmanagement/SSTracon";
	    }
	    StaffingStandardsTraconService.prototype.getSSTracon = function (scenarioId) {
	        return this.httpHelper.get(this._staffingStandardsTraconUrl + "/" + scenarioId);
	        //.map((response: Response) => <IStaffingStandardsTracon> response.json())
	        //.do(data => console.log('IStaffingStandardsTracon: ' +  JSON.stringify(data)))
	        //.catch(this.handleError);
	    };
	    StaffingStandardsTraconService.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    StaffingStandardsTraconService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], StaffingStandardsTraconService);
	    return StaffingStandardsTraconService;
	}());
	exports.StaffingStandardsTraconService = StaffingStandardsTraconService;


/***/ },

/***/ 826:
/***/ function(module, exports) {

	module.exports = "<div class='panel panel-primary'>\r\n    <div class='panel-heading' >\r\n       <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n    <div class='has-error' *ngIf='errorMessage'>{{errorMessage}}</div>\r\n    <div class='panel-body' style=\"width:100%; height: 100%\">\r\n        <div>Staffing Standards Tracon export:</div>\r\n        \r\n        <p-dataTable  #dt [value]=\"staffingStandardsTraconArr\" [rows]=\"31\" [paginator]=\"true\" [pageLinks]=\"3\" [rowsPerPageOptions]=\"[5,10,20,31]\">\r\n             <header>\r\n                <div class=\"ui-helper-clearfix\">\r\n                    <button type=\"button\" pButton  iconPos=\"left\" label=\" \" (click)=\"dt.exportCSV()\" style=\"float:left\">\r\n                         <i class=\"fa fa-file-text-o \" aria-hidden=\"true\"> Export To CSV</i>\r\n                    </button>\r\n                </div>\r\n            </header>\r\n            <p-column *ngFor=\"let col of cols\" [field]=\"col.field\" [header]=\"col.header\"></p-column>\r\n        </p-dataTable>\r\n    </div>\r\n</div>"

/***/ },

/***/ 827:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var staffing_standards_tower_service_1 = __webpack_require__(828);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var primeng_3 = __webpack_require__(708);
	var primeng_4 = __webpack_require__(708);
	var StaffingStandardsTowerComponent = (function () {
	    function StaffingStandardsTowerComponent(route, router, _staffingStandardsTowerService) {
	        this.route = route;
	        this.router = router;
	        this._staffingStandardsTowerService = _staffingStandardsTowerService;
	        this.pageTitle = 'Staffing Standards Tower';
	    }
	    StaffingStandardsTowerComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._staffingStandardsTowerService.getSSTower()
	            .subscribe(function (staffingStandardsTowerArr) { return _this.staffingStandardsTowerArr = staffingStandardsTowerArr; }, function (error) { return _this.errorMessage = error; });
	        this.cols = [
	            { field: "locid", header: 'Locid' },
	            { field: "year", header: 'Year' },
	            { field: "itnAc", header: 'Air Carrier' },
	            { field: "itnAt", header: 'Air Taxi' },
	            { field: "itnGa", header: 'General Aviation' },
	            { field: "itnMil", header: 'Military' },
	            { field: "locGa", header: 'Civil' },
	            { field: "locMil", header: 'Local Military' },
	            { field: "totOvers", header: 'Total Overflights' },
	            { field: "totOps", header: 'Total Operations' },
	        ];
	        //console.log('Staffing Standards Tower Component: ' +  JSON.stringify(this.cols));
	    };
	    StaffingStandardsTowerComponent.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    StaffingStandardsTowerComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/staffing-standards/staffing-standards-tower/staffing-standards-tower.component.html',
	            template: __webpack_require__(829),
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.DataTable, primeng_2.Column, primeng_3.Header, primeng_4.Paginator],
	            providers: [staffing_standards_tower_service_1.StaffingStandardsTowerService]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, staffing_standards_tower_service_1.StaffingStandardsTowerService])
	    ], StaffingStandardsTowerComponent);
	    return StaffingStandardsTowerComponent;
	}());
	exports.StaffingStandardsTowerComponent = StaffingStandardsTowerComponent;


/***/ },

/***/ 828:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var StaffingStandardsTowerService = (function () {
	    function StaffingStandardsTowerService(httpHelper) {
	        this.httpHelper = httpHelper;
	        //need to have this somewhere besides hardcoded in here
	        //private _staffingStandardsTowerUrl = `http://localhost:55706/api/systemmanagement/SSTower`;
	        this._staffingStandardsTowerUrl = "api/systemmanagement/SSTower";
	    }
	    StaffingStandardsTowerService.prototype.getSSTower = function () {
	        return this.httpHelper.get("" + this._staffingStandardsTowerUrl);
	        //.map((response: Response) => <IStaffingStandardsTower> response.json())
	        //.do(httpHelper => console.log('IStaffingStandardsTower: ' +  JSON.stringify(data)))
	        //.catch(this.handleError);
	    };
	    StaffingStandardsTowerService.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    StaffingStandardsTowerService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], StaffingStandardsTowerService);
	    return StaffingStandardsTowerService;
	}());
	exports.StaffingStandardsTowerService = StaffingStandardsTowerService;


/***/ },

/***/ 829:
/***/ function(module, exports) {

	module.exports = "<div class='panel panel-primary'>\r\n    <div class='panel-heading' >\r\n       <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n    <div class='has-error' *ngIf='errorMessage'>{{errorMessage}}</div>\r\n    <div class='panel-body' style=\"width:100%; height: 100%\">\r\n        <div>Staffing Standards Tracon export:</div>\r\n        \r\n        <p-dataTable  #dt [value]=\"staffingStandardsTowerArr\" [rows]=\"31\" [paginator]=\"true\" [pageLinks]=\"3\" [rowsPerPageOptions]=\"[5,10,20,31]\">\r\n             <header>\r\n                <div class=\"ui-helper-clearfix\">\r\n                    <button type=\"button\" pButton  iconPos=\"left\" label=\" \" (click)=\"dt.exportCSV()\" style=\"float:left\">\r\n                         <i class=\"fa fa-file-text-o \" aria-hidden=\"true\"> Export To CSV</i>\r\n                    </button>\r\n                </div>\r\n            </header>\r\n            <p-column *ngFor=\"let col of cols\" [field]=\"col.field\" [header]=\"col.header\"></p-column>\r\n        </p-dataTable>\r\n    </div>\r\n</div>"

/***/ },

/***/ 830:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var towers_tracons_import_service_1 = __webpack_require__(831);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var primeng_3 = __webpack_require__(708);
	var TowersTraconsImportComponent = (function () {
	    function TowersTraconsImportComponent(route, router, _towerstraconsImportService) {
	        this.route = route;
	        this.router = router;
	        this._towerstraconsImportService = _towerstraconsImportService;
	        this.pageTitle = 'Towers Tracons OPSNET Import Check ';
	    }
	    TowersTraconsImportComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._towerstraconsImportService.getTowersImport()
	            .subscribe(function (towersImportResult) { return _this.towersImportResult = towersImportResult; }, function (error) { return _this.errorMessage = error; });
	        this.cols = [
	            { field: "opsAc", header: 'OPSNET Air Carrier' },
	            { field: "opsAt", header: 'OPSNET Air Taxi' },
	            { field: "opsGa", header: 'OPSNET General Aviation' },
	            { field: "opsMil", header: 'OPSNET Military' },
	            { field: "opsLocGa", header: 'OPSNET Civil' },
	            { field: "opsLocMil", header: 'OPSNET Local Military' },
	            { field: "opsTotOvers", header: 'OPSNET Total Overflights' },
	        ];
	        this.cols1 = [
	            { field: "tafAc", header: 'TAF Air Carrier' },
	            { field: "tafAt", header: 'TAF Air Taxi' },
	            { field: "tafGa", header: 'TAF General Aviation' },
	            { field: "tafMil", header: 'TAF Military' },
	            { field: "tafLocGa", header: 'TAF Civil' },
	            { field: "tafLocMil", header: 'TAF Local Military' },
	            { field: "tafTotOvers", header: 'TAF Total Overflights' },
	        ];
	        this.cols2 = [
	            { field: "diffAc", header: 'DIFF Air Carrier' },
	            { field: "diffAt", header: 'DIFF Air Taxi' },
	            { field: "diffGa", header: 'DIFF General Aviation' },
	            { field: "diffMil", header: 'DIFF Military' },
	            { field: "diffLocGa", header: 'DIFF Civil' },
	            { field: "diffLocMil", header: 'DIFF Local Military' },
	            { field: "diffTotOvers", header: 'DIFF Total Overflights' },
	        ];
	    };
	    TowersTraconsImportComponent.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    TowersTraconsImportComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/towers-tracons-import/towers-tracons-import.component.html',
	            template: __webpack_require__(832),
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.DataTable, primeng_2.Column, primeng_3.Header],
	            providers: [towers_tracons_import_service_1.TowersTraconsImportService]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, towers_tracons_import_service_1.TowersTraconsImportService])
	    ], TowersTraconsImportComponent);
	    return TowersTraconsImportComponent;
	}());
	exports.TowersTraconsImportComponent = TowersTraconsImportComponent;


/***/ },

/***/ 831:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var TowersTraconsImportService = (function () {
	    function TowersTraconsImportService(httpHelper) {
	        this.httpHelper = httpHelper;
	        //need to have this somewhere besides hardcoded in here
	        //private _towersImportUrl = `http://localhost:55706/api/systemmanagement/TowersImport`;
	        this._towersImportUrl = "api/systemmanagement/TowersImport";
	    }
	    TowersTraconsImportService.prototype.getTowersImport = function () {
	        return this.httpHelper.get("" + this._towersImportUrl);
	        //.map((response: Response) => <ITowersTraconsImport> response.json())
	        //.do(data => console.log('Towers Import service: ' +  JSON.stringify(data)))
	        //.catch(this.handleError);
	    };
	    TowersTraconsImportService.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    TowersTraconsImportService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], TowersTraconsImportService);
	    return TowersTraconsImportService;
	}());
	exports.TowersTraconsImportService = TowersTraconsImportService;


/***/ },

/***/ 832:
/***/ function(module, exports) {

	module.exports = "<div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n\r\n    <h3 align=\"center\"> Tower Comparison OPSNET -TAF </h3>    \r\n      <p-dataTable  [value]=\"towersImportResult\" >\r\n            <p-column *ngFor=\"let col of cols\" [field]=\"col.field\" [header]=\"col.header\"></p-column>\r\n      </p-dataTable>\r\n        <p-dataTable  [value]=\"towersImportResult\" >\r\n            <p-column *ngFor=\"let col of cols1\" [field]=\"col.field\" [header]=\"col.header\"></p-column>\r\n      </p-dataTable>\r\n     <p-dataTable  [value]=\"towersImportResult\" >\r\n            <p-column *ngFor=\"let col of cols2\" [field]=\"col.field\" [header]=\"col.header\"></p-column>\r\n      </p-dataTable>\r\n      <h3 align=\"center\"> TRACONS Comparison OPSNET -TAF </h3>  \r\n</div>"

/***/ },

/***/ 833:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var growth_rates_component_1 = __webpack_require__(800);
	var growth_rates_save_component_1 = __webpack_require__(834);
	var set_hub_sizes_component_1 = __webpack_require__(837);
	exports.GrowthRatesRoutes = [
	    //all Growthrates routes here
	    { path: 'growth-rates', component: growth_rates_component_1.GrowthRatesComponent },
	    { path: 'growth-rates-save', component: growth_rates_save_component_1.GrowthRatesSaveComponent },
	    { path: 'set-hub-sizes', component: set_hub_sizes_component_1.SetHubSizesComponent },
	];


/***/ },

/***/ 834:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var growth_rates_save_1 = __webpack_require__(835);
	var growth_rates_save_service_1 = __webpack_require__(801);
	var user_session_1 = __webpack_require__(699);
	var user_info_service_1 = __webpack_require__(695);
	var scenario_service_1 = __webpack_require__(692);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var GrowthRatesSaveComponent = (function () {
	    function GrowthRatesSaveComponent(route, router, _growthRatesService, _scenarioService, User, _userInfoService) {
	        this.route = route;
	        this.router = router;
	        this._growthRatesService = _growthRatesService;
	        this._scenarioService = _scenarioService;
	        this.User = User;
	        this._userInfoService = _userInfoService;
	        this.pageTitle = 'Growth Rates Save ';
	        this.displaySpinner = false;
	        this.msgs = [];
	        this.isScenarioOwner = false;
	        this.growthRatesSaveResult = new growth_rates_save_1.IGrowthRatesSave("");
	    }
	    GrowthRatesSaveComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
	        this._scenarioService.getScenarios(this.User.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.setScenarioHeader(_this.User.getSession().scenarioId);
	        });
	        //this probably needs to be somewhere more central
	        this.User.updateSessionState();
	        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(function (success) { return _this.isScenarioOwner = success.isOwner; }, function (error) { return _this.errorMessage = error; });
	        this.displaySpinner = true;
	        this._growthRatesService.getSavedRatesResponse(this.User.getSession().scenarioId)
	            .subscribe(function (growthRatesSaveResult) {
	            _this.growthRatesSaveResult = growthRatesSaveResult;
	            if (_this.growthRatesSaveResult.message.indexOf("Error") >= 0) {
	                _this.displaySpinner = false;
	                _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: _this.growthRatesSaveResult.message });
	                console.error(_this.growthRatesSaveResult.message);
	            }
	            else {
	                _this.displaySpinner = false;
	                _this.msgs.push({ severity: 'info', summary: 'Info Message', detail: _this.growthRatesSaveResult.message });
	            }
	        }, function (error) {
	            _this.displaySpinner = false;
	            _this.errorMessage = "An error occured while trying to update the facility.";
	            _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: _this.errorMessage });
	            console.error(error);
	        });
	    };
	    GrowthRatesSaveComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	        this.scenarioHeaderDiv.innerHTML = "<strong>Current Scenario: " + this.currentScenario.scenarioName + " (" + this.currentScenario.id + ")</strong>";
	    };
	    GrowthRatesSaveComponent.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    __decorate([
	        core_1.ViewChild('scenarioHeader'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], GrowthRatesSaveComponent.prototype, "scenarioHeader", void 0);
	    GrowthRatesSaveComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/growth-rates/growth-rates-save/growth-rates-save.component.html',
	            template: __webpack_require__(836),
	            styles: [__webpack_require__(700)],
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.Dialog, primeng_2.Messages],
	            providers: [growth_rates_save_service_1.GrowthRatesSaveService]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, growth_rates_save_service_1.GrowthRatesSaveService, scenario_service_1.ScenarioService, user_session_1.UserSession, user_info_service_1.UserInfoService])
	    ], GrowthRatesSaveComponent);
	    return GrowthRatesSaveComponent;
	}());
	exports.GrowthRatesSaveComponent = GrowthRatesSaveComponent;


/***/ },

/***/ 835:
/***/ function(module, exports) {

	"use strict";
	var IGrowthRatesSave = (function () {
	    function IGrowthRatesSave(message) {
	        this.message = message;
	    }
	    return IGrowthRatesSave;
	}());
	exports.IGrowthRatesSave = IGrowthRatesSave;


/***/ },

/***/ 836:
/***/ function(module, exports) {

	module.exports = "  <div class=\"current-scenario\" #scenarioHeader></div>\r\n  <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n    <!--<div class='panel-body' *ngIf=\"growthRatesSaveResult?.message==''\" align=\"center\">\r\n        <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n        <div>Loading please wait ....</div>\r\n    </div>-->\r\n    <div class='panel-body'>\r\n        <p-dialog  [(visible)]=\"displaySpinner\" [modal]=true   [closable]=false showEffect=\"fade\">\r\n            <div align=\"center\">\r\n                <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n                <div>Loading please wait ....</div>\r\n                <div>Do Not click back or Refresh the page</div>\r\n            </div>\r\n        </p-dialog>\r\n        <div  *ngIf=\"growthRatesSaveResult?.message!=''\">\r\n            <br>\r\n            <div>\r\n                Message: {{ growthRatesSaveResult?.message }}\r\n            <div>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ },

/***/ 837:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var set_hub_sizes_1 = __webpack_require__(838);
	var set_hub_sizes_service_1 = __webpack_require__(802);
	var SetHubSizesComponent = (function () {
	    function SetHubSizesComponent(route, router, _setHubSizesService) {
	        this.route = route;
	        this.router = router;
	        this._setHubSizesService = _setHubSizesService;
	        this.pageTitle = 'Set Hub Sizes';
	        this.setHubSizesResult = new set_hub_sizes_1.ISetHubSizes("Completed set hub sizes stored procedure");
	    }
	    SetHubSizesComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._setHubSizesService.getSetHubSizesResponse()
	            .subscribe(function (setHubSizesResult) { return _this.setHubSizesResult = setHubSizesResult; }, function (error) { return _this.errorMessage = error; });
	    };
	    SetHubSizesComponent.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    SetHubSizesComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/growth-rates/set-hub-sizes/set-hub-sizes.component.html',
	            template: __webpack_require__(839),
	            directives: [router_1.ROUTER_DIRECTIVES],
	            providers: [set_hub_sizes_service_1.SetHubSizesService]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, set_hub_sizes_service_1.SetHubSizesService])
	    ], SetHubSizesComponent);
	    return SetHubSizesComponent;
	}());
	exports.SetHubSizesComponent = SetHubSizesComponent;


/***/ },

/***/ 838:
/***/ function(module, exports) {

	"use strict";
	var ISetHubSizes = (function () {
	    function ISetHubSizes(message) {
	        this.message = message;
	    }
	    return ISetHubSizes;
	}());
	exports.ISetHubSizes = ISetHubSizes;


/***/ },

/***/ 839:
/***/ function(module, exports) {

	module.exports = "  <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n    <div class='panel-body' *ngIf=\"setHubSizesResult?.message==''\" align=\"center\">\r\n        <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n        <div>Loading please wait ....</div>\r\n    </div>\r\n    <div  *ngIf=\"setHubSizesResult?.message!=''\">\r\n        Message: {{ setHubSizesResult?.message }}\r\n    </div>\r\n</div>\r\n"

/***/ },

/***/ 840:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var towers_tracons_import_steps_component_1 = __webpack_require__(841);
	exports.TowersTraconsImportStepsRoutes = [
	    //all Growthrates routes here
	    { path: 'towers-tracons-import-steps', component: towers_tracons_import_steps_component_1.TowersTraconsImportStepsComponent },
	];


/***/ },

/***/ 841:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var towers_tracons_import_steps_service_1 = __webpack_require__(842);
	var system_control_service_1 = __webpack_require__(694);
	var system_control_1 = __webpack_require__(843);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var primeng_3 = __webpack_require__(708);
	var primeng_4 = __webpack_require__(708);
	var TowersTraconsImportStepsComponent = (function () {
	    function TowersTraconsImportStepsComponent(route, router, _towerstraconsImportService, _systemControl, _systemControlService) {
	        this.route = route;
	        this.router = router;
	        this._towerstraconsImportService = _towerstraconsImportService;
	        this._systemControl = _systemControl;
	        this._systemControlService = _systemControlService;
	        this.pageTitle = 'Towers Tracons Import Steps ';
	        this.showSpinner = false;
	        this.showDataTable = false;
	        this.showOpsnetImportMsg = false;
	        this.showAOPSReforecastMsg = false;
	        this.systemControl = _systemControl;
	    }
	    TowersTraconsImportStepsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        // this.fyYear=this.systemControl.getFyYear();
	        //  alert(" ngOnInit this.fyYear " + this.fyYear);
	        this._systemControlService.getSystemControl()
	            .subscribe(function (systemControlElem) { return _this.systemControlElem = systemControlElem; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.fyYear = _this.systemControlElem.fyYear;
	            console.log("fyYear and ffcYear in SystemControl:" + _this.fyYear);
	        });
	    };
	    TowersTraconsImportStepsComponent.prototype.getTowersImportStepsLess12 = function () {
	        var _this = this;
	        this.showSpinner = true;
	        this._towerstraconsImportService.getTowersImportStepsLess12()
	            .subscribe(function (towersLessThan12) { return _this.towersLessThan12 = towersLessThan12; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.showDataTable = true;
	            _this.showSpinner = false;
	        });
	        this.cols = [
	            { field: "locid", header: 'Locid' },
	            { field: "sumAc", header: ' Air Carrier' },
	            { field: "sumAt", header: ' Air Taxi' },
	            { field: "sumGa", header: ' General Aviation' },
	            { field: "sumMil", header: ' Military' },
	            { field: "sumLocGa", header: ' Civil' },
	            { field: "sumLocMil", header: ' Local Military' },
	            { field: "sumTotOvers", header: ' Total Overflights' },
	        ];
	    };
	    TowersTraconsImportStepsComponent.prototype.startOpsnetTowersImport = function () {
	        var _this = this;
	        this.showSpinner = true;
	        this._towerstraconsImportService.startOpsnetTowersImport()
	            .subscribe(function (towersImportMsg) { return _this.towersImportMsg = towersImportMsg; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.showOpsnetImportMsg = true;
	            _this.showSpinner = false;
	        });
	    };
	    TowersTraconsImportStepsComponent.prototype.reforecastAOPS = function () {
	        var _this = this;
	        this.showSpinner = true;
	        this._towerstraconsImportService.reforecastAOPS()
	            .subscribe(function (towersReforecastMsg) { return _this.towersReforecastMsg = towersReforecastMsg; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.showAOPSReforecastMsg = true;
	            _this.showSpinner = false;
	        });
	    };
	    TowersTraconsImportStepsComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/towers-tracons-import/towers-tracons-import.component.html',
	            template: __webpack_require__(844),
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.DataTable, primeng_2.Column, primeng_3.Header, primeng_4.Paginator],
	            providers: [towers_tracons_import_steps_service_1.TowersTraconsImportStepsService, system_control_1.SystemControl]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, towers_tracons_import_steps_service_1.TowersTraconsImportStepsService, system_control_1.SystemControl, system_control_service_1.SystemControlService])
	    ], TowersTraconsImportStepsComponent);
	    return TowersTraconsImportStepsComponent;
	}());
	exports.TowersTraconsImportStepsComponent = TowersTraconsImportStepsComponent;


/***/ },

/***/ 842:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var TowersTraconsImportStepsService = (function () {
	    function TowersTraconsImportStepsService(httpHelper) {
	        this.httpHelper = httpHelper;
	        this._towersImporStepsLess12tUrl = "api/systemmanagement";
	    }
	    TowersTraconsImportStepsService.prototype.getTowersImportStepsLess12 = function () {
	        return this.httpHelper.get(this._towersImporStepsLess12tUrl + "/TowersImportStepsLess12");
	    };
	    TowersTraconsImportStepsService.prototype.startOpsnetTowersImport = function () {
	        return this.httpHelper.get(this._towersImporStepsLess12tUrl + "/TowersOpsnetImport");
	    };
	    TowersTraconsImportStepsService.prototype.reforecastAOPS = function () {
	        return this.httpHelper.get(this._towersImporStepsLess12tUrl + "/TowersReforecastAops");
	    };
	    TowersTraconsImportStepsService.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    TowersTraconsImportStepsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], TowersTraconsImportStepsService);
	    return TowersTraconsImportStepsService;
	}());
	exports.TowersTraconsImportStepsService = TowersTraconsImportStepsService;


/***/ },

/***/ 843:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var system_control_service_1 = __webpack_require__(694);
	/*@Component({
	    //templateUrl: 'app/system-management/growth-rates/growth-rates-save/growth-rates-save.component.html',
	    template:`<div></div>`,
	    directives: [ROUTER_DIRECTIVES],
	    providers:[SystemControlService]
	    
	})*/
	var SystemControl = (function () {
	    function SystemControl(_systemControlService) {
	        this._systemControlService = _systemControlService;
	        this.callService();
	    }
	    SystemControl.prototype.callService = function () {
	        var _this = this;
	        this._systemControlService.getSystemControl()
	            .subscribe(function (systemControlElem) { return _this.systemControlElem = systemControlElem; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.fyYear = _this.systemControlElem.fyYear;
	            _this.ffcYear = _this.systemControlElem.ffcYear;
	            _this.importStage = _this.systemControlElem.importStage;
	            _this.lfcYear = _this.systemControlElem.lfcYear;
	            _this.mangrLock = _this.systemControlElem.mangrLock;
	        });
	    };
	    SystemControl = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [system_control_service_1.SystemControlService])
	    ], SystemControl);
	    return SystemControl;
	}());
	exports.SystemControl = SystemControl;


/***/ },

/***/ 844:
/***/ function(module, exports) {

	module.exports = "<div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n    <div class='panel-body'>\r\n        <div  *ngIf=\"showSpinner\" align=\"center\">\r\n                <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n                <div>Loading please wait ....</div>\r\n        </div>\r\n         \r\n        <ul>\r\n            <li>Save rates for each year (2014-2015,etc) National Scenario (1).  \r\n                <a [routerLink]=\"['../growth-rates']\" style=\"color: black; text-decoration:underline\">(Start process)</a>\r\n            </li>\r\n            <li>Import actual {{fyYear}} operations from OPSNET to a temporary table in TAF.\r\n                This process is manual export from aspm OPSNET to VM then import into sql.    \r\n            </li>\r\n            <li>Review OPSNET facilities with less/more than 12 month of operations\r\n                <button class=\"btn btn-link\" (click)=\"getTowersImportStepsLess12();\">Display Report</button></li>\r\n            <div *ngIf=\"showDataTable\">\r\n                <p-dataTable  [value]=\"towersLessThan12\" >\r\n                    <p-column *ngFor=\"let col of cols\" [field]=\"col.field\" [header]=\"col.header\"></p-column>\r\n                </p-dataTable>\r\n            </div>\r\n            <li>Import actual 2015 operations from temporary table into airport operations  \r\n                <button class=\"btn btn-link\" (click)=\"startOpsnetTowersImport();\">Start Import</button></li>\r\n            <div *ngIf=\"showOpsnetImportMsg\" class=\"alert alert-info\"> Data Import Message: {{towersImportMsg?.message}}</div>\r\n            <li>Apply Growth Rate to new base.\r\n                <button class=\"btn btn-link\" (click)=\"reforecastAOPS();\">Start AOPS Reforecast</button></li>\r\n            <div *ngIf=\"showAOPSReforecastMsg\" class=\"alert alert-info\"> Data Import Message: {{towersReforecastMsg?.message}}</div>    \r\n        </ul>  \r\n    </div>\r\n</div>"

/***/ },

/***/ 845:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var new_year_rollover_component_1 = __webpack_require__(846);
	var new_year_rollover_steps_component_1 = __webpack_require__(848);
	var new_year_rollover_reports_component_1 = __webpack_require__(853);
	exports.NewYearRolloverRoutes = [
	    { path: 'new-year-rollover', component: new_year_rollover_component_1.NewYearRolloverComponent },
	    { path: 'new-year-rollover-steps', component: new_year_rollover_steps_component_1.NewYearStepsComponent },
	    { path: 'new-year-rollover-reports', component: new_year_rollover_reports_component_1.NewYearReportsComponent },
	];


/***/ },

/***/ 846:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var NewYearRolloverComponent = (function () {
	    function NewYearRolloverComponent(route, router) {
	        this.route = route;
	        this.router = router;
	        this.pageTitle = 'New Year Rollover';
	    }
	    NewYearRolloverComponent.prototype.ngOnInit = function () {
	    };
	    NewYearRolloverComponent.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    NewYearRolloverComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/new-year-rollover/new-year-rollover.component.html',
	            template: __webpack_require__(847),
	            directives: [router_1.ROUTER_DIRECTIVES],
	            providers: []
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router])
	    ], NewYearRolloverComponent);
	    return NewYearRolloverComponent;
	}());
	exports.NewYearRolloverComponent = NewYearRolloverComponent;


/***/ },

/***/ 847:
/***/ function(module, exports) {

	module.exports = "  <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n    <div class='panel-body'>\r\n       <ul>\r\n         <li><a [routerLink]=\"['/new-year-rollover-steps']\">New Year Rollover Steps</a></li>\r\n         <li><a [routerLink]=\"['/new-year-rollover-reports']\">New Year Rollover Reports</a></li>\r\n       </ul>\r\n    </div>\r\n</div>"

/***/ },

/***/ 848:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var new_year_rollover_steps_1 = __webpack_require__(849);
	var new_year_rollover_steps_service_1 = __webpack_require__(850);
	var system_control_1 = __webpack_require__(843);
	var system_control_service_1 = __webpack_require__(694);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var NewYearStepsComponent = (function () {
	    function NewYearStepsComponent(route, router, _newYearRolloverService, _systemControlService) {
	        this.route = route;
	        this.router = router;
	        this._newYearRolloverService = _newYearRolloverService;
	        this._systemControlService = _systemControlService;
	        this.pageTitle = 'New Year Steps';
	        this.displaySpinner = false;
	        this.msgs = [];
	        this.systemControl = new system_control_1.SystemControl(_systemControlService);
	        this.newYearRequest = new new_year_rollover_steps_1.INewYearRollOverRequest(this.systemControl.importStage);
	    }
	    NewYearStepsComponent.prototype.ngOnInit = function () {
	        this.newYearRolloverList = [new new_year_rollover_steps_1.INewYearRollOverDisplayElem({ stepNumber: 1, stepName: 'ManagerLock', stepDescription: '' }),
	            new new_year_rollover_steps_1.INewYearRollOverDisplayElem({ stepNumber: 2, stepName: 'Set up New Year Rollover',
	                stepDescription: 'The following tasks will be completed: Delete all scenario with id >1 Populate SAVED RATES Set Regional Input to false if regional input end year is less than first forecast year' }),
	            new new_year_rollover_steps_1.INewYearRollOverDisplayElem({ stepNumber: 3, stepName: 'EMDF/NPIAS Facility Data Preparation', stepDescription: ' Before running step 3 make sure EMDF/NPIAS tables are populated in database. The following steps must be completed before import is permitted:Comparison list between TAF and EMDF/NPIAS prepared FAA revisions to the list made FAA revisions incorporated into import' }),
	            new new_year_rollover_steps_1.INewYearRollOverDisplayElem({ stepNumber: 4, stepName: 'Import EMDF/NPIAS Facility Data', stepDescription: ' Check New Year Rollover Reports before running step 4.' }),
	            new new_year_rollover_steps_1.INewYearRollOverDisplayElem({ stepNumber: 5, stepName: ' for OPSNet facilities', stepDescription: 'Bring in OPSNet tower data before running step 5.' }),
	            new new_year_rollover_steps_1.INewYearRollOverDisplayElem({ stepNumber: 6, stepName: 'Tracon Ops Import for OPSNet facilities ', stepDescription: 'Bring in OPSNet TRACON data before running step 6.' }),
	            new new_year_rollover_steps_1.INewYearRollOverDisplayElem({ stepNumber: 7, stepName: 'NFDC Data Preparation  - Facilities, Facility Detail', stepDescription: 'The following steps must be completed before import is permitted: Comparison list between TAF and NFDC prepared APO revisions to the list made APO revisions incorporated into import' }),
	            new new_year_rollover_steps_1.INewYearRollOverDisplayElem({ stepNumber: 8, stepName: 'Import NFDC Data - AOPS, Based Aircraft  ', stepDescription: 'The following tasks will be completed:  Import facilities Import facility details for all facilities Import AOPS for non-OPSNet facilities Import Based Aircraft for all facilities' }),
	            new new_year_rollover_steps_1.INewYearRollOverDisplayElem({ stepNumber: 9, stepName: 'Enplanements Preparation', stepDescription: 'The following tasks will be completed: Mark enplanment forecasts for this fiscal year as history' }),
	            new new_year_rollover_steps_1.INewYearRollOverDisplayElem({ stepNumber: 10, stepName: 'System Release', stepDescription: 'The following steps must be completed before import is permitted: Find all facilities that have operations records that were not updated from forecast to history for the current fiscal year. Report to APO all facilities that still have forecasts for the current fiscal year. Get determination from APO on how to proceed. Based on APO feedback, set forecast years to history for the current fiscal year. ' }),
	            new new_year_rollover_steps_1.INewYearRollOverDisplayElem({ stepNumber: 11, stepName: 'Reforecast National Scenario based on stored rates ', stepDescription: '' }),
	        ];
	    };
	    NewYearStepsComponent.prototype.setLfcYear = function () {
	        this.newYearRequest.lfcYear = this.newForecastYearField.nativeElement.value;
	    };
	    NewYearStepsComponent.prototype.runSteps = function () {
	        var _this = this;
	        if (this.systemControl.importStage != 2)
	            this.newYearRequest.lfcYear = this.systemControl.lfcYear;
	        this.newYearRequest.fyYear = this.systemControl.fyYear;
	        this.newYearRequest.stepNumber = this.systemControl.importStage;
	        // alert("lfcYear " + this.systemControl.lfcYear +"/"+ this.newYearRequest.lfcYear);
	        // alert("stepNumber"  + this.systemControl.importStage +"/"+ this.newYearRequest.stepNumber);
	        this.displaySpinner = true;
	        this._newYearRolloverService.newYearRollOverRunSteps(this.newYearRequest)
	            .subscribe(function (newYearResponse) { return _this.newYearResponse = newYearResponse; }, function (error) {
	            _this.errorMessage = error;
	            _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: _this.newYearResponse.message + " " + _this.errorMessage });
	        }, function () {
	            if (_this.newYearResponse.message.indexOf("Error") >= 0) {
	                _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: _this.newYearResponse.message });
	            }
	            else {
	                _this.msgs.push({ severity: 'info', summary: 'Info Message', detail: _this.newYearResponse.message });
	            }
	            _this.systemControl = new system_control_1.SystemControl(_this._systemControlService);
	            _this.displaySpinner = false;
	            //console.log("newYear Response Message: " + this.newYearResponse.message);
	        });
	    };
	    NewYearStepsComponent.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', system_control_1.SystemControl)
	    ], NewYearStepsComponent.prototype, "systemControl", void 0);
	    __decorate([
	        core_1.ViewChild('newForecastYearField'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], NewYearStepsComponent.prototype, "newForecastYearField", void 0);
	    NewYearStepsComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/new-year-rollover/new-year-rollover-steps/new-year-rollover-steps.component.html',
	            template: __webpack_require__(851),
	            //styleUrls: ["../../../../node_modules/awesome-bootstrap-checkbox/awesome-bootstrap-checkbox.css"],
	            styles: [__webpack_require__(852)],
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.Dialog, primeng_2.Messages],
	            providers: [new_year_rollover_steps_service_1.NewYearRolloverStepsService, system_control_service_1.SystemControlService]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, new_year_rollover_steps_service_1.NewYearRolloverStepsService, system_control_service_1.SystemControlService])
	    ], NewYearStepsComponent);
	    return NewYearStepsComponent;
	}());
	exports.NewYearStepsComponent = NewYearStepsComponent;


/***/ },

/***/ 849:
/***/ function(module, exports) {

	"use strict";
	var INewYearRolloverSteps = (function () {
	    function INewYearRolloverSteps() {
	    }
	    return INewYearRolloverSteps;
	}());
	exports.INewYearRolloverSteps = INewYearRolloverSteps;
	var INewYearRollOverRequest = (function () {
	    function INewYearRollOverRequest(stepNumber) {
	        stepNumber = stepNumber;
	    }
	    return INewYearRollOverRequest;
	}());
	exports.INewYearRollOverRequest = INewYearRollOverRequest;
	var INewYearRollOverResponse = (function () {
	    function INewYearRollOverResponse() {
	    }
	    return INewYearRollOverResponse;
	}());
	exports.INewYearRollOverResponse = INewYearRollOverResponse;
	var INewYearRollOverDisplayList = (function () {
	    function INewYearRollOverDisplayList() {
	    }
	    return INewYearRollOverDisplayList;
	}());
	exports.INewYearRollOverDisplayList = INewYearRollOverDisplayList;
	var INewYearRollOverDisplayElem = (function () {
	    function INewYearRollOverDisplayElem(options) {
	        if (options) {
	            this.stepNumber = options.stepNumber;
	            this.stepName = options.stepName;
	            this.stepDescription = options.stepDescription;
	        }
	    }
	    return INewYearRollOverDisplayElem;
	}());
	exports.INewYearRollOverDisplayElem = INewYearRollOverDisplayElem;


/***/ },

/***/ 850:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var NewYearRolloverStepsService = (function () {
	    function NewYearRolloverStepsService(_httpHelper) {
	        this._httpHelper = _httpHelper;
	        this._newYearRolloverUrl = "api/systemmanagement";
	    }
	    /* getNewYearRolloverStep(): Observable<INewYearRolloverSteps> {
	          return this._httpHelper.get(`${this._newYearRolloverUrl}`)
	     }*/
	    NewYearRolloverStepsService.prototype.setManagerLockService = function (newYearRollOverRequest) {
	        return this._httpHelper.post(this._newYearRolloverUrl + "/SetManagerLock", newYearRollOverRequest);
	    };
	    NewYearRolloverStepsService.prototype.newYearRollOverRunSteps = function (newYearRollOverRequest) {
	        return this._httpHelper.post(this._newYearRolloverUrl + "/NewYearRollOverRunSteps", newYearRollOverRequest);
	    };
	    NewYearRolloverStepsService.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    NewYearRolloverStepsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], NewYearRolloverStepsService);
	    return NewYearRolloverStepsService;
	}());
	exports.NewYearRolloverStepsService = NewYearRolloverStepsService;


/***/ },

/***/ 851:
/***/ function(module, exports) {

	module.exports = "  <div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n    <div margin='5px'>\r\n        <p-messages [value]=\"msgs\" [closable]=\"false\"></p-messages>\r\n        <div *ngFor=\"let newYearElem of newYearRolloverList\">\r\n            <div>\r\n                <div class=\"checkbox abc-checkbox abc-checkbox-circle\" *ngIf=\"newYearElem?.stepNumber==systemControl.importStage\" style=\"background-color: yellow\">\r\n                    <input type=\"checkbox\" class=\"styled\" checked  value=\"{{newYearElem?.stepNumber}}\" (change)=\"onCheck($event)\">\r\n                    <label> \r\n                        <b>{{newYearElem?.stepNumber}}.{{newYearElem?.stepName}}</b>\r\n                        <wbr>{{newYearElem?.stepDescription}}\r\n                    </label>\r\n                </div>\r\n            \r\n                    <div class=\"checkbox abc-checkbox abc-checkbox-danger \" *ngIf=\"newYearElem?.stepNumber>systemControl.importStage\">\r\n                    <span></span>\r\n                    <input type=\"checkbox\" checked   disabled\r\n                    name=\"{{newYearElem?.stepNumber}}\" value=\"{{newYearElem?.stepNumber}}\">\r\n                    <label> \r\n                        <b>{{newYearElem?.stepNumber}}.{{newYearElem?.stepName}}</b>\r\n                        {{newYearElem?.stepDescription}}\r\n                    </label>\r\n                </div>\r\n                \r\n                <div class=\"checkbox abc-checkbox abc-checkbox-success\" *ngIf=\"newYearElem?.stepNumber<systemControl.importStage\"  >\r\n                    <input type=\"checkbox\" checked  disabled \r\n                    name=\"{{newYearElem?.stepNumber}}\" value=\"{{newYearElem?.stepNumber}}\">\r\n                    <label> \r\n                        <b>{{newYearElem?.stepNumber}}.{{newYearElem?.stepName}}</b>\r\n                        {{newYearElem?.stepDescription}}\r\n                    </label>\r\n                </div>            \r\n            </div>\r\n        </div>\r\n        <p-dialog  [(visible)]=\"displaySpinner\" [modal]=true   [closable]=false showEffect=\"fade\">\r\n                <div align=\"center\">\r\n                    <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n                    <div>Loading please wait ....</div>\r\n                    <div>Do Not click back or Refresh the page</div>\r\n                </div>\r\n        </p-dialog>\r\n        <div *ngIf=\"systemControl.importStage===2\">\r\n            <table>\r\n                    <tr>\r\n                    <td>Current TAF Fiscal Year: {{systemControl?.fyYear}}</td>\r\n                    </tr>\r\n                    <tr>\r\n                    <td>Current TAF First Forecast Year: {{systemControl?.ffcYear}}</td>\r\n                    </tr>\r\n                    <tr>\r\n                    <td><Strong>Please provide NEW Parameters:</Strong></td>\r\n                    </tr>\r\n                    <tr>\r\n                    <td>NEW TAF Fiscal Year: {{systemControl?.fyYear+1}}</td>\r\n                    </tr>\r\n                    <tr>\r\n                    <td> NEW TAF Last Forecast Year (Press [enter] when done):</td>\r\n                        <td><input \r\n                        id=\"newForecastYear\" \r\n                        #newForecastYearField \r\n                        name=\"newForecastYear\" \r\n                        required \r\n                        pattern=\"^(?=.*[0-9])(?=.*[0-9])(?=.*\\d)[0-9\\d]{4,}$\"\r\n                        class=\"form-control input-sm\"  \r\n                        type=\"text\" \r\n                        [(ngModel)]=\"newForecastYear\"\r\n                        validateEqual=\"repeatnewForecastYear\" \r\n                        (keyup.enter)=\"setLfcYear($event)\"\r\n                        reverse=\"true\"/></td> \r\n                        </tr>\r\n                        <!--<tr>\r\n                            <td colspan=\"2\">\r\n                                <div [hidden]=\"newForecastYearField.valid || newForecastYearField.pristine\" class=\"alert alert-danger\">\r\n                                    Last Forecast Year must be at least 4 characters long, and contain only numbers.\r\n                                </div>\r\n                            </td>\r\n                        </tr>-->\r\n            </table>\r\n        </div>\r\n        <button type=\"button\" class=\"btn btn-primary\" (click)=\"runSteps()\">Proceed with Import Step</button>\r\n\r\n\r\n        <!--<table>\r\n            <tr>\r\n                <td>Import Administrative Options:</td>\r\n            </tr>\r\n            <tr>\r\n                <td><b>1.Manager Lock On</b></td>\r\n                <td><button type=\"button\" class=\"btn btn-link\" (click)=\"setManagerLock()\">Run</button></td>\r\n            </tr>\r\n            <tr>\r\n                <td>\r\n                   <b> 2. Set up New Year Rollover</b>\r\n                        <ol>\r\n                            The following tasks will be completed:\r\n                            <li>Delete all scenario with id >1</li>\r\n                            <li>Populate SAVED RATES</li>\r\n                            <li>Set Regional Input to false if regional input end year is less than first forecast year</li>\r\n                        </ol>\r\n                </td>\r\n                <td><button type=\"button\" class=\"btn btn-link\" (click)=\"runStep2()\">Run</button></td>\r\n            </tr>\r\n            <tr>\r\n                    <td>\r\n                        <table>\r\n                            <tr>\r\n                               <td>Current TAF Fiscal Year: {{systemControl?.fyYear}}</td>\r\n                            </tr>\r\n                            <tr>\r\n                               <td>Current TAF First Forecast Year: {{systemControl?.ffcYear}}</td>\r\n                            </tr>\r\n                            <tr>\r\n                               <td><Strong>Please provide NEW Parameters:</Strong></td>\r\n                            </tr>\r\n                            <tr>\r\n                               <td>NEW TAF Fiscal Year: {{systemControl?.fyYear+1}}</td>\r\n                            </tr>\r\n                            <tr>\r\n                              <td> NEW TAF Last Forecast Year:</td>\r\n\r\n                                <td><input \r\n                                id=\"newForecastYear\" \r\n                                #newForecastYearField \r\n                                name=\"newForecastYear\" \r\n                                required \r\n                                pattern=\"^(?=.*[0-9])(?=.*[0-9])(?=.*\\d)[0-9\\d]{4,}$\"\r\n                                class=\"form-control input-sm\"  \r\n                                type=\"text\" \r\n                                [(ngModel)]=\"newForecastYear\"\r\n                                validateEqual=\"repeatnewForecastYear\" \r\n                                (keyup.enter)=\"setLfcYear($event)\"\r\n                                reverse=\"true\"/></td> \r\n                                </tr>\r\n                                <!--<tr>\r\n                                    <td colspan=\"2\">\r\n                                        <div [hidden]=\"newForecastYearField.valid || newForecastYearField.pristine\" class=\"alert alert-danger\">\r\n                                            Last Forecast Year must be at least 4 characters long, and contain only numbers.\r\n                                        </div>\r\n                                    </td>\r\n                                </tr>\r\n                        </table>\r\n                    </td>\r\n                </tr>\r\n                <tr>\r\n                    <td><b>3. EMDF/NPIAS Facility Data Preparation</b>\r\n                        <ol>\r\n                             The following steps must be completed before import is permitted:\r\n                            <li>Comparison list between TAF and EMDF/NPIAS prepared</li>\r\n                            <li>FAA revisions to the list made; see New Year Reports</li>\r\n                            <li>FAA revisions incorporated into import; see New Year Reports</li>\r\n                            <li>Run import</li>\r\n                        </ol>\r\n                    </td>\r\n                    <td><button type=\"button\" class=\"btn btn-link\" (click)=\"runStep3()\">Run</button></td>\r\n                </tr> \r\n        </table>-->\r\n    </div>\r\n</div>\r\n"

/***/ },

/***/ 852:
/***/ function(module, exports) {

	module.exports = "@charset \"UTF-8\";\r\n.abc-checkbox {\r\n  padding-left: 20px; }\r\n.abc-checkbox label {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  position: relative;\r\n  padding-left: 5px; }\r\n.abc-checkbox label::before {\r\n  cursor: pointer;\r\n  content: \"\";\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 17px;\r\n  height: 17px;\r\n  left: 0;\r\n  margin-left: -20px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 3px;\r\n  background-color: #fff; }\r\n.abc-checkbox label::after {\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 16px;\r\n  height: 16px;\r\n  left: 0;\r\n  top: 0;\r\n  margin-left: -20px;\r\n  padding-left: 3px;\r\n  padding-top: 1px;\r\n  font-size: 11px;\r\n  color: #55595c; }\r\n.abc-checkbox input[type=\"checkbox\"],\r\n.abc-checkbox input[type=\"radio\"] {\r\n  cursor: pointer;\r\n  opacity: 0;\r\n  z-index: 1; }\r\n.abc-checkbox input[type=\"checkbox\"]:focus + label::before,\r\n.abc-checkbox input[type=\"radio\"]:focus + label::before {\r\n  outline: thin dotted;\r\n  outline: 5px auto -webkit-focus-ring-color;\r\n  outline-offset: -2px; }\r\n.abc-checkbox input[type=\"checkbox\"]:checked + label::after,\r\n.abc-checkbox input[type=\"radio\"]:checked + label::after {\r\n  font-family: \"FontAwesome\";\r\n  content: \"\"; }\r\n.abc-checkbox input[type=\"checkbox\"]:indeterminate + label::after,\r\n.abc-checkbox input[type=\"radio\"]:indeterminate + label::after {\r\n  display: block;\r\n  content: \"\";\r\n  width: 10px;\r\n  height: 3px;\r\n  background-color: #555555;\r\n  border-radius: 2px;\r\n  margin-left: -16.5px;\r\n  margin-top: 7px; }\r\n.abc-checkbox input[type=\"checkbox\"]:disabled + label,\r\n.abc-checkbox input[type=\"radio\"]:disabled + label {\r\n  opacity: 0.65; }\r\n.abc-checkbox input[type=\"checkbox\"]:disabled + label::before,\r\n.abc-checkbox input[type=\"radio\"]:disabled + label::before {\r\n  background-color: #eceeef;\r\n  cursor: not-allowed; }\r\n.abc-checkbox.abc-checkbox-circle label::before {\r\n  border-radius: 50%; }\r\n.abc-checkbox.checkbox-inline {\r\n  margin-top: 0; }\r\n\r\n.abc-checkbox-primary input[type=\"checkbox\"]:checked + label::before,\r\n.abc-checkbox-primary input[type=\"radio\"]:checked + label::before {\r\n  background-color: #0275d8;\r\n  border-color: #0275d8; }\r\n\r\n.abc-checkbox-primary input[type=\"checkbox\"]:checked + label::after,\r\n.abc-checkbox-primary input[type=\"radio\"]:checked + label::after {\r\n  color: #fff; }\r\n\r\n.abc-checkbox-danger input[type=\"checkbox\"]:checked + label::before,\r\n.abc-checkbox-danger input[type=\"radio\"]:checked + label::before {\r\n  background-color: #d9534f;\r\n  border-color: #d9534f; }\r\n\r\n.abc-checkbox-danger input[type=\"checkbox\"]:checked + label::after,\r\n.abc-checkbox-danger input[type=\"radio\"]:checked + label::after {\r\n  color: #fff; }\r\n\r\n.abc-checkbox-info input[type=\"checkbox\"]:checked + label::before,\r\n.abc-checkbox-info input[type=\"radio\"]:checked + label::before {\r\n  background-color: #5bc0de;\r\n  border-color: #5bc0de; }\r\n\r\n.abc-checkbox-info input[type=\"checkbox\"]:checked + label::after,\r\n.abc-checkbox-info input[type=\"radio\"]:checked + label::after {\r\n  color: #fff; }\r\n\r\n.abc-checkbox-warning input[type=\"checkbox\"]:checked + label::before,\r\n.abc-checkbox-warning input[type=\"radio\"]:checked + label::before {\r\n  background-color: #f0ad4e;\r\n  border-color: #f0ad4e; }\r\n\r\n.abc-checkbox-warning input[type=\"checkbox\"]:checked + label::after,\r\n.abc-checkbox-warning input[type=\"radio\"]:checked + label::after {\r\n  color: #fff; }\r\n\r\n.abc-checkbox-success input[type=\"checkbox\"]:checked + label::before,\r\n.abc-checkbox-success input[type=\"radio\"]:checked + label::before {\r\n  background-color: #5cb85c;\r\n  border-color: #5cb85c; }\r\n\r\n.abc-checkbox-success input[type=\"checkbox\"]:checked + label::after,\r\n.abc-checkbox-success input[type=\"radio\"]:checked + label::after {\r\n  color: #fff; }\r\n\r\n.abc-checkbox-primary input[type=\"checkbox\"]:indeterminate + label::before,\r\n.abc-checkbox-primary input[type=\"radio\"]:indeterminate + label::before {\r\n  background-color: #0275d8;\r\n  border-color: #0275d8; }\r\n\r\n.abc-checkbox-primary input[type=\"checkbox\"]:indeterminate + label::after,\r\n.abc-checkbox-primary input[type=\"radio\"]:indeterminate + label::after {\r\n  background-color: #fff; }\r\n\r\n.abc-checkbox-danger input[type=\"checkbox\"]:indeterminate + label::before,\r\n.abc-checkbox-danger input[type=\"radio\"]:indeterminate + label::before {\r\n  background-color: #d9534f;\r\n  border-color: #d9534f; }\r\n\r\n.abc-checkbox-danger input[type=\"checkbox\"]:indeterminate + label::after,\r\n.abc-checkbox-danger input[type=\"radio\"]:indeterminate + label::after {\r\n  background-color: #fff; }\r\n\r\n.abc-checkbox-info input[type=\"checkbox\"]:indeterminate + label::before,\r\n.abc-checkbox-info input[type=\"radio\"]:indeterminate + label::before {\r\n  background-color: #5bc0de;\r\n  border-color: #5bc0de; }\r\n\r\n.abc-checkbox-info input[type=\"checkbox\"]:indeterminate + label::after,\r\n.abc-checkbox-info input[type=\"radio\"]:indeterminate + label::after {\r\n  background-color: #fff; }\r\n\r\n.abc-checkbox-warning input[type=\"checkbox\"]:indeterminate + label::before,\r\n.abc-checkbox-warning input[type=\"radio\"]:indeterminate + label::before {\r\n  background-color: #f0ad4e;\r\n  border-color: #f0ad4e; }\r\n\r\n.abc-checkbox-warning input[type=\"checkbox\"]:indeterminate + label::after,\r\n.abc-checkbox-warning input[type=\"radio\"]:indeterminate + label::after {\r\n  background-color: #fff; }\r\n\r\n.abc-checkbox-success input[type=\"checkbox\"]:indeterminate + label::before,\r\n.abc-checkbox-success input[type=\"radio\"]:indeterminate + label::before {\r\n  background-color: #5cb85c;\r\n  border-color: #5cb85c; }\r\n\r\n.abc-checkbox-success input[type=\"checkbox\"]:indeterminate + label::after,\r\n.abc-checkbox-success input[type=\"radio\"]:indeterminate + label::after {\r\n  background-color: #fff; }\r\n\r\n.abc-radio {\r\n  padding-left: 20px; }\r\n.abc-radio label {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  position: relative;\r\n  padding-left: 5px; }\r\n.abc-radio label::before {\r\n  content: \"\";\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 17px;\r\n  height: 17px;\r\n  left: 0;\r\n  margin-left: -20px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 50%;\r\n  background-color: #fff; }\r\n.abc-radio label::after {\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  position: absolute;\r\n  content: \" \";\r\n  width: 11px;\r\n  height: 11px;\r\n  left: 3px;\r\n  top: 3px;\r\n  margin-left: -20px;\r\n  border-radius: 50%;\r\n  background-color: #55595c;\r\n  transform: scale(0, 0);\r\n  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33); }\r\n.abc-radio input[type=\"radio\"] {\r\n  cursor: pointer;\r\n  opacity: 0;\r\n  z-index: 1; }\r\n.abc-radio input[type=\"radio\"]:focus + label::before {\r\n  outline: thin dotted;\r\n  outline: 5px auto -webkit-focus-ring-color;\r\n  outline-offset: -2px; }\r\n.abc-radio input[type=\"radio\"]:checked + label::after {\r\n  transform: scale(1, 1); }\r\n.abc-radio input[type=\"radio\"]:disabled + label {\r\n  opacity: 0.65; }\r\n.abc-radio input[type=\"radio\"]:disabled + label::before {\r\n  cursor: not-allowed; }\r\n.abc-radio.radio-inline {\r\n  margin-top: 0; }\r\n\r\n.abc-radio-primary input[type=\"radio\"] + label::after {\r\n  background-color: #0275d8; }\r\n\r\n.abc-radio-primary input[type=\"radio\"]:checked + label::before {\r\n  border-color: #0275d8; }\r\n\r\n.abc-radio-primary input[type=\"radio\"]:checked + label::after {\r\n  background-color: #0275d8; }\r\n\r\n.abc-radio-danger input[type=\"radio\"] + label::after {\r\n  background-color: #d9534f; }\r\n\r\n.abc-radio-danger input[type=\"radio\"]:checked + label::before {\r\n  border-color: #d9534f; }\r\n\r\n.abc-radio-danger input[type=\"radio\"]:checked + label::after {\r\n  background-color: #d9534f; }\r\n\r\n.abc-radio-info input[type=\"radio\"] + label::after {\r\n  background-color: #5bc0de; }\r\n\r\n.abc-radio-info input[type=\"radio\"]:checked + label::before {\r\n  border-color: #5bc0de; }\r\n\r\n.abc-radio-info input[type=\"radio\"]:checked + label::after {\r\n  background-color: #5bc0de; }\r\n\r\n.abc-radio-warning input[type=\"radio\"] + label::after {\r\n  background-color: #f0ad4e; }\r\n\r\n.abc-radio-warning input[type=\"radio\"]:checked + label::before {\r\n  border-color: #f0ad4e; }\r\n\r\n.abc-radio-warning input[type=\"radio\"]:checked + label::after {\r\n  background-color: #f0ad4e; }\r\n\r\n.abc-radio-success input[type=\"radio\"] + label::after {\r\n  background-color: #5cb85c; }\r\n\r\n.abc-radio-success input[type=\"radio\"]:checked + label::before {\r\n  border-color: #5cb85c; }\r\n\r\n.abc-radio-success input[type=\"radio\"]:checked + label::after {\r\n  background-color: #5cb85c; }\r\n\r\ninput[type=\"checkbox\"].styled:checked + label:after,\r\ninput[type=\"radio\"].styled:checked + label:after {\r\n  font-family: \"FontAwesome\";\r\n  content: \"\"; }\r\n\r\ninput[type=\"checkbox\"] .styled:checked + label::before,\r\ninput[type=\"radio\"] .styled:checked + label::before {\r\n  color: #fff; }\r\n\r\ninput[type=\"checkbox\"] .styled:checked + label::after,\r\ninput[type=\"radio\"] .styled:checked + label::after {\r\n  color: #fff; }\r\n"

/***/ },

/***/ 853:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var new_year_rollover_reports_service_1 = __webpack_require__(854);
	var system_control_1 = __webpack_require__(843);
	var system_control_service_1 = __webpack_require__(694);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var primeng_3 = __webpack_require__(708);
	var primeng_4 = __webpack_require__(708);
	var primeng_5 = __webpack_require__(708);
	var primeng_6 = __webpack_require__(708);
	var NewYearReportsComponent = (function () {
	    function NewYearReportsComponent(route, router, _newYearReportsService, _systemControlService) {
	        this.route = route;
	        this.router = router;
	        this._newYearReportsService = _newYearReportsService;
	        this._systemControlService = _systemControlService;
	        this.pageTitle = 'New Year Reports';
	        this.displaySpinner = false;
	        this.displayDialog = false;
	        this.msgs = [];
	        this.systemControl = new system_control_1.SystemControl(_systemControlService);
	    }
	    NewYearReportsComponent.prototype.ngOnInit = function () {
	    };
	    NewYearReportsComponent.prototype.getFacToBeInserted = function () {
	        var _this = this;
	        this.displaySpinner = true;
	        //console.log("getFacToBeInserted");
	        this._newYearReportsService.getNpiasToBeInserted()
	            .subscribe(function (npiasToBeInserted) { return _this.npiasToBeInserted = npiasToBeInserted; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.displaySpinner = false;
	            document.getElementById('facToBeInserted').style.display = 'block';
	            //this.years = _.map(this.traconLocid,'value');
	            //console.log("npiasToBeInserted " + this.npiasToBeInserted);
	        });
	        this.cols = [
	            { field: "locid", header: 'Locid' },
	            { field: "state", header: 'State' },
	            { field: "region", header: 'Region' },
	            { field: "facType", header: 'Facility Class' },
	            { field: "hubSize", header: 'Hub Size' },
	            { field: "iopsNoAdd", header: 'Iops NoAdd' },
	            { field: "facLevel", header: 'Facility Level' },
	            { field: "centerId", header: 'Center Id' },
	            { field: "iopsId", header: 'Iops Id' },
	        ];
	    };
	    NewYearReportsComponent.prototype.getFacToBedeleted = function () {
	        var _this = this;
	        this.displaySpinner = true;
	        console.log("getFacToBedeleted");
	        this._newYearReportsService.getNpiasToBeDeleted()
	            .subscribe(function (npiasToBeDeleted) { return _this.npiasToBeDeleted = npiasToBeDeleted; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.displaySpinner = false;
	            document.getElementById('facToBedeleted').style.display = 'block';
	            //this.years = _.map(this.traconLocid,'value');
	            //console.log("npiasToBeDeleted " + this.npiasToBeDeleted);
	        });
	        this.cols = [
	            { field: "locid", header: 'Locid' },
	            { field: "state", header: 'State' },
	            { field: "region", header: 'Region' },
	            { field: "facType", header: 'Facility Class' },
	            { field: "hubSize", header: 'Hub Size' },
	            { field: "iopsNoAdd", header: 'Iops NoAdd' },
	            { field: "facLevel", header: 'Facility Level' },
	            { field: "centerId", header: 'Center Id' },
	            { field: "iopsId", header: 'Iops Id' },
	        ];
	    };
	    NewYearReportsComponent.prototype.getFacSameSite = function () {
	        var _this = this;
	        this.displaySpinner = true;
	        //console.log("facSameSite");
	        this._newYearReportsService.getNpiasSameSite()
	            .subscribe(function (npiasSameSite) { return _this.npiasSameSite = npiasSameSite; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.displaySpinner = false;
	            document.getElementById('facSameSite').style.display = 'block';
	            //this.years = _.map(this.traconLocid,'value');
	            //console.log("facSameSite " + this.npiasSameSite);
	        });
	        this.cols = [
	            { field: "locidTaf", header: 'TAF Locid' },
	            { field: "locidNpias", header: 'NPIAS Locid' },
	            { field: "siteTaf", header: 'TAF Site' },
	            { field: "siteNpias", header: 'NPIAS Site' },
	            { field: "regionTaf", header: 'TAF Region' },
	            { field: "regionNpias", header: 'NPIAS Region' },
	            { field: "AportNameTaf", header: 'TAF Airport Name' },
	            { field: "AportNameNpias", header: 'NPIAS Airport Name' },
	        ];
	    };
	    NewYearReportsComponent.prototype.getFacDiffSite = function () {
	        var _this = this;
	        this.displaySpinner = true;
	        //console.log("npiasDiffSite");
	        this._newYearReportsService.getNpiasDiffSite()
	            .subscribe(function (npiasDiffSite) { return _this.npiasDiffSite = npiasDiffSite; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.displaySpinner = false;
	            document.getElementById('npiasDiffSite').style.display = 'block';
	            //this.years = _.map(this.traconLocid,'value');
	            //console.log("npiasDiffSite " + this.npiasDiffSite);
	        });
	        this.cols = [
	            { field: "locidTaf", header: 'TAF Locid' },
	            { field: "locidNpias", header: 'NPIAS Locid' },
	            { field: "siteTaf", header: 'TAF Site' },
	            { field: "siteNpias", header: 'NPIAS Site' },
	            { field: "regionTaf", header: 'TAF Region' },
	            { field: "regionNpias", header: 'NPIAS Region' },
	            { field: "AportNameTaf", header: 'TAF Airport Name' },
	            { field: "AportNameNpias", header: 'NPIAS Airport Name' },
	        ];
	    };
	    NewYearReportsComponent.prototype.getNpiasMissingFields = function () {
	        var _this = this;
	        this.displaySpinner = true;
	        //console.log("facMissingFields");
	        this._newYearReportsService.getNpiasMissingFields()
	            .subscribe(function (npiasMissingFields) { return _this.npiasMissingFields = npiasMissingFields; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.displaySpinner = false;
	            document.getElementById('facMissingFields').style.display = 'block';
	            //this.years = _.map(this.traconLocid,'value');
	            //console.log("facMissingFields " + this.npiasMissingFields);
	        });
	        this.cols = [
	            { field: "locid", header: 'Locid' },
	            { field: "region", header: 'Region' },
	            { field: "aportName", header: 'Airport Name' },
	            { field: "city", header: 'City' },
	            { field: "state", header: 'State' },
	            { field: "site", header: 'Site' },
	            { field: "naspno", header: 'Naspno' },
	            { field: "latitude", header: 'Latitude' },
	            { field: "longitude", header: 'Longitude' },
	        ];
	    };
	    NewYearReportsComponent.prototype.setHistory = function () {
	        var _this = this;
	        this.displaySpinner = true;
	        //console.log("setDataSetHistory");
	        this._newYearReportsService.setLocidHistory()
	            .subscribe(function (npiasMissingFields) { return _this.npiasMissingFields = npiasMissingFields; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.displaySpinner = false;
	            document.getElementById('setDataSetHistory').style.display = 'block';
	            //this.years = _.map(this.traconLocid,'value');
	            //console.log("setDataSetHistory " + this.npiasMissingFields);
	        });
	        this.cols = [
	            { field: "locid", header: 'Locid' },
	        ];
	    };
	    NewYearReportsComponent.prototype.onRowSelect = function (event) {
	        this.locid = event.data.locid;
	        this.displayDialog = true;
	    };
	    NewYearReportsComponent.prototype.delete = function () {
	        var _this = this;
	        var params = {
	            locId: this.locid
	        };
	        this._newYearReportsService.deleteNpiasLocid(params)
	            .subscribe(function (response) {
	            _this.response = response;
	            // console.log("response: "+  this.response.message + " Error string index:"+  this.response.message.indexOf("Error") );
	            if (_this.response.message.indexOf("Error") >= 0) {
	                _this.displayDialog = false;
	                _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: _this.response.message });
	                console.error(_this.response.message);
	            }
	            else {
	                _this.displayDialog = false;
	                _this.msgs.push({ severity: 'info', summary: 'Info Message', detail: _this.response.message });
	            }
	        }, function (error) {
	            _this.displayDialog = false;
	            _this.errorMessage = "An error occured while trying to update the facility.";
	            console.error(error);
	        });
	    };
	    NewYearReportsComponent.prototype.hideNpiasLocidToBeDeleted = function () {
	        document.getElementById('facToBedeleted').style.display = 'none';
	    };
	    NewYearReportsComponent.prototype.hideNpiasLocidToBeInserted = function () {
	        document.getElementById('facToBeInserted').style.display = 'none';
	    };
	    NewYearReportsComponent.prototype.hideNpiasLocidSameSite = function () {
	        document.getElementById('facSameSite').style.display = 'none';
	    };
	    NewYearReportsComponent.prototype.hideNpiasLocidDiffSite = function () {
	        document.getElementById('facDiffSite').style.display = 'none';
	    };
	    NewYearReportsComponent.prototype.hideNpiasMissingFields = function () {
	        document.getElementById('facMissingFields').style.display = 'none';
	    };
	    NewYearReportsComponent.prototype.hideSetHistory = function () {
	        document.getElementById('setDataSetHistory').style.display = 'none';
	    };
	    NewYearReportsComponent.prototype.insert = function () {
	        var _this = this;
	        var params = {
	            locId: this.locid
	        };
	        this._newYearReportsService.insertNpiasLocid(params)
	            .subscribe(function (response) {
	            _this.response = response;
	            //console.log("response: "+  this.response.message + " Error string index:"+  this.response.message.indexOf("Error") );
	            if (_this.response.message.indexOf("Error") >= 0) {
	                _this.displayDialog = false;
	                _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: _this.response.message });
	                _this.getFacToBedeleted();
	                console.error(_this.response.message);
	            }
	            else {
	                _this.displayDialog = false;
	                _this.msgs.push({ severity: 'info', summary: 'Info Message', detail: _this.response.message });
	            }
	        }, function (error) {
	            _this.displayDialog = false;
	            _this.errorMessage = "An error occured while trying to update the facility.";
	            console.error(error);
	        });
	    };
	    NewYearReportsComponent.prototype.ngOnDestroy = function () {
	        //alert("onDestroy");
	        //this.sub.unsubscribe();
	    };
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', system_control_1.SystemControl)
	    ], NewYearReportsComponent.prototype, "systemControl", void 0);
	    NewYearReportsComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/new-year-rollover/new-year-rollover-steps/new-year-rollover-steps.component.html',
	            template: __webpack_require__(855),
	            //styleUrls: ["../../../../node_modules/awesome-bootstrap-checkbox/awesome-bootstrap-checkbox.css"],
	            styles: [__webpack_require__(852)],
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.Dialog, primeng_2.Messages, primeng_3.DataTable, primeng_4.Column, primeng_5.Header, primeng_6.Paginator],
	            providers: [new_year_rollover_reports_service_1.NewYearReportsService]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, new_year_rollover_reports_service_1.NewYearReportsService, system_control_service_1.SystemControlService])
	    ], NewYearReportsComponent);
	    return NewYearReportsComponent;
	}());
	exports.NewYearReportsComponent = NewYearReportsComponent;


/***/ },

/***/ 854:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var NewYearReportsService = (function () {
	    function NewYearReportsService(_httpHelper) {
	        this._httpHelper = _httpHelper;
	        this._newYearRolloverUrl = "api/systemmanagement";
	    }
	    /* getNewYearRolloverStep(): Observable<INewYearRolloverSteps> {
	          return this._httpHelper.get(`${this._newYearRolloverUrl}`)
	     }*/
	    NewYearReportsService.prototype.setLocidHistory = function () {
	        return this._httpHelper.get(this._newYearRolloverUrl + "/SetHistoryList");
	    };
	    NewYearReportsService.prototype.getNpiasMissingFields = function () {
	        return this._httpHelper.get(this._newYearRolloverUrl + "/NpiasMissingFieldsLocidList");
	    };
	    NewYearReportsService.prototype.getNpiasDiffSite = function () {
	        return this._httpHelper.get(this._newYearRolloverUrl + "/NpiasDiffSiteSameLocidList");
	    };
	    NewYearReportsService.prototype.getNpiasSameSite = function () {
	        return this._httpHelper.get(this._newYearRolloverUrl + "/NpiasSameSiteDiffLocidList");
	    };
	    NewYearReportsService.prototype.getNpiasToBeInserted = function () {
	        return this._httpHelper.get(this._newYearRolloverUrl + "/NpiasToBeInsertedLocidList");
	    };
	    NewYearReportsService.prototype.getNpiasToBeDeleted = function () {
	        return this._httpHelper.get(this._newYearRolloverUrl + "/NpiasToBeDeletedLocidList");
	    };
	    NewYearReportsService.prototype.deleteNpiasLocid = function (request) {
	        return this._httpHelper.post(this._newYearRolloverUrl + "/NpiasDeleteLocid", request);
	    };
	    NewYearReportsService.prototype.insertNpiasLocid = function (request) {
	        return this._httpHelper.post(this._newYearRolloverUrl + "/NpiasInsertLocid", request);
	    };
	    NewYearReportsService.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    NewYearReportsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], NewYearReportsService);
	    return NewYearReportsService;
	}());
	exports.NewYearReportsService = NewYearReportsService;


/***/ },

/***/ 855:
/***/ function(module, exports) {

	module.exports = "<div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n    <p-messages [value]=\"msgs\" [closable]=\"false\"></p-messages>\r\n    <div  class=\"container-fluid\" >\r\n        <div  class=\"row\">\r\n            <div class=\"col-md-6\" style=\"background-color:LightGray;\" align=\"center\" >\r\n                <lable><b> NPIAS Check</b></lable>\r\n            </div>\r\n        </div>\r\n        <div  class=\"row\">\r\n            <div class=\" col-md-6\" align=\"right\">\r\n                        To be deleted (In TAF not in NPIAS)\r\n                        <button type=\"button\" class=\"btn btn-link\" (click)=\"getFacToBedeleted()\">Generate</button> \r\n                        <button type=\"button\" class=\"btn btn-link\" (click)=\"hideNpiasLocidToBeDeleted()\">Hide</button>\r\n                </div>\r\n        </div>\r\n        <div  class=\"row\">\r\n            <div class=\" col-md-6\" align=\"right\">\r\n                        To be inserted (In NPIAS not in TAF)\r\n                        <button type=\"button\" class=\"btn btn-link\" (click)=\"getFacToBeInserted()\">Generate</button> \r\n                        <button type=\"button\" class=\"btn btn-link\" (click)=\"hideNpiasLocidToBeInserted()\">Hide</button>\r\n                </div>\r\n        </div>\r\n        <div  class=\"row\">\r\n            <div class=\" col-md-6\" align=\"right\">\r\n                        Same site number different Locid \r\n                        <button type=\"button\" class=\"btn btn-link\" (click)=\"getFacSameSite()\">Generate</button> \r\n                        <button type=\"button\" class=\"btn btn-link\" (click)=\"hideNpiasLocidSameSite()\">Hide</button>\r\n                </div>\r\n        </div>\r\n       \r\n        <div  class=\"row\">\r\n            <div class=\" col-md-6\" align=\"right\">\r\n                        Different site number different Locid \r\n                        <button type=\"button\" class=\"btn btn-link\" (click)=\"getFacDiffSite()\">Generate</button> \r\n                        <button type=\"button\" class=\"btn btn-link\" (click)=\"hideNpiasLocidDiffSite()\">Hide</button>\r\n             </div>\r\n        </div>\r\n        <div  class=\"row\">\r\n            <div class=\" col-md-6\" align=\"right\">\r\n                        Missing one or more fields (city,aportname, region) \r\n                        <button type=\"button\" class=\"btn btn-link\" (click)=\"getNpiasMissingFields()\">Generate</button> \r\n                        <button type=\"button\" class=\"btn btn-link\" (click)=\"hideNpiasMissingFields()\">Hide</button>\r\n             </div>\r\n        </div>\r\n        <div  class=\"row\">\r\n            <div class=\"col-md-6\" style=\"background-color:LightGray;\" align=\"center\" >\r\n                <lable> <b>EMDF Check</b></lable>\r\n            </div>\r\n        </div>\r\n        <div  class=\"row\">\r\n            <div class=\" col-md-6\" align=\"right\">\r\n                        AOPS Import\r\n                        <button type=\"button\" class=\"btn btn-link\" (click)=\"aopsImportCkeck()\">Generate</button> \r\n                        <button type=\"button\" class=\"btn btn-link\" (click)=\"hideNpiasMissingFields()\">Hide</button>\r\n             </div>\r\n        </div>\r\n        <div  class=\"row\">\r\n            <div class=\" col-md-6\" align=\"right\">\r\n                        TRACON Import\r\n                        <button type=\"button\" class=\"btn btn-link\" (click)=\"TraconImportCheck()\">Generate</button> \r\n                        <button type=\"button\" class=\"btn btn-link\" (click)=\"hideNpiasMissingFields()\">Hide</button>\r\n             </div>\r\n        </div>\r\n       <div  class=\"row\">\r\n            <div class=\"col-md-6\" style=\"background-color:LightGray;\" align=\"center\" >\r\n                <lable> <b>Fiscal Year ({{systemControl.fyYear}}) not set to history </b></lable>\r\n            </div>\r\n       </div>\r\n       <div  class=\"row\">\r\n            <div class=\" col-md-6\" align=\"right\">\r\n                    Set AOPS/Enpl/BA/Tracons to history\r\n                    <button type=\"button\" class=\"btn btn-link\" (click)=\"setHistory()\">Generate</button> \r\n                    <button type=\"button\" class=\"btn btn-link\" (click)=\"hideSetHistory()\">Hide</button>\r\n            </div>\r\n       </div>\r\n    </div>\r\n    <div id=\"facToBedeleted\" *ngIf=\"npiasToBeDeleted\"  class=\"container-fluid\" >\r\n         <p-dataTable [value]=\"npiasToBeDeleted\" [rows]=\"31\" [paginator]=\"true\" [pageLinks]=\"3\" [rowsPerPageOptions]=\"[5,10,20,31]\"\r\n                      selectionMode=\"single\" [(selection)]=\"selectedLocid\" (onRowSelect)=\"onRowSelect($event)\">\r\n            <p-column *ngFor=\"let col of cols\" [field]=\"col.field\" [header]=\"col.header\"></p-column>\r\n        </p-dataTable>\r\n        <p-dialog header=\"NPIAS To Be Deleted\" [(visible)]=\"displayDialog\" [responsive]=\"true\" showEffect=\"fade\" [modal]=\"true\">\r\n            <div class=\"ui-grid ui-grid-responsive ui-fluid\" >\r\n                <div class=\"ui-grid-row\">\r\n                     <div class=\"ui-grid-col\"><label for=\"Locid\">Confirm delete facility {{locid}}.</label></div>\r\n                </div>\r\n            </div>\r\n            <footer>\r\n                <div class=\"ui-dialog-buttonpane ui-widget-content ui-helper-clearfix\">\r\n                    <button type=\"button\" pButton icon=\"fa-check\" (click)=\"delete()\" label=\"Yes\"></button>\r\n                    <button type=\"button\" pButton icon=\"fa-close\" (click)=\"displayDialog=false\" label=\"No\"></button>\r\n                </div>\r\n            </footer>\r\n        </p-dialog>\r\n    </div>\r\n    <div id=\"facToBeInserted\" *ngIf=\"npiasToBeInserted\"  class=\"container-fluid\" >\r\n         <p-dataTable [value]=\"npiasToBeInserted\" [rows]=\"31\" [paginator]=\"true\" [pageLinks]=\"3\" [rowsPerPageOptions]=\"[5,10,20,31]\"\r\n                      selectionMode=\"single\" [(selection)]=\"selectedLocid\" (onRowSelect)=\"onRowSelect($event)\">\r\n            <p-column *ngFor=\"let col of cols\" [field]=\"col.field\" [header]=\"col.header\"></p-column>\r\n        </p-dataTable>\r\n        <p-dialog header=\"NPIAS To Be Inserted\" [(visible)]=\"displayDialog\" [responsive]=\"true\" showEffect=\"fade\" [modal]=\"true\">\r\n            <div class=\"ui-grid ui-grid-responsive ui-fluid\" >\r\n                <div class=\"ui-grid-row\">\r\n                     <div class=\"ui-grid-col\"><label for=\"Locid\">Confirm insert facility {{locid}}.</label></div>\r\n                </div>\r\n            </div>\r\n            <footer>\r\n                <div class=\"ui-dialog-buttonpane ui-widget-content ui-helper-clearfix\">\r\n                    <button type=\"button\" pButton icon=\"fa-check\" (click)=\"insert()\" label=\"Yes\"></button>\r\n                    <button type=\"button\" pButton icon=\"fa-close\" (click)=\"displayDialog=false\" label=\"No\"></button>\r\n                </div>\r\n            </footer>\r\n        </p-dialog>\r\n    </div>\r\n    <div id=\"facSameSite\" *ngIf=\"npiasSameSite\"  class=\"container-fluid\" >\r\n         <p-dataTable [value]=\"npiasSameSite\" [rows]=\"31\" [paginator]=\"true\" [pageLinks]=\"3\" [rowsPerPageOptions]=\"[5,10,20,31]\">\r\n            <p-column *ngFor=\"let col of cols\" [field]=\"col.field\" [header]=\"col.header\"></p-column>\r\n        </p-dataTable>\r\n    </div>\r\n    <div id=\"facDiffSite\" *ngIf=\"npiasDiffSite\"  class=\"container-fluid\" >\r\n         <p-dataTable [value]=\"npiasDiffSite\" [rows]=\"31\" [paginator]=\"true\" [pageLinks]=\"3\" [rowsPerPageOptions]=\"[5,10,20,31]\">\r\n            <p-column *ngFor=\"let col of cols\" [field]=\"col.field\" [header]=\"col.header\"></p-column>\r\n        </p-dataTable>\r\n    </div>\r\n    <div id=\"facMissingFields\" *ngIf=\"npiasMissingFields\"  class=\"container-fluid\" >\r\n         <p-dataTable [value]=\"npiasMissingFields\" [rows]=\"31\" [paginator]=\"true\" [pageLinks]=\"3\" [rowsPerPageOptions]=\"[5,10,20,31]\">\r\n            <p-column *ngFor=\"let col of cols\" [field]=\"col.field\" [header]=\"col.header\"></p-column>\r\n        </p-dataTable>\r\n    </div>\r\n    <div id=\"setDataSetHistory\" *ngIf=\"setHistoryLocids\"  class=\"container-fluid\" >\r\n         <p-dataTable [value]=\"setHistoryLocids\" [rows]=\"31\" [paginator]=\"true\" [pageLinks]=\"3\" [rowsPerPageOptions]=\"[5,10,20,31]\">\r\n            <p-column *ngFor=\"let col of cols\" [field]=\"col.field\" [header]=\"col.header\"></p-column>\r\n        </p-dataTable>\r\n    </div>\r\n    <p-dialog  [(visible)]=\"displaySpinner\" [modal]=true   [closable]=false showEffect=\"fade\">\r\n        <div align=\"center\">\r\n            <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n            <div>Loading please wait ....</div>\r\n            <div>Do Not click back or Refresh the page</div>\r\n        </div>\r\n    </p-dialog>\r\n\r\n\r\n</div>"

/***/ },

/***/ 856:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var tracon_model_component_1 = __webpack_require__(857);
	var auth_guard_service_1 = __webpack_require__(696);
	exports.TraconModelRoutes = [
	    { path: 'tracon-model', component: tracon_model_component_1.TraconModelComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	];


/***/ },

/***/ 857:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var user_session_1 = __webpack_require__(699);
	var tracon_model_service_1 = __webpack_require__(858);
	var tracon_model_1 = __webpack_require__(859);
	var _ = __webpack_require__(680);
	var TraconModelComponent = (function () {
	    function TraconModelComponent(route, router, _traconModelService, _user) {
	        this.route = route;
	        this.router = router;
	        this._traconModelService = _traconModelService;
	        this._user = _user;
	        this.pageTitle = 'Tracon Model';
	        this.traconRequest = new tracon_model_1.ITraconModelRequest("A11", 2012, _user.getSession().scenarioId, 2012, 2045);
	        this.showTableSummary = false;
	    }
	    TraconModelComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._traconModelService.getTraconList()
	            .subscribe(function (traconLocid) { return _this.traconLocid = traconLocid; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.locid = _.map(_this.traconLocid, 'value');
	            // function(o){console.log("func:" +o.key);return o.key;});
	            //_.map(JSON.parse(JSON.stringify(_.fromPairs(this.traconLocid))),'key');
	            /*_.forOwn((this.traconLocid), function(value, key) {
	                console.log(value.value);
	                return value.value;
	            });*/
	        });
	        this._traconModelService.getYearsList()
	            .subscribe(function (traconLocid) { return _this.traconLocid = traconLocid; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.years = _.map(_this.traconLocid, 'value');
	        });
	    };
	    TraconModelComponent.prototype.onTraconLocidChange = function (event) {
	        var select = event.target;
	        this.traconRequest.traconId = select.value;
	    };
	    TraconModelComponent.prototype.onYearsChange = function (event) {
	        var select = event.target;
	        //alert(typeof(select.value));
	        this.traconRequest.ayear = +select.value;
	        //alert(this.traconRequest.ayear);
	    };
	    TraconModelComponent.prototype.generateReport = function () {
	        var _this = this;
	        this._traconModelService.getTraconResult(this.traconRequest)
	            .subscribe(function (traconResponse) { return _this.traconResponse = traconResponse; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.showTableSummary = false;
	            //this.years = _.map(this.traconLocid,'value');
	            //console.log("traconResponseLocid " + this.traconResponse);
	        });
	    };
	    TraconModelComponent.prototype.generateSummaryReport = function () {
	        var _this = this;
	        //console.log("cancel");
	        this._traconModelService.getTraconSummaryResult(this.traconRequest)
	            .subscribe(function (traconSummaryResponse) { return _this.traconSummaryResponse = traconSummaryResponse; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.showTableSummary = true;
	            //this.years = _.map(this.traconLocid,'value');
	            console.log("traconSummaryResponse " + _this.traconSummaryResponse);
	        });
	    };
	    TraconModelComponent.prototype.reforecastAopsIfr = function () {
	        var _this = this;
	        //console.log("cancel");
	        this._traconModelService.reforecastAopsIfr(this.traconRequest)
	            .subscribe(function (traconReforecastAopsIfr) { return _this.traconReforecastAopsIfr = traconReforecastAopsIfr; }, function (error) { return _this.errorMessage = error; }, function () {
	            //console.log("traconSummaryResponse " + this.traconReforecastAopsIfr);
	        });
	    };
	    TraconModelComponent.prototype.reforecastTracon = function () {
	        var _this = this;
	        //console.log("cancel");
	        this._traconModelService.reforecastAopsIfr(this.traconRequest)
	            .subscribe(function (traconReforecast) { return _this.traconReforecast = traconReforecast; }, function (error) { return _this.errorMessage = error; }, function () {
	            //console.log("traconSummaryResponse " + this.traconReforecast);
	        });
	    };
	    TraconModelComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/towers-tracons-import/towers-tracons-import.component.html',
	            template: __webpack_require__(860),
	            styles: [__webpack_require__(861)],
	            directives: [router_1.ROUTER_DIRECTIVES],
	            providers: [tracon_model_service_1.TraconModelService]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, tracon_model_service_1.TraconModelService, user_session_1.UserSession])
	    ], TraconModelComponent);
	    return TraconModelComponent;
	}());
	exports.TraconModelComponent = TraconModelComponent;


/***/ },

/***/ 858:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Observable_1 = __webpack_require__(70);
	var http_helper_1 = __webpack_require__(678);
	__webpack_require__(524);
	__webpack_require__(494);
	var TraconModelService = (function () {
	    function TraconModelService(_httpHelper) {
	        this._httpHelper = _httpHelper;
	        this._genericUrl = "api/data/";
	        this._traconReportUrl = "api/systemmanagement";
	    }
	    TraconModelService.prototype.getTraconList = function () {
	        return this._httpHelper.get(this._genericUrl + "/tracon");
	    };
	    TraconModelService.prototype.getYearsList = function () {
	        return this._httpHelper.get(this._genericUrl + "/years");
	    };
	    TraconModelService.prototype.getTraconResult = function (traconRequest) {
	        return this._httpHelper.post(this._traconReportUrl + "/GetTraconResult", traconRequest);
	    };
	    TraconModelService.prototype.getTraconSummaryResult = function (traconRequest) {
	        return this._httpHelper.post(this._traconReportUrl + "/GetTraconSummaryResult", traconRequest);
	    };
	    TraconModelService.prototype.reforecastAopsIfr = function (traconRequest) {
	        return this._httpHelper.post(this._traconReportUrl + "/ReforecastAopsIfr", traconRequest);
	    };
	    TraconModelService.prototype.reforecastTracon = function (traconRequest) {
	        return this._httpHelper.post(this._traconReportUrl + "/ReforecastTracon", traconRequest);
	    };
	    TraconModelService.prototype.handleError = function (error) {
	        // in a real world app, we may send the server to some remote logging infrastructure
	        // instead of just logging it to the console
	        console.error(error);
	        return Observable_1.Observable.throw(error.json().error || 'Server error');
	    };
	    TraconModelService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], TraconModelService);
	    return TraconModelService;
	}());
	exports.TraconModelService = TraconModelService;


/***/ },

/***/ 859:
/***/ function(module, exports) {

	"use strict";
	var ITraconLocid = (function () {
	    function ITraconLocid() {
	    }
	    return ITraconLocid;
	}());
	exports.ITraconLocid = ITraconLocid;
	var ITraconModelRequest = (function () {
	    function ITraconModelRequest(traconId, ayear, scenarioId, sYear, eYear) {
	        this.traconId = traconId;
	        this.ayear = ayear;
	        this.scenarioId = scenarioId;
	        this.sYear = sYear;
	        this.eYear = eYear;
	    }
	    return ITraconModelRequest;
	}());
	exports.ITraconModelRequest = ITraconModelRequest;
	var IYears = (function () {
	    function IYears() {
	    }
	    return IYears;
	}());
	exports.IYears = IYears;
	var ITraconModelResponse = (function () {
	    function ITraconModelResponse() {
	        var message = 'a';
	    }
	    return ITraconModelResponse;
	}());
	exports.ITraconModelResponse = ITraconModelResponse;
	var ITraconModelSummaryResponse = (function () {
	    function ITraconModelSummaryResponse() {
	    }
	    return ITraconModelSummaryResponse;
	}());
	exports.ITraconModelSummaryResponse = ITraconModelSummaryResponse;
	var ITraconModelReforecastAOPSIFR = (function () {
	    function ITraconModelReforecastAOPSIFR() {
	    }
	    return ITraconModelReforecastAOPSIFR;
	}());
	exports.ITraconModelReforecastAOPSIFR = ITraconModelReforecastAOPSIFR;


/***/ },

/***/ 860:
/***/ function(module, exports) {

	module.exports = "<div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n    <div class='panel-body'>\r\n            <div>\r\n                <div>\r\n                Select a Tracon:\r\n                <select (change)=\"onTraconLocidChange($event)\">\r\n                    <option *ngFor=\"let trLocid of locid\" [value]=\"trLocid\">\r\n                        {{trLocid}}\r\n                    </option>\r\n                </select>\r\n                </div>\r\n                <div>\r\n                Select base year:\r\n                <select (change)=\"onYearsChange($event)\">\r\n                    <option *ngFor=\"let ayear of years\" [value]=\"ayear\">\r\n                        {{ayear}}\r\n                    </option>\r\n                </select>\r\n                </div>\r\n            </div>\r\n            <div>\r\n                <button type=\"button\" class=\"btn btn-default\" (click)=\"generateReport()\">Generate Tracon Report (Scenario: {{_user.getSession().scenarioId}}) </button>\r\n                <button class=\"btn btn-default\" (click)=\"generateSummaryReport()\">Generate Tracon Summary Report (Scenario: {{_user.getSession().scenarioId}}) </button>\r\n            </div>\r\n            <p></p>\r\n             <div>\r\n                <span><font color ='red'>Next three steps run for selected scenario!</font></span>\r\n                <p>\r\n                <button type=\"button\" class=\"btn btn-default\" (click)=\"reforecastAopsIfr()\">\r\n                    Reforecast AOPS IFR (AC,AT,GA,Mil)(use ITN_AC rate to grow IFR_AC, ITN_AT rate to grow IFR_AT, etc) </button></p>\r\n                <p><button type=\"button\" class=\"btn btn-default\" (click)=\"reforecastTraconOps()\">\r\n                    Reforecast Tracon (AC,AT,GA,Mil)</button></p>\r\n                <p><button type=\"button\" class=\"btn btn-default\" (click)=\"reforecastTraconOVers()\">\r\n                    Reforecast Tracon Overflights  (determine anual national year to year growth rate for Tracons, apply that rate to the starting base)</button>\r\n                </p>\r\n            </div>\r\n            <p></p>\r\n       <div *ngIf=\"traconReforecastAopsIfr?.message==''\" align=\"center\">\r\n                <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n                <div>Loading please wait ....</div>\r\n            </div>\r\n            <div *ngIf=\"traconReforecastAopsIfr?.message!=''\">\r\n                Message: {{ traconReforecastAopsIfr?.message }}\r\n            </div>\r\n\r\n            <div *ngIf=\"traconReforecast?.message==''\" align=\"center\">\r\n                <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n                <div>Loading please wait ....</div>\r\n            </div>\r\n            <div  *ngIf=\"traconReforecast?.message!=''\">\r\n                Message: {{ traconReforecast?.message }}\r\n            </div>\r\n            \r\n            <div id=\"traconContent\"> \r\n                <table border=\"0\" width=\"100%\" *ngIf=\"traconResponse &&!showTableSummary\">\r\n                        <thead>\r\n                            <tr>\r\n                                <th align ='center' colspan='12'>\r\n                                    <h1 style='margin-bottom:0px;'>TRACON Operations Forecast Report</h1>\r\n                                </th>\r\n                            </tr>\r\n                            <tr>\r\n                                <td  align ='center' colspan='1'>YEAR </td>\r\n                                <td  align ='center' colspan='1'>LOCID </td>\r\n                                <td  align ='center' colspan='1'>Air Carrier</td>\r\n                                <td  align ='center' colspan='1'>Air Taxi</td>\r\n                                <td  align ='center' colspan='1'>GA</td>\r\n                                <td  align ='center' colspan='1'>Military</td>\r\n                                <td  align ='center' colspan='1'>Overflights</td>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <tr *ngFor=\"let trResp of traconResponse\"> \r\n                                <td align ='center' colspan='1'>{{trResp.aYear}}</td>\r\n                                <td align ='center' colspan='1'>{{trResp.locid}}</td>\r\n                                <td align ='center' colspan='1'>{{trResp.ifrItnAc}}</td>\r\n                                <td align ='center' colspan='1'>{{trResp.ifrItnAt}}</td>\r\n                                <td align ='center' colspan='1'>{{trResp.ifrItnGa}}</td>\r\n                                <td align ='center' colspan='1'>{{trResp.ifrItnMi}}</td>\r\n                                <td align ='center' colspan='1'>{{trResp.totOvers}}</td>\r\n                                <!--<table>\r\n                                <tr *ngIf=\"{{trResp.locid}} === 'Other''\">\r\n                                    <td align ='right'>-</td>\r\n                                    <td align ='right'>-</td>\r\n                                    <td align ='right'>-</td>\r\n                                    <td align ='right'>-</td>\r\n                                    <td align ='right'>-</td>\r\n                                    <td align ='right'>-</td>\r\n                                    <td align ='right'>-</td>\r\n                                </tr>\r\n                                <table>-->\r\n                            </tr>\r\n                        </tbody>\r\n                </table>\r\n                <table border=\"0\" width=\"40%\" *ngIf=\"showTableSummary && traconSummaryResponse\">\r\n                    <thead >\r\n                        <tr>\r\n                            <td align ='center' colspan='1'> Year </td>\r\n                            <td align ='center' colspan='1'> Tracon Level </td>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr *ngFor=\"let trResp of traconSummaryResponse\">\r\n                            <td align ='center' colspan='1'>{{trResp.fYear}}</td>\r\n                            <td align ='center' colspan='1'>{{trResp.sumFYear}}</td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n                <table border=\"0\" width=\"40%\" *ngIf=\"showTableSummary\">\r\n                    <thead >\r\n                        <tr>\r\n                            <td align ='center' colspan='1'> Year </td>\r\n                            <td align ='center' colspan='1'> Tracon GrowthRate </td>\r\n                        </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                        <tr *ngFor=\"let trResp of traconSummaryResponse\">\r\n                            <td align ='center' colspan='1'>{{trResp.lYear}}-{{trResp.fYear}}</td>\r\n                            <td align ='center' colspan='1'>{{trResp.traconYearlyRate}}</td>\r\n                        </tr>\r\n                    </tbody>\r\n                </table>\r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ },

/***/ 861:
/***/ function(module, exports) {

	module.exports = ".P {page-break-after: always}\r\n.THEAD{ display: table-header-group; }\r\n\r\n#traconContent THEAD TR {\r\n\t   BACKGROUND: #fff;\r\n\t\tCOLOR: #000;\r\n\t }\r\n#traconContent THEAD TR TH{\r\n\t\t FONT-WEIGHT: bold;\r\n\t\t FONT-SIZE:20px;\r\n\t\t COLOR: #fff;\r\n\t\tTEXT-ALIGN: center;\r\n\t  }\r\n#traconContent THEAD TR TD{\r\n\t\t FONT-SIZE: 12px;\r\n\t\t BACKGROUND: #e93f3f;\r\n\t\t COLOR: #fff;\r\n\t   }\r\n#traconContent TBODY TD{\r\n\t\t  BACKGROUND: #fff;\r\n\t\t FONT-SIZE: 9px;\r\n\t   }\r\n"

/***/ },

/***/ 862:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var regional_review_service_1 = __webpack_require__(863);
	var RegionalReviewComponent = (function () {
	    function RegionalReviewComponent(route, router) {
	        this.route = route;
	        this.router = router;
	        this.pageTitle = 'Regional Review';
	    }
	    RegionalReviewComponent.prototype.ngOnInit = function () { };
	    RegionalReviewComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/system-management/towers-tracons-import/towers-tracons-import.component.html',
	            template: __webpack_require__(864),
	            //styles: [require('./tracon-model.css')],
	            directives: [router_1.ROUTER_DIRECTIVES],
	            providers: [regional_review_service_1.RegionalReviewService]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router])
	    ], RegionalReviewComponent);
	    return RegionalReviewComponent;
	}());
	exports.RegionalReviewComponent = RegionalReviewComponent;


/***/ },

/***/ 863:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	__webpack_require__(524);
	__webpack_require__(494);
	var RegionalReviewService = (function () {
	    function RegionalReviewService() {
	    }
	    RegionalReviewService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], RegionalReviewService);
	    return RegionalReviewService;
	}());
	exports.RegionalReviewService = RegionalReviewService;


/***/ },

/***/ 864:
/***/ function(module, exports) {

	module.exports = "<div class='panel panel-primary'>  \r\n    <div class='panel-heading'>\r\n        <a [routerLink]=\"['/system-management']\" style=\"color: white; text-decoration:underline\">System Management</a>/{{pageTitle}}\r\n    </div>\r\n    <div class='panel-body'>\r\n    </div>\r\n</div>"

/***/ },

/***/ 865:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var scenario_activities_component_1 = __webpack_require__(866);
	var scenario_create_component_1 = __webpack_require__(868);
	var scenario_create_results_component_1 = __webpack_require__(870);
	var scenario_select_facilities_component_1 = __webpack_require__(872);
	var scenario_delete_list_component_1 = __webpack_require__(876);
	var scenario_update_component_1 = __webpack_require__(878);
	var scenario_modify_facilities_component_1 = __webpack_require__(880);
	var scenario_reforecast_component_1 = __webpack_require__(882);
	var scenario_reforecast_complete_component_1 = __webpack_require__(888);
	var auth_guard_service_1 = __webpack_require__(696);
	exports.ScenarioActivitiesRoutes = [
	    { path: 'scenario-activities', component: scenario_activities_component_1.ScenarioActivitiesComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'scenario-create', component: scenario_create_component_1.ScenarioCreateComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'scenario-create-results', component: scenario_create_results_component_1.ScenarioCreateResultsComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'scenario-select-facilities', component: scenario_select_facilities_component_1.ScenarioSelectFacilitiesComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'scenario-delete', component: scenario_delete_list_component_1.ScenarioDeleteListComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'scenario-update', component: scenario_update_component_1.ScenarioUpdateComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'scenario-modify-facilities', component: scenario_modify_facilities_component_1.ScenarioModifyFacilitiesComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'scenario-reforecast', component: scenario_reforecast_component_1.ScenarioReforecastComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'scenario-reforecast-complete', component: scenario_reforecast_complete_component_1.ScenarioReforecastCompleteComponent, canActivate: [auth_guard_service_1.AuthGuard] }
	];


/***/ },

/***/ 866:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var scenario_service_1 = __webpack_require__(692);
	var user_session_1 = __webpack_require__(699);
	var auth_service_1 = __webpack_require__(679);
	var user_info_service_1 = __webpack_require__(695);
	var ScenarioActivitiesComponent = (function () {
	    function ScenarioActivitiesComponent(route, router, _scenarioService, _User, authService, _userInfoService) {
	        this.route = route;
	        this.router = router;
	        this._scenarioService = _scenarioService;
	        this._User = _User;
	        this.authService = authService;
	        this._userInfoService = _userInfoService;
	        this.pageTitle = 'Scenario Activities';
	    }
	    ScenarioActivitiesComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._scenarioService.getScenarios(this._User.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            if (_this._User.hasValidSession()) {
	                console.log("this._User " + _this._User.getSession().scenarioId);
	                _this.setScenarioHeader(_this._User.getSession().scenarioId);
	            }
	            else {
	                _this.setScenarioHeader(_this._User.scenarioId);
	                _this._User.updateSessionState();
	            }
	        });
	        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
	        if (typeof (this._User.scenarioId) === 'undefined')
	            this.router.navigate(['./scenario-activities']);
	    };
	    ScenarioActivitiesComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	        this.scenarioHeaderDiv.innerHTML = "<strong>Current Scenario: " + this.currentScenario.scenarioName + " (" + this.currentScenario.id + ")</strong>";
	    };
	    __decorate([
	        core_1.ViewChild('scenarioHeader'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], ScenarioActivitiesComponent.prototype, "scenarioHeader", void 0);
	    ScenarioActivitiesComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(867),
	            styles: [__webpack_require__(700)],
	            directives: [router_1.ROUTER_DIRECTIVES],
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, scenario_service_1.ScenarioService, user_session_1.UserSession, auth_service_1.AuthService, user_info_service_1.UserInfoService])
	    ], ScenarioActivitiesComponent);
	    return ScenarioActivitiesComponent;
	}());
	exports.ScenarioActivitiesComponent = ScenarioActivitiesComponent;


/***/ },

/***/ 867:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\" #scenarioHeader></div>\r\n<div class=\"panel panel-primary\">\r\n    <div class=\"panel-heading\">\r\n        {{pageTitle}}\r\n    </div>\r\n    <div class=\"panel-body\">\r\n        <h4>Your Options:</h4>\r\n        <div class=\"container-fluid\">\r\n            <div class=\"row\">\r\n                <div class=\"col-md-4\">\r\n                    <a [routerLink]=\"['/scenario-create']\" data-toggle=\"tooltip\" title=\"Create a New Scenario\" class=\"btn btn-danger  btn-md active custom\" >Create a Scenario</a>\r\n                </div> \r\n                <div class=\"col-md-6\">\r\n                   <div class=\"customh3\">Create a New Scenario</div>\r\n                </div> \r\n            </div>\r\n            <div class=\"row\" style=\"padding-left:0; padding-right:0;padding-top:10px;\">\r\n                 <div class=\"col-md-4\">\r\n                    <a [routerLink]=\"['/scenario-modify-facilities']\" data-toggle=\"tooltip\" title=\"Move and Copy Facilities between Scenarios, Delete Facilities\" class=\"btn btn-danger  btn-md active custom\">Change Scenario Facilities</a>\r\n                 </div>\r\n                 <div class=\"col-md-6\">\r\n                      <div class=\"customh3\">Move and Copy Facilities between Scenarios, Delete Facilities</div>\r\n                 </div>\r\n            </div>\r\n            <div class=\"row\" style=\"padding-left:0; padding-right:0;padding-top:10px;\">\r\n                 <div class=\"col-md-4\">\r\n                    <a [routerLink]=\"['/scenario-delete']\" data-toggle=\"tooltip\" title=\"Delete a Scenario and all Associated Forecast Data\" class=\"btn btn-danger  btn-md active custom\">Delete a Scenario</a>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                     <div class=\"customh3\">Delete a Scenario and all Associated Forecast Data</div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"row\" style=\"padding-left:0; padding-right:0;padding-top:10px;\">\r\n                 <div class=\"col-md-4\">\r\n                    <a [routerLink]=\"['/scenario-update']\" data-toggle=\"tooltip\" title=\"Merge scenarios\" class=\"btn btn-danger  btn-md active custom\">Update a Scenario</a>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                     <div class=\"customh3\">Merge scenarios</div>\r\n                </div>\r\n            </div>\r\n           <div class=\"row\" style=\"padding-left:0; padding-right:0;padding-top:10px;\" *ngIf=\"_User.getSession().isAdmin\">\r\n                 <div class=\"col-md-4\">\r\n                    <a [routerLink]=\"['/scenario-reforecast']\" data-toggle=\"tooltip\" title=\"Reforecast selected scenario based on previously saved rates\" class=\"btn btn-danger  btn-md active custom\">Reforecast Using Stored Rates</a>\r\n                </div>\r\n                <div class=\"col-md-6\">\r\n                     <div class=\"customh3\">Reforecast selected scenario based on previously saved rates</div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ },

/***/ 868:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var scenario_service_1 = __webpack_require__(692);
	var user_session_1 = __webpack_require__(699);
	var primeng_1 = __webpack_require__(708);
	var ScenarioCreateComponent = (function () {
	    function ScenarioCreateComponent(route, router, request, _scenarioService, _User) {
	        this.route = route;
	        this.router = router;
	        this.request = request;
	        this._scenarioService = _scenarioService;
	        this._User = _User;
	        this.pageTitle = 'Create a Scenario';
	        this.displaySpinner = false;
	        this.msgs = [];
	    }
	    ScenarioCreateComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.displaySpinner = false;
	        if (typeof (this._User.scenarioId) === 'undefined')
	            this.router.navigate(['./scenario-activities']);
	        this.nameTextInput = this.scenarioName.nativeElement;
	        // Make a single call to get all scenarios to populate the dropdown and also 
	        // filter out the current scenario to display in the header
	        this._scenarioService.getScenarios(this._User.getSession()['id'])
	            .subscribe(function (allScenarios) { return _this.allScenarios = allScenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.currentScenario = _this.allScenarios.filter(function (el) {
	                return el.id === this._User.getSession().scenarioId;
	            }.bind(_this))[0];
	            _this.request.baseScenarioId = _this.allScenarios[0].id;
	        });
	        this.request.userId = this._User.userId;
	        this.request.public = false;
	    };
	    ScenarioCreateComponent.prototype.onNameChange = function () {
	        // Verify that the name doesn't already exist
	        if (this.scenarioNameExists(this.nameTextInput.value))
	            return;
	        this.request.scenarioName = this.nameTextInput.value;
	    };
	    ScenarioCreateComponent.prototype.onSelectChange = function (event) {
	        var select = event.target;
	        this.request.baseScenarioId = +select.value;
	    };
	    ScenarioCreateComponent.prototype.onCheckboxChange = function (event) {
	        var checkbox = event.target;
	        this.request.public = checkbox.checked;
	    };
	    ScenarioCreateComponent.prototype.selectFacilities = function () {
	        if (this.scenarioNameExists(this.nameTextInput.value))
	            return;
	        this.request.source = "filtered";
	        this.request.facilities = [];
	        // Set request in session storage to prevent data loss on browser refresh
	        //sessionStorage.setItem('create-scenario-request', JSON.stringify(this.request));
	        this.request.updateSessionState();
	        this.router.navigate(['./scenario-select-facilities']);
	    };
	    ScenarioCreateComponent.prototype.createWithAllFacilities = function () {
	        var _this = this;
	        if (this.scenarioNameExists(this.nameTextInput.value))
	            return;
	        this.request.source = "all";
	        this.displaySpinner = true;
	        this._scenarioService.createScenario(this.request)
	            .subscribe(function (response) {
	            if (response.responseStatus === 'ERROR') {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: response.responseMessage });
	                _this.displaySpinner = false;
	                return;
	            }
	            _this.displaySpinner = false;
	            _this.router.navigate(['./scenario-create-results']);
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    ScenarioCreateComponent.prototype.cancel = function () {
	        this.router.navigate(['./scenario-activities']);
	    };
	    ScenarioCreateComponent.prototype.scenarioNameExists = function (name) {
	        if (!name) {
	            this.msgs = [];
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Please fix the following error: Scenario Name exists or is empty' });
	            return true;
	        }
	        var found = this.allScenarios.filter(function (el) {
	            return el.scenarioName === name;
	        }.bind(this));
	        if (found.length > 0) {
	            this.msgs = [];
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Please fix the following error: Scenario Name exists or is empty' });
	            //alert('A scenario with that name has already been created. Please enter another name.')
	            this.nameTextInput.value = '';
	            return true;
	        }
	        return false;
	    };
	    __decorate([
	        core_1.ViewChild('scenarioName'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], ScenarioCreateComponent.prototype, "scenarioName", void 0);
	    ScenarioCreateComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(869),
	            styles: [__webpack_require__(700)],
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.Dialog],
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, scenario_service_1.CreateScenarioRequest, scenario_service_1.ScenarioService, user_session_1.UserSession])
	    ], ScenarioCreateComponent);
	    return ScenarioCreateComponent;
	}());
	exports.ScenarioCreateComponent = ScenarioCreateComponent;


/***/ },

/***/ 869:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\"><strong *ngIf=\"currentScenario\">Current Scenario: {{currentScenario.scenarioName}} ({{currentScenario.id}})</strong></div>\r\n\r\n<div class=\"panel panel-default\" >\r\n    <div class=\" panel-body\">\r\n        <p-messages [value]=\"msgs\" [closable]=\"false\"></p-messages>\r\n        <fieldset>\r\n            <div class=\"text-danger divider\"><b>Create TAF Scenario</b></div>\r\n           <p></p>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-4\">\r\n                    <div class=\"customtd\">Scenario Name: </div>\r\n                </div>\r\n                <div class=\"col-md-4 \">\r\n                    <input type=\"text\" class=\"form-control\" #scenarioName (keyup.enter)=\"onNameChange($event)\"  (blur)=\"onNameChange($event)\" maxlength=\"20\"/>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\" >\r\n                <div class=\"col-md-4\">\r\n                    <div class=\"customtd\">Scenario Based on:</div>\r\n                </div>\r\n                <div class=\"col-md-4\">\r\n                    <select class=\"form-control\" (change)=\"onSelectChange($event)\">\r\n                        <option *ngFor=\"let scenario of allScenarios\" [value]=\"scenario.id\" [selected]=\"scenario.id === currentScenario.id\">{{scenario.scenarioName}} ({{scenario.id}})</option> \r\n                    </select>\r\n                </div>\r\n            </div>\r\n                    <label>\r\n                        <input type=\"checkbox\" (click)=\"onCheckboxChange($event)\">\r\n                        Make this scenario viewable by everyone\r\n                    </label>\r\n                 <div class=\"customtd\">Fill in the scenario name and select a source scenario.</div>\r\n\r\n                <div class=\"customtd\">You may select facilities for your scenario by clicking the 'Continue and Select Facilities' button. \r\n                Or, you may simply copy all the facilities from the base scenario by clicking the 'Create Scenario with All Facilities in Base' button.</div>\r\n            <p></p>\r\n            <div class=\"row\" >\r\n                <button type=\"text\" pButton (click)=\"selectFacilities()\" label=\"Continue and Select Facilities\" style=\"width:300px!important\"></button>\r\n                <button type=\"text\" pButton (click)=\"createWithAllFacilities()\" label=\"Create Scenario with All Facilities in Base\" style=\"width:300px!important\"> </button>\r\n                <button type=\"text\" pButton (click)=\"cancel()\" label=\"Cancel\" style=\"width:300px!important\"></button>\r\n            </div>\r\n        </fieldset>\r\n    </div>\r\n    <p-dialog  [(visible)]=\"displaySpinner\" [modal]=true   [closable]=false showEffect=\"fade\">\r\n        <div align=\"center\">\r\n            <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n            <div>Loading please wait ....</div>\r\n            <div>Do Not click back or Refresh the page</div>\r\n        </div>\r\n    </p-dialog>\r\n</div>"

/***/ },

/***/ 870:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var scenario_service_1 = __webpack_require__(692);
	var ScenarioCreateResultsComponent = (function () {
	    function ScenarioCreateResultsComponent(request) {
	        this.request = request;
	        this.pageTitle = 'Create Scenario';
	    }
	    ScenarioCreateResultsComponent.prototype.ngOnDestroy = function () {
	        this.request.destroySession();
	    };
	    ScenarioCreateResultsComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(871),
	            styles: [__webpack_require__(700)],
	            directives: [router_1.ROUTER_DIRECTIVES]
	        }), 
	        __metadata('design:paramtypes', [scenario_service_1.CreateScenarioRequest])
	    ], ScenarioCreateResultsComponent);
	    return ScenarioCreateResultsComponent;
	}());
	exports.ScenarioCreateResultsComponent = ScenarioCreateResultsComponent;


/***/ },

/***/ 871:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\"><strong *ngIf=\"currentScenario\">Current Scenario: {{currentScenario.scenarioName}} ({{currentScenario.id}})</strong></div>\r\n\r\n<div class=\"panel panel-default\">\r\n    <div class=\"panel-body\">\r\n        <fieldset>\r\n            <div class=\"text-danger divider\"><b>Create Scenario Results</b></div>\r\n\r\n            <div>Scenario <strong *ngIf=\"request\" >{{request.scenarioName}}</strong> Created Successfully</div>\r\n\r\n            <div class=\"divider\">&nbsp;</div>\r\n\r\n            <ul>\r\n                <li *ngIf=\"request.source === 'all'\" >All facilities copied from source scenario</li>\r\n                <li *ngIf=\"request.source === 'filtered'\" ><span *ngIf=\"request.facilities\">{{request.facilities.length}}</span> facilities copied from source scenario</li>\r\n                <li *ngIf=\"request.public === true\" >This scenario is public</li>\r\n            </ul>\r\n\r\n            <div class=\"divider\">&nbsp;</div>\r\n\r\n            <div>Please go back to <a [routerLink]=\"['/scenario-activities']\">scenario activities</a></div>            \r\n            \r\n        </fieldset>\r\n    </div>\r\n</div>"

/***/ },

/***/ 872:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var scenario_service_1 = __webpack_require__(692);
	var airport_service_1 = __webpack_require__(677);
	var query_report_service_1 = __webpack_require__(691);
	var query_report_1 = __webpack_require__(698);
	var facility_search_request_1 = __webpack_require__(873);
	var commondata_service_1 = __webpack_require__(693);
	var user_session_1 = __webpack_require__(699);
	var ScenarioSelectFacilitiesComponent = (function () {
	    function ScenarioSelectFacilitiesComponent(route, router, request, searchRequest, _scenarioService, _queryReportService, _airportService, _commonDataService, _User) {
	        this.route = route;
	        this.router = router;
	        this.request = request;
	        this.searchRequest = searchRequest;
	        this._scenarioService = _scenarioService;
	        this._queryReportService = _queryReportService;
	        this._airportService = _airportService;
	        this._commonDataService = _commonDataService;
	        this._User = _User;
	        this.pageTitle = 'Select Scenario Facilities';
	        this.msgs = [];
	        this.autoCompleteQuery = '';
	        this.autoCompleteFilteredList = [];
	        this.moreSearchOptionsVisible = false;
	        this.moreSearchOptionsControlCssClass = 'glyphicon glyphicon-chevron-right';
	        this.moreSearchOptionsItemsCssClass = 'hidden';
	        this.showLocids = false;
	        this.displaySpinner = false;
	    }
	    ScenarioSelectFacilitiesComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.thisYear = new Date().getFullYear();
	        if (typeof (this._User.scenarioId) === 'undefined')
	            this.router.navigate(['./scenario-activities']);
	        this.request = this.request.getSession();
	        // Retrieve current scenario to set the current selected scenario name
	        this._scenarioService.getScenario(this._User.scenarioId)
	            .subscribe(function (scenario) { return _this.currentScenario = scenario; }, function (error) { return _this.errorMessage = error; });
	        // Retrieve locids from the source scenario for autocomplete
	        this._airportService.getAirportLocIds(this.request.baseScenarioId)
	            .subscribe(function (locIds) { return _this.sourceLocIds = locIds; }, function (error) { return _this.errorMessage = error; });
	        // Retrieve source scenario so we can set the name
	        this._scenarioService.getScenario(this.request.baseScenarioId)
	            .subscribe(function (scenario) { return _this.sourceScenario = scenario; }, function (error) { return _this.errorMessage = error; });
	        // Retrieve data for center ids
	        this._airportService.getAirportCenterIds(this.request.baseScenarioId)
	            .subscribe(function (centerIds) { return _this.centerids = centerIds; }, function (error) { return _this.errorMessage = error; });
	        // Retrieve data for Reliever locIds
	        this._airportService.getRelieverLocIds(this.request.baseScenarioId)
	            .subscribe(function (locIds) { return _this.relieverLocIds = locIds; }, function (error) { return _this.errorMessage = error; });
	        // Retrieve data for Approach Control ids
	        this._airportService.getApproachControlIds(this.request.baseScenarioId)
	            .subscribe(function (ids) { return _this.approachControlIds = ids; }, function (error) { return _this.errorMessage = error; });
	        // Retrieve the Variable Info
	        this._commonDataService.getVariableInfo()
	            .subscribe(function (info) { return _this.variables = info; }, function (error) { return _this.errorMessage = error; });
	        // Retrieve Enplanement Years
	        this._commonDataService.getEnplanementYears()
	            .subscribe(function (years) { return _this.enplanementYears = years; }, function (error) { return _this.errorMessage = error; });
	        var dropDownItems = ['region', 'state', 'hubsize', 'faclevel', 'emdfcode'];
	        for (var x = 0; x < dropDownItems.length; x++) {
	            this.populateDropdownData(dropDownItems[x]);
	        }
	        // Init the search 
	        this.searchRequest.baseScenarioId = this.request.baseScenarioId;
	        this.requestLocid = new query_report_1.IQueryReportsFacilityRequest([''], 1);
	    };
	    ScenarioSelectFacilitiesComponent.prototype.loadLocids = function () {
	        this.showLocids = true;
	    };
	    ScenarioSelectFacilitiesComponent.prototype.saveLocids = function () {
	        var _this = this;
	        var charExp = /[^a-zA-Z0-9]+/;
	        var nonAlpha = (this.selectedLocids.replace(/[\t\n\s\r]{1,}/g, "")).match(charExp);
	        if (nonAlpha != null) {
	            this.msgs = [];
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Please check the list of LOCID.\nIt can only contain digits[0-9] and alphabets[a-z].' });
	            return;
	        }
	        var selectedLocidsArr = this.selectedLocids.replace(/[\t\n\s\r]{1,}/g, ",").split(",");
	        var bError = false;
	        for (var i = 0; i <= selectedLocidsArr.length - 1; i++) {
	            if ((selectedLocidsArr[i]) != null) {
	                if ((selectedLocidsArr[i].length > 4) || (selectedLocidsArr[i].length < 3)) {
	                    bError = true;
	                    this.msgs = [];
	                    this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'The LOCID length can be only 3 or 4 characters.' });
	                    return;
	                }
	            }
	        }
	        this.requestLocid.locid = selectedLocidsArr;
	        this.requestLocid.scenarioId = this.currentScenario.id;
	        this._queryReportService.saveLocids(this.requestLocid)
	            .subscribe(function (response) {
	            if (response.responseMessage === "No Match") {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Following Locid list is not part of your selected scenario '
	                        + response.locidNoMatch + '. Please remove from list before continuing.' });
	            }
	            if (response.savedLocidList != null) {
	                _this.request.facilities = response.savedLocidList;
	                _this.showLocids = false;
	                _this.selectedLocids = '';
	                _this.msgs = [];
	            }
	        }, function (error) {
	            _this.msgs = [];
	            _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'An error occured while processing your request.' });
	            _this.showLocids = false;
	        }, function () { });
	    };
	    ScenarioSelectFacilitiesComponent.prototype.cancelLocids = function () {
	        this.showLocids = false;
	        this.selectedLocids = '';
	    };
	    ScenarioSelectFacilitiesComponent.prototype.search = function () {
	        var _this = this;
	        this._airportService.getAirportLocIdsByCriteria(this.searchRequest)
	            .subscribe(function (results) {
	            if (results.length === 0) {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'No facility found matching your criteria.' });
	                return;
	            }
	            // Don't add to list if already there
	            for (var x = 0; x < results.length; x++) {
	                if (_this.request.facilities.indexOf(results[x]) === -1) {
	                    _this.request.facilities.push(results[x]);
	                }
	            }
	            _this.request.updateSessionState();
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    ScenarioSelectFacilitiesComponent.prototype.moreSearchOptionsClick = function () {
	        if (!this.moreSearchOptionsVisible) {
	            this.moreSearchOptionsVisible = true;
	            this.moreSearchOptionsItemsCssClass = 'more-search-options';
	            this.moreSearchOptionsControlCssClass = this.moreSearchOptionsControlCssClass.replace('right', 'down');
	            // Set the defaults for the request
	            this.searchRequest.searchOption = "growth";
	            if (typeof (this.searchRequest.selectVariable) === 'undefined')
	                this.searchRequest.selectVariable = this.variables[0].searchVariable;
	            if (typeof (this.searchRequest.growthStartYear) === 'undefined')
	                this.searchRequest.growthStartYear = new Date().getFullYear();
	            if (typeof (this.searchRequest.growthEndYear) === 'undefined')
	                this.searchRequest.growthEndYear = new Date().getFullYear();
	            if (typeof (this.searchRequest.growthOperator) === 'undefined')
	                this.searchRequest.growthOperator = "less";
	            if (typeof (this.searchRequest.growthPercentage) === 'undefined')
	                this.searchRequest.growthPercentage = 0.00;
	            if (typeof (this.searchRequest.growthExcludeChanges) === 'undefined')
	                this.searchRequest.growthExcludeChanges = false;
	        }
	        else {
	            this.moreSearchOptionsVisible = false;
	            this.moreSearchOptionsItemsCssClass = 'hidden';
	            this.moreSearchOptionsControlCssClass = this.moreSearchOptionsControlCssClass.replace('down', 'right');
	            // Reset the request searchOptioin
	            this.searchRequest.searchOption = null;
	        }
	        console.log(this.searchRequest);
	    };
	    ScenarioSelectFacilitiesComponent.prototype.createScenario = function () {
	        var _this = this;
	        this.displaySpinner = true;
	        if (this.request.facilities.length === 0) {
	            var msg = "Please select a list of Facilities before creating the scenario.\nSelect your search criteria and then click the 'Search' button to populate the scenario facilities list.";
	            this.msgs = [];
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: msg });
	            //alert(msg);
	            return;
	        }
	        this._scenarioService.createScenario(this.request)
	            .subscribe(function (response) {
	            if (response.responseStatus === 'ERROR') {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: response.responseMessage });
	                //alert(response.responseMessage);
	                return;
	            }
	            _this.router.navigate(['./scenario-create-results']);
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    ScenarioSelectFacilitiesComponent.prototype.removeFacilityFromList = function (locid) {
	        var index = this.request.facilities.indexOf(locid);
	        this.request.facilities.splice(index, 1);
	        this.request.updateSessionState();
	    };
	    ScenarioSelectFacilitiesComponent.prototype.clearAllFacilities = function () {
	        this.request.facilities = [];
	        this.request.updateSessionState();
	    };
	    ScenarioSelectFacilitiesComponent.prototype.cancel = function () {
	        this.request.destroySession();
	        this.router.navigate(['./scenario-activities']);
	    };
	    ScenarioSelectFacilitiesComponent.prototype.onSelect = function (event, element) {
	        var select = event.target;
	        switch (element) {
	            case 'region':
	                this.searchRequest.region = select.value !== 'All' ? select.value : '';
	                break;
	            case 'state':
	                this.searchRequest.state = select.value !== 'All' ? select.value : '';
	                break;
	            case 'hubSize':
	                this.searchRequest.hubSize = select.value !== 'All' ? +select.value : -1;
	                break;
	            case 'level':
	                this.searchRequest.level = select.value !== 'All' ? +select.value : -1;
	                break;
	            case 'emdfCode':
	                this.searchRequest.type = select.value !== 'All' ? +select.value : -1;
	                break;
	            case 'centerAreaId':
	                this.searchRequest.centerId = select.value !== 'All' ? +select.value : -1;
	                break;
	            case 'selectVarible':
	                this.searchRequest.selectVariable = select.value;
	                break;
	            case 'growthStartYear':
	                this.searchRequest.growthStartYear = +select.value;
	                break;
	            case 'growthEndYear':
	                this.searchRequest.growthEndYear = +select.value;
	                break;
	            case 'valueYear':
	                this.searchRequest.varValueYear = +select.value;
	                break;
	        }
	    };
	    ScenarioSelectFacilitiesComponent.prototype.onInput = function (event, element) {
	        var input = event.target;
	        "test this";
	        if (isNaN(+input.value)) {
	            this.msgs = [];
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Please enter a decimal value for the growth rate' });
	            // alert('Please enter a decimal value for the growth rate');
	            input.value = '';
	            return;
	        }
	        if (element === 'growth')
	            this.searchRequest.growthPercentage = +input.value;
	        if (element === 'varvalue')
	            this.searchRequest.varValue = +input.value;
	    };
	    ScenarioSelectFacilitiesComponent.prototype.onMoreSelectOption = function (event, element) {
	        if (element === 'growth') {
	            this.searchRequest.searchOption = 'growth';
	        }
	        if (element === 'varvalue') {
	            this.searchRequest.searchOption = 'varvalue';
	            if (typeof (this.searchRequest.varValueYear) === 'undefined')
	                this.searchRequest.varValueYear = new Date().getFullYear();
	            if (typeof (this.searchRequest.varValueOperator) === 'undefined')
	                this.searchRequest.varValueOperator = 'less';
	            if (typeof (this.searchRequest.varValue) === 'undefined')
	                this.searchRequest.varValue = 0;
	        }
	    };
	    ScenarioSelectFacilitiesComponent.prototype.onOperatorSelectOption = function (event, element, value) {
	        if (element === 'growth') {
	            this.searchRequest.growthOperator = value;
	        }
	        if (element === 'varvalue') {
	            this.searchRequest.varValueOperator = value;
	        }
	    };
	    ScenarioSelectFacilitiesComponent.prototype.onCheck = function (event, element) {
	        var checkbox = event.target;
	        switch (element) {
	            case 'allFaaTowers':
	                this.searchRequest.allFaaTowers = checkbox.checked;
	                break;
	            case 'allFaaAndContractTowers':
	                this.searchRequest.allFaaContractTowers = checkbox.checked;
	                break;
	            case 'oeps35':
	                this.searchRequest.oep35 = checkbox.checked;
	                break;
	            case 'growthExcludeChanges':
	                this.searchRequest.growthExcludeChanges = checkbox.checked;
	                break;
	        }
	    };
	    ScenarioSelectFacilitiesComponent.prototype.autoCompleteFilter = function () {
	        this.searchRequest.locId = this.autoCompleteQuery.trim();
	        if (this.autoCompleteQuery.trim().length > 0) {
	            this.autoCompleteFilteredList = this.sourceLocIds.filter(function (el) {
	                return el.toUpperCase().indexOf(this.autoCompleteQuery.toUpperCase()) > -1;
	            }.bind(this));
	        }
	    };
	    ScenarioSelectFacilitiesComponent.prototype.autoCompleteSelect = function (item) {
	        this.autoCompleteQuery = item;
	        this.autoCompleteFilteredList = [];
	        this.searchRequest.locId = item;
	    };
	    ScenarioSelectFacilitiesComponent.prototype.populateDropdownData = function (source) {
	        var _this = this;
	        this._commonDataService.getData(source)
	            .subscribe(function (list) {
	            switch (source) {
	                case 'region':
	                    _this.regions = list;
	                    break;
	                case 'state':
	                    _this.states = list;
	                    break;
	                case 'hubsize':
	                    _this.hubSizes = list;
	                    break;
	                case 'faclevel':
	                    _this.facLevels = list;
	                    break;
	                case 'emdfcode':
	                    _this.emdfCodes = list;
	                    break;
	            }
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    ScenarioSelectFacilitiesComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(874),
	            styles: [__webpack_require__(700), __webpack_require__(875)],
	            providers: [facility_search_request_1.FacilitySearchRequest, commondata_service_1.KeyValuePair],
	            directives: [router_1.ROUTER_DIRECTIVES],
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, scenario_service_1.CreateScenarioRequest, facility_search_request_1.FacilitySearchRequest, scenario_service_1.ScenarioService, query_report_service_1.QueryReportService, airport_service_1.AirportService, commondata_service_1.CommonDataService, user_session_1.UserSession])
	    ], ScenarioSelectFacilitiesComponent);
	    return ScenarioSelectFacilitiesComponent;
	}());
	exports.ScenarioSelectFacilitiesComponent = ScenarioSelectFacilitiesComponent;


/***/ },

/***/ 873:
/***/ function(module, exports) {

	"use strict";
	var FacilitySearchRequest = (function () {
	    function FacilitySearchRequest() {
	        this.baseScenarioId = -1;
	        this.locId = '';
	        this.region = '';
	        this.state = '';
	        this.hubSize = -1;
	        this.level = -1;
	        this.type = -1;
	        this.allFaaTowers = false;
	        this.allFaaContractTowers = false;
	        this.oep35 = false;
	        this.centerId = -1;
	    }
	    return FacilitySearchRequest;
	}());
	exports.FacilitySearchRequest = FacilitySearchRequest;


/***/ },

/***/ 874:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\"><strong *ngIf=\"currentScenario\">Current Scenario: {{currentScenario.scenarioName}} ({{currentScenario.id}})</strong></div>\r\n\r\n<div  class=\"panel panel-default\" >\r\n\r\n    <div class=\"panel-body\">\r\n        <fieldset>\r\n            <div class=\"text-danger divider\"><b>Scenario Facility Selection</b></div>\r\n            <p-messages [value]=\"msgs\" [closable]=\"false\"></p-messages>\r\n            <div class=\"section-title\" *ngIf=\"request\" align=\"center\">Scenario: {{request.scenarioName}}</div>\r\n\r\n            <div class=\"section-title\" *ngIf=\"sourceScenario\" align=\"center\">Using source scenario: {{sourceScenario.scenarioName}} ({{sourceScenario.id}})</div>\r\n\r\n            <div class=\"search col-lg-8\">\r\n                <h3>Search Criteria</h3>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                    <label for=\"locid\" class=\"customtd\">LOCID:</label>\r\n                    <input type=\"text\" class=\"form-control\" id=\"locid\" [(ngModel)]=\"autoCompleteQuery\" (keyup)=\"autoCompleteFilter()\" />\r\n                    <div class=\"suggestions\" *ngIf=\"autoCompleteFilteredList.length > 0\">\r\n                        <ul *ngFor=\"let item of autoCompleteFilteredList\">\r\n                            <li><a (click)=\"autoCompleteSelect(item)\">{{item}}</a></li>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                    <label for=\"region\" class=\"customtd\">Region:</label>\r\n                    <select id=\"region\" class=\"form-control\" (change)=\"onSelect($event, 'region')\">\r\n                        <option>All</option>\r\n                        <option *ngFor=\"let region of regions\" [value]=\"region.key\">{{region.value}}</option> \r\n                    </select>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                    <label for=\"state\" class=\"customtd\">State:</label>\r\n                    <select id=\"state\" class=\"form-control\" (change)=\"onSelect($event, 'state')\">\r\n                        <option>All</option>\r\n                        <option *ngFor=\"let state of states\" [value]=\"state.key\">{{state.value}}</option> \r\n                    </select>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                    <label for=\"hubsize\" class=\"customtd\">Hub Size:</label>\r\n                    <select id=\"hubsize\" class=\"form-control\" (change)=\"onSelect($event, 'hubSize')\">\r\n                        <option>All</option>\r\n                        <option *ngFor=\"let size of hubSizes\" [value]=\"size.key\">{{size.value}}</option> \r\n                    </select>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                    <label for=\"faclevel\" class=\"customtd\">Level:</label>\r\n                    <select id=\"faclevel\" class=\"form-control\" (change)=\"onSelect($event, 'level')\">\r\n                        <option>All</option>\r\n                        <option *ngFor=\"let level of facLevels\" [value]=\"level.key\">{{level.value}}</option> \r\n                    </select>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                    <label for=\"emdfcode\" class=\"customtd\">Class:</label>\r\n                    <select id=\"emdfcode\" class=\"form-control\" (change)=\"onSelect($event, 'emdfCode')\">\r\n                        <option>All</option>\r\n                        <option *ngFor=\"let code of emdfCodes\" [value]=\"code.key\">{{code.value}}</option> \r\n                    </select>\r\n                </div>\r\n\r\n                <div class=\"checkbox-group\">\r\n                    <div class=\"checkbox col-sm-4\">\r\n                        <label class=\"customtd\"><input type=\"checkbox\" (change)=\"onCheck($event, 'allFaaTowers')\">All FAA Towers</label>\r\n                    </div>\r\n\r\n                    <div class=\"checkbox col-sm-4\">\r\n                        <label class=\"customtd\"><input type=\"checkbox\" (change)=\"onCheck($event, 'allFaaAndContractTowers')\">All FAA and Contract Towers</label>\r\n                    </div>\r\n\r\n                    <div class=\"checkbox col-sm-4\">\r\n                        <label class=\"customtd\"><input type=\"checkbox\" (change)=\"onCheck($event, 'oeps35')\">Core 30</label>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"col-md-6\">\r\n                    <label class=\"customtd\">Reliever Facility</label>&nbsp;&nbsp;\r\n                    <label class=\"radio-inline\"><input type=\"radio\" checked=\"checked\"/>Both</label>\r\n                    <label class=\"radio-inline\"><input type=\"radio\"/>Yes</label>\r\n                    <label class=\"radio-inline\"><input type=\"radio\"/>No</label>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-6\">\r\n                    <label for=\"relieverLocId\" class=\"customtd\">Reliever LOCID:</label>\r\n                    <select id=\"relieverLocId\" class=\"form-control\">\r\n                        <option>All</option>\r\n                        <option *ngFor=\"let id of relieverLocIds\" [value]=\"id\">{{id}}</option> \r\n                    </select>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-6\">\r\n                    <label for=\"centerid\" class=\"customtd\">Center Area ID:</label>\r\n                    <select id=\"centerid\" class=\"form-control\" (change)=\"onSelect($event, 'centerAreaId')\">\r\n                        <option>All</option>\r\n                        <option *ngFor=\"let id of centerids\" [value]=\"id\">{{id}}</option> \r\n                    </select>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-6\">\r\n                    <label for=\"approachControlId\" class=\"customtd\">Approach Control ID:</label>\r\n                    <select id=\"approachControlId\" class=\"form-control\">\r\n                        <option>All</option>\r\n                        <option *ngFor=\"let id of approachControlIds\" [value]=\"id\">{{id}}</option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"col-lg-3\">\r\n                <div class=\"locids\">\r\n                    <div class=\"header\"><strong>Selected Facilities</strong></div>\r\n                    <div>\r\n                        <ul *ngIf=\"request.facilities\">\r\n                            <li *ngFor=\"let item of request.facilities\">{{item}} <a (click)=\"removeFacilityFromList(item)\">Remove</a></li>\r\n                        </ul>\r\n                    </div>\r\n                </div>\r\n                <div class=\"totals\" *ngIf=\"request.facilities.length > 0\"><small>Currently Facilities Selected: {{request.facilities.length}}</small></div>\r\n            </div>\r\n\r\n        </fieldset>\r\n    </div>\r\n\r\n    <div class=\"more-search-options-panel panel-body\">\r\n        <fieldset>\r\n            <div class=\"text-danger divider\">Display More Search  Options\r\n                <span [ngClass]=\"moreSearchOptionsControlCssClass\" (click)=\"moreSearchOptionsClick()\"></span> \r\n            </div>\r\n            <div [ngClass]=\"moreSearchOptionsItemsCssClass\">\r\n                <div class=\"form-group col-md-12\">\r\n                    <label for=\"selectVariables\">Select Variables:</label>\r\n                    <select id=\"selectVariables\" class=\"form-control\" (change)=\"onSelect($event, 'selectVariable')\">\r\n                        <option *ngFor=\"let variable of variables\" [value]=\"variable.searchVariable\">{{variable.displayVariable}}</option>\r\n                    </select>\r\n\r\n                    <div class=\"divider\">&nbsp;</div>\r\n\r\n                    <div class=\"search-option-container col-md-12\">\r\n                        <div class=\"col-sm-3\">\r\n                            <label class=\"radio\" (click)=\"onMoreSelectOption($event, 'growth')\"><input type=\"radio\" name=\"search-option\" checked=\"checked\"/> Find where group rate for years</label>\r\n                        </div>\r\n                        <div class=\"col-sm-2\">\r\n                            <select class=\"form-control\" (change)=\"onSelect($event, 'growthStartYear')\">\r\n                            <option *ngFor=\"let year of enplanementYears\" [value]=\"year\" [selected]=\"year === thisYear\">{{year}}</option>\r\n                        </select>\r\n                        </div>\r\n                        <div class=\"col-sm-1\">\r\n                            <span> to </span>\r\n                        </div>\r\n                        <div class=\"col-sm-2\">\r\n                            <select class=\"form-control\" (change)=\"onSelect($event, 'growthEndYear')\">\r\n                            <option *ngFor=\"let year of enplanementYears\" [value]=\"year\" [selected]=\"year === thisYear\">{{year}}</option>\r\n                        </select>\r\n                        </div>\r\n\r\n                        <div class=\"divider\"></div>\r\n\r\n                        <div class=\"col-sm-12\">\r\n                            <div class=\"form-group\">\r\n                                is &nbsp;&nbsp;\r\n                                <label class=\"radio-inline\"><input type=\"radio\" name=\"rate-operator\" checked=\"checked\" (check)=\"onOperatorSelectOption($event,'growth','less')\"> less than</label>\r\n                                <label class=\"radio-inline\"><input type=\"radio\" name=\"rate-operator\" (check)=\"onOperatorSelectOption($event,'growth','greater')\"> greater than</label>\r\n                            </div>\r\n                            <div class=\"form-group\">\r\n                                <label for=\"growth-rate\">the rate</label>\r\n                                <input name=\"growth-rate\" type=\"text\" class=\"form-control\" placeholder=\"0.00%\" (keyup)=\"onInput($event, 'growthRate')\"/>\r\n                            </div>\r\n                            <div class=\"checkbox\">\r\n                                <label><input type=\"checkbox\" (check)=\"onCheck($event, 'growthExcludeChanges')\"/>Exclude changes from 0 (infinite growth)</label>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"search-option-container col-md-12\">\r\n                        <div class=\"col-sm-3\">\r\n                            <label class=\"radio\" (click)=\"onMoreSelectOption($event, 'varvalue')\"><input type=\"radio\" name=\"search-option\"/> Find where value for year</label>\r\n                        </div>\r\n                        <div class=\"col-sm-3\">\r\n                            <select class=\"form-control\" (change)=\"onSelect($event,'valueYear')\">\r\n                            <option *ngFor=\"let year of enplanementYears\" [value]=\"year\" [selected]=\"year === thisYear\">{{year}}</option> \r\n                        </select>\r\n                        </div>\r\n                        <div class=\"col-sm-12\">\r\n                            <div class=\"form-group\">\r\n                                is &nbsp;&nbsp;\r\n                                <label class=\"radio-inline\"><input type=\"radio\" name=\"value-operator\" checked=\"checked\" (check)=\"onOperatorSelectOption($event,'varvalue','less')\"> less than</label>\r\n                                <label class=\"radio-inline\"><input type=\"radio\" name=\"value-operator\" (check)=\"onOperatorSelectOption($event,'varvalue','greater')\"> greater than</label>\r\n                            </div>\r\n                            <div class=\"form-group\">\r\n                                <label for=\"the-value\">the value</label>\r\n                                <input name=\"the-value\" type=\"text\" class=\"form-control\" placeholder=\"0\"  (keyup)=\"onInput($event, 'varvalue')\"/>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n\r\n                </div>\r\n            </div>\r\n        </fieldset>\r\n    </div>\r\n    <p-dialog  modal=\"modal\" showEffect=\"fade\" [(visible)]=\"showLocids\" responsive=\"true\">\r\n                <h1 style=\"font-size:83%;color:red\">\r\n                    You may paste a list of LOCIDs into the box below. \r\n                    This list will override any previous LOCID entries.\r\n                    To keep your current list of LOCIDs, please click the \"Cancel\" button. \r\n                    Enter data here, one LOCID per line (no commas):\r\n                </h1>\r\n                <div>\r\n                    <textarea class=\"form-control\" rows=\"5\" id=\"locids\" [(ngModel)]=\"selectedLocids\"   ></textarea>\r\n                </div>\r\n                <div>\r\n                    <div class=\"col-sm-6\">\r\n                        <button type=\"text\" pButton (click)=\"saveLocids()\" label=\"Save\" style=\"width:100px!important\"></button>\r\n                    </div>\r\n                    <div class=\"col-sm-6\">\r\n                        <button type=\"text\" pButton (click)=\"cancelLocids()\" label=\"Cancel\" style=\"width:100px!important\"></button>\r\n                    </div>\r\n                </div>\r\n    </p-dialog>\r\n    <div class=\"col-lg-12\">\r\n        <button class=\"btn btn-primary\" (click)=\"loadLocids()\">Load LOCIDs</button>\r\n        <button class=\"btn btn-primary\" (click)=\"search()\">Search</button>\r\n        <button class=\"btn btn-primary\" (click)=\"createScenario()\">Create Scenario</button>\r\n        <button class=\"btn btn-primary\" (click)=\"cancel()\">Cancel</button>\r\n        <button class=\"btn btn-primary\" (click)=\"clearAllFacilities()\">Remove all facilities</button>\r\n    </div>\r\n    <p-dialog  [(visible)]=\"displaySpinner\" [modal]=true   [closable]=false showEffect=\"fade\">\r\n        <div align=\"center\">\r\n            <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n            <div>Loading please wait ....</div>\r\n            <div>Do Not click back or Refresh the page</div>\r\n        </div>\r\n    </p-dialog>\r\n\r\n    <div class=\"divider\">&nbsp;</div>\r\n</div>"

/***/ },

/***/ 875:
/***/ function(module, exports) {

	module.exports = ".search {\r\n    border: 1px solid #e5e5e5;\r\n    border-radius: 5px;\r\n    margin: 10px 0 20px 0;\r\n    padding: 0 10px 10px 10px;\r\n}\r\n.search h3 {\r\n    text-align: center;\r\n}\r\n.locids {\r\n    border: 1px solid #e5e5e5;\r\n    border-radius: 5px;\r\n    margin: 10px 0 0 5px;\r\n    height: 400px;\r\n    background-color: #f6f6f6;\r\n    overflow: scroll;\r\n}\r\n.locids .header {\r\n    text-align: center;\r\n}\r\n.locids ul {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n.locids ul li a {\r\n    float: right;\r\n    cursor: pointer;\r\n}\r\n.checkbox-group {\r\n    clear: both;\r\n    height: 25px;\r\n    margin-bottom: 5px;\r\n}\r\n.checkbox-group .checkbox {\r\n    margin-top: 5px;\r\n}\r\n.hidden {\r\n    display: none;\r\n}\r\n.more-search-options-panel {\r\n    margin-top: -20px;\r\n}\r\n.more-search-options-panel .glyphicon {\r\n    cursor: pointer;\r\n}\r\n.more-search-options {\r\n    display: block;\r\n}\r\n.totals {\r\n    margin-left: 5px;\r\n}\r\n.search-option-container {\r\n    border: 1px solid #d5d5d5;\r\n    border-radius: 5px;\r\n    clear: both;\r\n    padding: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n.search-option-container .radio {\r\n    margin-left: 20px;\r\n}"

/***/ },

/***/ 876:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var scenario_service_1 = __webpack_require__(692);
	var user_session_1 = __webpack_require__(699);
	var auth_service_1 = __webpack_require__(679);
	var user_info_service_1 = __webpack_require__(695);
	var ScenarioDeleteListComponent = (function () {
	    function ScenarioDeleteListComponent(route, router, _scenarioService, _User, _userInfoService, authService) {
	        this.route = route;
	        this.router = router;
	        this._scenarioService = _scenarioService;
	        this._User = _User;
	        this._userInfoService = _userInfoService;
	        this.authService = authService;
	        this.pageTitle = 'Scenario Delete';
	        this.msgs = [];
	        this.displayPage = "false";
	        this.isScenarioOwner = false;
	        this.ownScenarios = "true";
	    }
	    ScenarioDeleteListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this._scenarioService.getScenarios(this._User.getSession()['id'])
	            .subscribe(function (scenarios) { _this.allScenarios = scenarios; console.log("scenarios:" + _this.allScenarios[0].scenarioName); }, function (error) { return _this.errorMessage = error; }, function () {
	            if (_this._User.hasValidSession()) {
	                _this.setScenarioHeader(_this._User.getSession().scenarioId);
	            }
	            else {
	                _this.setScenarioHeader(_this._User.scenarioId);
	                _this._User.updateSessionState();
	            }
	        });
	        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
	        if (typeof (this._User.scenarioId) === 'undefined')
	            this.router.navigate(['./scenario-activities']);
	        this._userInfoService.isScenarioOwner(this._User.getSession()['id'], this._User.getSession().scenarioId).subscribe(function (success) {
	            _this.isScenarioOwner = success.isOwner;
	            if (_this.isScenarioOwner == false && _this._User.isAdmin == false) {
	                _this.ownScenarios = "false";
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'warn', summary: 'Warn Message', detail: 'We\'re sorry,  your access level does not permit you to view this page. Contact the TAF administrator to change your access privileges.' });
	            }
	        }, function (error) { return _this.errorMessage = error; });
	        this._scenarioService.getDeleteListScenarios(this._User.userId)
	            .subscribe(function (scenarios) { return _this.scenarios = scenarios; }, function (error) { return _this.errorMessage = error; });
	        this.displayPage = "true";
	        this.selectedOptionValues = [];
	    };
	    ScenarioDeleteListComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	        this.scenarioHeaderDiv.innerHTML = "<strong>Current Scenario: " + this.currentScenario.scenarioName + " (" + this.currentScenario.id + ")</strong>";
	    };
	    ScenarioDeleteListComponent.prototype.deleteScenarios = function () {
	        var _this = this;
	        this._scenarioService.deleteScenarios(this.selectedOptionValues)
	            .subscribe(function (msgResponse) { return _this.msgResponse = msgResponse; }, function (error) { return _this.errorMessage = error; }, function () {
	            //console.log("delete response" + this.msgResponse.length);
	            if (_this.errorMessage) {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Delete scenario error"' + _this.errorMessage });
	                return;
	            }
	            else {
	                _this.displayPage = "true";
	            }
	            window.location.reload();
	            // this.router.navigate(['./scenario-activities']);
	        });
	    };
	    ScenarioDeleteListComponent.prototype.updateOptionsList = function (optionInt) {
	        this.selectedOptionValues.push(optionInt);
	    };
	    ScenarioDeleteListComponent.prototype.cancelDelete = function () {
	        this.router.navigate(['./scenario-activities']);
	    };
	    __decorate([
	        core_1.ViewChild('scenarioHeader'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], ScenarioDeleteListComponent.prototype, "scenarioHeader", void 0);
	    ScenarioDeleteListComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(877),
	            styles: [__webpack_require__(700)],
	            directives: [router_1.ROUTER_DIRECTIVES]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, scenario_service_1.ScenarioService, user_session_1.UserSession, user_info_service_1.UserInfoService, auth_service_1.AuthService])
	    ], ScenarioDeleteListComponent);
	    return ScenarioDeleteListComponent;
	}());
	exports.ScenarioDeleteListComponent = ScenarioDeleteListComponent;


/***/ },

/***/ 877:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\" #scenarioHeader></div>\r\n\r\n<div class=\"panel panel-primary\">\r\n    <p-messages [value]=\"msgs\" [closable]=\"false\"></p-messages>\r\n    <button type=\"text\" pButton (click)=\"cancelDelete()\" label=\"Cancel\" *ngIf=\"ownScenarios ==='false'\"  ></button>\r\n    <div class=\"panel-body\" *ngIf=\"ownScenarios ==='true'\" >\r\n        <div class=\"customh2\">Delete a Scenario</div>\r\n        <div *ngIf=\"displayPage=='true'\">\r\n            <div class=\"table-responsive\">\r\n                <table class=\"table table-striped\">\r\n                    <tr>\r\n                        <th>Scenario Name</th>\r\n                        <th>Owner</th>\r\n                        <th>Date Created or Updated</th>\r\n                    </tr>\r\n                    <tr *ngFor=\"let scenario of scenarios\" >\r\n                        <td >\r\n                            <div class=\"checkbox abc-checkbox abc-checkbox-circle\">\r\n                                <label>\r\n                                    <input type=\"checkbox\" value=\"{{scenario.id}}\" (change)=\"updateOptionsList(scenario.id)\">{{scenario.scenarioName}}\r\n                                </label>\r\n                            </div>\r\n                        </td>\r\n                        <td>{{scenario.owner}}</td>\r\n                        <td>{{scenario.lastUpdated | date: 'yMd'}} {{scenario.lastUpdated | date: 'jms'}}</td>\r\n                    </tr>\r\n                </table>\r\n            </div>\r\n            <button type=\"text\" pButton (click)=\"deleteScenarios()\" label=\"Delete\"></button>\r\n            <button type=\"text\" pButton (click)=\"cancelDelete()\" label=\"Cancel\"></button>\r\n        </div>\r\n    </div>\r\n</div>"

/***/ },

/***/ 878:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var scenario_service_1 = __webpack_require__(692);
	var user_session_1 = __webpack_require__(699);
	var primeng_1 = __webpack_require__(708);
	var user_info_service_1 = __webpack_require__(695);
	var auth_service_1 = __webpack_require__(679);
	var ScenarioUpdateComponent = (function () {
	    function ScenarioUpdateComponent(route, router, request, _scenarioService, _userInfoService, _User, authService) {
	        this.route = route;
	        this.router = router;
	        this.request = request;
	        this._scenarioService = _scenarioService;
	        this._userInfoService = _userInfoService;
	        this._User = _User;
	        this.authService = authService;
	        this.pageTitle = 'Scenario Merge';
	        this.msgs = [];
	        this.ownScenarios = "false";
	        this.displaySpinner = false;
	        this.isScenarioOwner = false;
	    }
	    ScenarioUpdateComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        // Setup default request object
	        this.request.userId = this._User.userId;
	        this.request.all = 1;
	        this.request.towerWithoutRadar = 1;
	        this.request.tracon = 1;
	        this.request.combinedTraconTower = 1;
	        this.request.combinedNonRadarTower = 1;
	        this.request.towerWithDisplay = 1;
	        this.request.combinedControlFacility = 1;
	        this.request.towerWithRadar = 1;
	        this.request.enrouteCenter = 1;
	        this.request.combinedTracon = 1;
	        this.request.faaContractTower = 1;
	        this.request.nonFaaFacility = 1;
	        this.request.aopsFlag = 1;
	        this.request.trFlag = 1;
	        this.request.baFlag = 1;
	        this.request.enplFlag = 1;
	        this.request.preserveFlag = 1;
	        this._scenarioService.getScenarios(this._User.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            if (_this._User.hasValidSession()) {
	                _this.setScenarioHeader(_this._User.getSession().scenarioId);
	            }
	            else {
	                _this.setScenarioHeader(_this._User.scenarioId);
	                _this._User.updateSessionState();
	            }
	        });
	        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
	        if (typeof (this._User.scenarioId) === 'undefined')
	            this.router.navigate(['./scenario-activities']);
	        console.log("isScenarioOwner = " + this.isScenarioOwner + " ... isAdmin =  " + this._User.isAdmin);
	        this._userInfoService.isScenarioOwner(this._User.getSession()['id'], this._User.getSession().scenarioId).subscribe(function (success) {
	            _this.isScenarioOwner = success.isOwner;
	            if (_this.isScenarioOwner == false && _this._User.isAdmin == false) {
	                _this.ownScenarios = "false";
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'warn', summary: 'Warn Message', detail: 'We\'re sorry,  your access level does not permit you to view this page. Contact the TAF administrator to change your access privileges.' });
	            }
	        }, function (error) { return _this.errorMessage = error; });
	        //this probably needs to be somewhere more central
	        this._User.updateSessionState();
	        // Set list for Source scenarios
	        this._scenarioService.getMergeListScenarios("source", this._User.userId)
	            .subscribe(function (sourceScenarios) {
	            _this.sourceScenarios = sourceScenarios;
	            if (_this.sourceScenarios.length > 0) {
	                _this.request.scenarioSourceId = _this.sourceScenarios[0].id;
	                _this.request.scenarioSourceName = _this.sourceScenarios[0].scenarioName;
	                _this.ownScenarios = "true";
	            }
	            else {
	                _this.ownScenarios = "false";
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Error Message',
	                    detail: 'Sorry, you do not own any scenario.Please create one scenario if you would like to use this menu.' });
	            }
	        }, function (error) { return _this.errorMessage = error; });
	        // Set list for Target Scenarios
	        this._scenarioService.getMergeListScenarios("target", this._User.userId)
	            .subscribe(function (targetScenarios) { return _this.targetScenarios = targetScenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.request.scenarioTargetId = _this.targetScenarios[0].id;
	            _this.request.scenarioTargetName = _this.targetScenarios[0].scenarioName;
	        });
	    };
	    ScenarioUpdateComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	        this.scenarioHeaderDiv.innerHTML = "<strong>Current Scenario: " + this.currentScenario.scenarioName + " (" + this.currentScenario.id + ")</strong>";
	    };
	    ScenarioUpdateComponent.prototype.onSelectChange = function (event, type) {
	        var select = event.target;
	        if (type == 'source') {
	            this.request.scenarioSourceId = +select.value;
	            this.request.scenarioSourceName = select.options[select.selectedIndex].innerHTML;
	        }
	        if (type == 'target') {
	            this.request.scenarioTargetId = +select.value;
	            this.request.scenarioTargetName = select.options[select.selectedIndex].innerHTML;
	        }
	    };
	    ScenarioUpdateComponent.prototype.onCheckboxChangeParam = function (event) {
	        var checkbox = event.target;
	        switch (checkbox.id) {
	            case 'aopsFlag':
	                this.request.aopsFlag = checkbox.checked ? 1 : 0;
	                break;
	            case 'trFlag':
	                this.request.trFlag = checkbox.checked ? 1 : 0;
	                break;
	            case 'baFlag':
	                this.request.baFlag = checkbox.checked ? 1 : 0;
	                break;
	            case 'enplFlag':
	                this.request.enplFlag = checkbox.checked ? 1 : 0;
	                break;
	            case 'preserveFlag':
	                this.request.preserveFlag = checkbox.checked ? 1 : 0;
	                break;
	        }
	    };
	    ScenarioUpdateComponent.prototype.onCheckboxChange = function (event) {
	        var checkbox = event.target;
	        // If unchecking any checkbox other than all, unmark all checkbox
	        if (checkbox.id !== 'all' && !checkbox.checked) {
	            // this.allCheckbox.checked = false;
	            this.request.all = 0;
	        }
	        // If checking all, check all other checkboxes 
	        if (checkbox.id === 'all' && checkbox.checked) {
	            /* let checkboxes:HTMLInputElement[] = [
	                 this.towerWithoutRadarCheckbox,
	                 this.traconCheckbox,
	                 this.combinedTraconTowerCheckbox,
	                 this.combinedNonRadarTowerCheckbox,
	                 this.towerWithDisplayCheckbox,
	                 this.combinedControlFacilityCheckbox,
	                 this.towerWithRadarCheckbox,
	                 this.enrouteCenterCheckbox,
	                 this.combinedTraconCheckbox,
	                 this.faaContractTowerCheckbox,
	                 this.nonFaaFacilityCheckbox
	             ];
	             checkboxes.forEach(box => {
	                 box.checked = true;
	             });*/
	            this.request.all = 1;
	            this.request.towerWithoutRadar = 1;
	            this.request.tracon = 1;
	            this.request.combinedTraconTower = 1;
	            this.request.combinedNonRadarTower = 1;
	            this.request.towerWithDisplay = 1;
	            this.request.combinedControlFacility = 1;
	            this.request.towerWithRadar = 1;
	            this.request.enrouteCenter = 1;
	            this.request.combinedTracon = 1;
	            this.request.faaContractTower = 1;
	            this.request.nonFaaFacility = 1;
	        }
	        // Set values for post
	        /* switch (checkbox.id) {
	             case 'all':
	                 this.request.all = checkbox.checked ? 1 : 0;
	                 break;
	             case 'towerWithoutRadar':
	                 this.request.towerWithoutRadar = checkbox.checked ? 1 : 0;
	                 break;
	             case 'tracon':
	                 this.request.tracon = checkbox.checked ? 1 : 0;
	                 break;
	             case 'combinedTraconTower':
	                 this.request.combinedTraconTower = checkbox.checked ? 1 : 0;
	                 break;
	             case 'combinedNonRadarTower':
	                 this.request.combinedNonRadarTower = checkbox.checked ? 1 : 0;
	                 break;
	             case 'towerWithDisplay':
	                 this.request.towerWithDisplay = checkbox.checked ? 1 : 0;
	                 break;
	             case 'combinedControlFacility':
	                 this.request.combinedControlFacility = checkbox.checked ? 1 : 0;
	                 break;
	             case 'towerWithRadar':
	                 this.request.towerWithRadar = checkbox.checked ? 1 : 0;
	                 break;
	             case 'enrouteCenter':
	                 this.request.enrouteCenter = checkbox.checked ? 1 : 0;
	                 break;
	             case 'combinedTracon':
	                 this.request.combinedTracon = checkbox.checked ? 1 : 0;
	                 break;
	             case 'faaContractTower':
	                 this.request.faaContractTower = checkbox.checked ? 1 : 0;
	                 break;
	             case 'nonFaaFacility':
	                 this.request.nonFaaFacility = checkbox.checked ? 1 : 0;
	                 break;
	             case 'aopsFlag':
	                 this.request.aopsFlag = checkbox.checked ? 1 : 0;
	                 break;
	             case 'trFlag':
	                 this.request.trFlag = checkbox.checked ? 1 : 0;
	                 break;
	             case 'baFlag':
	                 this.request.baFlag = checkbox.checked ? 1 : 0;
	                 break;
	             case 'enplFlag':
	                 this.request.enplFlag = checkbox.checked ? 1 : 0;
	                 break;
	             case 'preserveFlag':
	                 this.request.preserveFlag = checkbox.checked ? 1 : 0;
	                 break;
	         }*/
	    };
	    ScenarioUpdateComponent.prototype.applyChanges = function () {
	        var _this = this;
	        this.displaySpinner = true;
	        //console.log("Update Scenario Apply Changes");
	        //console.log(this.request);
	        this._scenarioService.updateCommitScenario(this.request)
	            .subscribe(function (response) { return _this.serviceResponse = response; }, function (error) { return _this.errorMessage = error; }, function () {
	            if (_this.errorMessage) {
	                alert(_this.errorMessage);
	                return;
	            }
	            if (_this.serviceResponse.responseStatus === "ERROR") {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: _this.serviceResponse.responseMessage });
	                _this.displaySpinner = false;
	                return;
	            }
	            _this.router.navigate(['./scenario-activities']);
	        });
	    };
	    ScenarioUpdateComponent.prototype.cancel = function () {
	        this.router.navigate(['./scenario-activities']);
	    };
	    __decorate([
	        core_1.ViewChild('scenarioHeader'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], ScenarioUpdateComponent.prototype, "scenarioHeader", void 0);
	    ScenarioUpdateComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(879),
	            styles: [__webpack_require__(700)],
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.Dialog],
	            providers: [scenario_service_1.UpdateCommitScenarioRequest, scenario_service_1.UpdateCommitScenarioResponse]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, scenario_service_1.UpdateCommitScenarioRequest, scenario_service_1.ScenarioService, user_info_service_1.UserInfoService, user_session_1.UserSession, auth_service_1.AuthService])
	    ], ScenarioUpdateComponent);
	    return ScenarioUpdateComponent;
	}());
	exports.ScenarioUpdateComponent = ScenarioUpdateComponent;


/***/ },

/***/ 879:
/***/ function(module, exports) {

	module.exports = "\r\n<div class=\"current-scenario\" #scenarioHeader></div>\r\n<div class=\"panel panel-default\" >\r\n    <p-messages [value]=\"msgs\" [closable]=\"false\"></p-messages>\r\n    <button type=\"text\" pButton (click)=\"cancel()\" label=\"Back\" *ngIf=\"ownScenarios ==='false'\"></button>\r\n    <div *ngIf=\"ownScenarios ==='true'\">\r\n        <div class=\" panel-body\">\r\n            <div class=\"container-fluid\">\r\n                <b>Merge Scenarios</b>\r\n                <div class=\"divider-space\"></div>\r\n                <div class=\"text-danger divider\"><b>Merge</b></div>\r\n                    <div class=\"divider-space\"></div>\r\n\r\n                    <div class=\"row\"  style=\"padding-left:0;padding-right:0\">\r\n                        <div  class=\"col-sm-3\" style=\"padding-right:0;\">\r\n                            <div class=\"custom-checkbox-label\">Choose Source Scenario for Merge</div>\r\n                        </div>\r\n                        <div  class=\"col-sm-4\" style=\"padding-left:0;\">\r\n                            <select class=\"form-control\" (change)=\"onSelectChange($event, 'source')\" style=\"width:250px;height: 30px;\">\r\n                                <option *ngFor=\"let scenario of sourceScenarios\" [value]=\"scenario.id\">{{scenario.scenarioName}} ({{scenario.id}})</option>\r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"row\"  style=\"padding-left:0;padding-right:0\">\r\n                        <div  class=\"col-sm-3\" style=\"padding-right:0;\">\r\n                            <div class=\"custom-checkbox-label\">Choose Target Scenario for Merge</div>\r\n                        </div>\r\n                        <div  class=\"col-sm-4\" style=\"padding-left:0;\">\r\n                            <select class=\"form-control\" (change)=\"onSelectChange($event, 'target')\" style=\"width:250px;height: 30px;\">\r\n                                <option *ngFor=\"let scenario of targetScenarios\" [value]=\"scenario.id\">{{scenario.scenarioName}} ({{scenario.id}})</option> \r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n\r\n            <div class=\"text-danger divider\">&nbsp;</div>\r\n            <div>\r\n                <div class=\"custom-checkbox-label\">Choose Facility Class(es)</div>\r\n                \r\n                <div class=\"checkbox-group\">\r\n                    <div class=\"checkbox\">\r\n                        <label  style=\"font-size:90%\"><input type=\"checkbox\" #all id=\"all\" \r\n                        [ngModel]=\"request.all\" (click)=\"onCheckboxChange($event)\" checked=\"checked\">All Types</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label  style=\"font-size:90%\"><input type=\"checkbox\" #towerWithoutRadar id=\"towerWithoutRadar\" \r\n                        [ngModel]=\"request.towerWithoutRadar\" (click)=\"onCheckboxChange($event)\" checked=\"checked\">Towers Without Radar</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label  style=\"font-size:90%\"><input type=\"checkbox\" #tracon id=\"tracon\" \r\n                        [ngModel]=\"request.tracon\"  (click)=\"onCheckboxChange($event)\" checked=\"checked\">Tracons, Rapcons, or Ceraps</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label style=\"font-size:90%\"><input type=\"checkbox\" #combinedTraconTower id=\"combinedTraconTower\"\r\n                        [ngModel]=\"request.combinedTraconTower\"   (click)=\"onCheckboxChange($event)\" checked=\"checked\">\r\n                        Combined Tracons and Towers with Radar </label>\r\n                    </div>\r\n                </div>\r\n                <div class=\"checkbox-group\">\r\n                    <div class=\"checkbox\">\r\n                        <label  style=\"font-size:90%\"><input type=\"checkbox\" #combinedNonRadarTower id=\"combinedNonRadarTower\" \r\n                        [ngModel]=\"request.combinedNonRadarTower\"  (click)=\"onCheckboxChange($event)\" checked=\"checked\">\r\n                            Combination Non-Radar Approach Control and Towers without Radar \r\n                        </label>\r\n                    </div>\r\n                   <!--  No such airports in TAF, keep as placeholder\r\n                       <div class=\"checkbox\">\r\n                        <label  style=\"font-size:90%\"><input type=\"checkbox\" #towerWithDisplay id=\"towerWithDisplay\" \r\n                        [ngModel]=\"request.towerWithDisplay\"  (click)=\"onCheckboxChange($event)\" checked=\"checked\">Towers With Display</label>\r\n                    </div>-->\r\n                    <div class=\"checkbox\">\r\n                        <label  style=\"font-size:90%\"><input type=\"checkbox\" #combinedControlFacility id=\"combinedControlFacility\" \r\n                        [ngModel]=\"request.combinedControlFacility\"  (click)=\"onCheckboxChange($event)\" checked=\"checked\">\r\n                        Combined Control Facilities</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label  style=\"font-size:90%\"><input type=\"checkbox\" #towerWithRadar id=\"towerWithRadar\" \r\n                        [ngModel]=\"request.towerWithRadar\"  (click)=\"onCheckboxChange($event)\" checked=\"checked\">Towers with Radar </label>\r\n                    </div>\r\n                </div>\r\n                <div class=\"checkbox-group\">\r\n                    <div class=\"checkbox\">\r\n                        <label  style=\"font-size:90%\"><input type=\"checkbox\" #combinedTracon id=\"combinedTracon\" \r\n                        [ngModel]=\"request.combinedTracon\"  (click)=\"onCheckboxChange($event)\" checked=\"checked\">Combined Tracons</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label  style=\"font-size:90%\"><input type=\"checkbox\" #faaContractTower id=\"faaContractTower\" \r\n                        [ngModel]=\"request.faaContractTower\"  (click)=\"onCheckboxChange($event)\" checked=\"checked\">Federal Contract Towers</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label  style=\"font-size:90%\"><input type=\"checkbox\" #nonFaaFacility id=\"nonFaaFacility\" \r\n                        [ngModel]=\"request.nonFaaFacility\"  (click)=\"onCheckboxChange($event)\" checked=\"checked\">Non-FAA Facilities</label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n        <div class=\"text-danger divider\">&nbsp;</div>\r\n            <div>\r\n                <div class=\"custom-checkbox-label\">Choose parameter(s)</div>\r\n                <div class=\"checkbox-group\">\r\n                    <div class=\"checkbox\">\r\n                        <label  style=\"font-size:90%\"><input type=\"checkbox\" id=\"aopsFlag\"\r\n                         [ngModel]=\"request.aopsFlag\"  (click)=\"onCheckboxChangeParam($event)\" checked=\"checked\">Airport Operations</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label  style=\"font-size:90%\"><input type=\"checkbox\" id=\"trFlag\" \r\n                        [ngModel]=\"request.trFlag\"  (click)=\"onCheckboxChangeParam($event)\" checked=\"checked\">Tracon Operations</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label style=\"font-size:90%\"><input type=\"checkbox\" id=\"baFlag\"\r\n                         [ngModel]=\"request.baFlag\"  (click)=\"onCheckboxChangeParam($event)\" checked=\"checked\">Based Aircraft</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label style=\"font-size:90%\" ><input type=\"checkbox\" id=\"enplFlag\" \r\n                        [ngModel]=\"request.enplFlag\"  (click)=\"onCheckboxChangeParam($event)\" checked=\"checked\">Enplanements</label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"divider divider-space\">&nbsp;</div>\r\n\r\n            <div class=\"checkbox-group\">\r\n                <div class=\"checkbox\">\r\n                    <label style=\"font-size:90%\" ><input type=\"checkbox\" id=\"preserveFlag\" checked=\"checked\" \r\n                      [ngModel]=\"request.preserveFlag\" (click)=\"onCheckboxChangeParam($event)\"><b>Preserve Source</b></label>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"divider divider-space\">&nbsp;</div>\r\n\r\n            <button type=\"text\" pButton (click)=\"applyChanges()\" label=\"Apply\"></button>\r\n            <button type=\"text\" pButton (click)=\"cancel()\" label=\"Cancel\"></button>\r\n            \r\n            <p-dialog  [(visible)]=\"displaySpinner\" [modal]=true   [closable]=false showEffect=\"fade\">\r\n                <div align=\"center\">\r\n                    <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n                    <div>Loading please wait ....</div>\r\n                    <div>Do Not click back or Refresh the page</div>\r\n                </div>\r\n            </p-dialog>\r\n        </div>\r\n\r\n    </div>\r\n\r\n</div>\r\n"

/***/ },

/***/ 880:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var scenario_service_1 = __webpack_require__(692);
	var airport_service_1 = __webpack_require__(677);
	var user_session_1 = __webpack_require__(699);
	var user_info_service_1 = __webpack_require__(695);
	var auth_service_1 = __webpack_require__(679);
	var ScenarioModifyFacilitiesComponent = (function () {
	    function ScenarioModifyFacilitiesComponent(route, router, request, _scenarioService, _airportService, _userInfoService, _User, authService) {
	        this.route = route;
	        this.router = router;
	        this.request = request;
	        this._scenarioService = _scenarioService;
	        this._airportService = _airportService;
	        this._userInfoService = _userInfoService;
	        this._User = _User;
	        this.authService = authService;
	        this.pageTitle = 'Scenario Modify Facilities';
	        this.moveCopyLocIdsInput = null;
	        this.autoCompleteMoveCopyQuery = '';
	        this.autoCompleteMoveCopyFilteredList = [];
	        this.autoCompleteDeleteQuery = '';
	        this.autoCompleteDeleteFilteredList = [];
	        this.autoCompleteTargetField = '';
	        this.ownScenarios = "true";
	        this.msgs = [];
	        this.isScenarioOwner = false;
	    }
	    ScenarioModifyFacilitiesComponent.prototype.ngAfterViewInit = function () {
	        // Bind element references
	        this.moveCopyLocIdsInput = this.moveCopyLocIds.nativeElement;
	        this.deleteLocIdsInput = this.deleteLocIds.nativeElement;
	    };
	    ScenarioModifyFacilitiesComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        // Retrieve current scenario to set the current selected scenario name
	        this._scenarioService.getScenarios(this._User.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            if (_this._User.hasValidSession()) {
	                _this.setScenarioHeader(_this._User.getSession().scenarioId);
	            }
	            else {
	                _this.setScenarioHeader(_this._User.scenarioId);
	                _this._User.updateSessionState();
	            }
	        });
	        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
	        if (typeof (this._User.scenarioId) === 'undefined') {
	            this.router.navigate(['./scenario-activities']);
	        }
	        this._userInfoService.isScenarioOwner(this._User.getSession()['id'], this._User.getSession().scenarioId).subscribe(function (success) {
	            _this.isScenarioOwner = success.isOwner;
	            if (_this.isScenarioOwner == false && _this._User.isAdmin == false) {
	                _this.msgs = [];
	                _this.ownScenarios = "false";
	                _this.msgs.push({ severity: 'warn', summary: 'Warn Message', detail: 'We\'re sorry,  your access level does not permit you to view this page. Contact the TAF administrator to change your access privileges.' });
	            }
	        }, function (error) { return _this.errorMessage = error; });
	        // Request defaults
	        this.request.Overwrite = false;
	        this.request.operation = 'move';
	        this.request.currentScenarioId = this._User.getSession().scenarioId;
	        this.request.targetScenarioId = this._User.getSession().scenarioId;
	        this.request.deleteScenarioId = this._User.getSession().scenarioId;
	        /*this._scenarioService.getScenario(this._User.getSession().scenarioId)
	            .subscribe(
	            scenario => this.currentScenario = scenario,
	            error => this.errorMessage = <any>error
	            );*/
	        // Set list for Source scenarios
	        this._scenarioService.getMergeListScenarios("source", this._User.userId)
	            .subscribe(function (sourceScenarios) {
	            _this.sourceScenarios = sourceScenarios;
	            if (_this.sourceScenarios.length == 0) {
	                _this.ownScenarios = "false";
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Error Message',
	                    detail: 'Sorry, you do not own any scenario.Please create one scenario if you would like to use this menu.' });
	            }
	        }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.request.sourceScenarioId = _this.sourceScenarios[0].id;
	            // Set Airport LocIds for autocomplete text field for Move/Copy
	            _this._airportService.getAirportLocIds(_this.sourceScenarios[0].id)
	                .subscribe(function (locIds) { return _this.moveCopyAirportLocIds = locIds; }, function (error) { return _this.errorMessage = error; });
	        });
	        // Set list for Target Scenarios
	        this._scenarioService.getMergeListScenarios("target", this._User.userId)
	            .subscribe(function (targetScenarios) { return _this.targetScenarios = targetScenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            //this.targetScenarios[0].id - this does not work when switching scenarios
	            _this.request.targetScenarioId = _this._User.getSession().scenarioId;
	            _this.request.deleteScenarioId = _this._User.getSession().scenarioId;
	            // Set Airport LocIds for autocomplete text field for Delete
	            _this._airportService.getAirportLocIds(_this._User.getSession().scenarioId)
	                .subscribe(function (locIds) { return _this.deleteAirportLocIds = locIds; }, function (error) { return _this.errorMessage = error; });
	        });
	    };
	    ScenarioModifyFacilitiesComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	        this.scenarioHeaderDiv.innerHTML = "<strong>Current Scenario: " + this.currentScenario.scenarioName + " (" + this.currentScenario.id + ")</strong>";
	    };
	    ScenarioModifyFacilitiesComponent.prototype.onSelectChange = function (event, type, targetSource) {
	        var _this = this;
	        var select = event.target;
	        if (type === 'source') {
	            this.request.sourceScenarioId = +select.value;
	            this._airportService.getAirportLocIds(this.request.sourceScenarioId)
	                .subscribe(function (locIds) { return _this.moveCopyAirportLocIds = locIds; }, function (error) { return _this.errorMessage = error; });
	        }
	        if (type === 'target' && targetSource === 'movecopy') {
	            this.request.targetScenarioId = +select.value;
	            this._airportService.getAirportLocIds(this.request.targetScenarioId)
	                .subscribe(function (locIds) {
	                _this.moveCopyAirportLocIds = locIds;
	            }, function (error) { return _this.errorMessage = error; });
	        }
	        if (type === 'target' && targetSource === 'delete') {
	            this.request.deleteScenarioId = +select.value;
	            this._airportService.getAirportLocIds(this.request.deleteScenarioId)
	                .subscribe(function (locIds) { return _this.deleteAirportLocIds = locIds; }, function (error) { return _this.errorMessage = error; });
	        }
	    };
	    ScenarioModifyFacilitiesComponent.prototype.onChooseActionRadioChange = function (event, action) {
	        this.request.operation = action;
	    };
	    ScenarioModifyFacilitiesComponent.prototype.onOverwriteCheckboxChange = function (event) {
	        var checkbox = event.target;
	        this.request.Overwrite = checkbox.checked;
	    };
	    ScenarioModifyFacilitiesComponent.prototype.onMoveCopyApply = function () {
	        var _this = this;
	        this.msgs = [];
	        if (this.request.operation == "delete") {
	            this.request.operation = "move";
	        }
	        // VALIDATION
	        if (this.request.sourceScenarioId === 1 && this.request.operation === 'move') {
	            this.msgs = [];
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'You cannot move facilities from the National Scenario. Choose Copy or select another source scenario.' });
	            return;
	        }
	        if (this.request.sourceScenarioId === this.request.targetScenarioId) {
	            this.msgs = [];
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'You must choose two different scenarios for Move/Copy' });
	            return;
	        }
	        if (this.moveCopyLocIdsInput === null) {
	            this.msgs = [];
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Please choose at least one facility for this operation.' });
	            return;
	        }
	        else {
	            var locIds = this.moveCopyLocIdsInput.value.replace(/\s*/g, "").replace(/\'/g, "").toUpperCase();
	            //console.log("onMoveCopyApply " +(locIds));
	            this.request.locIds = locIds.split(',');
	            // Sanitize LocIDs list
	            if (this.request.locIds.length === 1 && this.request.locIds[0].length === 0)
	                this.request.locIds.pop();
	        }
	        this._scenarioService.modifyScenarioFacilities(this.request)
	            .subscribe(function (response) {
	            var responseMessage = '';
	            // Facilities not in Source Scenario
	            if (response.notFoundLocIds.length > 0) {
	                responseMessage += 'The following facilities were not found in the source scenario:\r\n';
	                for (var x = 0; x < response.notFoundLocIds.length; x++) {
	                    responseMessage += "- " + response.notFoundLocIds[x] + "\r\n";
	                }
	                responseMessage += '\r\n';
	            }
	            // Facilities that have been overwritten
	            if (response.overwrittenLocIds.length > 0) {
	                responseMessage += 'The following facilities have been overwritten in the destination scenario:\r\n';
	                for (var x = 0; x < response.overwrittenLocIds.length; x++) {
	                    responseMessage += "- " + response.overwrittenLocIds[x] + "\r\n";
	                }
	                responseMessage += '\r\n';
	            }
	            // Facilities that already exist in the destination (not set for overwrite)
	            if (response.existingLocIds.length > 0) {
	                responseMessage += "The following facilities already exist in the destination scenario and will not be " + (_this.request.operation === 'move' ? 'moved' : 'copied') + " from the source scenario:\r\n";
	                for (var x = 0; x < response.existingLocIds.length; x++) {
	                    responseMessage += "- " + response.existingLocIds[x] + "\r\n";
	                }
	            }
	            // Facilities that were processed in the move/Copy
	            if (response.processedLocIds.length > 0) {
	                responseMessage += "The following facilities where successfully " + (_this.request.operation === 'move' ? 'moved' : 'copied') + ":\r\n";
	                for (var x = 0; x < response.processedLocIds.length; x++) {
	                    responseMessage += "- " + response.processedLocIds[x] + "\r\n";
	                }
	            }
	            _this.msgs = [];
	            _this.msgs.push({ severity: 'info', summary: 'Info Message', detail: responseMessage });
	            //this.router.navigate(['./scenario-activities']);
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    ScenarioModifyFacilitiesComponent.prototype.onDeleteApply = function () {
	        var _this = this;
	        this.request.operation = "delete";
	        var locIds = this.deleteLocIdsInput.value.replace(/\s*/g, "").replace(/\'/g, "").toUpperCase();
	        this.request.locIds = locIds.split(',');
	        if (locIds.length === 0) {
	            this.msgs = [];
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Please choose at least one facility for this operation!' });
	            return;
	        }
	        this._scenarioService.modifyScenarioFacilities(this.request)
	            .subscribe(function (response) {
	            var responseMessage = '';
	            // Facilities not in target scenario
	            if (response.invalidDeletedLocIds.length > 0) {
	                responseMessage += 'The following facilities were not in the designated scenario and therefore could not be deleted:';
	                for (var x = 0; x < response.invalidDeletedLocIds.length; x++) {
	                    responseMessage += "- " + response.invalidDeletedLocIds[x];
	                }
	            }
	            // Facilities that were deleted
	            if (response.deletedLocIds.length > 0) {
	                responseMessage += "Deleted Facilities:";
	                for (var x = 0; x < response.deletedLocIds.length; x++) {
	                    responseMessage += "- " + response.deletedLocIds[x];
	                }
	            }
	            _this.msgs = [];
	            _this.msgs.push({ severity: 'Info', summary: 'Info Message', detail: responseMessage });
	            //this.router.navigate(['./scenario-activities']);
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    ScenarioModifyFacilitiesComponent.prototype.cancel = function () {
	        this.router.navigate(['./scenario-activities']);
	    };
	    ScenarioModifyFacilitiesComponent.prototype.autoCompleteFilter = function (targetField) {
	        this.autoCompleteTargetField = targetField;
	        if (this.autoCompleteMoveCopyQuery.trim().length === 0 && this.autoCompleteDeleteQuery.trim().length === 0) {
	            this.autoCompleteMoveCopyFilteredList = [];
	            this.autoCompleteDeleteFilteredList = [];
	            return;
	        }
	        if (this.autoCompleteMoveCopyQuery.trim().length > 0) {
	            this.autoCompleteMoveCopyFilteredList = this.moveCopyAirportLocIds.filter(function (el) {
	                return el.toUpperCase().indexOf(this.autoCompleteMoveCopyQuery.split(',')[this.autoCompleteMoveCopyQuery.split(',').length - 1].trim().toUpperCase()) > -1;
	            }.bind(this));
	        }
	        if (this.autoCompleteDeleteQuery.trim().length > 0) {
	            this.autoCompleteDeleteFilteredList = this.deleteAirportLocIds.filter(function (el) {
	                return el.toUpperCase().indexOf(this.autoCompleteDeleteQuery.split(',')[this.autoCompleteDeleteQuery.split(',').length - 1].trim().toUpperCase()) > -1;
	            }.bind(this));
	        }
	    };
	    ScenarioModifyFacilitiesComponent.prototype.autoCompleteSelect = function (fieldTarget, item) {
	        var inputValue = '';
	        if (fieldTarget !== 'movecopy' && fieldTarget !== 'delete')
	            return;
	        if (fieldTarget === 'movecopy') {
	            for (var x = 0; x < this.moveCopyLocIdsInput.value.split(',').length - 1; x++) {
	                inputValue += this.moveCopyLocIdsInput.value.split(',')[x] + ',';
	            }
	            this.autoCompleteMoveCopyQuery = inputValue + item;
	        }
	        if (fieldTarget === 'delete') {
	            for (var x = 0; x < this.deleteLocIdsInput.value.split(',').length - 1; x++) {
	                inputValue += this.deleteLocIdsInput.value.split(',')[x] + ',';
	            }
	            this.autoCompleteDeleteQuery = inputValue + item;
	        }
	        this.autoCompleteMoveCopyFilteredList = [];
	        this.autoCompleteDeleteFilteredList = [];
	    };
	    __decorate([
	        core_1.ViewChild('moveCopyLocIds'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], ScenarioModifyFacilitiesComponent.prototype, "moveCopyLocIds", void 0);
	    __decorate([
	        core_1.ViewChild('deleteLocIds'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], ScenarioModifyFacilitiesComponent.prototype, "deleteLocIds", void 0);
	    __decorate([
	        core_1.ViewChild('scenarioHeader'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], ScenarioModifyFacilitiesComponent.prototype, "scenarioHeader", void 0);
	    ScenarioModifyFacilitiesComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(881),
	            styles: [__webpack_require__(700)],
	            directives: [router_1.ROUTER_DIRECTIVES],
	            providers: [scenario_service_1.ModifyScenarioFacilitiesRequest, scenario_service_1.ModifyScenarioFacilitiesResponse]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, scenario_service_1.ModifyScenarioFacilitiesRequest, scenario_service_1.ScenarioService, airport_service_1.AirportService, user_info_service_1.UserInfoService, user_session_1.UserSession, auth_service_1.AuthService])
	    ], ScenarioModifyFacilitiesComponent);
	    return ScenarioModifyFacilitiesComponent;
	}());
	exports.ScenarioModifyFacilitiesComponent = ScenarioModifyFacilitiesComponent;


/***/ },

/***/ 881:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\" #scenarioHeader></div>\r\n<div class=\"panel panel-default\" >\r\n<p-messages [value]=\"msgs\" [closable]=\"false\"></p-messages>\r\n<button type=\"text\" pButton (click)=\"cancel()\" label=\"Back\" *ngIf=\"ownScenarios ==='false'\"></button>\r\n<div *ngIf=\"ownScenarios ==='true'\" >\r\n    <h1>Move, Copy or Delete Scenario Facilities</h1>\r\n    <div class=\"panel-body\">\r\n        <fieldset>\r\n            <div class=\"customh2\">Move/Copy</div>\r\n            <div>\r\n                <div class=\"merge-column\">\r\n                    <div class=\"section-title\">Choose Source Scenario for Merge</div>\r\n                    <select class=\"form-control\" (change)=\"onSelectChange($event, 'source', 'movecopy')\">\r\n                        <option *ngFor=\"let scenario of sourceScenarios\" [value]=\"scenario.id\">{{scenario.scenarioName}} ({{scenario.id}})</option>\r\n                    </select>\r\n                </div>\r\n\r\n                <div class=\"merge-column\">\r\n                    <div class=\"section-title\">Choose Target Scenario for Merge</div>\r\n                    <select class=\"form-control\" (change)=\"onSelectChange($event, 'target', 'movecopy')\">\r\n                        <option *ngFor=\"let scenario of targetScenarios\" [value]=\"scenario.id\"  [selected]=\"scenario.id === currentScenario.id\">{{scenario.scenarioName}} ({{scenario.id}})</option> \r\n                    </select>\r\n                </div>\r\n\r\n                <div class=\"divider\">&nbsp;</div>\r\n\r\n                <div>\r\n                    <div class=\"section-title\">Choose an action</div>\r\n                    <div class=\"radio-group\">\r\n                        <div class=\"radio\">\r\n                            <label><input type=\"radio\" name=\"move-copy-input\" (click)=\"onChooseActionRadioChange($event, 'move')\" checked=\"checked\">Move</label>\r\n                        </div>\r\n                        <div class=\"radio\">\r\n                            <label><input type=\"radio\" name=\"move-copy-input\"  (click)=\"onChooseActionRadioChange($event, 'copy')\">Copy</label>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n\r\n                <div class=\"divider\">&nbsp;</div>\r\n\r\n                <div>\r\n                    <div class=\"section-title\">Facilities from Source Scenario</div>\r\n                    <div class=\"field-group\">\r\n                        Enter facilities as a comma-separated list of LOCIDs, in any order.<br/>\r\n                        For example: <strong>BOS, ATL, LAX, PDX, IAD</strong>\r\n\r\n                        <input type=\"text\" #moveCopyLocIds class=\"form-control\" [(ngModel)]=\"autoCompleteMoveCopyQuery\" (keyup)=\"autoCompleteFilter('movecopy')\"/>\r\n                        <div class=\"suggestions\" *ngIf=\"autoCompleteTargetField === 'movecopy' && autoCompleteMoveCopyFilteredList.length > 0\">\r\n                            <ul *ngFor=\"let item of autoCompleteMoveCopyFilteredList\">\r\n                                <li>\r\n                                    <a (click)=\"autoCompleteSelect('movecopy', item)\">{{item}}</a>\r\n                                </li>\r\n                            </ul>\r\n                        </div>\r\n\r\n                        <div class=\"checkbox\" (click)=\"onOverwriteCheckboxChange($event)\">\r\n                            <label><input type=\"checkbox\">\r\n                             If a facility already exists in the destination scenario, \r\n                             check this box and the destination facility will be overwritten with the \r\n                             source upon move/copy.\r\n                            </label>\r\n                        </div>\r\n                    </div>\r\n\r\n                    <div class=\"divider\">&nbsp;</div>\r\n\r\n                    <button  type=\"text\" pButton (click)=\"onMoveCopyApply()\" label=\"Apply\"></button>\r\n                    <button  type=\"text\" pButton (click)=\"cancel()\" label=\"Cancel\"></button>\r\n                    \r\n                </div>\r\n            </div>\r\n        </fieldset>\r\n    </div>\r\n\r\n    <div class=\"divider divider-space\"></div>\r\n    <div class=\"panel-body\">\r\n        <fieldset>\r\n            <div class=\"customh2\">Delete</div>\r\n            <div>\r\n                Enter facilities as a comma-separated list of LOCIDs, in any order.<br>\r\n                For example: <strong>BOS, ATL, LAX, PDX, IAD</strong>\r\n\r\n                <div class=\"divider\">&nbsp;</div>\r\n\r\n                <div class=\"merge-column\">\r\n                    <div class=\"section-title\">Choose Destination Scenario</div>\r\n                    <select class=\"form-control\" (change)=\"onSelectChange($event, 'target', 'delete')\">\r\n                        <option *ngFor=\"let scenario of targetScenarios\" [value]=\"scenario.id\" [selected]=\"scenario.id === currentScenario.id\">\r\n                            {{scenario.scenarioName}} ({{scenario.id}})</option>\r\n                    </select>\r\n                </div>\r\n\r\n                <div class=\"divider\">&nbsp;</div>\r\n\r\n                <div class=\"section-title\">Delete facilities from Destination Scenario</div>\r\n\r\n                <input type=\"text\" #deleteLocIds class=\"form-control\" [(ngModel)]=\"autoCompleteDeleteQuery\" (keyup)=\"autoCompleteFilter('delete')\"/>\r\n                        <div class=\"suggestions\" *ngIf=\"autoCompleteTargetField === 'delete' && autoCompleteDeleteFilteredList.length > 0\">\r\n                            <ul *ngFor=\"let item of autoCompleteDeleteFilteredList\">\r\n                                <li>\r\n                                    <a (click)=\"autoCompleteSelect('delete', item)\">{{item}}</a>\r\n                                </li>\r\n                            </ul>\r\n                        </div>\r\n\r\n                <div class=\"divider\">&nbsp;</div>\r\n                \r\n                <button  type=\"text\" pButton  (click)=\"onDeleteApply()\" label=\"Apply\"></button>\r\n                <button  type=\"text\" pButton (click)=\"cancel()\" label=\"Cancel\"></button>\r\n                \r\n            </div>\r\n        </fieldset>\r\n    </div>\r\n</div>\r\n</div>\r\n"

/***/ },

/***/ 882:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var scenario_service_1 = __webpack_require__(692);
	var commondata_service_1 = __webpack_require__(693);
	var user_session_1 = __webpack_require__(699);
	var airport_operations_1 = __webpack_require__(883);
	var based_aircraft_1 = __webpack_require__(884);
	var enplanements_1 = __webpack_require__(885);
	var tracon_operations_1 = __webpack_require__(886);
	var ScenarioReforecastComponent = (function () {
	    function ScenarioReforecastComponent(_router, _commonDataService, _scenarioService, _user, _request) {
	        this._router = _router;
	        this._commonDataService = _commonDataService;
	        this._scenarioService = _scenarioService;
	        this._user = _user;
	        this._request = _request;
	        this.pageTitle = 'Reforecast Using Stored Rates';
	        this.startYears = [];
	        this.endYears = [];
	        this.aopsEnabled = false;
	        this.basedAircraftEnabled = false;
	        this.enplanementsEnabled = false;
	        this.traconsEnabled = false;
	        this.aopsCssClass = 'glyphicon glyphicon-chevron-right';
	        this.basedAircraftCssClass = 'glyphicon glyphicon-chevron-right';
	        this.enplanementsCssClass = 'glyphicon glyphicon-chevron-right';
	        this.traconsCssClass = 'glyphicon glyphicon-chevron-right';
	        this.aopsMenuCssClass = 'menu-items';
	        this.baMenuCssClass = 'menu-items';
	        this.enplMenuCssClass = 'menu-items';
	        this.traconMenuCssClass = 'menu-items';
	        this.reforecastButtonCssClass = 'btn btn-primary';
	        this.reforecastButtonSpinnerCssClass = 'hidden';
	        this.reforecastButtonText = 'Reforecast';
	        this.processingCssClass = 'processing';
	        this.displaySpinner = false;
	        this.msgs = [];
	        this.bProcess = false;
	    }
	    ScenarioReforecastComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.displaySpinner = false;
	        if (typeof (this._user.scenarioId) === 'undefined')
	            this._router.navigate(['./scenario-activities']);
	        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
	        this._scenarioService.getScenarios(this._user.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.setScenarioHeader(_this._user.getSession().scenarioId);
	        });
	        // Retrieve SystemControl so we can populate years for the date ranges
	        this._commonDataService.getSystemControlData()
	            .subscribe(function (record) {
	            var minYear = record.fyYear - 3;
	            var maxYear = record.lfcYear;
	            for (var x = minYear; x <= maxYear; x++) {
	                _this.startYears.push(x);
	            }
	            for (var x = maxYear; x >= minYear; x--) {
	                _this.endYears.push(x);
	            }
	            _this._request.startYear = _this.startYears[0];
	            _this._request.endYear = _this.endYears[0];
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    ScenarioReforecastComponent.prototype.onScenarioChange = function (event) {
	        var selectedScenarioId = +event.target.value;
	        this._user.scenarioId = selectedScenarioId;
	        this.setScenarioHeader(selectedScenarioId);
	        this._user.updateSessionState();
	    };
	    ScenarioReforecastComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	        this.scenarioHeaderDiv.innerHTML = "<strong>Current Scenario: " + this.currentScenario.scenarioName + " (" + this.currentScenario.id + ")</strong>";
	    };
	    ScenarioReforecastComponent.prototype.menuClick = function (event, menu) {
	        switch (menu) {
	            case 'aops':
	                if (!this.aopsEnabled) {
	                    this.aopsEnabled = true;
	                    this.aopsCssClass = this.aopsCssClass.replace('right', 'down');
	                    this.aopsMenuCssClass = this.aopsMenuCssClass.concat('-visible');
	                    this._request.airportOperations = new airport_operations_1.AirportOperations();
	                    this._request.airportOperations.ifrItnAt = false;
	                    this._request.airportOperations.ifrItnAc = false;
	                    this._request.airportOperations.ifrItnGa = false;
	                    this._request.airportOperations.ifrItnMi = false;
	                    this._request.airportOperations.itnAirCarrier = false;
	                    this._request.airportOperations.itnAirTaxi = false;
	                    this._request.airportOperations.itnGa = false;
	                    this._request.airportOperations.itnMil = false;
	                    this._request.airportOperations.localGa = false;
	                    this._request.airportOperations.localMil = false;
	                    this._request.airportOperations.totalOverflights = false;
	                }
	                else {
	                    this.aopsEnabled = false;
	                    this.aopsCssClass = this.aopsCssClass.replace('down', 'right');
	                    this.aopsMenuCssClass = this.aopsMenuCssClass.replace('-visible', '');
	                    this._request.airportOperations = undefined;
	                }
	                break;
	            case 'ba':
	                if (!this.basedAircraftEnabled) {
	                    this.basedAircraftEnabled = true;
	                    this.basedAircraftCssClass = this.basedAircraftCssClass.replace('right', 'down');
	                    this.baMenuCssClass = this.baMenuCssClass.concat('-visible');
	                    this._request.basedAircraft = new based_aircraft_1.BasedAircraft();
	                    this._request.basedAircraft.helicopter = false;
	                    this._request.basedAircraft.jet = false;
	                    this._request.basedAircraft.multi = false;
	                    this._request.basedAircraft.other = false;
	                    this._request.basedAircraft.single = false;
	                }
	                else {
	                    this.basedAircraftEnabled = false;
	                    this.basedAircraftCssClass = this.basedAircraftCssClass.replace('down', 'right');
	                    this.baMenuCssClass = this.baMenuCssClass.replace('-visible', '');
	                    this._request.basedAircraft = undefined;
	                }
	                break;
	            case 'enpl':
	                if (!this.enplanementsEnabled) {
	                    this.enplanementsEnabled = true;
	                    this.enplanementsCssClass = this.enplanementsCssClass.replace('right', 'down');
	                    this.enplMenuCssClass = this.enplMenuCssClass.concat('-visible');
	                    this._request.enplanements = new enplanements_1.Enplanements();
	                    this._request.enplanements.airCarrier = false;
	                    this._request.enplanements.airTaxi = false;
	                    this._request.enplanements.commuter = false;
	                    this._request.enplanements.foreignFlag = false;
	                    this._request.enplanements.usFlag = false;
	                }
	                else {
	                    this.enplanementsEnabled = false;
	                    this.enplanementsCssClass = this.enplanementsCssClass.replace('down', 'right');
	                    this.enplMenuCssClass = this.enplMenuCssClass.replace('-visible', '');
	                    this._request.enplanements = undefined;
	                }
	                break;
	            case 'tracon':
	                if (!this.traconsEnabled) {
	                    this.traconsEnabled = true;
	                    this.traconsCssClass = this.traconsCssClass.replace('right', 'down');
	                    this.traconMenuCssClass = this.traconMenuCssClass.concat('-visible');
	                    this._request.traconOperations = new tracon_operations_1.TraconOperations();
	                    this._request.traconOperations.airCarrier = false;
	                    this._request.traconOperations.airTaxi = false;
	                    this._request.traconOperations.generalAviation = false;
	                    this._request.traconOperations.military = false;
	                    this._request.traconOperations.totalOverflights = false;
	                }
	                else {
	                    //alert(" traconenable=false");
	                    this.traconsEnabled = false;
	                    this.traconsCssClass = this.traconsCssClass.replace('down', 'right');
	                    this.traconMenuCssClass = this.traconMenuCssClass.replace('-visible', '');
	                    this._request.traconOperations = undefined;
	                }
	                break;
	        }
	    };
	    ScenarioReforecastComponent.prototype.onSelectChange = function (event, source) {
	        var select = event.target;
	        switch (source) {
	            case 'scenario':
	                this._request.scenarioId = +select.value;
	                var scenarioId_1 = this._request.scenarioId;
	                var match = this.allScenarios.filter(function (s) {
	                    return s.id === scenarioId_1;
	                })[0];
	                this._request.setNameInSession(match.scenarioName);
	                break;
	            case 'startYears':
	                this._request.startYear = +select.value;
	                break;
	            case 'endYears':
	                this._request.endYear = +select.value;
	                break;
	        }
	    };
	    ScenarioReforecastComponent.prototype.onCheckboxChange = function (event, section, option) {
	        var checkbox = event.target;
	        switch (section) {
	            case 'aops':
	                switch (option) {
	                    case 'itnAirCarrier':
	                        this._request.airportOperations.itnAirCarrier = checkbox.checked;
	                        break;
	                    case 'itnAirTaxi':
	                        this._request.airportOperations.itnAirTaxi = checkbox.checked;
	                        break;
	                    case 'itnGa':
	                        this._request.airportOperations.itnGa = checkbox.checked;
	                        break;
	                    case 'itnMil':
	                        this._request.airportOperations.itnMil = checkbox.checked;
	                        break;
	                    case 'localGa':
	                        this._request.airportOperations.localGa = checkbox.checked;
	                        break;
	                    case 'localMil':
	                        this._request.airportOperations.localMil = checkbox.checked;
	                        break;
	                    case 'totalOverflights':
	                        this._request.airportOperations.totalOverflights = checkbox.checked;
	                        break;
	                    case 'ifrItnAc':
	                        this._request.airportOperations.ifrItnAc = checkbox.checked;
	                        break;
	                    case 'ifrItnAt':
	                        this._request.airportOperations.ifrItnAt = checkbox.checked;
	                        break;
	                    case 'ifrItnGa':
	                        this._request.airportOperations.ifrItnGa = checkbox.checked;
	                        break;
	                    case 'ifrItnMi':
	                        this._request.airportOperations.ifrItnMi = checkbox.checked;
	                        break;
	                }
	                break;
	            case 'ba':
	                switch (option) {
	                    case 'single':
	                        this._request.basedAircraft.single = checkbox.checked;
	                        break;
	                    case 'jet':
	                        this._request.basedAircraft.jet = checkbox.checked;
	                        break;
	                    case 'multi':
	                        this._request.basedAircraft.multi = checkbox.checked;
	                        break;
	                    case 'helicopter':
	                        this._request.basedAircraft.helicopter = checkbox.checked;
	                        break;
	                    case 'other':
	                        this._request.basedAircraft.other = checkbox.checked;
	                        break;
	                }
	                break;
	            case 'enpl':
	                switch (option) {
	                    case 'airCarrier':
	                        this._request.enplanements.airCarrier = checkbox.checked;
	                        break;
	                    case 'airTaxi':
	                        this._request.enplanements.airTaxi = checkbox.checked;
	                        break;
	                    case 'commuter':
	                        this._request.enplanements.commuter = checkbox.checked;
	                        break;
	                    case 'usFlag':
	                        this._request.enplanements.usFlag = checkbox.checked;
	                        break;
	                    case 'foreignFlag':
	                        this._request.enplanements.foreignFlag = checkbox.checked;
	                        break;
	                }
	                break;
	            case 'tracon':
	                switch (option) {
	                    case 'airCarrier':
	                        this._request.traconOperations.airCarrier = checkbox.checked;
	                        break;
	                    case 'airTaxi':
	                        this._request.traconOperations.airTaxi = checkbox.checked;
	                        break;
	                    case 'generalAviation':
	                        this._request.traconOperations.generalAviation = checkbox.checked;
	                        break;
	                    case 'military':
	                        this._request.traconOperations.military = checkbox.checked;
	                        break;
	                    case 'totalOverflights':
	                        this._request.traconOperations.totalOverflights = checkbox.checked;
	                        break;
	                }
	                break;
	        }
	    };
	    ScenarioReforecastComponent.prototype.reforecast = function () {
	        var _this = this;
	        if (this._request.startYear >= this._request.endYear) {
	            this.msgs = [];
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Start year must be less than End year' });
	            this.bProcess = true;
	        }
	        // Check if all datasets is set to null
	        if ((typeof (this._request.airportOperations) === 'undefined') &&
	            typeof (this._request.basedAircraft) === 'undefined' &&
	            typeof (this._request.enplanements) === 'undefined' &&
	            typeof (this._request.traconOperations) === 'undefined') {
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Please select a dataset' });
	            this.bProcess = true;
	        }
	        // Check Airport Operations dataset options
	        if (typeof (this._request.airportOperations) != 'undefined' &&
	            (this._request.airportOperations.ifrItnAc === false) &&
	            (this._request.airportOperations.ifrItnAt === false) &&
	            (this._request.airportOperations.ifrItnGa === false) &&
	            (this._request.airportOperations.ifrItnMi === false) &&
	            (this._request.airportOperations.itnAirCarrier === false) &&
	            (this._request.airportOperations.itnAirTaxi === false) &&
	            (this._request.airportOperations.itnGa === false) &&
	            (this._request.airportOperations.itnMil === false) &&
	            (this._request.airportOperations.localGa === false) &&
	            (this._request.airportOperations.localMil === false) &&
	            (this._request.airportOperations.totalOverflights === false)) {
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Please select a dataset option from Airport Operations' });
	            this.bProcess = true;
	        }
	        // Check Based Aircraft dataset options
	        if (typeof (this._request.basedAircraft) != 'undefined' &&
	            (this._request.basedAircraft.helicopter === false) &&
	            (this._request.basedAircraft.jet === false) &&
	            (this._request.basedAircraft.multi === false) &&
	            (this._request.basedAircraft.other === false) &&
	            (this._request.basedAircraft.single === false)) {
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Please select a dataset option from Based Aircraft' });
	            this.bProcess = true;
	        }
	        // Check Enplanements dataset options
	        if (typeof (this._request.enplanements) != 'undefined' &&
	            (this._request.enplanements.airCarrier === false) &&
	            (this._request.enplanements.airTaxi === false) &&
	            (this._request.enplanements.commuter === false) &&
	            (this._request.enplanements.foreignFlag === false) &&
	            (this._request.enplanements.usFlag === false)) {
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Please select a dataset option from Enplanements' });
	            this.bProcess = true;
	        }
	        // Check Tracon Operations dataset options
	        if (typeof (this._request.traconOperations) != 'undefined' &&
	            (this._request.traconOperations.airCarrier === false) &&
	            (this._request.traconOperations.airTaxi === false) &&
	            (this._request.traconOperations.generalAviation === false) &&
	            (this._request.traconOperations.military === false) &&
	            (this._request.traconOperations.totalOverflights === false)) {
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Please select a dataset option from Tracon Operations' });
	            this.bProcess = true;
	        }
	        if (!this.bProcess) {
	            this.msgs = [];
	            this.displaySpinner = true;
	            this.processingCssClass = this.processingCssClass.concat('-visible');
	            this.reforecastButtonCssClass = this.reforecastButtonCssClass.replace('btn-primary', 'btn-processing');
	            this.reforecastButtonText = '   Processing...';
	            this._scenarioService.executeReforecast(this._request)
	                .subscribe(function (response) {
	                _this.displaySpinner = false;
	                if (response.responseStatus === 'ERROR') {
	                    _this.processingCssClass = _this.processingCssClass.replace('-visible', '');
	                    _this.reforecastButtonCssClass = _this.reforecastButtonCssClass.replace('btn-processing', 'btn-primary');
	                    _this.reforecastButtonSpinnerCssClass = 'hidden';
	                    _this.reforecastButtonText = 'Reforecast';
	                    _this.msgs = [];
	                    _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'An error has occurred executing your request' });
	                    return;
	                }
	                _this._router.navigate(['./scenario-reforecast-complete']);
	            }, function (error) { return _this.errorMessage = error; });
	        }
	        else {
	            this.bProcess = false;
	        }
	    };
	    ScenarioReforecastComponent.prototype.cancel = function () {
	        this._router.navigate(['./scenario-activities']);
	    };
	    __decorate([
	        core_1.ViewChild('scenarioHeader'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], ScenarioReforecastComponent.prototype, "scenarioHeader", void 0);
	    ScenarioReforecastComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(887),
	            styles: [__webpack_require__(700)],
	            providers: [scenario_service_1.ScenarioForecastRequest, airport_operations_1.AirportOperations, based_aircraft_1.BasedAircraft, enplanements_1.Enplanements, tracon_operations_1.TraconOperations],
	            directives: [router_1.ROUTER_DIRECTIVES],
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, commondata_service_1.CommonDataService, scenario_service_1.ScenarioService, user_session_1.UserSession, scenario_service_1.ScenarioForecastRequest])
	    ], ScenarioReforecastComponent);
	    return ScenarioReforecastComponent;
	}());
	exports.ScenarioReforecastComponent = ScenarioReforecastComponent;


/***/ },

/***/ 883:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var AirportOperations = (function () {
	    function AirportOperations() {
	    }
	    AirportOperations = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], AirportOperations);
	    return AirportOperations;
	}());
	exports.AirportOperations = AirportOperations;


/***/ },

/***/ 884:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var BasedAircraft = (function () {
	    function BasedAircraft() {
	    }
	    BasedAircraft = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], BasedAircraft);
	    return BasedAircraft;
	}());
	exports.BasedAircraft = BasedAircraft;


/***/ },

/***/ 885:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var Enplanements = (function () {
	    function Enplanements() {
	    }
	    Enplanements = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], Enplanements);
	    return Enplanements;
	}());
	exports.Enplanements = Enplanements;


/***/ },

/***/ 886:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var TraconOperations = (function () {
	    function TraconOperations() {
	    }
	    TraconOperations = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], TraconOperations);
	    return TraconOperations;
	}());
	exports.TraconOperations = TraconOperations;


/***/ },

/***/ 887:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\" #scenarioHeader></div>\r\n<div class=\"panel panel-default\" >\r\n    <div class=\" panel-body\">\r\n        <p-messages [value]=\"msgs\" [closable]=\"false\"></p-messages>\r\n        <div class=\"container-fluid\">\r\n                <div class=\"text-danger divider\"><b>Reforecast Using Stored Rates</b></div>\r\n                <div class=\"divider-space\"></div>\r\n                <div class=\"row\"  style=\"padding-left:0;padding-right:0\">\r\n                    <div  class=\"col-sm-1\" style=\"padding-right:0;\">\r\n                        <div class=\"custom-checkbox-label\">Scenario:</div>\r\n                    </div>\r\n                     <div  class=\"col-sm-1\" style=\"padding-left:0;\">\r\n                        <select class=\"form-control\" (change)=\"onScenarioChange($event)\" style=\"width:250px;height: 30px;\">\r\n                            <option *ngFor=\"let item of allScenarios\" [value]=\"item.id\" [selected]=\"item.id === currentScenario.id\">{{item.scenarioName}}({{item.id}})</option> \r\n                        </select>\r\n                    </div>\r\n                </div>\r\n                <div class=\"divider-space\"></div>\r\n                <div class=\"row\"  style=\"padding-left:0;padding-right:0\">\r\n                    <div class=\"col-sm-1\"  style=\"padding-right:0;\">\r\n                        <div class=\"custom-checkbox-label\" >Start year:</div>\r\n                    </div>\r\n                    <div class=\"col-sm-1\" style=\"padding-left:0;\">\r\n                        <select class=\"form-control\" (change)=\"onSelectChange($event, 'startYears')\" style=\"width:100px;height:30px;\">\r\n                            <option *ngFor=\"let year of startYears\" [value]=\"year\">{{year}}</option>\r\n                        </select>\r\n                    </div>\r\n                    <div class=\"col-sm-1\"  style=\"padding-right:0\">\r\n                        <div class=\"custom-checkbox-label\"> to End Year:</div>\r\n                    </div>\r\n                    <div class=\"col-sm-1\" style=\"padding-left:0\">\r\n                        <select class=\"form-control\" (change)=\"onSelectChange($event, 'endYears')\" style=\"width:100px;height:30px;\">\r\n                            <option *ngFor=\"let year of endYears\" [value]=\"year\">{{year}}</option>\r\n                        </select>\r\n                    </div>\r\n                </div>\r\n            <div class=\"divider-space\"></div>\r\n            <div class=\"text-danger divider\"><b> Select Data Sets</b></div>\r\n\r\n            <div class=\"menu-section col-sm-3\">\r\n                <span [ngClass]=\"aopsCssClass\" (click)=\"menuClick($event,'aops')\"></span> Airport Operations\r\n\r\n                <div [ngClass]=\"aopsMenuCssClass\" >\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'aops','itnAirCarrier')\" >Itn air carrier</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'aops','itnAirTaxi')\" >Itn air taxi</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'aops','itnGa')\" >Itn ga</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'aops','itnMil')\" >Itn mil</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'aops','localGa')\" >Local civil</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'aops','localMil')\" >Local mil</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'aops','totalOverflights')\" >Total Overflights</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'aops','ifrItnAc')\" >IFR Itn ac</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'aops','ifrItnAt')\" >IFR Itn at</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'aops','ifrItnGa')\" >IFR Itn ga</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'aops','ifrItnMi')\" >IFR Itn Mi</label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            \r\n            <div class=\"menu-section col-sm-3\">\r\n                <span [ngClass]=\"basedAircraftCssClass\" (click)=\"menuClick($event,'ba')\"></span> Based Aircraft\r\n\r\n                <div [ngClass]=\"baMenuCssClass\" >\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'ba','single')\" >Single</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'ba','jet')\" >Jet</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'ba','multi')\" >Multi</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'ba','helo')\" >Helicopter</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'ba','other')\" >Other</label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"menu-section col-sm-3\">\r\n                <span [ngClass]=\"enplanementsCssClass\" (click)=\"menuClick($event,'enpl')\"></span> Enplanements\r\n\r\n                <div [ngClass]=\"enplMenuCssClass\" >\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'enpl','airCarrier')\" >Domestic Air Carrier</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'enpl','airTaxi')\" >Air Taxi</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'enpl','commuter')\" >Commuter</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'enpl','usFlag')\" >US Flag</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'enpl','foreignFlag')\" >Foreign Flag</label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"menu-section col-sm-3\">\r\n                <span [ngClass]=\"traconsCssClass\" (click)=\"menuClick($event,'tracon')\"></span> Tracon Operations\r\n\r\n                <div [ngClass]=\"traconMenuCssClass\" >\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'tracon','airCarrier')\">Air Carrier</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'tracon','airTaxi')\">Air Taxi</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'tracon','generalAviation')\">General Aviation</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'tracon','military')\">Military</label>\r\n                    </div>\r\n                    <div class=\"checkbox\">\r\n                        <label><input type=\"checkbox\" (click)=\"onCheckboxChange($event, 'tracon','totalOverflights')\">Total Overflights</label>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"divider-space\"></div>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-12\">\r\n                    <button  type=\"text\" pButton [ngClass]=\"reforecastButtonCssClass\"  (click)=\"reforecast()\" label={{reforecastButtonText}}></button>\r\n                    <button type=\"text\" pButton (click)=\"cancel()\" label=\"Cancel\"></button>\r\n                </div>\r\n            </div>\r\n            <p-dialog  [(visible)]=\"displaySpinner\" [modal]=true   [closable]=false showEffect=\"fade\">\r\n                <div align=\"center\">\r\n                    <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n                    <div>Loading please wait ....</div>\r\n                    <div>Do Not click back or Refresh the page</div>\r\n                </div>\r\n            </p-dialog>           \r\n        </div>\r\n    </div>\r\n</div>"

/***/ },

/***/ 888:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var scenario_service_1 = __webpack_require__(692);
	var user_session_1 = __webpack_require__(699);
	var ScenarioReforecastCompleteComponent = (function () {
	    function ScenarioReforecastCompleteComponent(_scenarioService, _user, _router, _request) {
	        this._scenarioService = _scenarioService;
	        this._user = _user;
	        this._router = _router;
	        this._request = _request;
	        this.pageTitle = 'Scenario Reforecast Complete';
	    }
	    ScenarioReforecastCompleteComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        if (typeof (this._user.scenarioId) === 'undefined')
	            this._router.navigate(['./scenario-activities']);
	        this._scenarioService.getScenario(this._user.getSession().scenarioId)
	            .subscribe(function (scenario) { return _this.currentScenario = scenario; }, function (error) { return _this.errorMessage = error; });
	        this.reforecastScenarioName = this._request.getNameInSession();
	    };
	    ScenarioReforecastCompleteComponent.prototype.ngOnDestroy = function () {
	        this._request.destroySessionValues();
	    };
	    ScenarioReforecastCompleteComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(889),
	            styles: [__webpack_require__(890)],
	            providers: [scenario_service_1.ScenarioForecastRequest],
	            directives: [router_1.ROUTER_DIRECTIVES],
	        }), 
	        __metadata('design:paramtypes', [scenario_service_1.ScenarioService, user_session_1.UserSession, router_1.Router, scenario_service_1.ScenarioForecastRequest])
	    ], ScenarioReforecastCompleteComponent);
	    return ScenarioReforecastCompleteComponent;
	}());
	exports.ScenarioReforecastCompleteComponent = ScenarioReforecastCompleteComponent;


/***/ },

/***/ 889:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\"><strong *ngIf=\"currentScenario\">Current Scenario: {{currentScenario.scenarioName}} ({{currentScenario.id}})</strong></div>\r\n\r\n<div class=\"panel-body\">\r\n    <h4>Reforecast done for scenario {{reforecastScenarioName}}</h4>\r\n\r\n    <div class=\"divider\">&nbsp;</div>\r\n\r\n    <div>Please go back to <a [routerLink]=\"['/scenario-reforecast']\">Reforecast</a></div>\r\n</div>"

/***/ },

/***/ 890:
/***/ function(module, exports) {

	module.exports = ".current-scenario{\r\n    text-align: center;\r\n}\r\n\r\n.divider-space {\r\n    margin-bottom: 20px;\r\n}\r\n.merge-column {\r\n    float: left;\r\n    margin-right: 100px;\r\n}\r\n.section-title {\r\n    font-weight: bold;\r\n}\r\n.btn-right {\r\n    float: right;\r\n    margin-left: 15px;\r\n}\r\n\r\n.suggestions {\r\n    position: absolute;\r\n    z-index: 100;\r\n    border: 1px solid #aeaeae;\r\n    width: 100px;\r\n    background-color: #fff;\r\n}\r\n.suggestions ul {\r\n    padding: 0;\r\n    list-style-type: none;\r\n}\r\n.suggestions ul li {\r\n    cursor: pointer;\r\n    padding-left: 10px;\r\n}\r\n.suggestions ul li:hover {\r\n    background-color: #f1f1f1;\r\n}\r\n.suggestions ul li a {\r\n    text-decoration: none;\r\n    color: #767676;\r\n}"

/***/ },

/***/ 891:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var query_report_component_1 = __webpack_require__(892);
	var query_reports_graph_selections_component_1 = __webpack_require__(894);
	var query_reports_graph_display_component_1 = __webpack_require__(896);
	var auth_guard_service_1 = __webpack_require__(696);
	exports.QueryReportRoutes = [
	    { path: 'query-reports', component: query_report_component_1.QueryReportComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'query-reports-graph-selections', component: query_reports_graph_selections_component_1.QueryReportGraphSelectionsComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'query-reports-graph-display', component: query_reports_graph_display_component_1.QueryReportGraphDisplayComponent, canActivate: [auth_guard_service_1.AuthGuard] }
	];


/***/ },

/***/ 892:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var query_report_1 = __webpack_require__(698);
	var query_report_service_1 = __webpack_require__(691);
	var scenario_service_1 = __webpack_require__(692);
	var user_session_1 = __webpack_require__(699);
	var user_info_service_1 = __webpack_require__(695);
	var system_control_service_1 = __webpack_require__(694);
	var primeng_1 = __webpack_require__(708);
	var QueryReportComponent = (function () {
	    function QueryReportComponent(route, router, _queryReportService, _scenarioService, User, _userInfoService, _systemControlService) {
	        this.route = route;
	        this.router = router;
	        this._queryReportService = _queryReportService;
	        this._scenarioService = _scenarioService;
	        this.User = User;
	        this._userInfoService = _userInfoService;
	        this._systemControlService = _systemControlService;
	        this.pageTitle = 'Query Reports';
	        this.msgs = [];
	        this.isScenarioOwner = false;
	        this.hideElement = false;
	        this.showLocids = false;
	        this.showGraphs = false;
	        this.displaySpinner = false;
	        this.locidCnt = 0;
	        this.graphIdSelected = 0;
	        this.yearIdSelected = 0;
	        this.selectedOption = new query_report_1.IQueryReportListComponent(1, 'Scenario Quick Data Summary Report ');
	        this.selectedFacOption = new query_report_1.IQueryReportListComponent(9, 'Select all LOCIDs  ');
	        this.options = [
	            new query_report_1.IQueryReportListComponent(1, 'Scenario Quick Data Summary Report '),
	            new query_report_1.IQueryReportListComponent(2, 'Scenario Quick Growth Rate Summary Report '),
	            new query_report_1.IQueryReportListComponent(3, 'Scenario Operations and Enplanement Data Summary  (Date range is always last history year through last forecast year) '),
	            new query_report_1.IQueryReportListComponent(4, 'Scenario Operations and Enplanement Growth Rates Summary  (Date range is always last history year through last forecast year) '),
	            new query_report_1.IQueryReportListComponent(5, 'Scenario Facility List   (Date range does not affect this report) '),
	            new query_report_1.IQueryReportListComponent(6, 'Facility Quick Data Summary Report '),
	            new query_report_1.IQueryReportListComponent(7, 'Facility Quick Growth Rate Summary Report '),
	            new query_report_1.IQueryReportListComponent(8, 'Produce Graphs (for the entire scenario)  ')
	        ];
	        this.facOptions = [
	            new query_report_1.IQueryReportListComponent(9, 'Select all LOCIDs  '),
	            new query_report_1.IQueryReportListComponent(10, 'Select a subset of LOCIDs '),
	        ];
	        this.graphOptions = [
	            { display: 'Airport Operations', value: 0, dbName: 'AirportOperations' },
	            { display: 'Based Aircraft', value: 1, dbName: 'Basedaircraft' },
	            { display: 'Enplanements', value: 2, dbName: 'Enplanements' },
	            { display: 'Tracon Operations', value: 3, dbName: 'TraconOPS' }
	        ];
	        this.allYears = [new query_report_1.IQueryReportListComponent(0, '')];
	    }
	    QueryReportComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
	        this._scenarioService.getScenarios(this.User.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.setScenarioHeader(_this.User.getSession().scenarioId);
	        });
	        //this probably needs to be somewhere more central
	        this.User.updateSessionState();
	        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(function (success) { return _this.isScenarioOwner = success.isOwner; }, function (error) { return _this.errorMessage = error; });
	        this.getSystemControlValues();
	        //this.locidResponse = new IQueryReportResponse('','','','','',[],[]);
	    };
	    QueryReportComponent.prototype.getSystemControlValues = function () {
	        var _this = this;
	        this._systemControlService.getSystemControl()
	            .subscribe(function (systemControlElem) {
	            _this.systemControlElem = systemControlElem;
	        }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.selYear = _this.systemControlElem.fyYear - 3;
	            _this.request = new query_report_1.IQueryReportRequest(_this.systemControlElem.fyYear - 3, 1, 1, 9, []);
	            _this.requestLocid = new query_report_1.IQueryReportsFacilityRequest([''], 1);
	            //set first year of report dropdown; rather than going to the database for this dropdown, we will create the data array here
	            // using sysControl Fyear-3 as end point and 1980 as first year of report.
	            for (var year = 1976; year <= _this.systemControlElem.fyYear - 3; year++) {
	                _this.allYears.push(new query_report_1.IQueryReportListComponent(year, year + ""));
	            }
	            _this.yearIdSelected = _this.systemControlElem.fyYear - 3;
	        });
	    };
	    QueryReportComponent.prototype.getValueFacOpt = function (optionid) {
	        this.selectedFacOption = this.facOptions.filter(function (item) { return item.id == optionid; })[0];
	        if (this.selectedFacOption.id == 10) {
	            this.showLocids = true;
	        }
	        else {
	            this.showLocids = false;
	        }
	    };
	    QueryReportComponent.prototype.onYearChange = function (event) {
	        var yearOptionSelected = +event.target.value;
	        this.yearIdSelected = yearOptionSelected;
	    };
	    QueryReportComponent.prototype.onGraphSelectionChange = function (event) {
	        var graphOptionSelected = +event.target.value;
	        this.graphIdSelected = graphOptionSelected;
	    };
	    QueryReportComponent.prototype.onScenarioChange = function (event) {
	        var selectedScenarioId = +event.target.value;
	        this.User.scenarioId = selectedScenarioId;
	        this.setScenarioHeader(selectedScenarioId);
	        this.User.updateSessionState();
	    };
	    QueryReportComponent.prototype.getValue = function (optionid) {
	        this.selectedOption = this.options.filter(function (item) { return item.id == optionid; })[0];
	        if (this.selectedOption.id === 7 || this.selectedOption.id === 6) {
	            this.hideElement = true;
	        }
	        else {
	            this.hideElement = false;
	        }
	        if (this.selectedOption.id === 8) {
	            this.showGraphs = true;
	        }
	        else {
	            this.showGraphs = false;
	        }
	    };
	    QueryReportComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	        this.scenarioHeaderDiv.innerHTML = "<strong>Current Scenario: " + this.currentScenario.scenarioName + " (" + this.currentScenario.id + ")</strong>";
	    };
	    QueryReportComponent.prototype.generateReport = function () {
	        var _this = this;
	        this.msgs = [];
	        this.displaySpinner = true;
	        this.request.scenario = this.currentScenario.id;
	        this.request.startYear = this.yearIdSelected;
	        this.request.reportId = this.selectedOption.id;
	        this.request.facOption = this.selectedFacOption.id;
	        this.request.locidList = [];
	        if (this.request.startYear == 0) {
	            this.msgs = [];
	            this.msgs.push({ severity: 'info', summary: 'Info Message', detail: 'Please select start year.' });
	            this.displaySpinner = false;
	            return;
	        }
	        if (this.locidResponse == null
	            && this.selectedFacOption.id === 10
	            && (this.request.reportId === 6 || this.request.reportId === 7)) {
	            this.msgs = [];
	            this.msgs.push({ severity: 'info', summary: 'Info Message', detail: 'Please select at least one locid for Facility level reports.' });
	            this.displaySpinner = false;
	            return;
	        }
	        else if (this.locidResponse != null &&
	            this.selectedFacOption.id === 10) {
	            this.request.locidList = this.locidResponse.savedLocidList;
	        }
	        if (this.request.reportId === 8) {
	            var params = {
	                startYear: this.yearIdSelected,
	                endYear: this.systemControlElem.lfcYear,
	                scenario: this.request.scenario,
	                tableId: this.graphIdSelected,
	                reportId: this.request.reportId
	            };
	            this.router.navigate(["/query-reports-graph-selections", params]);
	            return;
	        }
	        this._queryReportService.getFacilityListReport(this.request)
	            .subscribe(function (response) {
	            _this.displaySpinner = false;
	            _this.facReportListResponse = response;
	            if (_this.facReportListResponse[0].responseStatus === 'ERROR') {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'An error has occurred executing your request'
	                        + _this.facReportListResponse[0].responseMessage });
	            }
	            else if (_this.facReportListResponse[0].responseMessage === 'No Data') {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Info Message', detail: 'No Data returned.'
	                        + _this.facReportListResponse[0].responseMessage });
	                _this.facReportListResponse[0].pdfFileUrl = "";
	                _this.facReportListResponse[0].htmlFileUrl = "";
	            }
	            else {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'info', summary: 'Info Message', detail: 'PDF & HTML file generated; please click links below' });
	                _this.cols = [
	                    { field: "htmlFileUrl", header: 'Html' },
	                    { field: "pdfFileUrl", header: 'Pdf' },
	                ];
	                if (_this.request.reportId === 6 || _this.request.reportId === 7) {
	                    _this.locidResponse.savedLocidList = null;
	                    _this.locidCnt = 0;
	                }
	            }
	            //console.log ("response facility report " + this.facReportListResponse[0].htmlFileUrl + "  " 
	            //                + this.facReportListResponse[0].pdfFileUrl +" " + this.facReportListResponse[0].responseMessage +" "
	            //                + this.facReportListResponse[0].responseStatus +" " + this.facReportListResponse[0].responseDisplay)
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    /* removeFacilityFromList(locid: string): void {
	         let index: number = this.request.facilities.indexOf(locid);
	         this.request.facilities.splice(index, 1);
	     }
	 
	     clearAllFacilities(): void {
	         this.request.facilities = [];
	     }*/
	    QueryReportComponent.prototype.cancelLocids = function () {
	        this.showLocids = false;
	        this.selectedLocids = '';
	    };
	    QueryReportComponent.prototype.removeFacilityFromList = function (locid) {
	        var index = this.locidResponse.savedLocidList.indexOf(locid);
	        this.locidResponse.savedLocidList.splice(index, 1);
	        this.locidCnt = this.locidResponse.savedLocidList.length;
	    };
	    QueryReportComponent.prototype.cancel = function () {
	        this.router.navigate(['/welcome']);
	    };
	    QueryReportComponent.prototype.saveLocids = function () {
	        var _this = this;
	        var charExp = /[^a-zA-Z0-9]+/;
	        var nonAlpha = (this.selectedLocids.replace(/[\t\n\s\r]{1,}/g, "")).match(charExp);
	        if (nonAlpha != null) {
	            this.msgs = [];
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Please check the list of LOCID.\nIt can only contain digits[0-9] and alphabets[a-z].' });
	            return;
	        }
	        var selectedLocidsArr = this.selectedLocids.replace(/[\t\n\s\r]{1,}/g, ",").split(",");
	        var bError = false;
	        for (var i = 0; i <= selectedLocidsArr.length - 1; i++) {
	            if ((selectedLocidsArr[i]) != null) {
	                if ((selectedLocidsArr[i].length > 4) || (selectedLocidsArr[i].length < 3)) {
	                    bError = true;
	                    this.msgs = [];
	                    this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'The LOCID length can be only 3 or 4 characters.' });
	                    return;
	                }
	            }
	        }
	        this.requestLocid.locid = selectedLocidsArr;
	        this.requestLocid.scenarioId = this.currentScenario.id;
	        this._queryReportService.saveLocids(this.requestLocid)
	            .subscribe(function (response) {
	            _this.locidResponse = response;
	            if (_this.locidResponse.responseMessage === "No Match") {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Following Locid list is not part of your selected scenario '
	                        + _this.locidResponse.locidNoMatch + '. Please correct the errors before continuing.' });
	                _this.locidCnt = 0;
	            }
	            _this.showLocids = false;
	            if (_this.locidResponse.savedLocidList != null) {
	                _this.locidCnt = _this.locidResponse.savedLocidList.length;
	            }
	        }, function (error) {
	            _this.msgs = [];
	            _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'An error occured while processing your request.' });
	            _this.showLocids = false;
	            _this.locidCnt = 0;
	        }, function () { });
	        this.selectedLocids = '';
	    };
	    QueryReportComponent.prototype.openPDFFile = function (responsepdf) {
	        window.open(responsepdf, '_blank');
	    };
	    QueryReportComponent.prototype.openHTMLFile = function (responseHtml) {
	        window.open(responseHtml, '_blank');
	    };
	    QueryReportComponent.prototype.ngOnDestroy = function () {
	        // this.sub.unsubscribe();
	    };
	    __decorate([
	        core_1.ViewChild('scenarioHeader'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], QueryReportComponent.prototype, "scenarioHeader", void 0);
	    QueryReportComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(893),
	            styles: [__webpack_require__(700)],
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.Dialog]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, query_report_service_1.QueryReportService, scenario_service_1.ScenarioService, user_session_1.UserSession, user_info_service_1.UserInfoService, system_control_service_1.SystemControlService])
	    ], QueryReportComponent);
	    return QueryReportComponent;
	}());
	exports.QueryReportComponent = QueryReportComponent;


/***/ },

/***/ 893:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\" #scenarioHeader></div>\r\n<div class='panel panel-primary'>\r\n    <div class='panel-heading' >\r\n        {{pageTitle}}\r\n    </div>\r\n    <div class='panel-body'>\r\n          <p-messages [value]=\"msgs\" [closable]=\"false\"></p-messages>\r\n          <div>\r\n                <div class= \"row\" *ngFor=\"let resp of facReportListResponse\">\r\n                        <div class=\"col-md-4\">\r\n                             HTML: <button class=\"btn btn-link btn-right btn-sm\"  (click)=\"openHTMLFile(resp.htmlFileUrl)\">{{resp.responseDisplay}}</button>\r\n                        </div>\r\n                        <div class=\"col-md-4\">\r\n                              PDF:   <button class=\"btn btn-link btn-right btn-sm\"  (click)=\"openPDFFile(resp.pdfFileUrl)\">{{resp.responseDisplay}}</button>\r\n                        </div>\r\n                </div>\r\n           </div>\r\n           <div class=\"divider\" *ngIf=\"facReportListResponse\"></div>\r\n           <p></p>\r\n            <div class=\"row\" >\r\n             <div class=\"col-md-10\">\r\n                <div class=\"text-danger divider\"><b>Query Reports</b></div>\r\n                    <p></p>\r\n                    <div class=\"row\">\r\n                        <div class=\"col-md-2\">\r\n                            <div class=\"customtd\"><b>Scenario Name:</b></div>\r\n                        </div>\r\n                        <div class=\"col-md-4\">\r\n                            <select class=\"form-control\" (change)=\"onScenarioChange($event)\" >\r\n                                <option *ngFor=\"let scenario of allScenarios\" [value]=\"scenario.id\" [selected]=\"scenario.id === currentScenario.id\">{{scenario.scenarioName}} ({{scenario.id}})</option> \r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"row\"  *ngIf=\"allYears\">\r\n                        <div class=\"col-md-2\">\r\n                            <div class=\"customtd\"><b>First year used in report:</b></div>\r\n                        </div>\r\n                        <div class=\"col-md-4\">\r\n                            <select class=\"form-control\" (change)=\"onYearChange($event)\" >\r\n                                <option value=\"0\" selected>Please Select</option>\r\n                                <option *ngFor=\"let year of allYears\" [value]=\"year.id\" [selected]=\"year.id==selYear\">{{year.name}}</option> \r\n                            </select>\r\n                        </div>\r\n                    </div>\r\n                    <div><p></p></div>\r\n                    <div class=\"text-danger divider\"><b>Scenario-Level Reports</b></div>\r\n                    <div class=\"abc-radio-primary \" *ngFor=\"let option of options.slice(0,5)\">\r\n                        <span></span>\r\n                        <input type=\"radio\" class=\"styled\" id=\"option.id\" [checked]=\"option.id == selectedOption.id\" value=\"option.id\" (click)=\"getValue(option.id)\">\r\n                        <label class=\"customtd\"> \r\n                            {{option.name}}\r\n                        </label>\r\n                    </div>\r\n                    <p></p>\r\n                    <div class=\"text-danger divider\"><b>Facility-Level Reports</b></div>\r\n                    <div class=\"abc-radio-primary \" *ngFor=\"let option of options.slice(5,7)\">\r\n                        <span></span>\r\n                        <input type=\"radio\" class=\"styled\" id=\"option.id\" [checked]=\"option.id == selectedOption.id\" value=\"option.id\" (click)=\"getValue(option.id)\">\r\n                        <label class=\"customtd\"> \r\n                            {{option.name}}\r\n                        </label>\r\n                    </div>\r\n                    <div class=\"selectionOptions\" *ngIf=\"hideElement\">\r\n                            For Facility-Level Reports, you may select all LOCIDs or a subset:<br>\r\n                                <div class=\"abc-radio-primary \" *ngFor=\"let option of facOptions\">\r\n                                    <span></span>\r\n                                    <input type=\"radio\" class=\"styled\" id=\"option.id\" [checked]=\"option.id == selectedFacOption.id\" value=\"option.id\" (click)=\"getValueFacOpt(option.id)\">\r\n                                    <label class=\"customtd\"> \r\n                                        {{option.name}}\r\n                                    </label>\r\n                                </div>\r\n                        </div>\r\n                    <p></p>\r\n                    <div class=\"text-danger divider\"><b>Graph Reports</b></div>\r\n                    <div class=\"abc-radio-primary \" *ngFor=\"let option of options.slice(7)\">\r\n                        <span></span>\r\n                        <input type=\"radio\" class=\"styled\" id=\"option.id\" [checked]=\"option.id == selectedOption.id\" value=\"option.id\" (click)=\"getValue(option.id)\">\r\n                        <label class=\"customtd\"> \r\n                            {{option.name}}\r\n                        </label>\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-4\" *ngIf=\"showGraphs\"> \r\n                                <div class=\"col-sm-4\">\r\n                                    <div class=\"customtd\">Choose data set: </div>\r\n                                </div>\r\n                                <select class=\"form-control\" (change)=\"onGraphSelectionChange($event)\">\r\n                                    <option *ngFor=\"let item of graphOptions\" [value]=\"item.value\">{{item.display}}</option> \r\n                                </select>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n             </div>\r\n             <div class=\"col-md-2\">\r\n                <div><p></p><p></p><p></p></div>\r\n                <div class=\"row\">\r\n                    <div >\r\n                        <div class=\"locids\">\r\n                            <div class=\"header\"><strong>Selected Facilities</strong></div>\r\n                                <div>\r\n                                    <ul *ngIf=\"locidResponse\">\r\n                                        <li *ngFor=\"let item of locidResponse.savedLocidList\">{{item}} <a (click)=\"removeFacilityFromList(item)\">Remove</a></li>\r\n                                    </ul>\r\n                                </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row\" style=\"padding-right:0px;padding-left:0px;margin:0px\">\r\n                    <div class=\"col-sm-2 customtd\" style=\"width: 90px;margin-left: 0px;padding-left: 0px;\"> Currently Facilities Selected: </div>\r\n                    <div class=\"col-sm-4 customtd\">{{locidCnt}} </div>\r\n                </div>\r\n             </div>\r\n            </div>\r\n            <p-dialog  modal=\"modal\" showEffect=\"fade\" [(visible)]=\"showLocids\" responsive=\"true\">\r\n                <h1 style=\"font-size:83%;color:red\">\r\n                    You may paste a list of LOCIDs into the box below. \r\n                    This list will override any previous LOCID entries.\r\n                    To keep your current list of LOCIDs, please click the \"Cancel\" button. \r\n                    Enter data here, one LOCID per line (no commas):\r\n                </h1>\r\n                <div>\r\n                    <textarea class=\"form-control\" rows=\"5\" id=\"locids\" [(ngModel)]=\"selectedLocids\"   ></textarea>\r\n                </div>\r\n                <div>\r\n                    <div class=\"col-sm-6\">\r\n                        <button type=\"text\" pButton (click)=\"saveLocids()\" label=\"Save\" style=\"width:100px!important\"></button>\r\n                    </div>\r\n                    <div class=\"col-sm-6\">\r\n                        <button type=\"text\" pButton (click)=\"cancelLocids()\" label=\"Cancel\" style=\"width:100px!important\"></button>\r\n                    </div>\r\n                </div>\r\n            </p-dialog>\r\n            <div class=\"row\">\r\n                <div class=\"col-sm-8\">\r\n                    <button type=\"text\" pButton  (click)=\"generateReport()\" label=\"Generate\"></button>\r\n                    <button type=\"text\" pButton  (click)=\"cancel()\" label=\"Cancel\"></button>\r\n                </div>\r\n            </div>\r\n            <p-dialog  [(visible)]=\"displaySpinner\" [modal]=true   [closable]=false showEffect=\"fade\">\r\n                <div align=\"center\">\r\n                    <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n                    <div>Loading please wait ....</div>\r\n                    <div>Do Not click back or Refresh the page</div>\r\n                </div>\r\n            </p-dialog>\r\n\r\n    </div>\r\n</div>"

/***/ },

/***/ 894:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var airport_service_1 = __webpack_require__(677);
	var query_report_1 = __webpack_require__(698);
	var scenario_service_1 = __webpack_require__(692);
	var user_info_service_1 = __webpack_require__(695);
	var query_report_service_1 = __webpack_require__(691);
	var user_session_1 = __webpack_require__(699);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var system_control_service_1 = __webpack_require__(694);
	var QueryReportGraphSelectionsComponent = (function () {
	    function QueryReportGraphSelectionsComponent(route, router, _airportService, _queryReportService, _scenarioService, _userInfoService, User, request, _systemControlService) {
	        this.route = route;
	        this.router = router;
	        this._airportService = _airportService;
	        this._queryReportService = _queryReportService;
	        this._scenarioService = _scenarioService;
	        this._userInfoService = _userInfoService;
	        this.User = User;
	        this.request = request;
	        this._systemControlService = _systemControlService;
	        //columns: IOperationListColumnResponse[];
	        this.msgs = [];
	        this.startYears = [];
	        this.endYears = [];
	        this.graphType = "Line";
	        this.yearsToPreview = 4;
	        this.dataCheckDone = false;
	        this.isScenarioOwner = false;
	        this.displaySpinner = false;
	    }
	    QueryReportGraphSelectionsComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.scenarioHeaderDiv = this.scenarioHeader.nativeElement;
	        this._scenarioService.getScenarios(this.User.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.setScenarioHeader(_this.User.getSession().scenarioId);
	        });
	        //this probably needs to be somewhere more central
	        this.User.updateSessionState();
	        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(function (success) { return _this.isScenarioOwner = success.isOwner; }, function (error) { return _this.errorMessage = error; });
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.tableId = params['tableId'];
	            _this.startYear = params['startYear'];
	            _this.endYear = params['endYear'];
	            _this.scenario = params['scenario'];
	            switch (_this.tableId) {
	                case "0":
	                    {
	                        _this.tableName = 'AirportOperations';
	                        _this.tableDisplayName = 'Airport Operations';
	                        break;
	                    }
	                case "1":
	                    {
	                        _this.tableName = 'Basedaircraft';
	                        _this.tableDisplayName = 'Based Aircraft';
	                        break;
	                    }
	                case "2":
	                    {
	                        _this.tableName = 'Enplanements';
	                        _this.tableDisplayName = 'Enplanements';
	                        break;
	                    }
	                case "3":
	                    {
	                        _this.tableName = 'traconops';
	                        _this.tableDisplayName = 'Tracon Operations';
	                        break;
	                    }
	                default:
	                    break;
	            }
	            _this.getColumns();
	        });
	    };
	    QueryReportGraphSelectionsComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	        this.scenarioHeaderDiv.innerHTML = "<strong>Current Scenario: " + this.currentScenario.scenarioName + " (" + this.currentScenario.id + ")</strong>";
	    };
	    QueryReportGraphSelectionsComponent.prototype.getColumns = function () {
	        var _this = this;
	        //reusing airports code
	        this.request.tableName = this.tableName;
	        this.request.scenario = this.User.getSession().scenarioId;
	        this.request.isAdmin = this.User.getSession().isAdmin ? 1 : 0;
	        this._airportService.getOperationsColumns(this.request)
	            .subscribe(function (columns) { return _this.columns = columns; }, function (error) { return _this.errorMessage = error; });
	    };
	    QueryReportGraphSelectionsComponent.prototype.getSystemControlValues = function () {
	        var _this = this;
	        this._systemControlService.getSystemControl()
	            .subscribe(function (systemControlElem) {
	            _this.systemControlElem = systemControlElem;
	        }, function (error) { return _this.errorMessage = error; });
	    };
	    QueryReportGraphSelectionsComponent.prototype.cancel = function () {
	        this.router.navigate(["/query-reports"]);
	    };
	    QueryReportGraphSelectionsComponent.prototype.ngOnDestroy = function () { };
	    QueryReportGraphSelectionsComponent.prototype.generateGraph = function () {
	        var _this = this;
	        this.displaySpinner = true;
	        var selectedColumns = this.columns.filter(function (column) {
	            return column.graphR == 1;
	        });
	        if (selectedColumns.length === 0) {
	            this.msgs = [];
	            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'At least one data column must be selected.' });
	            return;
	        }
	        sessionStorage.setItem('operations-graph-columns', JSON.stringify(selectedColumns));
	        /*    let params = {
	                displayName: this.tableDisplayName,
	                tableName:this.tableName,
	                locId: 0, //pass sin 0 to run graphs for entire scenario
	                airportName: '',
	                graphType: this.graphType,
	                startYear: this.startYear,
	                endYear: this.endYear,
	                quickGraph: "false",
	                reportId: this.request
	            };*/
	        this.request.graphType = this.graphType;
	        this.request.scenarioId = this.scenario;
	        this.request.startYear = this.startYear;
	        this.request.reportId = 8; //produce graphs
	        this.request.columns = JSON.parse(sessionStorage.getItem('operations-graph-columns'));
	        this._queryReportService.getFacilityListReport(this.request)
	            .subscribe(function (response) {
	            _this.displaySpinner = false;
	            _this.facReportListResponse = response;
	            if (_this.facReportListResponse[0].responseStatus === 'ERROR') {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'An error has occurred executing your request'
	                        + _this.facReportListResponse[0].responseMessage });
	            }
	            else if (_this.facReportListResponse[0].responseMessage === 'No Data') {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'error', summary: 'Info Message', detail: 'No Data returned.'
	                        + _this.facReportListResponse[0].responseMessage });
	                _this.facReportListResponse[0].pdfFileUrl = "";
	                _this.facReportListResponse[0].htmlFileUrl = "";
	            }
	            else {
	                _this.msgs = [];
	                _this.msgs.push({ severity: 'info', summary: 'Info Message', detail: 'PDF & HTML file generated; please click links below' });
	                _this.cols = [
	                    { field: "htmlFileUrl", header: 'Html' },
	                    { field: "pdfFileUrl", header: 'Pdf' },
	                ];
	            }
	            //console.log ("response facility report " + this.facReportListResponse[0].htmlFileUrl + "  " 
	            //                + this.facReportListResponse[0].pdfFileUrl +" " + this.facReportListResponse[0].responseMessage +" "
	            //                + this.facReportListResponse[0].responseStatus +" " + this.facReportListResponse[0].responseDisplay)
	        }, function (error) { return _this.errorMessage = error; });
	        //this.router.navigate([`/query-reports-graph-display`, params]);
	    };
	    QueryReportGraphSelectionsComponent.prototype.openPDFFile = function (responsepdf) {
	        window.open(responsepdf, '_blank');
	    };
	    QueryReportGraphSelectionsComponent.prototype.openHTMLFile = function (responseHtml) {
	        window.open(responseHtml, '_blank');
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], QueryReportGraphSelectionsComponent.prototype, "selected", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], QueryReportGraphSelectionsComponent.prototype, "locId", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], QueryReportGraphSelectionsComponent.prototype, "airportName", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean)
	    ], QueryReportGraphSelectionsComponent.prototype, "displayAll", void 0);
	    __decorate([
	        core_1.ViewChild('scenarioHeader'), 
	        __metadata('design:type', core_1.ElementRef)
	    ], QueryReportGraphSelectionsComponent.prototype, "scenarioHeader", void 0);
	    QueryReportGraphSelectionsComponent = __decorate([
	        core_1.Component({
	            selector: 'query-reports-graph-selections',
	            template: __webpack_require__(895),
	            styles: [__webpack_require__(700)],
	            directives: [primeng_1.Button, primeng_2.Checkbox]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, airport_service_1.AirportService, query_report_service_1.QueryReportService, scenario_service_1.ScenarioService, user_info_service_1.UserInfoService, user_session_1.UserSession, query_report_1.QueryReportListRequest, system_control_service_1.SystemControlService])
	    ], QueryReportGraphSelectionsComponent);
	    return QueryReportGraphSelectionsComponent;
	}());
	exports.QueryReportGraphSelectionsComponent = QueryReportGraphSelectionsComponent;


/***/ },

/***/ 895:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\" #scenarioHeader></div>\r\n<div class='panel panel-primary'>\r\n    <div class='panel-body'>\r\n        <p-messages [value]=\"msgs\" [closable]=\"false\"></p-messages>\r\n        <p-dialog  [(visible)]=\"displaySpinner\" [modal]=true   [closable]=false showEffect=\"fade\">\r\n                    <div align=\"center\">\r\n                        <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n                        <div>Loading please wait ....</div>\r\n                        <div>Do Not click back or Refresh the page</div>\r\n                    </div>\r\n        </p-dialog>\r\n        <div>\r\n            <div class= \"row\" *ngFor=\"let resp of facReportListResponse\">\r\n                    <!--<div class=\"col-md-4\">\r\n                            HTML: <button class=\"btn btn-link btn-right btn-sm\"  (click)=\"openHTMLFile(resp.htmlFileUrl)\">{{resp.responseDisplay}}</button>\r\n                    </div>-->\r\n                    <div class=\"col-md-4\">\r\n                            PDF:   <button class=\"btn btn-link btn-right btn-sm\"  (click)=\"openPDFFile(resp.pdfFileUrl)\">{{resp.responseDisplay}}</button>\r\n                    </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"divider\"></div>\r\n        <div class=\"row customtd\" style=\"margin-left:0px\">\r\n        <b> Data: {{tableDisplayName}}</b> \r\n        </div>\r\n        <div *ngIf=\"!columns && !dataCheckDone\" align=\"center\">\r\n            <i style=\"color:blue\" class=\"fa fa-spinner fa-spin fa-5x\"> </i>\r\n            <div>Loading please wait ....</div>\r\n            <div>Do Not click back or Refresh the page</div>\r\n        </div>\r\n        <div class=\"row col-md-12 customtd\" > \r\n            <div class=\"checkbox\" *ngFor=\"let column of columns\" >\r\n                <label><input type=\"checkbox\" name=\"graphColumns\" [(ngModel)]=\"column.graphR\">{{column.displayName}}</label>\r\n            </div>\r\n        </div>\r\n        <br/>\r\n        <div class=\"row\">\r\n            <div for=\"graphType\" class=\"col-sm-4 customtd\" style=\"width: 110px;\"><b>Graph Types:</b></div>\r\n            <div class=\"btn-group col-sm-4\" >\r\n                <div class=\"radio\" style=\"margin:0px!important;padding-left: 0px;\" >\r\n                    <input type=\"radio\" [(ngModel)]=\"graphType\"  name=\"graphTypeGroup\" value=\"Bar\">Bar<br>\r\n                    <input type=\"radio\" [(ngModel)]=\"graphType\"  name=\"graphTypeGroup\" value=\"Line\">Line\r\n                </div>\r\n            </div>\r\n        </div>\r\n        <div class=\"container\" style=\"margin:0px!important;padding-left: 0px;\">\r\n            <div class=\"row\">        \r\n                <div class=\"col-sm-10\">\r\n                    <button type=\"text\" pButton class=\"btn btn-success\" style=\"margin-right:10px\" (click)=\"generateGraph()\" label=\"Generate Graph\"></button>\r\n                    <button type=\"text\" pButton class=\"btn btn-danger\" (click)=\"cancel()\" label=\"Cancel\"></button>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n"

/***/ },

/***/ 896:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var router_1 = __webpack_require__(655);
	var query_report_service_1 = __webpack_require__(691);
	var scenario_service_1 = __webpack_require__(692);
	var user_session_1 = __webpack_require__(699);
	var user_info_service_1 = __webpack_require__(695);
	var primeng_1 = __webpack_require__(708);
	var _ = __webpack_require__(680);
	var QueryReportGraphDisplayComponent = (function () {
	    function QueryReportGraphDisplayComponent(route, router, _queryReportService, _scenarioService, User, _userInfoService) {
	        this.route = route;
	        this.router = router;
	        this._queryReportService = _queryReportService;
	        this._scenarioService = _scenarioService;
	        this.User = User;
	        this._userInfoService = _userInfoService;
	        this.msgs = [];
	        this.graphType = "bar";
	    }
	    QueryReportGraphDisplayComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.tableName = params['tableName'];
	            _this.displayName = params['displayName'];
	            _this.locId = params['locId'];
	            _this.airportName = params['airportName'];
	            _this.graphType = params['graphType'];
	            _this.startYear = params['startYear'];
	            _this.endYear = params['endYear'];
	            _this.quickGraph = params['quickGraph'];
	            _this.columns = JSON.parse(sessionStorage.getItem('operations-graph-columns'));
	            _this.getGraphData();
	        });
	        this._scenarioService.getScenarios(this.User.getSession()['id'])
	            .subscribe(function (scenarios) { return _this.allScenarios = scenarios; }, function (error) { return _this.errorMessage = error; }, function () {
	            _this.setScenarioHeader(_this.User.getSession().scenarioId);
	        });
	    };
	    QueryReportGraphDisplayComponent.prototype.getGraphData = function () {
	        var _this = this;
	        var params = {
	            tableName: this.tableName,
	            locId: 0,
	            scenarioId: this.User.getSession().scenarioId,
	            startYear: this.startYear,
	            endYear: this.endYear,
	            columns: this.columns
	        };
	        this._queryReportService.getFacilityListReport(params)
	            .subscribe(function (result) {
	            _this.result = result;
	            _this.createGraphDataSet();
	        });
	    };
	    QueryReportGraphDisplayComponent.prototype.createGraphDataSet = function () {
	        var labels = _.map(this.result, 'AYEAR');
	        var datasets = [];
	        for (var index in this.columns) {
	            var dataset = {
	                label: this.columns[index].graphName,
	                data: _.map(this.result, this.columns[index].graphName),
	                fill: false,
	                backgroundColor: this.getRandomColor(),
	                borderColor: this.getRandomColor()
	            };
	            datasets[index] = dataset;
	        }
	        this.data = {
	            labels: labels,
	            datasets: datasets
	        };
	    };
	    QueryReportGraphDisplayComponent.prototype.ngOnDestroy = function () {
	        this.sub.unsubscribe();
	    };
	    QueryReportGraphDisplayComponent.prototype.setScenarioHeader = function (scenarioId) {
	        var foundScenarios = this.allScenarios.filter(function (scenario) {
	            return scenario.id === scenarioId;
	        });
	        if (foundScenarios.length > 0) {
	            this.currentScenario = foundScenarios[0];
	        }
	    };
	    QueryReportGraphDisplayComponent.prototype.getRandomColor = function () {
	        var letters = '0123456789ABCDEF';
	        var color = '#';
	        for (var i = 0; i < 6; i++) {
	            color += letters[Math.floor(Math.random() * 16)];
	        }
	        return color;
	    };
	    QueryReportGraphDisplayComponent = __decorate([
	        core_1.Component({
	            template: __webpack_require__(897),
	            styles: [__webpack_require__(700)],
	            directives: [router_1.ROUTER_DIRECTIVES, primeng_1.UIChart]
	        }), 
	        __metadata('design:paramtypes', [router_1.ActivatedRoute, router_1.Router, query_report_service_1.QueryReportService, scenario_service_1.ScenarioService, user_session_1.UserSession, user_info_service_1.UserInfoService])
	    ], QueryReportGraphDisplayComponent);
	    return QueryReportGraphDisplayComponent;
	}());
	exports.QueryReportGraphDisplayComponent = QueryReportGraphDisplayComponent;


/***/ },

/***/ 897:
/***/ function(module, exports) {

	module.exports = "<div class=\"current-scenario\"><strong *ngIf=\"currentScenario\">Current Scenario: {{currentScenario.scenarioName}}</strong></div>\r\n<div class='panel panel-primary'>\r\n    <div class='panel-heading'>\r\n        {{'Facility: ' + locId + ' - ' + airportName }}\r\n    </div>\r\n\r\n    <!-- Filter the Products   -->\r\n    <div class='panel-body'>\r\n\r\n        <div class='alert alert-danger' *ngIf='errorMessage'>{{errorMessage}}</div>\r\n\r\n        <div class='row'>\r\n            <button *ngIf=\"quickGraph === 'false'\" type=\"text\" (click)=\"backFacilityView()\" pButton icon=\"fa-arrow-circle-left\" label=\"Facility View {{locId}}\"></button>\r\n            <button *ngIf=\"quickGraph === 'false'\" type=\"text\" (click)=\"backDataSheet()\" pButton icon=\"fa-arrow-circle-left\" label=\"Data Sheet\"></button>\r\n            <button *ngIf=\"quickGraph === 'false'\" type=\"text\" (click)=\"backSelections()\" pButton icon=\"fa-arrow-circle-left\" label=\"Graph Selections\"></button>\r\n            <button *ngIf=\"quickGraph === 'true'\" type=\"text\" (click)=\"backReforecast()\" pButton icon=\"fa-arrow-circle-left\" label=\"Reforecast Tools\"></button>\r\n        </div>\r\n\r\n        <div style=\"font-family:Arial; font-size:25px;text-align:center;\">\r\n            {{displayName}}\r\n        </div>\r\n\r\n        <div class='row'>\r\n\r\n            <p-chart *ngIf=\"data && graphType === 'bar'\" type=\"bar\" [data]=\"data\" ></p-chart>\r\n            <p-chart *ngIf=\"data && graphType === 'line'\" type=\"line\" [data]=\"data\" ></p-chart>\r\n\r\n        </div>\r\n    </div>\r\n</div>"

/***/ },

/***/ 898:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var login_component_1 = __webpack_require__(899);
	var forgot_password_component_1 = __webpack_require__(902);
	var reset_password_component_1 = __webpack_require__(905);
	var reset_password_success_component_1 = __webpack_require__(908);
	exports.AuthRoutes = [
	    { path: 'login', component: login_component_1.LoginComponent },
	    { path: 'login-help', component: forgot_password_component_1.ForgotPasswordComponent },
	    { path: 'reset-password', component: reset_password_component_1.ResetPasswordComponent },
	    { path: 'reset-password-success', component: reset_password_success_component_1.ResetPasswordSuccessComponent }
	];


/***/ },

/***/ 899:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var auth_service_1 = __webpack_require__(679);
	var router_1 = __webpack_require__(655);
	var loading_indicator_1 = __webpack_require__(900);
	var user_session_1 = __webpack_require__(699);
	var user_info_service_1 = __webpack_require__(695);
	var _ = __webpack_require__(680);
	var LoginComponent = (function () {
	    function LoginComponent(router, authService, route, User, _userInfoService) {
	        this.router = router;
	        this.authService = authService;
	        this.route = route;
	        this.User = User;
	        this._userInfoService = _userInfoService;
	        this.userNameFocus = true;
	        this.requestedUrl = '';
	        this.oidcCode = '';
	    }
	    LoginComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        console.log(this.route.queryParams);
	        this.sub = this.route.params.subscribe(function (params) {
	            _this.requestedUrl = params['requestedUrl'];
	        });
	        this.suboidc = this.route.queryParams.subscribe(function (params) {
	            var oidcCode = params['code'];
	            if (!_.isEmpty(oidcCode)) {
	                _this.login(oidcCode);
	            }
	        });
	        if (this.authService.isLoggedIn()) {
	            this.router.navigate(['/welcome']);
	        }
	    };
	    LoginComponent.prototype.loginoidc = function () {
	        this.authService.oidclogin();
	    };
	    LoginComponent.prototype.login = function (oidcCode) {
	        var _this = this;
	        this.loggingIn = true;
	        this.authService.login(oidcCode)
	            .subscribe(function (success) {
	            _this.User.updateSessionState();
	            _this.ngOnInit();
	            if (_this.requestedUrl) {
	                _this.router.navigate([_this.requestedUrl]);
	            }
	            else {
	                _this.router.navigate(['/welcome']);
	            }
	            window.location.reload();
	        }, function (error) {
	            console.log("ERROR" + error);
	            _this.alerts = [];
	            _this.alerts.push({ type: 'danger', msg: error.error_description || 'Error Connecting to Server' });
	            _this.loggingIn = false;
	        });
	    };
	    LoginComponent.prototype.closeAlert = function (index) {
	        this.alerts.splice(index, 1);
	    };
	    LoginComponent = __decorate([
	        core_1.Component({
	            //providers: [AuthService],
	            directives: [loading_indicator_1.LoadingIndicator],
	            //templateUrl: 'app/authentication/login.component.html'
	            template: __webpack_require__(901),
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, auth_service_1.AuthService, router_1.ActivatedRoute, user_session_1.UserSession, user_info_service_1.UserInfoService])
	    ], LoginComponent);
	    return LoginComponent;
	}());
	exports.LoginComponent = LoginComponent;


/***/ },

/***/ 900:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var LoadingPage = (function () {
	    function LoadingPage(val) {
	        this.loading = val;
	    }
	    LoadingPage.prototype.standby = function () {
	        this.loading = true;
	    };
	    LoadingPage.prototype.ready = function () {
	        this.loading = false;
	    };
	    return LoadingPage;
	}());
	exports.LoadingPage = LoadingPage;
	var LoadingIndicator = (function () {
	    function LoadingIndicator() {
	    }
	    LoadingIndicator = __decorate([
	        core_1.Component({
	            selector: 'loading-indicator',
	            template: "<style type='text/css'>@-webkit-keyframes uil-default-anim { 0% { opacity: 1} 100% {opacity: 0} }@keyframes uil-default-anim { 0% { opacity: 1} 100% {opacity: 0} }.uil-default-css > div:nth-of-type(1){-webkit-animation: uil-default-anim 1s linear infinite;animation: uil-default-anim 1s linear infinite;-webkit-animation-delay: -0.5s;animation-delay: -0.5s;}.uil-default-css { position: relative;background:none;width:200px;height:200px;}.uil-default-css > div:nth-of-type(2){-webkit-animation: uil-default-anim 1s linear infinite;animation: uil-default-anim 1s linear infinite;-webkit-animation-delay: -0.4166666666666667s;animation-delay: -0.4166666666666667s;}.uil-default-css { position: relative;background:none;width:200px;height:200px;}.uil-default-css > div:nth-of-type(3){-webkit-animation: uil-default-anim 1s linear infinite;animation: uil-default-anim 1s linear infinite;-webkit-animation-delay: -0.33333333333333337s;animation-delay: -0.33333333333333337s;}.uil-default-css { position: relative;background:none;width:200px;height:200px;}.uil-default-css > div:nth-of-type(4){-webkit-animation: uil-default-anim 1s linear infinite;animation: uil-default-anim 1s linear infinite;-webkit-animation-delay: -0.25s;animation-delay: -0.25s;}.uil-default-css { position: relative;background:none;width:200px;height:200px;}.uil-default-css > div:nth-of-type(5){-webkit-animation: uil-default-anim 1s linear infinite;animation: uil-default-anim 1s linear infinite;-webkit-animation-delay: -0.16666666666666669s;animation-delay: -0.16666666666666669s;}.uil-default-css { position: relative;background:none;width:200px;height:200px;}.uil-default-css > div:nth-of-type(6){-webkit-animation: uil-default-anim 1s linear infinite;animation: uil-default-anim 1s linear infinite;-webkit-animation-delay: -0.08333333333333331s;animation-delay: -0.08333333333333331s;}.uil-default-css { position: relative;background:none;width:200px;height:200px;}.uil-default-css > div:nth-of-type(7){-webkit-animation: uil-default-anim 1s linear infinite;animation: uil-default-anim 1s linear infinite;-webkit-animation-delay: 0s;animation-delay: 0s;}.uil-default-css { position: relative;background:none;width:200px;height:200px;}.uil-default-css > div:nth-of-type(8){-webkit-animation: uil-default-anim 1s linear infinite;animation: uil-default-anim 1s linear infinite;-webkit-animation-delay: 0.08333333333333337s;animation-delay: 0.08333333333333337s;}.uil-default-css { position: relative;background:none;width:200px;height:200px;}.uil-default-css > div:nth-of-type(9){-webkit-animation: uil-default-anim 1s linear infinite;animation: uil-default-anim 1s linear infinite;-webkit-animation-delay: 0.16666666666666663s;animation-delay: 0.16666666666666663s;}.uil-default-css { position: relative;background:none;width:200px;height:200px;}.uil-default-css > div:nth-of-type(10){-webkit-animation: uil-default-anim 1s linear infinite;animation: uil-default-anim 1s linear infinite;-webkit-animation-delay: 0.25s;animation-delay: 0.25s;}.uil-default-css { position: relative;background:none;width:200px;height:200px;}.uil-default-css > div:nth-of-type(11){-webkit-animation: uil-default-anim 1s linear infinite;animation: uil-default-anim 1s linear infinite;-webkit-animation-delay: 0.33333333333333337s;animation-delay: 0.33333333333333337s;}.uil-default-css { position: relative;background:none;width:200px;height:200px;}.uil-default-css > div:nth-of-type(12){-webkit-animation: uil-default-anim 1s linear infinite;animation: uil-default-anim 1s linear infinite;-webkit-animation-delay: 0.41666666666666663s;animation-delay: 0.41666666666666663s;}.uil-default-css { position: relative;background:none;width:200px;height:200px;}</style><div class='uil-default-css' style='transform: scale(0.34)'><div style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(0deg) translate(0,-60px);transform:rotate(0deg) translate(0,-60px);border-radius:10px;position:absolute;'></div><div style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(30deg) translate(0,-60px);transform:rotate(30deg) translate(0,-60px);border-radius:10px;position:absolute;'></div><div style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(60deg) translate(0,-60px);transform:rotate(60deg) translate(0,-60px);border-radius:10px;position:absolute;'></div><div style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(90deg) translate(0,-60px);transform:rotate(90deg) translate(0,-60px);border-radius:10px;position:absolute;'></div><div style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(120deg) translate(0,-60px);transform:rotate(120deg) translate(0,-60px);border-radius:10px;position:absolute;'></div><div style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(150deg) translate(0,-60px);transform:rotate(150deg) translate(0,-60px);border-radius:10px;position:absolute;'></div><div style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(180deg) translate(0,-60px);transform:rotate(180deg) translate(0,-60px);border-radius:10px;position:absolute;'></div><div style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(210deg) translate(0,-60px);transform:rotate(210deg) translate(0,-60px);border-radius:10px;position:absolute;'></div><div style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(240deg) translate(0,-60px);transform:rotate(240deg) translate(0,-60px);border-radius:10px;position:absolute;'></div><div style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(270deg) translate(0,-60px);transform:rotate(270deg) translate(0,-60px);border-radius:10px;position:absolute;'></div><div style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(300deg) translate(0,-60px);transform:rotate(300deg) translate(0,-60px);border-radius:10px;position:absolute;'></div><div style='top:80px;left:93px;width:14px;height:40px;background:#00b2ff;-webkit-transform:rotate(330deg) translate(0,-60px);transform:rotate(330deg) translate(0,-60px);border-radius:10px;position:absolute;'></div></div>"
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LoadingIndicator);
	    return LoadingIndicator;
	}());
	exports.LoadingIndicator = LoadingIndicator;


/***/ },

/***/ 901:
/***/ function(module, exports) {

	module.exports = "\r\n<div style=\"width: 100%;\">\r\n    <div class='panel panel-primary' style=\"width: 600px; margin: auto; \">\r\n\r\n        <div class='panel-heading'>\r\n            Sign In\r\n        </div>\r\n    \r\n        <div class='panel-body' style=\"background-color:'#FFFF99' border='0' cellspacing='0' cellpadding='5' width='400'\">\r\n        \r\n        <div [hidden]=\"loggingIn\" style=\"margin-top: 10px;\" class=\"alert alert-{{alert.type}}\" *ngFor=\"let alert of alerts\" close=\"closeAlert($index)\">{{alert.msg}}</div>\r\n        <center>\r\n        <div>\r\n            Users are accessing a U.S. Government information system.<br>\r\n            System usage may be monitored, recorded, and subject to audit.<br>\r\n            Unauthorized use of the system is prohibited and\r\n            subject to civil and criminal penalties.<br>\r\n            Use of the system indicates consent to monitoring and recording.<br> <br>\r\n        </div>  \r\n        \r\n       \r\n            <button type=\"text\" pButton class=\"btn btn-success\"  (click)=\"loginoidc()\" label=\"Log In\"><i *ngIf=\"loggingIn\" style=\"color:green\" class=\"fa fa-spinner fa-spin\"></i></button>\r\n        </center>\r\n            \r\n        </div>\r\n    </div>\r\n</div>\r\n"

/***/ },

/***/ 902:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var account_service_1 = __webpack_require__(903);
	var router_1 = __webpack_require__(655);
	var ForgotPasswordComponent = (function () {
	    function ForgotPasswordComponent(router, accountService, route) {
	        this.router = router;
	        this.accountService = accountService;
	        this.route = route;
	        this.forgot = 'username';
	    }
	    ForgotPasswordComponent.prototype.ngOnInit = function () {
	        //So for this don't think I need the below currently because we are not doing security questions
	        // this.sub = this.route.params.subscribe(
	        //     params => {
	        //         this.email = params['email'];
	        //         this.code = params['code'];
	        // });
	        // if(this.email){
	        // 	this.accountService.getSecurityQuestionForEmail(this.email)
	        //         .subscribe(
	        //             data => this.question = data.question,
	        //             error => {
	        //                 this.alerts = [];
	        // 				this.alerts.push({type: 'danger', 
	        // 					msg: 'An unexpected error occurred while retrieving your security question.'});
	        //                 this.timeoutAlert();   
	        //             }
	        //         );
	        // }
	    };
	    ForgotPasswordComponent.prototype.timeoutAlert = function () {
	        var _this = this;
	        setTimeout(function () {
	            _this.alerts = [];
	            //supposedly not needed in angular2
	            //$scope.$apply();
	        }, 1000);
	    };
	    ForgotPasswordComponent.prototype.forgotSomething = function () {
	        var _this = this;
	        this.sendingEmail = true;
	        var baseUrl = window.location.href.substring(0, window.location.href.lastIndexOf('/'));
	        // if(this.forgot === 'username'){
	        //     this.accountService.retrieveUsername({email: this.email, baseUrl: baseUrl})
	        //         .subscribe(
	        //             success => {
	        //                 this.alerts = [];
	        //                 this.alerts.push({type: 'success', msg: 'Your e-mail has been sent.'});                  
	        //             },
	        //             error => {
	        //                 this.alerts = [];
	        //                 this.alerts.push({type: 'danger', msg: error});
	        //                 this.timeoutAlert();
	        //             }
	        //         );
	        // }
	        // else{
	        this.accountService.forgotPwd({ email: this.email, baseUrl: baseUrl })
	            .finally(function () { return _this.sendingEmail = false; })
	            .subscribe(function (success) {
	            _this.alerts = [];
	            _this.alerts.push({ type: 'success', msg: 'Your e-mail has been sent.' });
	        }, function (error) {
	            _this.alerts = [];
	            _this.alerts.push({ type: 'danger', msg: error });
	            _this.timeoutAlert();
	        });
	        //}
	    };
	    ForgotPasswordComponent.prototype.closeAlert = function (index) {
	        this.alerts.splice(index, 1);
	    };
	    ForgotPasswordComponent.prototype.verifySecurityQuestion = function () {
	        var _this = this;
	        this.accountService.verifySecurityQuestion(this.email, this.answer)
	            .subscribe(function (data) {
	            if (data === 'true') {
	                _this.router.navigate(['/reset-password']);
	            }
	            else {
	                _this.alerts = [];
	                _this.alerts.push({ type: 'danger', msg: "The answer doesn't match our records. Please try again." });
	            }
	        }, function (error) {
	            _this.alerts = [];
	            _this.alerts.push({ type: 'danger', msg: 'An unexpected error occurred while verifying your answer.' });
	        }, function () { return _this.timeoutAlert(); });
	    };
	    ForgotPasswordComponent.prototype.resetPassword = function () {
	        var _this = this;
	        var pwdData = {
	            email: this.email,
	            resetToken: this.code,
	            newPassword: this.newPassword
	        };
	        this.accountService.resetPwd(pwdData)
	            .subscribe(function (data) {
	            if (data.succeeded) {
	                _this.router.navigate(['/reset-password-success']);
	            }
	            else {
	                _this.alerts = [];
	                _this.alerts.push({ type: 'danger', msg: data.errors[0] });
	            }
	        }, function (error) {
	            _this.alerts = [];
	            _this.alerts.push({ type: 'danger', msg: 'An error occurred resetting your password. Please try again' });
	        }, function () { return _this.timeoutAlert(); });
	    };
	    ForgotPasswordComponent = __decorate([
	        core_1.Component({
	            providers: [account_service_1.AccountService],
	            //templateUrl: 'app/authentication/forgot-password.component.html'
	            template: __webpack_require__(904),
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, account_service_1.AccountService, router_1.ActivatedRoute])
	    ], ForgotPasswordComponent);
	    return ForgotPasswordComponent;
	}());
	exports.ForgotPasswordComponent = ForgotPasswordComponent;


/***/ },

/***/ 903:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var http_helper_1 = __webpack_require__(678);
	var AccountService = (function () {
	    function AccountService(httpHelper) {
	        this.httpHelper = httpHelper;
	    }
	    AccountService.prototype.changePwd = function (pwdData) {
	        return this.httpHelper.post('auth/api/account/changepwd', JSON.stringify(pwdData));
	    };
	    AccountService.prototype.forgotPwd = function (pwdData) {
	        return this.httpHelper.post('auth/api/account/forgotpwd', JSON.stringify(pwdData));
	    };
	    AccountService.prototype.verifySecurityQuestion = function (email, answer) {
	        var data = {
	            email: email,
	            answer: answer
	        };
	        return this.httpHelper.post('auth/api/account/validatesecurityquestion', JSON.stringify(data));
	    };
	    AccountService.prototype.getSecurityQuestionForEmail = function (email) {
	        var secQuestionData = {
	            email: email
	        };
	        return this.httpHelper.post('auth/api/account/securityquestion', JSON.stringify(secQuestionData));
	    };
	    AccountService.prototype.resetPwd = function (pwdData) {
	        return this.httpHelper.post('auth/api/account/resetpwd', JSON.stringify(pwdData));
	    };
	    AccountService.prototype.getSecurityQuestions = function () {
	        return this.httpHelper.get('auth/api/account/questions');
	    };
	    AccountService.prototype.getAccountInfo = function (username) {
	        var data = {
	            username: username
	        };
	        return this.httpHelper.post('auth/api/account/info', JSON.stringify(data));
	        //JSON.stringify('username':username}));
	    };
	    AccountService.prototype.saveSecurityQuestionAnswers = function (securityQuestionData) {
	        return this.httpHelper.post('auth/api/account/savesecurityanswer', JSON.stringify(securityQuestionData));
	    };
	    AccountService.prototype.retrieveUsername = function (usernameData) {
	        return this.httpHelper.post('auth/api/account/forgotusername', JSON.stringify(usernameData));
	    };
	    AccountService.prototype.confirmEmail = function (confirmationData) {
	        return this.httpHelper.post('auth/api/account/confirmemail', JSON.stringify(confirmationData));
	    };
	    AccountService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], AccountService);
	    return AccountService;
	}());
	exports.AccountService = AccountService;


/***/ },

/***/ 904:
/***/ function(module, exports) {

	module.exports = "<div class='panel panel-primary'>\r\n\r\n    <div class='panel-heading'>\r\n        Forgot Password\r\n    </div>\r\n\r\n    <div class='panel-body'>\r\n        <form class=\"form-horizontal\" role=\"form\" (ngSubmit)=\"forgotSomething()\" #needHelpForm=\"ngForm\">\r\n            <div [hidden]=\"sendingEmail\" style=\"margin-top:10px\" class=\"alert alert-{{alert.type}}\" *ngFor=\"let alert of alerts\" close=\"closeAlert($index)\">{{alert.msg}}</div>\r\n            \r\n            <div class=\"form-group\">\r\n                <label for=\"email\" class=\"col-md-3 control-label\">Email</label>\r\n                <div class=\"col-md-5\">\r\n                    <input [(ngModel)]=\"email\" id=\"email\" #emailField=\"ngModel\" pattern=\"^\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$\" required name=\"email\" class=\"form-control\" />\r\n                    <div [hidden]=\"emailField.valid || emailField.pristine\" class=\"alert alert-danger\">\r\n                        Vaid email address required\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n                <div class=\"col-md-offset-3 col-md-9\">\r\n                    <button type=\"submit\" class=\"btn btn-default\" [disabled]=\"!needHelpForm.form.valid\">Send Email</button>\r\n                </div>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>\r\n    \r\n    \r\n    \r\n    "

/***/ },

/***/ 905:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var account_service_1 = __webpack_require__(903);
	var router_1 = __webpack_require__(655);
	var confirm_validator_directive_1 = __webpack_require__(906);
	var ResetPasswordComponent = (function () {
	    function ResetPasswordComponent(router, accountService, route) {
	        this.router = router;
	        this.accountService = accountService;
	        this.route = route;
	    }
	    ResetPasswordComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.sub = this.route.queryParams.subscribe(function (params) {
	            _this.email = params['email'];
	            _this.code = params['code'];
	        });
	    };
	    ResetPasswordComponent.prototype.timeoutAlert = function () {
	        var _this = this;
	        setTimeout(function () {
	            _this.alerts = [];
	            //supposedly not needed in angular2
	            //$scope.$apply();
	        }, 1000);
	    };
	    ResetPasswordComponent.prototype.closeAlert = function (index) {
	        this.alerts.splice(index, 1);
	    };
	    ResetPasswordComponent.prototype.resetPassword = function () {
	        var _this = this;
	        this.alerts = [];
	        var pwdData = {
	            email: this.email,
	            resetToken: this.code,
	            newPassword: this.newPassword
	        };
	        this.accountService.resetPwd(pwdData)
	            .subscribe(function (data) {
	            if (data.succeeded) {
	                _this.router.navigate(['/reset-password-success']);
	            }
	            else {
	                _this.alerts.push({ type: 'danger', msg: data.errors[0] });
	            }
	        }, function (error) {
	            _this.alerts.push({ type: 'danger', msg: 'An error occurred resetting your password. Please try again' });
	        }, function () { return _this.timeoutAlert(); });
	    };
	    ResetPasswordComponent = __decorate([
	        core_1.Component({
	            providers: [account_service_1.AccountService],
	            //templateUrl: 'app/authentication/reset-password.component.html',
	            template: __webpack_require__(907),
	            directives: [confirm_validator_directive_1.EqualValidator]
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, account_service_1.AccountService, router_1.ActivatedRoute])
	    ], ResetPasswordComponent);
	    return ResetPasswordComponent;
	}());
	exports.ResetPasswordComponent = ResetPasswordComponent;


/***/ },

/***/ 906:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(11);
	var forms_1 = __webpack_require__(337);
	var EqualValidator = (function () {
	    function EqualValidator(validateEqual, reverse) {
	        this.validateEqual = validateEqual;
	        this.reverse = reverse;
	    }
	    Object.defineProperty(EqualValidator.prototype, "isReverse", {
	        get: function () {
	            if (!this.reverse)
	                return false;
	            return this.reverse === 'true' ? true : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    EqualValidator.prototype.validate = function (c) {
	        // self value
	        var v = c.value;
	        // control vlaue
	        var e = c.root.find(this.validateEqual);
	        // value not equal
	        if (e && v !== e.value && !this.isReverse) {
	            return {
	                validateEqual: false
	            };
	        }
	        // value equal and reverse
	        if (e && v === e.value && this.isReverse) {
	            delete e.errors['validateEqual'];
	            if (!Object.keys(e.errors).length)
	                e.setErrors(null);
	        }
	        // value not equal and reverse
	        if (e && v !== e.value && this.isReverse) {
	            e.setErrors({
	                validateEqual: false
	            });
	        }
	        return null;
	    };
	    EqualValidator = __decorate([
	        core_1.Directive({
	            selector: '[validateEqual][formControlName],[validateEqual][formControl],[validateEqual][ngModel]',
	            providers: [
	                core_1.provide(forms_1.NG_VALIDATORS, { useExisting: core_1.forwardRef(function () { return EqualValidator; }), multi: true })
	            ]
	        }),
	        __param(0, core_1.Attribute('validateEqual')),
	        __param(1, core_1.Attribute('reverse')), 
	        __metadata('design:paramtypes', [String, String])
	    ], EqualValidator);
	    return EqualValidator;
	}());
	exports.EqualValidator = EqualValidator;


/***/ },

/***/ 907:
/***/ function(module, exports) {

	module.exports = "\r\n<div class=\"panel panel-primary\">\r\n    <div class=\"panel-heading\">\r\n        Reset Password\r\n    </div>\r\n    <div class=\"panel-body\">\r\n        <form class=\"form-horizontal\" (ngSubmit)=\"resetPassword()\" #resetPwdForm=\"ngForm\">\r\n            <div [hidden]=\"!alerts\" style=\"margin-top:10px\" class=\"alert alert-{{alert.type}}\" *ngFor=\"let alert of alerts\" close=\"closeAlert($index)\">{{alert.msg}}</div>\r\n\r\n            <div class=\"form-group\">\r\n                <label for=\"newPassword\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">New Password</label>            \r\n                <div class=\"col-md-5\">\r\n                    <input \r\n                        id=\"newPassword\" \r\n                        #newPasswordField=\"ngModel\" \r\n                        name=\"newPassword\" \r\n                        required \r\n                        pattern=\"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{6,}$\"\r\n                        class=\"form-control input-sm\"  \r\n                        type=\"password\" \r\n                        [(ngModel)]=\"newPassword\"\r\n                        validateEqual=\"repeatNewPassword\" \r\n                        reverse=\"true\"/> \r\n                    <div [hidden]=\"newPasswordField.valid || newPasswordField.pristine\" class=\"alert alert-danger\">\r\n                            Password must be at least 6 characters long, and contain at least one upper case letter, one lower case letter, and one number.\r\n                    </div>                                       \r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n                <label for=\"repeatNewPassword\" style=\"text-align:right\" class=\"col-md-2 control-label\">Confirm New Password</label>\r\n                <div class=\"col-md-5\">\r\n                    <!-- password validator uses id name not ngmodel name -->\r\n                    <input \r\n                        id=\"repeatNewPassword\" \r\n                        name=\"repeatNewPassword\" \r\n                        class=\"form-control input-sm\" \r\n                        required type=\"password\" \r\n                        [(ngModel)]=\"repeatNewPassword\"\r\n                        #confirmPassword=\"ngModel\"\r\n                        validateEqual=\"newPassword\" \r\n                        reverse=\"false\" />\r\n                    <div [hidden]=\"confirmPassword.valid || confirmPassword.pristine\" class=\"alert alert-danger\">\r\n                            Password's must match\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n                <div class=\"col-md-offset-4 col-md-10\">\r\n                    <button type=\"submit\" class=\"btn btn-default\" [disabled]=\"!resetPwdForm.form.valid\">Save Password</button>\r\n                </div>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>"

/***/ },

/***/ 908:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var ResetPasswordSuccessComponent = (function () {
	    function ResetPasswordSuccessComponent() {
	    }
	    ResetPasswordSuccessComponent = __decorate([
	        core_1.Component({
	            //templateUrl: 'app/authentication/reset-password-success.component.html'
	            template: __webpack_require__(909),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ResetPasswordSuccessComponent);
	    return ResetPasswordSuccessComponent;
	}());
	exports.ResetPasswordSuccessComponent = ResetPasswordSuccessComponent;


/***/ },

/***/ 909:
/***/ function(module, exports) {

	module.exports = "<div class=\"panel panel-primary\">\r\n    <div class=\"panel-heading\">\r\n        Password Reset Success\r\n    </div>\r\n    <div class=\"panel-body\"  >\r\n        <div class=\"well\">\r\n            Click <a [routerLink]=\"['/login']\">here</a> to login. \r\n        </div>        \r\n    </div>\r\n</div>"

/***/ },

/***/ 910:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var admin_component_1 = __webpack_require__(911);
	var user_component_1 = __webpack_require__(914);
	var auth_guard_service_1 = __webpack_require__(696);
	exports.AdminRoutes = [
	    { path: 'admin', component: admin_component_1.AdminComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'user-admin', component: user_component_1.UserComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'user-admin/:id', component: user_component_1.UserComponent, canActivate: [auth_guard_service_1.AuthGuard] }
	];


/***/ },

/***/ 911:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var admin_service_1 = __webpack_require__(912);
	var router_1 = __webpack_require__(655);
	var primeng_1 = __webpack_require__(708);
	var primeng_2 = __webpack_require__(708);
	var primeng_3 = __webpack_require__(708);
	var primeng_4 = __webpack_require__(708);
	var primeng_5 = __webpack_require__(708);
	var primeng_6 = __webpack_require__(708);
	var primeng_7 = __webpack_require__(708);
	var AdminComponent = (function () {
	    function AdminComponent(router, adminService, route) {
	        this.router = router;
	        this.adminService = adminService;
	        this.route = route;
	        this.retrievingUsers = false;
	    }
	    AdminComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.users = [];
	        this.getUsers();
	        this.items = [
	            { label: 'Edit', icon: 'fa-edit', command: function (event) { return _this.editUser(_this.selectedUser); } },
	            { label: 'Delete', icon: 'fa-trash', command: function (event) { return _this.deleteUser(_this.selectedUser); } }
	        ];
	    };
	    AdminComponent.prototype.getUsers = function () {
	        var _this = this;
	        this.retrievingUsers = true;
	        this.adminService.getUsers()
	            .subscribe(function (users) {
	            _this.users = users;
	            _this.users.map(function (user) {
	                user.roles = user.roles.map(function (role) { return role.name; }).join(', ');
	            });
	        }, function (error) {
	            _this.alerts = [];
	            _this.alerts.push({ type: 'danger', msg: 'There was an error retrieving users.' });
	        }, function () { return _this.retrievingUsers = false; });
	    };
	    AdminComponent.prototype.addUser = function () {
	        this.router.navigate(['/user-admin']);
	    };
	    AdminComponent.prototype.editUser = function (user) {
	        this.router.navigate(['/user-admin', { id: user.id }]);
	    };
	    AdminComponent.prototype.deleteUser = function (user) {
	        var _this = this;
	        var confirmAnswer = confirm("Are you sure you want to delete user " + user.userName);
	        if (confirmAnswer == true) {
	            this.adminService.deleteUser(user.id)
	                .subscribe(function (users) {
	                _this.retrievingUsers = true;
	                _this.alerts = [];
	                _this.alerts.push({ type: 'success', msg: 'Successfully removed user' });
	                _this.getUsers();
	            }, function (error) {
	                _this.alerts = [];
	                _this.alerts.push({ type: 'danger', msg: 'Failed to remove user' });
	            }, function () { return _this.retrievingUsers = false; });
	        }
	    };
	    AdminComponent = __decorate([
	        core_1.Component({
	            providers: [admin_service_1.AdminService],
	            //templateUrl: 'app/administration/admin.component.html',
	            template: __webpack_require__(913),
	            directives: [primeng_2.DataTable, primeng_3.Column, primeng_4.Header, primeng_5.Button, primeng_6.Menu, primeng_1.ContextMenu, primeng_7.ContextMenuSub]
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, admin_service_1.AdminService, router_1.ActivatedRoute])
	    ], AdminComponent);
	    return AdminComponent;
	}());
	exports.AdminComponent = AdminComponent;


/***/ },

/***/ 912:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var http_helper_1 = __webpack_require__(678);
	var AdminService = (function () {
	    function AdminService(httpHelper) {
	        this.httpHelper = httpHelper;
	    }
	    //Do we need a user types?????
	    AdminService.prototype.getUsers = function () {
	        //wasn't able to get cacheing to work but found a couple of examples
	        //this really isn't pulling back that much data so just going to run the call again
	        return this.httpHelper.get('api/users');
	    };
	    AdminService.prototype.getRoles = function () {
	        return this.httpHelper.get('auth/api/account/roles');
	    };
	    //This seems to be never used
	    AdminService.prototype.getCachedUsers = function () {
	        return this.users;
	    };
	    //so will have an user interface but not sure if I will need it here
	    AdminService.prototype.createUser = function (user) {
	        return this.httpHelper.post(
	        //'auth/api/users/',
	        'api/users/', JSON.stringify(user));
	        //TODO: test error handling here
	    };
	    AdminService.prototype.emailExists = function (email) {
	        return this.httpHelper.post('auth/api/account/emailexists', 
	        //this might not be right
	        JSON.stringify({ email: email }));
	    };
	    AdminService.prototype.usernameExists = function (username) {
	        return this.httpHelper.post('auth/api/account/usernameexists', 
	        //this might not be right
	        JSON.stringify({ username: username }));
	    };
	    AdminService.prototype.updateUser = function (user) {
	        return this.httpHelper.put('api/users/' + user.id, JSON.stringify(user));
	    };
	    AdminService.prototype.deleteUser = function (userid) {
	        return this.httpHelper.delete('api/users/' + userid);
	    };
	    AdminService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [http_helper_1.HttpHelper])
	    ], AdminService);
	    return AdminService;
	}());
	exports.AdminService = AdminService;


/***/ },

/***/ 913:
/***/ function(module, exports) {

	module.exports = " <div class=\"panel panel-primary\">\r\n    <div class=\"panel-heading\">\r\n        Admin\r\n    </div>\r\n    <div class=\"panel-body\">\r\n        <div style=\"display:inline-block\">\r\n            <i class=\"fa fa-users fa-2x\" style=\"margin-right:15px\"></i>Users\r\n        </div>\r\n        <div style=\"display:inline-block;float:right\">\r\n            <button class=\"btn btn-success\" (click)=\"addUser()\"><i class=\"fa fa-user-plus\"></i> Add User</button>\r\n        </div>\r\n        <div *ngIf=\"retrievingUsers\" style=\"margin-top:20px\">\r\n            Loading Users <i class=\"fa fa-spinner fa-spin\"></i>\r\n        </div>\r\n        <br/>\r\n        <br/>\r\n        <span style=\"margin-top:5px\" *ngIf=\"!retrievingUsers && users.length == 0\"><h4>No users found.</h4></span>\r\n        <p-dataTable #dt [value]=\"users\" [rows]=\"25\" [paginator]=\"true\" [pageLinks]=\"3\" [rowsPerPageOptions]=\"[5,10,20]\" selectionMode=\"single\" [(selection)]=\"selectedUser\" [contextMenu]=\"cm\" *ngIf=\"!retrievingUsers && users.length > 0\">\r\n            <p-column field=\"firstName\" header=\"First Name\"></p-column>\r\n            <p-column field=\"lastName\" header=\"Last Name\"></p-column>\r\n            <p-column field=\"userName\" header=\"User Name\"></p-column>\r\n            <p-column field=\"email\" header=\"Email\"></p-column>\r\n            <p-column field=\"roles\" header=\"Role\"></p-column>\r\n        </p-dataTable>\r\n        <p-contextMenu #cm [model]=\"items\"></p-contextMenu>\r\n    </div>\r\n</div>\r\n \r\n "

/***/ },

/***/ 914:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var admin_service_1 = __webpack_require__(912);
	var router_1 = __webpack_require__(655);
	var commondata_service_1 = __webpack_require__(693);
	var _ = __webpack_require__(680);
	var UserComponent = (function () {
	    function UserComponent(router, adminService, _commonDataService, route) {
	        this.router = router;
	        this.adminService = adminService;
	        this._commonDataService = _commonDataService;
	        this.route = route;
	    }
	    UserComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.sub = this.route.params.subscribe(function (params) {
	            var id = params['id'];
	            if (id === undefined) {
	                _this.newUser = true;
	                _this.pageTitle = 'Create User';
	                _this.user = {};
	                _this.getRoles();
	            }
	            else {
	                _this.newUser = false;
	                _this.pageTitle = 'Edit User';
	                _this.idParam = id;
	                //console.log(this.idParam);
	                _this.adminService.getUsers().subscribe(function (data) {
	                    var users = data;
	                    _this.user = _.find(users, function (user) {
	                        return user.id === Number(id);
	                    });
	                    _this.origUser = _.cloneDeep(_this.user);
	                    _this.getRoles();
	                });
	            }
	        });
	        this.getKeyValues('region');
	    };
	    UserComponent.prototype.getKeyValues = function (id) {
	        var _this = this;
	        this._commonDataService.getData(id)
	            .subscribe(function (list) {
	            if (id == "region") {
	                _this.regions = list;
	            }
	        });
	    };
	    UserComponent.prototype.getRoles = function () {
	        var _this = this;
	        this.adminService.getRoles()
	            .subscribe(function (roles) {
	            _this.roles = roles;
	            _this.selectRole();
	        });
	    };
	    UserComponent.prototype.selectRole = function () {
	        if (this.user && this.user.roles) {
	            var roleId_1 = this.user.roles[0].id;
	            this.user.selectedRole = _.find(this.roles, function (role) {
	                return role.id === roleId_1;
	            });
	        }
	        else {
	            this.user.selectedRole = this.roles[1];
	        }
	    };
	    UserComponent.prototype.submitUser = function () {
	        var _this = this;
	        this.alerts = [];
	        if (this.newUser) {
	            this.adminService.usernameExists(this.user.userName)
	                .subscribe(function (success) {
	                if (success == true) {
	                    _this.alerts.push({ type: 'danger', msg: 'User Name is Already in Use' });
	                }
	                else {
	                    _this.adminService.emailExists(_this.user.email)
	                        .subscribe(function (success) {
	                        if (success == true) {
	                            _this.alerts.push({ type: 'danger', msg: 'Email is Already in Use' });
	                        }
	                        else {
	                            _this.saveUser();
	                        }
	                    }, function (error) {
	                        _this.alerts.push({ type: 'danger', msg: 'Error Occured Connecting to Server' });
	                    });
	                }
	            }, function (error) {
	                _this.alerts.push({ type: 'danger', msg: 'Error Occured Connecting to Server' });
	            });
	        }
	        else {
	            this.saveUser();
	        }
	    };
	    UserComponent.prototype.saveUser = function () {
	        var _this = this;
	        this.alerts = [];
	        this.user.role = this.user.selectedRole.name;
	        if (this.newUser) {
	            //TODO: not sure I need this
	            this.user.baseUrl = window.location.href.substring(0, window.location.href.lastIndexOf('/'));
	            this.adminService.createUser(this.user)
	                .subscribe(function (success) { return _this.router.navigate(['/admin']); }, function (error) {
	                _this.alerts.push({ type: 'danger', msg: 'Creation failed.' });
	            });
	        }
	        else {
	            this.adminService.updateUser(this.user)
	                .subscribe(function (success) { return _this.router.navigate(['/admin']); }, function (error) {
	                _this.alerts.push({ type: 'danger', msg: 'Update failed.' });
	            });
	        }
	    };
	    UserComponent.prototype.resetForm = function () {
	        this.user = this.origUser;
	        this.selectRole();
	        //https://github.com/angular/angular/pull/9974
	        //this.form.markAsPristine();
	    };
	    UserComponent.prototype.closeAlert = function (index) {
	        this.alerts.splice(index, 1);
	    };
	    UserComponent = __decorate([
	        core_1.Component({
	            providers: [admin_service_1.AdminService],
	            //templateUrl: 'app/administration/user.component.html'
	            template: __webpack_require__(915),
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, admin_service_1.AdminService, commondata_service_1.CommonDataService, router_1.ActivatedRoute])
	    ], UserComponent);
	    return UserComponent;
	}());
	exports.UserComponent = UserComponent;


/***/ },

/***/ 915:
/***/ function(module, exports) {

	module.exports = "<div class=\"panel panel-primary\">\r\n    <div class=\"panel-heading\">\r\n      {{ pageTitle }}\r\n    </div>\r\n    <div class=\"panel-body\">\r\n\r\n        <form *ngIf=\"newUser || user\" #userForm=\"ngForm\" class=\"form-vertical\" (ngSubmit)=\"submitUser()\" novalidate>\r\n            <div [hidden]=\"!alerts\" style=\"margin-top:10px\" class=\"alert alert-{{alert.type}}\" *ngFor=\"let alert of alerts\" close=\"closeAlert($index)\">{{alert.msg}}</div>\r\n\r\n            <div class=\"form-group row\">\r\n                <label for=\"username\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Username</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"username\" name=\"username\" required class=\"form-control input-sm\" [disabled]=\"!newUser\" type=\"text\" [(ngModel)]=\"user.userName\" #userNameField=\"ngModel\"/>\r\n                    <div [hidden]=\"userNameField.valid || userNameField.pristine\" class=\"alert alert-danger\">\r\n                        User Name is required\r\n                    </div>\r\n                </div>\r\n            </div>\r\n\r\n            <div class=\"form-group row\">\r\n                <label for=\"email\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Email</label>\r\n                <div class=\"col-md-5\">\r\n                    <input [(ngModel)]=\"user.email\" id=\"email\" [disabled]=\"!newUser\" #emailField=\"ngModel\" pattern=\"^\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$\" required name=\"email\" class=\"form-control input-sm\" />\r\n                    <div [hidden]=\"emailField.valid || emailField.pristine\" class=\"alert alert-danger\">\r\n                        Vaid email address required\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"firstName\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">First Name</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"firstName\" name=\"firstName\" required class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"user.firstName\" #firstNameField=\"ngModel\" />\r\n                    <div [hidden]=\"firstNameField.valid || firstNameField.pristine\" class=\"alert alert-danger\">\r\n                        First Name is required\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"lastName\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Last Name</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"lastName\" name=\"lastName\" required class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"user.lastName\" #lastNameField=\"ngModel\"/>\r\n                    <div [hidden]=\"lastNameField.valid || lastNameField.pristine\" class=\"alert alert-danger\">\r\n                        Last Name is required\r\n                    </div>\r\n                </div>             \r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"phone\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Phone</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"phone\" name=\"phone\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"user.phone\"/>\r\n                </div>                \r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"phone\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Organization</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"organization\" name=\"organization\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"user.organization\"/>\r\n                </div>                \r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"title\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Title</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"title\" name=\"title\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"user.title\"/>\r\n                </div>                \r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"addressLine1\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Address Line 1</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"addressLine1\" name=\"addressLine1\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"user.addressLine1\"/>\r\n                </div>                \r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"addressLine2\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Address Line 2</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"addressLine2\" name=\"addressLine2\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"user.addressLine2\"/>\r\n                </div>                \r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"city\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">City</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"city\" name=\"city\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"user.city\"/>\r\n                </div>                \r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"state\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">State</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"state\" name=\"state\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"user.state\"/>\r\n                </div>                \r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"zip\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Zip</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"zip\" name=\"zip\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"user.zip\"/>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"regCode\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Region:</label>\r\n                <div class=\"col-md-5\">\r\n                    <select id=\"regCode\" name=\"regCode\" required class=\"form-control input-sm\" [(ngModel)]=\"user.regCode\">\r\n                        <option *ngFor=\"let region of regions\" [ngValue]=\"region.key\">{{region.value}}</option>\r\n                    </select>\r\n                </div>\r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"startYear\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Regional Start Year:</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"startYear\" name=\"startYear\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"user.startYear\"/>\r\n                </div>             \r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"endYear\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Regional End Year:</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"endYear\" minlength=\"4\" maxlength=\"4\" name=\"endYear\" class=\"form-control input-sm\" type=\"text\"  [(ngModel)]=\"user.endYear\"/>\r\n                </div>             \r\n            </div>\r\n            <div class=\"form-group row\">\r\n                <label for=\"role\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Role</label>\r\n                <div class=\"col-md-5\">\r\n                    <select id=\"role\" name=\"role\" required class=\"form-control input-sm\" [(ngModel)]=\"user.selectedRole\">\r\n                        <option *ngFor=\"let role of roles\" [ngValue]=\"role\">{{role.name}}</option>\r\n                    </select>\r\n                </div>              \r\n            </div>\r\n            <div class=\"form-group row\">        \r\n                <div class=\"col-md-offset-3 col-md-10\">\r\n                    <button type=\"submit\" class=\"btn btn-success\" style=\"margin-right:10px\" [disabled]=\"!userForm.form.valid\">Save</button>\r\n                    <button type=\"button\" class=\"btn btn-danger\" (click)=\"resetForm()\">Cancel</button>\r\n                </div>\r\n            </div>\r\n        </form>\r\n    </div>\r\n</div>"

/***/ },

/***/ 916:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var account_component_1 = __webpack_require__(917);
	var email_confirmation_component_1 = __webpack_require__(919);
	var auth_guard_service_1 = __webpack_require__(696);
	exports.AccountRoutes = [
	    { path: 'account', component: account_component_1.AccountComponent, canActivate: [auth_guard_service_1.AuthGuard] },
	    { path: 'email-confirmation', component: email_confirmation_component_1.EmailConfirmationComponent },
	];


/***/ },

/***/ 917:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var account_service_1 = __webpack_require__(903);
	var auth_service_1 = __webpack_require__(679);
	var router_1 = __webpack_require__(655);
	var AccountComponent = (function () {
	    function AccountComponent(router, accountService, authService, route) {
	        this.router = router;
	        this.accountService = accountService;
	        this.authService = authService;
	        this.route = route;
	    }
	    //TODO: may not need this 
	    AccountComponent.prototype.ngOnInit = function () {
	    };
	    AccountComponent.prototype.timeoutAlert = function () {
	        setTimeout(function () {
	            this.errorAlerts = [];
	        }, 10000);
	    };
	    AccountComponent.prototype.changePassword = function () {
	        var _this = this;
	        this.alerts = [];
	        var pwdData = {
	            username: this.authService.getLoggedInUser(),
	            currentPassword: this.currentPassword,
	            newPassword: this.newPassword
	        };
	        this.accountService.changePwd(pwdData)
	            .subscribe(function (data) {
	            if (data.succeeded) {
	                _this.alerts.push({ type: 'success', msg: 'Password successfully changed' });
	            }
	            else {
	                _this.alerts.push({ type: 'danger', msg: data.errors[0] });
	            }
	        }, function (error) {
	            _this.alerts.push({ type: 'danger', msg: error });
	        }, function () { return _this.timeoutAlert(); });
	    };
	    //not used for now
	    // getSecurityQuestions(){
	    // 	this.accountService.getSecurityQuestions().
	    //         subscribe(
	    //             data => {
	    //                 this.questions = data;
	    // 			    this.getUserAccountInfo();
	    //             },
	    //             error => {
	    // 			    this.alerts = [];
	    // 			    this.alerts.push({type: 'danger', 
	    //       			    msg: 'An unexpected error occurred while retrieving the list of security questions'});
	    //             });
	    // }
	    // getUserAccountInfo(){
	    // 	this.accountService.getAccountInfo(this.authService.getLoggedInUser()).
	    //         subscribe(
	    //             data => {
	    //                 this.question = _.find(this.questions, function(q: any){
	    // 				    return q.id === data.questionId;});
	    // 			    this.answer = data.answer;
	    // 		    });
	    // }
	    // saveSecurityQuestionAnswer(){
	    //     var securityQuestionData = {
	    // 	    username: this.authService.getLoggedInUser(),
	    // 		questionid: this.question.id,
	    // 		answer: this.answer
	    // 	};
	    // 	this.accountService.saveSecurityQuestionAnswers(securityQuestionData)
	    //         .subscribe(
	    //             success => {
	    //                 this.alerts = [];
	    // 				this.alerts.push({type: 'success', msg: 'Security Question saved.'});
	    //             },
	    //             error => {
	    // 			    this.alerts = [];
	    // 				this.alerts.push({type: 'danger', msg: 'Unexpected error saving security question'});
	    //             },
	    //             () => this.timeoutAlert()
	    //         );	
	    // }
	    AccountComponent.prototype.closeAlert = function (index) {
	        this.alerts.splice(index, 1);
	    };
	    AccountComponent = __decorate([
	        core_1.Component({
	            providers: [account_service_1.AccountService, auth_service_1.AuthService],
	            //templateUrl: 'app/accounts/account.component.html'
	            template: __webpack_require__(918),
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, account_service_1.AccountService, auth_service_1.AuthService, router_1.ActivatedRoute])
	    ], AccountComponent);
	    return AccountComponent;
	}());
	exports.AccountComponent = AccountComponent;


/***/ },

/***/ 918:
/***/ function(module, exports) {

	module.exports = "<div class=\"panel panel-primary\">\r\n    <div class=\"panel-heading\">\r\n        Account Management\r\n    </div>\r\n    <div class=\"panel-body\"  >\r\n        <h4>Change Password</h4>  \r\n        <hr/>\r\n        <form class=\"form-horizontal\" (ngSubmit)=\"changePassword()\" #changePwdForm=\"ngForm\" >\r\n            <div [hidden]=\"!alerts\" style=\"margin-top:10px\" class=\"alert alert-{{alert.type}}\" *ngFor=\"let alert of alerts\" close=\"closeAlert($index)\">{{alert.msg}}</div>\r\n            \r\n            <!--row???-->\r\n            <div class=\"form-group\">\r\n                <label for=\"currentPassword\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">Current Password</label>\r\n                <div class=\"col-md-5\">\r\n                    <input id=\"currentPassword\" name=\"currentPassword\" #currentPasswordField=\"ngModel\" required class=\"form-control input-sm\" type=\"password\"  [(ngModel)]=\"currentPassword\"/>\r\n                    <div [hidden]=\"currentPasswordField.valid || currentPasswordField.pristine\" class=\"alert alert-danger\">\r\n                        Password is required\r\n                    </div>\r\n                </div>                \r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n                <label for=\"newPassword\"  style=\"text-align:right\"  class=\"col-md-2 control-label\">New Password</label>            \r\n                <div class=\"col-md-5\">\r\n                    <input \r\n                        id=\"newPassword\" \r\n                        #newPasswordField=\"ngModel\" \r\n                        name=\"newPassword\" \r\n                        required \r\n                        pattern=\"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{6,}$\"\r\n                        class=\"form-control input-sm\"  \r\n                        type=\"password\" \r\n                        [(ngModel)]=\"newPassword\"\r\n                        validateEqual=\"repeatNewPassword\" \r\n                        reverse=\"true\"/>  \r\n                    <div [hidden]=\"newPasswordField.valid || newPasswordField.pristine\" class=\"alert alert-danger\">\r\n                            Password must be at least 6 characters long, and contain at least one upper case letter, one lower case letter, and one number.\r\n                    </div>                       \r\n                </div>\r\n            </div>\r\n\r\n\r\n            <div class=\"form-group\">\r\n                <label for=\"repeatNewPassword\" style=\"text-align:right\" class=\"col-md-2 control-label\">Confirm New Password</label>\r\n                <div class=\"col-md-5\">\r\n                    <!-- password validator uses id name not ngmodel name -->\r\n                    <input \r\n                        id=\"repeatNewPassword\" \r\n                        name=\"repeatNewPassword\" \r\n                        class=\"form-control input-sm\" \r\n                        required type=\"password\" \r\n                        [(ngModel)]=\"repeatNewPassword\"\r\n                        #confirmPassword=\"ngModel\"\r\n                        validateEqual=\"newPassword\" \r\n                        reverse=\"false\" />\r\n                    <div [hidden]=\"confirmPassword.valid || confirmPassword.pristine\" class=\"alert alert-danger\">\r\n                            Password's must match\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"col-md-offset-4 col-md-10\">\r\n                    <button type=\"submit\" class=\"btn btn-default\" [disabled]=\"!changePwdForm.form.valid\">Change Password</button>\r\n                </div>\r\n            </div>\r\n        </form>    \r\n    </div>\r\n</div>"

/***/ },

/***/ 919:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(11);
	var account_service_1 = __webpack_require__(903);
	var router_1 = __webpack_require__(655);
	var EmailConfirmationComponent = (function () {
	    function EmailConfirmationComponent(router, accountService, route) {
	        this.router = router;
	        this.accountService = accountService;
	        this.route = route;
	    }
	    EmailConfirmationComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var email;
	        var token;
	        this.sub = this.route.queryParams.subscribe(function (params) {
	            email = params['email'];
	            token = params['token'];
	        });
	        var data = {
	            email: email,
	            token: token
	        };
	        this.accountService.confirmEmail(data).
	            subscribe(function (success) {
	            _this.message = "Confirmation of e-mail address complete.";
	            //seems no way to do this right now, not sure if needed
	            //$location.search('email', undefined);
	            //$location.search('token', undefined);
	        }, function (error) { return _this.message = "Failed to confirm e-mail. " + error; });
	    };
	    EmailConfirmationComponent = __decorate([
	        core_1.Component({
	            //selector: 'login-form',
	            providers: [account_service_1.AccountService],
	            //templateUrl: 'app/accounts/email-confirmation.component.html',
	            template: __webpack_require__(920),
	            directives: [router_1.ROUTER_DIRECTIVES]
	        }), 
	        __metadata('design:paramtypes', [router_1.Router, account_service_1.AccountService, router_1.ActivatedRoute])
	    ], EmailConfirmationComponent);
	    return EmailConfirmationComponent;
	}());
	exports.EmailConfirmationComponent = EmailConfirmationComponent;


/***/ },

/***/ 920:
/***/ function(module, exports) {

	module.exports = "<div class=\"panel panel-primary\">\r\n    <div class=\"panel-heading\">\r\n        Email confirmation\r\n    </div>\r\n    <div class=\"well\" *ngIf='message'>{{message}}\r\n    </div>\r\n</div>"

/***/ }

});


/** WEBPACK FOOTER **
 ** app.4e7fdec8a5a40bdf6602.js
 **/